/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _uuid: { input: any; output: any; }
  date: { input: any; output: any; }
  files_scalar: { input: any; output: any; }
  float8: { input: number; output: number; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: number; output: number; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

export type AbortMultipartUploadError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type AbortMultipartUploadErrors = {
  __typename?: 'AbortMultipartUploadErrors';
  errors: Array<AbortMultipartUploadError>;
};

export type AbortMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  uploadId: Scalars['String']['input'];
};

export type AbortMultipartUploadResult = AbortMultipartUploadErrors | AbortMultipartUploadSuccess;

export type AbortMultipartUploadSuccess = {
  __typename?: 'AbortMultipartUploadSuccess';
  isAborted: Scalars['Boolean']['output'];
};

export type AbortTaskAttachmentMultipartUploadError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type AbortTaskAttachmentMultipartUploadErrors = {
  __typename?: 'AbortTaskAttachmentMultipartUploadErrors';
  errors: Array<AbortTaskAttachmentMultipartUploadError>;
};

export type AbortTaskAttachmentMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  uploadId: Scalars['String']['input'];
};

export type AbortTaskAttachmentMultipartUploadResult = AbortTaskAttachmentMultipartUploadErrors | AbortTaskAttachmentMultipartUploadSuccess;

export type AbortTaskAttachmentMultipartUploadSuccess = {
  __typename?: 'AbortTaskAttachmentMultipartUploadSuccess';
  isAborted: Scalars['Boolean']['output'];
};

export type AddFileApprovalsFileVersionsError = FileAccessDenied | FileApprovalNotExist | NotAuthorOfTheUpload;

export type AddFileApprovalsFileVersionsErrors = {
  __typename?: 'AddFileApprovalsFileVersionsErrors';
  errors: Array<AddFileApprovalsFileVersionsError>;
};

export type AddFileApprovalsFileVersionsInput = {
  fileApprovalId: Scalars['uuid']['input'];
  fileVersionId: Scalars['uuid']['input'];
};

export type AddFileApprovalsFileVersionsResult = AddFileApprovalsFileVersionsErrors | AddFileApprovalsFileVersionsSuccess;

export type AddFileApprovalsFileVersionsSuccess = {
  __typename?: 'AddFileApprovalsFileVersionsSuccess';
  saved: Scalars['Boolean']['output'];
};

export type AddMembersToProjectChannelError = ChannelDoesNotExist | InputValidationError | NotMemberOfThisChannel | ProjectAccessDenied | ProjectDoesNotExist | UserDoesNotExist | UserNotModeratorOfThisChannel;

export type AddMembersToProjectChannelErrors = {
  __typename?: 'AddMembersToProjectChannelErrors';
  errors: Array<AddMembersToProjectChannelError>;
};

export type AddMembersToProjectChannelInput = {
  channelId: Scalars['String']['input'];
  members: Array<Scalars['String']['input']>;
};

export type AddMembersToProjectChannelResult = AddMembersToProjectChannelErrors | AddMembersToProjectChannelSuccess;

export type AddMembersToProjectChannelSuccess = {
  __typename?: 'AddMembersToProjectChannelSuccess';
  channel_id: Scalars['String']['output'];
  project_id: Scalars['uuid']['output'];
};

export type AddMultiUserApprovalToFileVersionSuccess = {
  __typename?: 'AddMultiUserApprovalToFileVersionSuccess';
  file_ids: Array<FileMultipleApprovalIds>;
};

export type AddUserApprovalToFileVersionError = DuplicateApprovalOnFileVersion | FileAccessDenied | FileDoesNotExists | FileNotInApprovalMode | FileVersionDoesNotExists | UserCommentIsNecessaryToFile | UserNotAssignedToFile;

export type AddUserApprovalToFileVersionErrors = {
  __typename?: 'AddUserApprovalToFileVersionErrors';
  errors: Array<AddUserApprovalToFileVersionError>;
};

export type AddUserApprovalToFileVersionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  file_version_id: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
};

export type AddUserApprovalToFileVersionResult = AddUserApprovalToFileVersionErrors | AddUserApprovalToFileVersionSuccess;

export type AddUserApprovalToFileVersionSuccess = {
  __typename?: 'AddUserApprovalToFileVersionSuccess';
  file_approval_id: Scalars['uuid']['output'];
  file_version_id: Scalars['uuid']['output'];
};

export type AddUserInTeamError = InputValidationError | TeamAccessDenied | TeamDoesNotExist | UserAlreadyPartOfThisTeam | UserDoesNotExist;

export type AddUserInTeamErrors = {
  __typename?: 'AddUserInTeamErrors';
  errors: Array<AddUserInTeamError>;
};

export type AddUserInTeamInput = {
  teamId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

export type AddUserInTeamResult = AddUserInTeamErrors | AddUserInTeamSuccess;

export type AddUserInTeamSuccess = {
  __typename?: 'AddUserInTeamSuccess';
  project_id: Scalars['uuid']['output'];
  team_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

export type AddUserMultiApprovalToFilesVersionError = DuplicateApprovalOnFileVersion | FileAccessDenied | FileDoesNotExists | FileNotInApprovalMode | FileVersionDoesNotExists | InputValidationError | UserNotAssignedToFile;

export type AddUserMultiApprovalToFilesVersionErrors = {
  __typename?: 'AddUserMultiApprovalToFilesVersionErrors';
  errors: Array<AddUserMultiApprovalToFilesVersionError>;
};

export type AddUserMultiApprovalToFilesVersionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  files: Array<Scalars['uuid']['input']>;
  status: Scalars['String']['input'];
};

export type AddUserMultiApprovalToFilesVersionResult = AddMultiUserApprovalToFileVersionSuccess | AddUserMultiApprovalToFilesVersionErrors;

export type AddUserViewToFileVersionError = FileAccessDenied | FileDoesNotExists | FileVersionDoesNotExists | InputValidationError;

export type AddUserViewToFileVersionErrors = {
  __typename?: 'AddUserViewToFileVersionErrors';
  errors: Array<AddUserViewToFileVersionError>;
};

export type AddUserViewToFileVersionInput = {
  file_version_id: Scalars['uuid']['input'];
};

export type AddUserViewToFileVersionResult = AddUserViewToFileVersionErrors | AddUserViewToFileVersionSuccess;

export type AddUserViewToFileVersionSuccess = {
  __typename?: 'AddUserViewToFileVersionSuccess';
  file_version_id: Scalars['uuid']['output'];
};

export type AddUserViewToFolderError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type AddUserViewToFolderErrors = {
  __typename?: 'AddUserViewToFolderErrors';
  errors: Array<AddUserViewToFolderError>;
};

export type AddUserViewToFolderInput = {
  folder_id: Scalars['uuid']['input'];
};

export type AddUserViewToFolderResult = AddUserViewToFolderErrors | AddUserViewToFolderSuccess;

export type AddUserViewToFolderSuccess = {
  __typename?: 'AddUserViewToFolderSuccess';
  folder_id: Scalars['uuid']['output'];
};

export type AddUserViewToProjectError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist;

export type AddUserViewToProjectErrors = {
  __typename?: 'AddUserViewToProjectErrors';
  errors: Array<AddUserViewToProjectError>;
};

export type AddUserViewToProjectInput = {
  project_id: Scalars['uuid']['input'];
};

export type AddUserViewToProjectResult = AddUserViewToProjectErrors | AddUserViewToProjectSuccess;

export type AddUserViewToProjectSuccess = {
  __typename?: 'AddUserViewToProjectSuccess';
  project_id: Scalars['uuid']['output'];
};

export type AddUserViewToTaskError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type AddUserViewToTaskErrors = {
  __typename?: 'AddUserViewToTaskErrors';
  errors: Array<AddUserViewToTaskError>;
};

export type AddUserViewToTaskInput = {
  task_id: Scalars['uuid']['input'];
};

export type AddUserViewToTaskResult = AddUserViewToTaskErrors | AddUserViewToTaskSuccess;

export type AddUserViewToTaskSuccess = {
  __typename?: 'AddUserViewToTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type AnnotateFileError = FileAccessDenied | FileFormatNotSupported | FileVersionDoesNotExists;

export type AnnotateFileErrors = {
  __typename?: 'AnnotateFileErrors';
  errors: Array<AnnotateFileError>;
};

export type AnnotateFileInput = {
  file_version_id: Scalars['uuid']['input'];
  xfdf?: InputMaybe<Scalars['String']['input']>;
};

export type AnnotateFileResult = AnnotateFileErrors | AnnotateFileSuccess;

export type AnnotateFileSuccess = {
  __typename?: 'AnnotateFileSuccess';
  file_version_id: Scalars['uuid']['output'];
};

export type AssigneesInput = {
  orgs?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BulkDeleteTasksError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type BulkDeleteTasksErrors = {
  __typename?: 'BulkDeleteTasksErrors';
  errors: Array<BulkDeleteTasksError>;
};

export type BulkDeleteTasksInput = {
  taskIds: Array<Scalars['uuid']['input']>;
};

export type BulkDeleteTasksResult = BulkDeleteTasksErrors | BulkDeleteTasksSuccess;

export type BulkDeleteTasksSuccess = {
  __typename?: 'BulkDeleteTasksSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type CannotConvertToTemplateOrgProject = {
  __typename?: 'CannotConvertToTemplateOrgProject';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotCreateOrgProjectSummaryOnOrgProject = {
  __typename?: 'CannotCreateOrgProjectSummaryOnOrgProject';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotDeleteOrgProject = {
  __typename?: 'CannotDeleteOrgProject';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotDeleteProjectSharedWithMultipleOrgs = {
  __typename?: 'CannotDeleteProjectSharedWithMultipleOrgs';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotInviteOnProject = {
  __typename?: 'CannotInviteOnProject';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotModifyEmailOfActiveUser = {
  __typename?: 'CannotModifyEmailOfActiveUser';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotModifyUserWithGreaterProjectRoleThanYours = {
  __typename?: 'CannotModifyUserWithGreaterProjectRoleThanYours';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotRemoveApprovalOnFile = {
  __typename?: 'CannotRemoveApprovalOnFile';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotSetGreaterProjectRoleThanYours = {
  __typename?: 'CannotSetGreaterProjectRoleThanYours';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CannotUpdateProjectRole = {
  __typename?: 'CannotUpdateProjectRole';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CapawesomeChannel = {
  __typename?: 'CapawesomeChannel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CapgoChannel = {
  __typename?: 'CapgoChannel';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ChannelDoesNotExist = {
  __typename?: 'ChannelDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CompleteMultipartUploadError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type CompleteMultipartUploadErrors = {
  __typename?: 'CompleteMultipartUploadErrors';
  errors: Array<CompleteMultipartUploadError>;
};

export type CompleteMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  parentId: Scalars['uuid']['input'];
  parts: Array<UploadPartsInput>;
  uploadId: Scalars['String']['input'];
};

export type CompleteMultipartUploadResult = CompleteMultipartUploadErrors | CompleteMultipartUploadSuccess;

export type CompleteMultipartUploadSuccess = {
  __typename?: 'CompleteMultipartUploadSuccess';
  location: Scalars['String']['output'];
};

export type CompleteTaskAttachmentMultipartUploadError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type CompleteTaskAttachmentMultipartUploadErrors = {
  __typename?: 'CompleteTaskAttachmentMultipartUploadErrors';
  errors: Array<CompleteTaskAttachmentMultipartUploadError>;
};

export type CompleteTaskAttachmentMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  parts: Array<UploadPartsTaskAttachmentInput>;
  taskId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type CompleteTaskAttachmentMultipartUploadResult = CompleteTaskAttachmentMultipartUploadErrors | CompleteTaskAttachmentMultipartUploadSuccess;

export type CompleteTaskAttachmentMultipartUploadSuccess = {
  __typename?: 'CompleteTaskAttachmentMultipartUploadSuccess';
  location: Scalars['String']['output'];
};

export type ConvertFileError = FileAccessDenied | FileDoesNotExists | FileFormatNotSupported | FileVersionDoesNotExists | InputValidationError;

export type ConvertFileErrors = {
  __typename?: 'ConvertFileErrors';
  errors: Array<ConvertFileError>;
};

export type ConvertFileInput = {
  extension: Scalars['String']['input'];
  fileId: Scalars['uuid']['input'];
  fileVersionId: Scalars['uuid']['input'];
  url: Scalars['String']['input'];
};

export type ConvertFileResult = ConvertFileErrors | ConvertFileSuccess;

export type ConvertFileSuccess = {
  __typename?: 'ConvertFileSuccess';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CopyFromTemporaryBucketFailed = {
  __typename?: 'CopyFromTemporaryBucketFailed';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CopyProjectError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist;

export type CopyProjectErrors = {
  __typename?: 'CopyProjectErrors';
  errors: Array<CopyProjectError>;
};

export type CopyProjectInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  isDemoProject?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options: OptionsInput;
  projectId: Scalars['uuid']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type CopyProjectResult = CopyProjectErrors | CopyProjectSuccess;

export type CopyProjectSuccess = {
  __typename?: 'CopyProjectSuccess';
  project_id: Scalars['uuid']['output'];
  steps: OptionsSuccess;
};

export type CopyTaskAttachmentsUploadError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type CopyTaskAttachmentsUploadErrors = {
  __typename?: 'CopyTaskAttachmentsUploadErrors';
  errors: Array<CopyTaskAttachmentsUploadError>;
};

export type CopyTaskAttachmentsUploadInput = {
  attachmentsId: Array<Scalars['uuid']['input']>;
  taskId: Scalars['uuid']['input'];
};

export type CopyTaskAttachmentsUploadResult = CopyTaskAttachmentsUploadErrors | CopyTaskAttachmentsUploadSuccess;

export type CreateAssignationsTask = {
  orgs: Array<Scalars['uuid']['input']>;
  teams: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type CreateChannelForApprovalError = FileApprovalNotExist | FileVersionDoesNotExists | ProjectDoesNotExist | TaskAccessDenied | TaskDoesNotExist;

export type CreateChannelForApprovalErrors = {
  __typename?: 'CreateChannelForApprovalErrors';
  errors: Array<CreateChannelForApprovalError>;
};

export type CreateChannelForApprovalInput = {
  clovis_approval_id: Scalars['uuid']['input'];
  clovis_entity_type: Scalars['String']['input'];
  clovis_file_version_id: Scalars['uuid']['input'];
  clovis_project_id: Scalars['uuid']['input'];
  clovis_visibility: Scalars['String']['input'];
};

export type CreateChannelForApprovalResult = CreateChannelForApprovalErrors | CreateChannelForApprovalSuccess;

export type CreateChannelForApprovalSuccess = {
  __typename?: 'CreateChannelForApprovalSuccess';
  approval_id: Scalars['uuid']['output'];
  channel_id: Scalars['String']['output'];
};

export type CreateChannelForProjectError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | UserDoesNotExist;

export type CreateChannelForProjectErrors = {
  __typename?: 'CreateChannelForProjectErrors';
  errors: Array<CreateChannelForProjectError>;
};

export type CreateChannelForProjectInput = {
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  visibility: Scalars['String']['input'];
};

export type CreateChannelForProjectResult = CreateChannelForProjectErrors | CreateChannelForProjectSuccess;

export type CreateChannelForProjectSuccess = {
  __typename?: 'CreateChannelForProjectSuccess';
  channel_id: Scalars['String']['output'];
  project_id: Scalars['uuid']['output'];
};

export type CreateChannelForTaskError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type CreateChannelForTaskErrors = {
  __typename?: 'CreateChannelForTaskErrors';
  errors: Array<CreateChannelForTaskError>;
};

export type CreateChannelForTaskInput = {
  taskId: Scalars['uuid']['input'];
};

export type CreateChannelForTaskResult = CreateChannelForTaskErrors | CreateChannelForTaskSuccess;

export type CreateChannelForTaskSuccess = {
  __typename?: 'CreateChannelForTaskSuccess';
  channel_id: Scalars['String']['output'];
  task_id: Scalars['uuid']['output'];
};

export type CreateEmptyFileError = FileFormatNotSupported | FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type CreateEmptyFileErrors = {
  __typename?: 'CreateEmptyFileErrors';
  errors: Array<CreateEmptyFileError>;
};

export type CreateEmptyFileInput = {
  folderId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
};

export type CreateEmptyFileResult = CreateEmptyFileErrors | CreateEmptyFileSuccess;

export type CreateEmptyFileSuccess = {
  __typename?: 'CreateEmptyFileSuccess';
  fileId: Scalars['uuid']['output'];
  fileVersionId: Scalars['uuid']['output'];
};

export type CreateFilterError = FilterMultipleVisibility | FilterNeedToBeVisible | InputValidationError | OrgAccessDenied | OrgDoesNotExist | ProjectAccessDenied | ProjectDoesNotExist;

export type CreateFilterErrors = {
  __typename?: 'CreateFilterErrors';
  errors: Array<CreateFilterError>;
};

export type CreateFilterInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  filterType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  visibilityOrgId?: InputMaybe<Scalars['uuid']['input']>;
  visibilityProjectId?: InputMaybe<Scalars['uuid']['input']>;
  visibilityTeamId?: InputMaybe<Scalars['uuid']['input']>;
  visibilityUserId?: InputMaybe<Scalars['uuid']['input']>;
};

export type CreateFilterResult = CreateFilterErrors | CreateFilterSuccess;

export type CreateFilterSuccess = {
  __typename?: 'CreateFilterSuccess';
  filter_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type CreateFolderError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type CreateFolderErrors = {
  __typename?: 'CreateFolderErrors';
  errors: Array<CreateFolderError>;
};

export type CreateFolderInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['uuid']['input'];
};

export type CreateFolderResult = CreateFolderErrors | CreateFolderSuccess;

export type CreateFolderSuccess = {
  __typename?: 'CreateFolderSuccess';
  folder_id: Scalars['uuid']['output'];
};

export type CreateMultipartUploadError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type CreateMultipartUploadErrors = {
  __typename?: 'CreateMultipartUploadErrors';
  errors: Array<CreateMultipartUploadError>;
};

export type CreateMultipartUploadInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['uuid']['input'];
};

export type CreateMultipartUploadResult = CreateMultipartUploadErrors | CreateMultipartUploadSuccess;

export type CreateMultipartUploadSuccess = {
  __typename?: 'CreateMultipartUploadSuccess';
  key: Scalars['uuid']['output'];
  uploadId: Scalars['String']['output'];
};

export type CreateOrgError = CreateOrgFailed | InputValidationError;

export type CreateOrgErrors = {
  __typename?: 'CreateOrgErrors';
  errors: Array<CreateOrgError>;
};

export type CreateOrgFailed = {
  __typename?: 'CreateOrgFailed';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CreateOrgInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  legal_number?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrgProjectSummaryError = CannotCreateOrgProjectSummaryOnOrgProject | InputValidationError | OrgAccessDenied | OrgDoesNotExist | OrgProjectSummaryAlreadyExist | ProjectAccessDenied | ProjectCategoryDoesNotExist | ProjectDoesNotExist;

export type CreateOrgProjectSummaryErrors = {
  __typename?: 'CreateOrgProjectSummaryErrors';
  errors: Array<CreateOrgProjectSummaryError>;
};

export type CreateOrgProjectSummaryInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  client_email?: InputMaybe<Scalars['String']['input']>;
  client_fullname?: InputMaybe<Scalars['String']['input']>;
  client_phone_number?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  orgId: Scalars['uuid']['input'];
  price_estimate?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['uuid']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type CreateOrgProjectSummaryResult = CreateOrgProjectSummaryErrors | CreateOrgProjectSummarySuccess;

export type CreateOrgProjectSummarySuccess = {
  __typename?: 'CreateOrgProjectSummarySuccess';
  org_project_summary_id: Scalars['uuid']['output'];
};

export type CreateOrgResult = CreateOrgErrors | CreateOrgSuccess;

export type CreateOrgSuccess = {
  __typename?: 'CreateOrgSuccess';
  org_id: Scalars['uuid']['output'];
};

export type CreatePermissionsTask = {
  orgs: Array<Scalars['uuid']['input']>;
  teams: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type CreateProjectCategoryError = InputValidationError | OrgDoesNotExist | ProjectCategoryAccessDenied;

export type CreateProjectCategoryErrors = {
  __typename?: 'CreateProjectCategoryErrors';
  errors: Array<CreateProjectCategoryError>;
};

export type CreateProjectCategoryInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orgId: Scalars['uuid']['input'];
};

export type CreateProjectCategoryResult = CreateProjectCategoryErrors | CreateProjectCategorySuccess;

export type CreateProjectCategorySuccess = {
  __typename?: 'CreateProjectCategorySuccess';
  project_category_id: Scalars['uuid']['output'];
};

export type CreateProjectDirectMessageError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | UserDoesNotExist;

export type CreateProjectDirectMessageErrors = {
  __typename?: 'CreateProjectDirectMessageErrors';
  errors: Array<CreateProjectDirectMessageError>;
};

export type CreateProjectDirectMessageInput = {
  members: Array<Scalars['String']['input']>;
  projectId: Scalars['uuid']['input'];
};

export type CreateProjectDirectMessageResult = CreateProjectDirectMessageErrors | CreateProjectDirectMessageSuccess;

export type CreateProjectDirectMessageSuccess = {
  __typename?: 'CreateProjectDirectMessageSuccess';
  channel_id: Scalars['String']['output'];
};

export type CreateProjectError = InputValidationError | OrgRequired;

export type CreateProjectErrors = {
  __typename?: 'CreateProjectErrors';
  errors: Array<CreateProjectError>;
};

export type CreateProjectGroupError = InputValidationError | OrgDoesNotExist | ProjectGroupAccessDenied;

export type CreateProjectGroupErrors = {
  __typename?: 'CreateProjectGroupErrors';
  errors: Array<CreateProjectGroupError>;
};

export type CreateProjectGroupInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orgId: Scalars['uuid']['input'];
};

export type CreateProjectGroupResult = CreateProjectGroupErrors | CreateProjectGroupSuccess;

export type CreateProjectGroupSuccess = {
  __typename?: 'CreateProjectGroupSuccess';
  project_group_id: Scalars['uuid']['output'];
};

export type CreateProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_project_template?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProjectLabelError = InputValidationError | ProjectDoesNotExist | ProjectLabelAccessDenied;

export type CreateProjectLabelErrors = {
  __typename?: 'CreateProjectLabelErrors';
  errors: Array<CreateProjectLabelError>;
};

export type CreateProjectLabelInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
};

export type CreateProjectLabelResult = CreateProjectLabelErrors | CreateProjectLabelSuccess;

export type CreateProjectLabelSuccess = {
  __typename?: 'CreateProjectLabelSuccess';
  project_label_id: Scalars['uuid']['output'];
};

export type CreateProjectResult = CreateProjectErrors | CreateProjectSuccess;

export type CreateProjectSuccess = {
  __typename?: 'CreateProjectSuccess';
  project_id: Scalars['uuid']['output'];
};

export type CreateReportBlocksError = InputValidationError | OrgAccessDenied | OrgDoesNotExist | ProjectAccessDenied | ProjectDoesNotExist | ReportBlockMultipleVisibility | ReportBlockNeedToBeVisible;

export type CreateReportBlocksErrors = {
  __typename?: 'CreateReportBlocksErrors';
  errors: Array<CreateReportBlocksError>;
};

export type CreateReportBlocksInput = {
  blockContent: Scalars['String']['input'];
  blockType: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  visibilityOrgId?: InputMaybe<Scalars['String']['input']>;
  visibilityProjectId?: InputMaybe<Scalars['String']['input']>;
  visibilityTeamId?: InputMaybe<Scalars['String']['input']>;
  visibilityUserId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportBlocksResult = CreateReportBlocksErrors | CreateReportBlocksSuccess;

export type CreateReportBlocksSuccess = {
  __typename?: 'CreateReportBlocksSuccess';
  name: Scalars['String']['output'];
  report_block_id: Scalars['uuid']['output'];
};

export type CreateSubtaskError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type CreateSubtaskErrors = {
  __typename?: 'CreateSubtaskErrors';
  errors: Array<CreateSubtaskError>;
};

export type CreateSubtaskInput = {
  closed: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  taskId: Scalars['uuid']['input'];
};

export type CreateSubtaskResult = CreateSubtaskErrors | CreateSubtaskSuccess;

export type CreateSubtaskSuccess = {
  __typename?: 'CreateSubtaskSuccess';
  subtask_id: Scalars['uuid']['output'];
  task_id: Scalars['uuid']['output'];
};

export type CreateTaskAttachmentMultipartUploadError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type CreateTaskAttachmentMultipartUploadErrors = {
  __typename?: 'CreateTaskAttachmentMultipartUploadErrors';
  errors: Array<CreateTaskAttachmentMultipartUploadError>;
};

export type CreateTaskAttachmentMultipartUploadInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taskId: Scalars['uuid']['input'];
};

export type CreateTaskAttachmentMultipartUploadResult = CreateTaskAttachmentMultipartUploadErrors | CreateTaskAttachmentMultipartUploadSuccess;

export type CreateTaskAttachmentMultipartUploadSuccess = {
  __typename?: 'CreateTaskAttachmentMultipartUploadSuccess';
  key: Scalars['uuid']['output'];
  uploadId: Scalars['String']['output'];
};

export type CreateTaskDependencies = {
  ancestors?: InputMaybe<Array<InputMaybe<DependenciesInformation>>>;
  predecessors?: InputMaybe<Array<InputMaybe<DependenciesInformation>>>;
};

export type CreateTaskError = InputValidationError | ProjectDoesNotExist | TaskAccessDenied | TaskAssignationsNotAllowed;

export type CreateTaskErrors = {
  __typename?: 'CreateTaskErrors';
  errors: Array<CreateTaskError>;
};

export type CreateTaskFileVersions = {
  file_version_id: Scalars['uuid']['input'];
  location?: InputMaybe<CreateTaskFileVersionsLocation>;
};

export type CreateTaskFileVersionsLocation = {
  page_number: Scalars['Int']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateTaskInput = {
  assignations?: InputMaybe<CreateAssignationsTask>;
  dependencies?: InputMaybe<CreateTaskDependencies>;
  description: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  file_versions?: InputMaybe<Array<InputMaybe<CreateTaskFileVersions>>>;
  hours_done?: InputMaybe<Scalars['Float']['input']>;
  hours_expected?: InputMaybe<Scalars['Float']['input']>;
  label_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  location?: InputMaybe<CreateTaskLocation>;
  permissions?: InputMaybe<CreatePermissionsTask>;
  project_id: Scalars['uuid']['input'];
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  subtasks?: InputMaybe<Array<CreateTaskSubtasks>>;
  task_number?: InputMaybe<Scalars['Int']['input']>;
  temporary_task_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTaskLocation = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type CreateTaskResult = CreateTaskErrors | CreateTaskSuccess;

export type CreateTaskSubtasks = {
  closed: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTaskSuccess = {
  __typename?: 'CreateTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type CreateTeamError = InputValidationError | ProjectDoesNotExist | TeamAccessDenied | TeamNameAlreadyExist;

export type CreateTeamErrors = {
  __typename?: 'CreateTeamErrors';
  errors: Array<CreateTeamError>;
};

export type CreateTeamInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
};

export type CreateTeamResult = CreateTeamErrors | CreateTeamSuccess;

export type CreateTeamSuccess = {
  __typename?: 'CreateTeamSuccess';
  project_id: Scalars['uuid']['output'];
  team_id: Scalars['uuid']['output'];
};

export type DeleteFileError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type DeleteFileErrors = {
  __typename?: 'DeleteFileErrors';
  errors: Array<DeleteFileError>;
};

export type DeleteFileInput = {
  fileId: Scalars['uuid']['input'];
};

export type DeleteFileResult = DeleteFileErrors | DeleteFileSuccess;

export type DeleteFileSuccess = {
  __typename?: 'DeleteFileSuccess';
  file_id: Scalars['uuid']['output'];
};

export type DeleteFilterError = FilterDoesNotExist | InputValidationError;

export type DeleteFilterErrors = {
  __typename?: 'DeleteFilterErrors';
  errors: Array<DeleteFilterError>;
};

export type DeleteFilterInput = {
  filterId: Scalars['uuid']['input'];
};

export type DeleteFilterResult = DeleteFilterErrors | DeleteFilterSuccess;

export type DeleteFilterSuccess = {
  __typename?: 'DeleteFilterSuccess';
  filter_id?: Maybe<Scalars['uuid']['output']>;
};

export type DeleteFirebaseTokenError = InputValidationError;

export type DeleteFirebaseTokenErrors = {
  __typename?: 'DeleteFirebaseTokenErrors';
  errors: Array<DeleteFirebaseTokenError>;
};

export type DeleteFirebaseTokenInput = {
  token: Scalars['String']['input'];
};

export type DeleteFirebaseTokenResult = DeleteFirebaseTokenErrors | DeleteFirebaseTokenSuccess;

export type DeleteFirebaseTokenSuccess = {
  __typename?: 'DeleteFirebaseTokenSuccess';
  user_id: Scalars['uuid']['output'];
};

export type DeleteFolderError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type DeleteFolderErrors = {
  __typename?: 'DeleteFolderErrors';
  errors: Array<DeleteFolderError>;
};

export type DeleteFolderInput = {
  folderId: Scalars['uuid']['input'];
};

export type DeleteFolderResult = DeleteFolderErrors | DeleteFolderSuccess;

export type DeleteFolderSuccess = {
  __typename?: 'DeleteFolderSuccess';
  folder_id: Scalars['uuid']['output'];
};

export type DeleteProjectCategoryError = InputValidationError | ProjectCategoryAccessDenied | ProjectCategoryDoesNotExist;

export type DeleteProjectCategoryErrors = {
  __typename?: 'DeleteProjectCategoryErrors';
  errors: Array<DeleteProjectCategoryError>;
};

export type DeleteProjectCategoryInput = {
  projectCategoryId: Scalars['uuid']['input'];
};

export type DeleteProjectCategoryResult = DeleteProjectCategoryErrors | DeleteProjectCategorySuccess;

export type DeleteProjectCategorySuccess = {
  __typename?: 'DeleteProjectCategorySuccess';
  project_category_id: Scalars['uuid']['output'];
};

export type DeleteProjectError = CannotDeleteOrgProject | CannotDeleteProjectSharedWithMultipleOrgs | InputValidationError | ProjectAccessDenied | ProjectDoesNotExist;

export type DeleteProjectErrors = {
  __typename?: 'DeleteProjectErrors';
  errors: Array<DeleteProjectError>;
};

export type DeleteProjectGroupError = InputValidationError | ProjectGroupAccessDenied | ProjectGroupDoesNotExist;

export type DeleteProjectGroupErrors = {
  __typename?: 'DeleteProjectGroupErrors';
  errors: Array<DeleteProjectGroupError>;
};

export type DeleteProjectGroupInput = {
  projectGroupId: Scalars['uuid']['input'];
};

export type DeleteProjectGroupResult = DeleteProjectGroupErrors | DeleteProjectGroupSuccess;

export type DeleteProjectGroupSuccess = {
  __typename?: 'DeleteProjectGroupSuccess';
  project_group_id: Scalars['uuid']['output'];
};

export type DeleteProjectInput = {
  projectId: Scalars['uuid']['input'];
};

export type DeleteProjectLabelError = InputValidationError | ProjectLabelAccessDenied | ProjectLabelDoesNotExist;

export type DeleteProjectLabelErrors = {
  __typename?: 'DeleteProjectLabelErrors';
  errors: Array<DeleteProjectLabelError>;
};

export type DeleteProjectLabelInput = {
  projectLabelId: Scalars['uuid']['input'];
};

export type DeleteProjectLabelResult = DeleteProjectLabelErrors | DeleteProjectLabelSuccess;

export type DeleteProjectLabelSuccess = {
  __typename?: 'DeleteProjectLabelSuccess';
  project_label_id: Scalars['uuid']['output'];
};

export type DeleteProjectResult = DeleteProjectErrors | DeleteProjectSuccess;

export type DeleteProjectSuccess = {
  __typename?: 'DeleteProjectSuccess';
  project_id: Scalars['uuid']['output'];
};

export type DeleteReportBlockError = InputValidationError | ReportBlockDoesNotExist;

export type DeleteReportBlockErrors = {
  __typename?: 'DeleteReportBlockErrors';
  errors: Array<DeleteReportBlockError>;
};

export type DeleteReportBlockInput = {
  reportBlockId: Scalars['uuid']['input'];
};

export type DeleteReportBlockResult = DeleteReportBlockErrors | DeleteReportBlockSuccess;

export type DeleteReportBlockSuccess = {
  __typename?: 'DeleteReportBlockSuccess';
  reportBlockId?: Maybe<Scalars['uuid']['output']>;
};

export type DeleteSubtaskError = InputValidationError | SubtaskAccessDenied | SubtaskDoesNotExist;

export type DeleteSubtaskErrors = {
  __typename?: 'DeleteSubtaskErrors';
  errors: Array<DeleteSubtaskError>;
};

export type DeleteSubtaskInput = {
  subtaskId: Scalars['uuid']['input'];
};

export type DeleteSubtaskResult = DeleteSubtaskErrors | DeleteSubtaskSuccess;

export type DeleteSubtaskSuccess = {
  __typename?: 'DeleteSubtaskSuccess';
  subtask_id: Scalars['uuid']['output'];
  task_id: Scalars['uuid']['output'];
};

export type DeleteTaskAttachmentError = InputValidationError | TaskAttachmentAccessDenied | TaskAttachmentDoesNotExist;

export type DeleteTaskAttachmentErrors = {
  __typename?: 'DeleteTaskAttachmentErrors';
  errors: Array<DeleteTaskAttachmentError>;
};

export type DeleteTaskAttachmentInput = {
  taskAttachmentId: Scalars['uuid']['input'];
};

export type DeleteTaskAttachmentResult = DeleteTaskAttachmentErrors | DeleteTaskAttachmentSuccess;

export type DeleteTaskAttachmentSuccess = {
  __typename?: 'DeleteTaskAttachmentSuccess';
  task_id: Scalars['uuid']['output'];
};

export type DeleteTaskDependenciesError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type DeleteTaskDependenciesErrors = {
  __typename?: 'DeleteTaskDependenciesErrors';
  errors: Array<DeleteTaskDependenciesError>;
};

export type DeleteTaskDependenciesInput = {
  taskIds: Array<Scalars['uuid']['input']>;
};

export type DeleteTaskDependenciesResult = DeleteTaskDependenciesErrors | DeleteTaskDependenciesSuccess;

export type DeleteTaskDependenciesSuccess = {
  __typename?: 'DeleteTaskDependenciesSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type DeleteTaskError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type DeleteTaskErrors = {
  __typename?: 'DeleteTaskErrors';
  errors: Array<DeleteTaskError>;
};

export type DeleteTaskInput = {
  id: Scalars['uuid']['input'];
};

export type DeleteTaskResult = DeleteTaskErrors | DeleteTaskSuccess;

export type DeleteTaskSuccess = {
  __typename?: 'DeleteTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type DeleteTasksError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type DeleteTasksErrors = {
  __typename?: 'DeleteTasksErrors';
  errors: Array<DeleteTasksError>;
};

export type DeleteTasksInput = {
  taskIds: Array<Scalars['uuid']['input']>;
  toDelete: Scalars['Boolean']['input'];
};

export type DeleteTasksResult = DeleteTasksErrors | DeleteTasksSuccess;

export type DeleteTasksSuccess = {
  __typename?: 'DeleteTasksSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type DeleteTeamError = InputValidationError | TeamAccessDenied | TeamDoesNotExist;

export type DeleteTeamErrors = {
  __typename?: 'DeleteTeamErrors';
  errors: Array<DeleteTeamError>;
};

export type DeleteTeamInput = {
  teamId: Scalars['uuid']['input'];
};

export type DeleteTeamResult = DeleteTeamErrors | DeleteTeamSuccess;

export type DeleteTeamSuccess = {
  __typename?: 'DeleteTeamSuccess';
  project_id: Scalars['uuid']['output'];
  team_id: Scalars['uuid']['output'];
};

export type DependenciesInformation = {
  from_id?: InputMaybe<Scalars['String']['input']>;
  from_side: Scalars['String']['input'];
  taskIds: Array<InputMaybe<Scalars['uuid']['input']>>;
  to_id?: InputMaybe<Scalars['String']['input']>;
  to_side: Scalars['String']['input'];
};

export type DependenciesUpdateInformation = {
  from_id: Scalars['String']['input'];
  from_side: Scalars['String']['input'];
  taskIds: Array<Scalars['uuid']['input']>;
  to_id: Scalars['String']['input'];
  to_side: Scalars['String']['input'];
};

export type DownloadFolderError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type DownloadFolderErrors = {
  __typename?: 'DownloadFolderErrors';
  errors: Array<DownloadFolderError>;
};

export type DownloadFolderInput = {
  folderId: Scalars['uuid']['input'];
};

export type DownloadFolderResult = DownloadFolderErrors | DownloadFolderSuccess;

export type DownloadFolderSuccess = {
  __typename?: 'DownloadFolderSuccess';
  folder_id: Scalars['uuid']['output'];
};

export type DuplicateApprovalOnFileVersion = {
  __typename?: 'DuplicateApprovalOnFileVersion';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DuplicateFilesError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type DuplicateFilesErrors = {
  __typename?: 'DuplicateFilesErrors';
  errors: Array<DuplicateFilesError>;
};

export type DuplicateFilesInput = {
  fileIds: Array<Scalars['uuid']['input']>;
};

export type DuplicateFilesResult = DuplicateFilesErrors | DuplicateFilesSuccess;

export type DuplicateFilesSuccess = {
  __typename?: 'DuplicateFilesSuccess';
  file_ids: Array<Scalars['uuid']['output']>;
};

export type EditTaskDependencies = {
  ancestors?: InputMaybe<Array<InputMaybe<DependenciesUpdateInformation>>>;
  predecessors?: InputMaybe<Array<InputMaybe<DependenciesUpdateInformation>>>;
};

export type EmailAlreadyUsedByAnotherUser = {
  __typename?: 'EmailAlreadyUsedByAnotherUser';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ErrorReportType = {
  __typename?: 'ErrorReportType';
  email: Scalars['String']['output'];
  org_id?: Maybe<Scalars['String']['output']>;
  org_name?: Maybe<Scalars['String']['output']>;
  project_id: Scalars['String']['output'];
  project_name: Scalars['String']['output'];
  user_already_org_project_member?: Maybe<Scalars['Boolean']['output']>;
  user_already_project_member?: Maybe<Scalars['Boolean']['output']>;
};

export type FileAccessDenied = {
  __typename?: 'FileAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FileApprovalNotExist = {
  __typename?: 'FileApprovalNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FileDoesNotExists = {
  __typename?: 'FileDoesNotExists';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FileFormatNotSupported = {
  __typename?: 'FileFormatNotSupported';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FileMultipleApprovalIds = {
  __typename?: 'FileMultipleApprovalIds';
  file_approval_id: Scalars['uuid']['output'];
  file_version_id: Scalars['uuid']['output'];
};

export type FileNotInApprovalMode = {
  __typename?: 'FileNotInApprovalMode';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FileTooLarge = {
  __typename?: 'FileTooLarge';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FileVersionDoesNotExists = {
  __typename?: 'FileVersionDoesNotExists';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FilterCannotBeUpdate = {
  __typename?: 'FilterCannotBeUpdate';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FilterDoesNotExist = {
  __typename?: 'FilterDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FilterMultipleVisibility = {
  __typename?: 'FilterMultipleVisibility';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FilterNeedToBeVisible = {
  __typename?: 'FilterNeedToBeVisible';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FilterUserDefaultError = FilterDoesNotExist | InputValidationError;

export type FilterUserDefaultErrors = {
  __typename?: 'FilterUserDefaultErrors';
  errors: Array<FilterUserDefaultError>;
};

export type FilterUserDefaultInput = {
  filterId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUserDefaultResult = FilterUserDefaultErrors | FilterUserDefaultSuccess;

export type FilterUserDefaultSuccess = {
  __typename?: 'FilterUserDefaultSuccess';
  defaultFilterId: Scalars['uuid']['output'];
};

export type FinalizeUploadedChannelAssetError = CopyFromTemporaryBucketFailed | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedChannelAssetErrors = {
  __typename?: 'FinalizeUploadedChannelAssetErrors';
  errors: Array<FinalizeUploadedChannelAssetError>;
};

export type FinalizeUploadedChannelAssetInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedChannelAssetResult = FinalizeUploadedChannelAssetErrors | FinalizeUploadedChannelAssetSuccess;

export type FinalizeUploadedChannelAssetSuccess = {
  __typename?: 'FinalizeUploadedChannelAssetSuccess';
  channel_id: Scalars['String']['output'];
  public_url: Scalars['String']['output'];
};

export type FinalizeUploadedFileApprovalsAttachmentError = CannotRemoveApprovalOnFile | DuplicateApprovalOnFileVersion | FileApprovalNotExist | FileNotInApprovalMode | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload | NotFoundFilesInApprovalMode | UserNotAssignedToFile;

export type FinalizeUploadedFileApprovalsAttachmentErrors = {
  __typename?: 'FinalizeUploadedFileApprovalsAttachmentErrors';
  errors: Array<FinalizeUploadedFileApprovalsAttachmentError>;
};

export type FinalizeUploadedFileApprovalsAttachmentInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedFileApprovalsAttachmentResult = FinalizeUploadedFileApprovalsAttachmentErrors | FinalizeUploadedFileApprovalsAttachmentSuccess;

export type FinalizeUploadedFileApprovalsAttachmentSuccess = {
  __typename?: 'FinalizeUploadedFileApprovalsAttachmentSuccess';
  file_approval_attachment_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedFileError = CopyFromTemporaryBucketFailed | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedFileErrors = {
  __typename?: 'FinalizeUploadedFileErrors';
  errors: Array<FinalizeUploadedFileError>;
};

export type FinalizeUploadedFileInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedFileResult = FinalizeUploadedFileErrors | FinalizeUploadedFileSuccess;

export type FinalizeUploadedFileStructureError = FileTooLarge | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedFileStructureErrors = {
  __typename?: 'FinalizeUploadedFileStructureErrors';
  errors: Array<FinalizeUploadedFileStructureError>;
};

export type FinalizeUploadedFileStructureInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedFileStructureResult = FinalizeUploadedFileStructureErrors | FinalizeUploadedFileStructureSuccess;

export type FinalizeUploadedFileStructureSuccess = {
  __typename?: 'FinalizeUploadedFileStructureSuccess';
  parent_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedFileSuccess = {
  __typename?: 'FinalizeUploadedFileSuccess';
  file_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedFileVersionError = CopyFromTemporaryBucketFailed | FileDoesNotExists | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedFileVersionErrors = {
  __typename?: 'FinalizeUploadedFileVersionErrors';
  errors: Array<FinalizeUploadedFileVersionError>;
};

export type FinalizeUploadedFileVersionInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedFileVersionResult = FinalizeUploadedFileVersionErrors | FinalizeUploadedFileVersionSuccess;

export type FinalizeUploadedFileVersionSuccess = {
  __typename?: 'FinalizeUploadedFileVersionSuccess';
  file_version_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedOrgAvatarError = CopyFromTemporaryBucketFailed | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedOrgAvatarErrors = {
  __typename?: 'FinalizeUploadedOrgAvatarErrors';
  errors: Array<FinalizeUploadedOrgAvatarError>;
};

export type FinalizeUploadedOrgAvatarInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedOrgAvatarResult = FinalizeUploadedOrgAvatarErrors | FinalizeUploadedOrgAvatarSuccess;

export type FinalizeUploadedOrgAvatarSuccess = {
  __typename?: 'FinalizeUploadedOrgAvatarSuccess';
  org_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedOrgBackgroundError = CopyFromTemporaryBucketFailed | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedOrgBackgroundErrors = {
  __typename?: 'FinalizeUploadedOrgBackgroundErrors';
  errors: Array<FinalizeUploadedOrgBackgroundError>;
};

export type FinalizeUploadedOrgBackgroundInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedOrgBackgroundResult = FinalizeUploadedOrgBackgroundErrors | FinalizeUploadedOrgBackgroundSuccess;

export type FinalizeUploadedOrgBackgroundSuccess = {
  __typename?: 'FinalizeUploadedOrgBackgroundSuccess';
  org_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedProjectAvatarError = InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedProjectAvatarErrors = {
  __typename?: 'FinalizeUploadedProjectAvatarErrors';
  errors: Array<FinalizeUploadedProjectAvatarError>;
};

export type FinalizeUploadedProjectAvatarInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedProjectAvatarResult = FinalizeUploadedProjectAvatarErrors | FinalizeUploadedProjectAvatarSuccess;

export type FinalizeUploadedProjectAvatarSuccess = {
  __typename?: 'FinalizeUploadedProjectAvatarSuccess';
  project_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedProjectBackgroundError = InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedProjectBackgroundErrors = {
  __typename?: 'FinalizeUploadedProjectBackgroundErrors';
  errors: Array<FinalizeUploadedProjectBackgroundError>;
};

export type FinalizeUploadedProjectBackgroundInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedProjectBackgroundResult = FinalizeUploadedProjectBackgroundErrors | FinalizeUploadedProjectBackgroundSuccess;

export type FinalizeUploadedProjectBackgroundSuccess = {
  __typename?: 'FinalizeUploadedProjectBackgroundSuccess';
  project_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedProjectBannerError = InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedProjectBannerErrors = {
  __typename?: 'FinalizeUploadedProjectBannerErrors';
  errors: Array<FinalizeUploadedProjectBannerError>;
};

export type FinalizeUploadedProjectBannerInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedProjectBannerResult = FinalizeUploadedProjectBannerErrors | FinalizeUploadedProjectBannerSuccess;

export type FinalizeUploadedProjectBannerSuccess = {
  __typename?: 'FinalizeUploadedProjectBannerSuccess';
  project_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedProjectGroupAvatarError = InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedProjectGroupAvatarErrors = {
  __typename?: 'FinalizeUploadedProjectGroupAvatarErrors';
  errors: Array<FinalizeUploadedProjectGroupAvatarError>;
};

export type FinalizeUploadedProjectGroupAvatarInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedProjectGroupAvatarResult = FinalizeUploadedProjectGroupAvatarErrors | FinalizeUploadedProjectGroupAvatarSuccess;

export type FinalizeUploadedProjectGroupAvatarSuccess = {
  __typename?: 'FinalizeUploadedProjectGroupAvatarSuccess';
  project_group_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedProjectSpreadsheetError = FileTooLarge | InputValidationError | InvalidContentType | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedProjectSpreadsheetErrors = {
  __typename?: 'FinalizeUploadedProjectSpreadsheetErrors';
  errors: Array<FinalizeUploadedProjectSpreadsheetError>;
};

export type FinalizeUploadedProjectSpreadsheetInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedProjectSpreadsheetResult = FinalizeUploadedProjectSpreadsheetErrors | FinalizeUploadedProjectSpreadsheetSuccess;

export type FinalizeUploadedProjectSpreadsheetSuccess = {
  __typename?: 'FinalizeUploadedProjectSpreadsheetSuccess';
  org_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedTaskAttachmentAnnotationError = CopyFromTemporaryBucketFailed | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload | TaskAttachmentDoesNotExist;

export type FinalizeUploadedTaskAttachmentAnnotationErrors = {
  __typename?: 'FinalizeUploadedTaskAttachmentAnnotationErrors';
  errors: Array<FinalizeUploadedTaskAttachmentAnnotationError>;
};

export type FinalizeUploadedTaskAttachmentAnnotationInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedTaskAttachmentAnnotationResult = FinalizeUploadedTaskAttachmentAnnotationErrors | FinalizeUploadedTaskAttachmentAnnotationSuccess;

export type FinalizeUploadedTaskAttachmentAnnotationSuccess = {
  __typename?: 'FinalizeUploadedTaskAttachmentAnnotationSuccess';
  task_attachment_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedTaskAttachmentError = CopyFromTemporaryBucketFailed | InputValidationError | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedTaskAttachmentErrors = {
  __typename?: 'FinalizeUploadedTaskAttachmentErrors';
  errors: Array<FinalizeUploadedTaskAttachmentError>;
};

export type FinalizeUploadedTaskAttachmentInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedTaskAttachmentResult = FinalizeUploadedTaskAttachmentErrors | FinalizeUploadedTaskAttachmentSuccess;

export type FinalizeUploadedTaskAttachmentSuccess = {
  __typename?: 'FinalizeUploadedTaskAttachmentSuccess';
  task_attachment_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedTaskSpreadsheetError = FileTooLarge | InputValidationError | InvalidContentType | KeyDoesNotExists | MissingMetadata | NotAuthorOfTheUpload;

export type FinalizeUploadedTaskSpreadsheetErrors = {
  __typename?: 'FinalizeUploadedTaskSpreadsheetErrors';
  errors: Array<FinalizeUploadedTaskSpreadsheetError>;
};

export type FinalizeUploadedTaskSpreadsheetInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedTaskSpreadsheetResult = FinalizeUploadedTaskSpreadsheetErrors | FinalizeUploadedTaskSpreadsheetSuccess;

export type FinalizeUploadedTaskSpreadsheetSuccess = {
  __typename?: 'FinalizeUploadedTaskSpreadsheetSuccess';
  project_id: Scalars['uuid']['output'];
};

export type FinalizeUploadedUserAvatarError = CopyFromTemporaryBucketFailed | InputValidationError | KeyDoesNotExists | MissingMetadata;

export type FinalizeUploadedUserAvatarErrors = {
  __typename?: 'FinalizeUploadedUserAvatarErrors';
  errors: Array<FinalizeUploadedUserAvatarError>;
};

export type FinalizeUploadedUserAvatarInput = {
  key: Scalars['uuid']['input'];
};

export type FinalizeUploadedUserAvatarResult = FinalizeUploadedUserAvatarErrors | FinalizeUploadedUserAvatarSuccess;

export type FinalizeUploadedUserAvatarSuccess = {
  __typename?: 'FinalizeUploadedUserAvatarSuccess';
  user_id: Scalars['uuid']['output'];
};

export type FolderAccessDenied = {
  __typename?: 'FolderAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FolderCannotBeMoveInAnotherProject = {
  __typename?: 'FolderCannotBeMoveInAnotherProject';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FolderDoesNotExists = {
  __typename?: 'FolderDoesNotExists';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GenerateApiTokenError = GenerateApiTokenPermissionDenied | InputValidationError | OrgDoesNotExist;

export type GenerateApiTokenErrors = {
  __typename?: 'GenerateApiTokenErrors';
  errors: Array<GenerateApiTokenError>;
};

export type GenerateApiTokenInput = {
  id: Scalars['ID']['input'];
};

export type GenerateApiTokenPermissionDenied = {
  __typename?: 'GenerateApiTokenPermissionDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GenerateApiTokenResult = GenerateApiTokenErrors | GenerateApiTokenSuccess;

export type GenerateApiTokenSuccess = {
  __typename?: 'GenerateApiTokenSuccess';
  token: Scalars['ID']['output'];
};

export type GetAlgoliaUserApiKeySuccess = {
  __typename?: 'GetAlgoliaUserApiKeySuccess';
  exp: Scalars['timestamptz']['output'];
  key: Scalars['String']['output'];
};

export type GetOrgProejectTemplate = {
  __typename?: 'GetOrgProejectTemplate';
  templates?: Maybe<Array<OrgProjectTemplate>>;
};

export type GetStreamChatUserTokenSuccess = {
  __typename?: 'GetStreamChatUserTokenSuccess';
  token: Scalars['String']['output'];
};

export type InputValidationError = {
  __typename?: 'InputValidationError';
  fieldErrors: Scalars['json']['output'];
  formErrors: Array<Maybe<Scalars['String']['output']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvalidContentType = {
  __typename?: 'InvalidContentType';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JoinOrgUserProjectError = CannotInviteOnProject | InputValidationError | JoinOrgUserProjectPermissionDenied;

export type JoinOrgUserProjectErrors = {
  __typename?: 'JoinOrgUserProjectErrors';
  errors: Array<JoinOrgUserProjectError>;
};

export type JoinOrgUserProjectInput = {
  project_id: Scalars['uuid']['input'];
};

export type JoinOrgUserProjectPermissionDenied = {
  __typename?: 'JoinOrgUserProjectPermissionDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JoinOrgUserProjectResult = JoinOrgUserProjectErrors | JoinOrgUserProjectSuccess;

export type JoinOrgUserProjectSuccess = {
  __typename?: 'JoinOrgUserProjectSuccess';
  projectId: Scalars['uuid']['output'];
};

export type KeyDoesNotExists = {
  __typename?: 'KeyDoesNotExists';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ListMultipartUploadError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type ListMultipartUploadErrors = {
  __typename?: 'ListMultipartUploadErrors';
  errors: Array<ListMultipartUploadError>;
};

export type ListMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  parentId: Scalars['uuid']['input'];
  uploadId: Scalars['String']['input'];
};

export type ListMultipartUploadResult = ListMultipartUploadErrors | ListMultipartUploadSuccess;

export type ListMultipartUploadSuccess = {
  __typename?: 'ListMultipartUploadSuccess';
  parts: Array<AwsS3Part>;
};

export type ListTaskAttachmentMultipartUploadError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type ListTaskAttachmentMultipartUploadErrors = {
  __typename?: 'ListTaskAttachmentMultipartUploadErrors';
  errors: Array<ListTaskAttachmentMultipartUploadError>;
};

export type ListTaskAttachmentMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  taskId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type ListTaskAttachmentMultipartUploadResult = ListTaskAttachmentMultipartUploadErrors | ListTaskAttachmentMultipartUploadSuccess;

export type ListTaskAttachmentMultipartUploadSuccess = {
  __typename?: 'ListTaskAttachmentMultipartUploadSuccess';
  parts: Array<AwsS3PartTaskAttachment>;
};

export type MigrateAvatarPublicUrlError = MigrateAvatarPublicUrlFailed;

export type MigrateAvatarPublicUrlErrors = {
  __typename?: 'MigrateAvatarPublicUrlErrors';
  errors: Array<MigrateAvatarPublicUrlError>;
};

export type MigrateAvatarPublicUrlFailed = {
  __typename?: 'MigrateAvatarPublicUrlFailed';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MigrateAvatarPublicUrlResult = MigrateAvatarPublicUrlErrors | MigrateAvatarPublicUrlSuccess;

export type MigrateAvatarPublicUrlSuccess = {
  __typename?: 'MigrateAvatarPublicUrlSuccess';
  ok: Scalars['Boolean']['output'];
};

export type MissingMetadata = {
  __typename?: 'MissingMetadata';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MoveFilesError = FileAccessDenied | FileDoesNotExists | InputValidationError | PermissionsConflictError;

export type MoveFilesErrors = {
  __typename?: 'MoveFilesErrors';
  errors: Array<MoveFilesError>;
};

export type MoveFilesInput = {
  fileIds: Array<Scalars['uuid']['input']>;
  newParentId: Scalars['uuid']['input'];
};

export type MoveFilesResult = MoveFilesErrors | MoveFilesSuccess;

export type MoveFilesSuccess = {
  __typename?: 'MoveFilesSuccess';
  file_ids: Array<Scalars['uuid']['output']>;
};

export type MoveFoldersError = FolderAccessDenied | FolderCannotBeMoveInAnotherProject | FolderDoesNotExists | InputValidationError | PermissionsConflictError;

export type MoveFoldersErrors = {
  __typename?: 'MoveFoldersErrors';
  errors: Array<MoveFoldersError>;
};

export type MoveFoldersInput = {
  folderIds: Array<Scalars['uuid']['input']>;
  newParentId: Scalars['uuid']['input'];
};

export type MoveFoldersResult = MoveFoldersErrors | MoveFoldersSuccess;

export type MoveFoldersSuccess = {
  __typename?: 'MoveFoldersSuccess';
  folder_ids: Array<Scalars['uuid']['output']>;
};

export type NotAuthorOfTheUpload = {
  __typename?: 'NotAuthorOfTheUpload';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotFoundFiles = {
  __typename?: 'NotFoundFiles';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotFoundFilesInApprovalMode = {
  __typename?: 'NotFoundFilesInApprovalMode';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotMemberOfThisChannel = {
  __typename?: 'NotMemberOfThisChannel';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotificationDoesNotExists = {
  __typename?: 'NotificationDoesNotExists';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgAccessDenied = {
  __typename?: 'OrgAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgDoesNotExist = {
  __typename?: 'OrgDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgOrProjectUserDoesNotExist = {
  __typename?: 'OrgOrProjectUserDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgProfileAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type OrgProjectSummaryAlreadyExist = {
  __typename?: 'OrgProjectSummaryAlreadyExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgProjectSummaryDoesNotExist = {
  __typename?: 'OrgProjectSummaryDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgProjectTemplate = {
  __typename?: 'OrgProjectTemplate';
  avatar?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type OrgRequired = {
  __typename?: 'OrgRequired';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgSettings = {
  showMenuByGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionsConflictError = {
  __typename?: 'PermissionsConflictError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PrepareChannelAssetForUploadError = ChannelDoesNotExist | InputValidationError | NotMemberOfThisChannel;

export type PrepareChannelAssetForUploadErrors = {
  __typename?: 'PrepareChannelAssetForUploadErrors';
  errors: Array<PrepareChannelAssetForUploadError>;
};

export type PrepareChannelAssetForUploadInput = {
  channelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PrepareChannelAssetForUploadResult = PrepareChannelAssetForUploadErrors | PrepareChannelAssetForUploadSuccess;

export type PrepareChannelAssetForUploadSuccess = {
  __typename?: 'PrepareChannelAssetForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareFileApprovalsAttachmentForUploadError = FileAccessDenied | FileApprovalNotExist | InputValidationError;

export type PrepareFileApprovalsAttachmentForUploadErrors = {
  __typename?: 'PrepareFileApprovalsAttachmentForUploadErrors';
  errors: Array<PrepareFileApprovalsAttachmentForUploadError>;
};

export type PrepareFileApprovalsAttachmentForUploadInput = {
  fileApprovalId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
};

export type PrepareFileApprovalsAttachmentForUploadResult = PrepareFileApprovalsAttachmentForUploadErrors | PrepareFileApprovalsAttachmentForUploadSuccess;

export type PrepareFileApprovalsAttachmentForUploadSuccess = {
  __typename?: 'PrepareFileApprovalsAttachmentForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareFileForAutodeskViewerError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type PrepareFileForAutodeskViewerErrors = {
  __typename?: 'PrepareFileForAutodeskViewerErrors';
  errors: Array<PrepareFileForAutodeskViewerError>;
};

export type PrepareFileForAutodeskViewerInput = {
  file_version_id: Scalars['uuid']['input'];
};

export type PrepareFileForAutodeskViewerResult = PrepareFileForAutodeskViewerErrors | PrepareFileForAutodeskViewerSuccess;

export type PrepareFileForAutodeskViewerSuccess = {
  __typename?: 'PrepareFileForAutodeskViewerSuccess';
  file_version_id: Scalars['uuid']['output'];
};

export type PrepareFileForUploadError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type PrepareFileForUploadErrors = {
  __typename?: 'PrepareFileForUploadErrors';
  errors: Array<PrepareFileForUploadError>;
};

export type PrepareFileForUploadInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['uuid']['input'];
};

export type PrepareFileForUploadResult = PrepareFileForUploadErrors | PrepareFileForUploadSuccess;

export type PrepareFileForUploadSuccess = {
  __typename?: 'PrepareFileForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareFileStructureForUploadError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type PrepareFileStructureForUploadErrors = {
  __typename?: 'PrepareFileStructureForUploadErrors';
  errors: Array<PrepareFileStructureForUploadError>;
};

export type PrepareFileStructureForUploadInput = {
  parentId: Scalars['uuid']['input'];
};

export type PrepareFileStructureForUploadResult = PrepareFileStructureForUploadErrors | PrepareFileStructureForUploadSuccess;

export type PrepareFileStructureForUploadSuccess = {
  __typename?: 'PrepareFileStructureForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareFileVersionAnnotationForUploadError = FileAccessDenied | FileVersionDoesNotExists | InputValidationError;

export type PrepareFileVersionAnnotationForUploadErrors = {
  __typename?: 'PrepareFileVersionAnnotationForUploadErrors';
  errors: Array<PrepareFileVersionAnnotationForUploadError>;
};

export type PrepareFileVersionAnnotationForUploadInput = {
  fileVersionId: Scalars['uuid']['input'];
};

export type PrepareFileVersionAnnotationForUploadResult = PrepareFileVersionAnnotationForUploadErrors | PrepareFileVersionAnnotationForUploadSuccess;

export type PrepareFileVersionAnnotationForUploadSuccess = {
  __typename?: 'PrepareFileVersionAnnotationForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareFileVersionForUploadError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type PrepareFileVersionForUploadErrors = {
  __typename?: 'PrepareFileVersionForUploadErrors';
  errors: Array<PrepareFileVersionForUploadError>;
};

export type PrepareFileVersionForUploadInput = {
  fileId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
};

export type PrepareFileVersionForUploadResult = PrepareFileVersionForUploadErrors | PrepareFileVersionForUploadSuccess;

export type PrepareFileVersionForUploadSuccess = {
  __typename?: 'PrepareFileVersionForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareMultipartUploadError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type PrepareMultipartUploadErrors = {
  __typename?: 'PrepareMultipartUploadErrors';
  errors: Array<PrepareMultipartUploadError>;
};

export type PrepareMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  parentId: Scalars['uuid']['input'];
  partNumbers: Array<Scalars['Int']['input']>;
  uploadId: Scalars['String']['input'];
};

export type PrepareMultipartUploadResult = PrepareMultipartUploadErrors | PrepareMultipartUploadSuccess;

export type PrepareMultipartUploadSuccess = {
  __typename?: 'PrepareMultipartUploadSuccess';
  key: Scalars['uuid']['output'];
  presignedUrls: Scalars['json']['output'];
  uploadId: Scalars['String']['output'];
};

export type PrepareOrgAssetForUploadError = InputValidationError | OrgAccessDenied | OrgDoesNotExist;

export type PrepareOrgAssetForUploadErrors = {
  __typename?: 'PrepareOrgAssetForUploadErrors';
  errors: Array<PrepareOrgAssetForUploadError>;
};

export type PrepareOrgAssetForUploadInput = {
  name: Scalars['String']['input'];
  orgId: Scalars['uuid']['input'];
};

export type PrepareOrgAssetForUploadResult = PrepareOrgAssetForUploadErrors | PrepareOrgAssetForUploadSuccess;

export type PrepareOrgAssetForUploadSuccess = {
  __typename?: 'PrepareOrgAssetForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareProjectAssetForUploadError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist;

export type PrepareProjectAssetForUploadErrors = {
  __typename?: 'PrepareProjectAssetForUploadErrors';
  errors: Array<PrepareProjectAssetForUploadError>;
};

export type PrepareProjectAssetForUploadInput = {
  name: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
};

export type PrepareProjectAssetForUploadResult = PrepareProjectAssetForUploadErrors | PrepareProjectAssetForUploadSuccess;

export type PrepareProjectAssetForUploadSuccess = {
  __typename?: 'PrepareProjectAssetForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareProjectGroupAssetForUploadError = InputValidationError | ProjectGroupDoesNotExist;

export type PrepareProjectGroupAssetForUploadErrors = {
  __typename?: 'PrepareProjectGroupAssetForUploadErrors';
  errors: Array<PrepareProjectGroupAssetForUploadError>;
};

export type PrepareProjectGroupAssetForUploadInput = {
  name: Scalars['String']['input'];
  projectGroupId: Scalars['uuid']['input'];
};

export type PrepareProjectGroupAssetForUploadResult = PrepareProjectGroupAssetForUploadErrors | PrepareProjectGroupAssetForUploadSuccess;

export type PrepareProjectGroupAssetForUploadSuccess = {
  __typename?: 'PrepareProjectGroupAssetForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareProjectSpreadsheetForUploadError = InputValidationError | OrgAccessDenied | OrgDoesNotExist;

export type PrepareProjectSpreadsheetForUploadErrors = {
  __typename?: 'PrepareProjectSpreadsheetForUploadErrors';
  errors: Array<PrepareProjectSpreadsheetForUploadError>;
};

export type PrepareProjectSpreadsheetForUploadInput = {
  orgId: Scalars['uuid']['input'];
};

export type PrepareProjectSpreadsheetForUploadResult = PrepareProjectSpreadsheetForUploadErrors | PrepareProjectSpreadsheetForUploadSuccess;

export type PrepareProjectSpreadsheetForUploadSuccess = {
  __typename?: 'PrepareProjectSpreadsheetForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareProjectUserAvatarForUploadError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | UpdateProjectUserInfosPermissionDenied | UserDoesNotExist;

export type PrepareProjectUserAvatarForUploadErrors = {
  __typename?: 'PrepareProjectUserAvatarForUploadErrors';
  errors: Array<PrepareProjectUserAvatarForUploadError>;
};

export type PrepareProjectUserAvatarForUploadInput = {
  name: Scalars['String']['input'];
  project_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

export type PrepareProjectUserAvatarForUploadResult = PrepareProjectUserAvatarForUploadErrors | PrepareProjectUserAvatarForUploadSuccess;

export type PrepareProjectUserAvatarForUploadSuccess = {
  __typename?: 'PrepareProjectUserAvatarForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareTaskAttachmentAnnotationForUploadError = InputValidationError | TaskAccessDenied | TaskAttachmentDoesNotExist | TaskDoesNotExist;

export type PrepareTaskAttachmentAnnotationForUploadErrors = {
  __typename?: 'PrepareTaskAttachmentAnnotationForUploadErrors';
  errors: Array<PrepareTaskAttachmentAnnotationForUploadError>;
};

export type PrepareTaskAttachmentAnnotationForUploadInput = {
  taskAttachmentId: Scalars['uuid']['input'];
};

export type PrepareTaskAttachmentAnnotationForUploadResult = PrepareTaskAttachmentAnnotationForUploadErrors | PrepareTaskAttachmentAnnotationForUploadSuccess;

export type PrepareTaskAttachmentAnnotationForUploadSuccess = {
  __typename?: 'PrepareTaskAttachmentAnnotationForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareTaskAttachmentForUploadError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type PrepareTaskAttachmentForUploadErrors = {
  __typename?: 'PrepareTaskAttachmentForUploadErrors';
  errors: Array<PrepareTaskAttachmentForUploadError>;
};

export type PrepareTaskAttachmentForUploadInput = {
  name: Scalars['String']['input'];
  taskId: Scalars['uuid']['input'];
};

export type PrepareTaskAttachmentForUploadResult = PrepareTaskAttachmentForUploadErrors | PrepareTaskAttachmentForUploadSuccess;

export type PrepareTaskAttachmentForUploadSuccess = {
  __typename?: 'PrepareTaskAttachmentForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareTaskAttachmentMultipartUploadError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type PrepareTaskAttachmentMultipartUploadErrors = {
  __typename?: 'PrepareTaskAttachmentMultipartUploadErrors';
  errors: Array<PrepareTaskAttachmentMultipartUploadError>;
};

export type PrepareTaskAttachmentMultipartUploadInput = {
  key: Scalars['uuid']['input'];
  partNumbers: Array<Scalars['Int']['input']>;
  taskId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type PrepareTaskAttachmentMultipartUploadResult = PrepareTaskAttachmentMultipartUploadErrors | PrepareTaskAttachmentMultipartUploadSuccess;

export type PrepareTaskAttachmentMultipartUploadSuccess = {
  __typename?: 'PrepareTaskAttachmentMultipartUploadSuccess';
  key: Scalars['uuid']['output'];
  presignedUrls: Scalars['json']['output'];
  uploadId: Scalars['String']['output'];
};

export type PrepareTaskSpreadsheetForUploadError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist;

export type PrepareTaskSpreadsheetForUploadErrors = {
  __typename?: 'PrepareTaskSpreadsheetForUploadErrors';
  errors: Array<PrepareTaskSpreadsheetForUploadError>;
};

export type PrepareTaskSpreadsheetForUploadInput = {
  projectId: Scalars['uuid']['input'];
};

export type PrepareTaskSpreadsheetForUploadResult = PrepareTaskSpreadsheetForUploadErrors | PrepareTaskSpreadsheetForUploadSuccess;

export type PrepareTaskSpreadsheetForUploadSuccess = {
  __typename?: 'PrepareTaskSpreadsheetForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type PrepareUserAvatarForUploadError = InputValidationError;

export type PrepareUserAvatarForUploadErrors = {
  __typename?: 'PrepareUserAvatarForUploadErrors';
  errors: Array<PrepareUserAvatarForUploadError>;
};

export type PrepareUserAvatarForUploadInput = {
  name: Scalars['String']['input'];
};

export type PrepareUserAvatarForUploadResult = PrepareUserAvatarForUploadErrors | PrepareUserAvatarForUploadSuccess;

export type PrepareUserAvatarForUploadSuccess = {
  __typename?: 'PrepareUserAvatarForUploadSuccess';
  key: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type ProjectAccessDenied = {
  __typename?: 'ProjectAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectCategoryAccessDenied = {
  __typename?: 'ProjectCategoryAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectCategoryDoesNotExist = {
  __typename?: 'ProjectCategoryDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectDoesNotExist = {
  __typename?: 'ProjectDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectGroupAccessDenied = {
  __typename?: 'ProjectGroupAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectGroupDoesNotExist = {
  __typename?: 'ProjectGroupDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectImportRequestExcelTemplateError = ProjectRequestCarboneImportExcelTemplateVoid | UserDoesNotExist;

export type ProjectImportRequestExcelTemplateErrors = {
  __typename?: 'ProjectImportRequestExcelTemplateErrors';
  errors: Array<ProjectImportRequestExcelTemplateError>;
};

export type ProjectImportRequestExcelTemplateResult = ProjectImportRequestExcelTemplateErrors | ProjectImportRequestExcelTemplateSuccess;

export type ProjectImportRequestExcelTemplateSuccess = {
  __typename?: 'ProjectImportRequestExcelTemplateSuccess';
  url: Scalars['String']['output'];
};

export type ProjectInvitationRequestExcelTemplateError = ProjectRequestCarboneInvitationExcelTemplateVoid | UserDoesNotExist;

export type ProjectInvitationRequestExcelTemplateErrors = {
  __typename?: 'ProjectInvitationRequestExcelTemplateErrors';
  errors: Array<ProjectInvitationRequestExcelTemplateError>;
};

export type ProjectInvitationRequestExcelTemplateResult = ProjectInvitationRequestExcelTemplateErrors | ProjectInvitationRequestExcelTemplateSuccess;

export type ProjectInvitationRequestExcelTemplateSuccess = {
  __typename?: 'ProjectInvitationRequestExcelTemplateSuccess';
  url: Scalars['String']['output'];
};

export type ProjectInvitationsError = CannotUpdateProjectRole | InputValidationError | ProjectAccessDenied;

export type ProjectInvitationsErrors = {
  __typename?: 'ProjectInvitationsErrors';
  errors: Array<ProjectInvitationsError>;
};

export type ProjectInvitationsInput = {
  project_ids: Array<Scalars['uuid']['input']>;
  sendEmailInvitation: Scalars['Boolean']['input'];
  users: Array<UsersProjectInvitation>;
};

export type ProjectInvitationsResult = ProjectInvitationsErrors | ProjectInvitationsSuccess;

export type ProjectInvitationsSuccess = {
  __typename?: 'ProjectInvitationsSuccess';
  errorReport: Array<ErrorReportType>;
  ok: Scalars['Boolean']['output'];
  successReport: Array<SuccessReportType>;
};

export type ProjectLabelAccessDenied = {
  __typename?: 'ProjectLabelAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectLabelDoesNotExist = {
  __typename?: 'ProjectLabelDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectNeedsAtLeastOneOwner = {
  __typename?: 'ProjectNeedsAtLeastOneOwner';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectProfileAddress = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectRequestCarboneImportExcelTemplateVoid = {
  __typename?: 'ProjectRequestCarboneImportExcelTemplateVoid';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectRequestCarboneInvitationExcelTemplateVoid = {
  __typename?: 'ProjectRequestCarboneInvitationExcelTemplateVoid';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReadNotificationsError = InputValidationError | NotificationDoesNotExists;

export type ReadNotificationsErrors = {
  __typename?: 'ReadNotificationsErrors';
  errors: Array<ReadNotificationsError>;
};

export type ReadNotificationsInput = {
  notificationIds: Array<Scalars['uuid']['input']>;
};

export type ReadNotificationsResult = ReadNotificationsErrors | ReadNotificationsSuccess;

export type ReadNotificationsSuccess = {
  __typename?: 'ReadNotificationsSuccess';
  notification_ids: Array<Scalars['uuid']['output']>;
};

export type RemoveMembersFromProjectChannelError = ChannelDoesNotExist | InputValidationError | NotMemberOfThisChannel | ProjectAccessDenied | ProjectDoesNotExist | UserNotModeratorOfThisChannel;

export type RemoveMembersFromProjectChannelErrors = {
  __typename?: 'RemoveMembersFromProjectChannelErrors';
  errors: Array<RemoveMembersFromProjectChannelError>;
};

export type RemoveMembersFromProjectChannelInput = {
  channelId: Scalars['String']['input'];
  members: Array<Scalars['String']['input']>;
};

export type RemoveMembersFromProjectChannelResult = RemoveMembersFromProjectChannelErrors | RemoveMembersFromProjectChannelSuccess;

export type RemoveMembersFromProjectChannelSuccess = {
  __typename?: 'RemoveMembersFromProjectChannelSuccess';
  channel_id: Scalars['String']['output'];
  project_id: Scalars['uuid']['output'];
};

export type RemoveUserInTeamError = InputValidationError | TeamAccessDenied | TeamDoesNotExist | UserDoesNotExist | UserNotPartOfThisTeam;

export type RemoveUserInTeamErrors = {
  __typename?: 'RemoveUserInTeamErrors';
  errors: Array<RemoveUserInTeamError>;
};

export type RemoveUserInTeamInput = {
  teamId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

export type RemoveUserInTeamResult = RemoveUserInTeamErrors | RemoveUserInTeamSuccess;

export type RemoveUserInTeamSuccess = {
  __typename?: 'RemoveUserInTeamSuccess';
  project_id: Scalars['uuid']['output'];
  team_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

export type RenameChannelForProjectError = ChannelDoesNotExist | InputValidationError | NotMemberOfThisChannel | ProjectAccessDenied | ProjectDoesNotExist | UserNotModeratorOfThisChannel;

export type RenameChannelForProjectErrors = {
  __typename?: 'RenameChannelForProjectErrors';
  errors: Array<RenameChannelForProjectError>;
};

export type RenameChannelForProjectInput = {
  channelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type RenameChannelForProjectResult = RenameChannelForProjectErrors | RenameChannelForProjectSuccess;

export type RenameChannelForProjectSuccess = {
  __typename?: 'RenameChannelForProjectSuccess';
  channel_id: Scalars['String']['output'];
  project_id: Scalars['uuid']['output'];
};

export type RenameFileError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type RenameFileErrors = {
  __typename?: 'RenameFileErrors';
  errors: Array<RenameFileError>;
};

export type RenameFileInput = {
  fileId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
};

export type RenameFileResult = RenameFileErrors | RenameFileSuccess;

export type RenameFileSuccess = {
  __typename?: 'RenameFileSuccess';
  file_id: Scalars['uuid']['output'];
};

export type RenameFolderError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type RenameFolderErrors = {
  __typename?: 'RenameFolderErrors';
  errors: Array<RenameFolderError>;
};

export type RenameFolderInput = {
  folderId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
};

export type RenameFolderResult = RenameFolderErrors | RenameFolderSuccess;

export type RenameFolderSuccess = {
  __typename?: 'RenameFolderSuccess';
  folder_id: Scalars['uuid']['output'];
};

export type ReportBlockCannotBeUpdate = {
  __typename?: 'ReportBlockCannotBeUpdate';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReportBlockDoesNotExist = {
  __typename?: 'ReportBlockDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReportBlockMultipleVisibility = {
  __typename?: 'ReportBlockMultipleVisibility';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReportBlockNeedToBeVisible = {
  __typename?: 'ReportBlockNeedToBeVisible';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RequestApprovalExportError = FileDoesNotExists | InputValidationError | NotFoundFilesInApprovalMode | ProjectAccessDenied | ProjectDoesNotExist;

export type RequestApprovalExportErrors = {
  __typename?: 'RequestApprovalExportErrors';
  errors: Array<RequestApprovalExportError>;
};

export type RequestApprovalExportInput = {
  broadcast?: InputMaybe<BroadcastApprovalExport>;
  fileIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  folderIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  format: Scalars['String']['input'];
  options?: InputMaybe<OptionsApprovalExport>;
  projectId: Scalars['uuid']['input'];
  title: Scalars['String']['input'];
};

export type RequestApprovalExportResult = RequestApprovalExportErrors | RequestApprovalExportSuccess;

export type RequestApprovalExportSuccess = {
  __typename?: 'RequestApprovalExportSuccess';
  project_id: Scalars['uuid']['output'];
};

export type RequestApprovalReportError = FileDoesNotExists | InputValidationError | NotFoundFilesInApprovalMode | ProjectAccessDenied | ProjectDoesNotExist;

export type RequestApprovalReportErrors = {
  __typename?: 'RequestApprovalReportErrors';
  errors: Array<RequestApprovalReportError>;
};

export type RequestApprovalReportInput = {
  broadcast?: InputMaybe<BroadcastApprovalReport>;
  content?: InputMaybe<ContentApprovalReport>;
  fileIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  folderIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  format: Scalars['String']['input'];
  options?: InputMaybe<OptionsApprovalReport>;
  projectId: Scalars['uuid']['input'];
  title: Scalars['String']['input'];
};

export type RequestApprovalReportResult = RequestApprovalReportErrors | RequestApprovalReportSuccess;

export type RequestApprovalReportSuccess = {
  __typename?: 'RequestApprovalReportSuccess';
  project_id: Scalars['uuid']['output'];
};

export type RequestFilesTreeReportError = FileDoesNotExists | InputValidationError | NotFoundFiles | ProjectAccessDenied | ProjectDoesNotExist;

export type RequestFilesTreeReportErrors = {
  __typename?: 'RequestFilesTreeReportErrors';
  errors: Array<RequestFilesTreeReportError>;
};

export type RequestFilesTreeReportInput = {
  broadcast?: InputMaybe<BroadcastFilesTreeReport>;
  content?: InputMaybe<ContentFilesTreeReport>;
  fileIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  folderIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  format: Scalars['String']['input'];
  options?: InputMaybe<OptionsFilesTreeReport>;
  projectId: Scalars['uuid']['input'];
  title: Scalars['String']['input'];
};

export type RequestFilesTreeReportResult = RequestFilesTreeReportErrors | RequestFilesTreeReportSuccess;

export type RequestFilesTreeReportSuccess = {
  __typename?: 'RequestFilesTreeReportSuccess';
  project_id: Scalars['uuid']['output'];
};

export type RequestProjectExportError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist;

export type RequestProjectExportErrors = {
  __typename?: 'RequestProjectExportErrors';
  errors: Array<RequestProjectExportError>;
};

export type RequestProjectExportInput = {
  projectId: Scalars['uuid']['input'];
};

export type RequestProjectExportResult = RequestProjectExportErrors | RequestProjectExportSuccess;

export type RequestProjectExportSuccess = {
  __typename?: 'RequestProjectExportSuccess';
  project_id: Scalars['uuid']['output'];
};

export type RequestTasksExportError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | TaskDoesNotExist | TeamDoesNotExist | UserDoesNotExist;

export type RequestTasksExportErrors = {
  __typename?: 'RequestTasksExportErrors';
  errors: Array<RequestTasksExportError>;
};

export type RequestTasksExportInput = {
  broadcast?: InputMaybe<BroadcastTasksExport>;
  format: Scalars['String']['input'];
  projectId: Scalars['uuid']['input'];
  taskIds: Array<Scalars['uuid']['input']>;
  title: Scalars['String']['input'];
};

export type RequestTasksExportResult = RequestTasksExportErrors | RequestTasksExportSuccess;

export type RequestTasksExportSuccess = {
  __typename?: 'RequestTasksExportSuccess';
  project_id: Scalars['uuid']['output'];
};

export type RequestTasksReportError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | TaskDoesNotExist | TeamDoesNotExist | UserDoesNotExist;

export type RequestTasksReportErrors = {
  __typename?: 'RequestTasksReportErrors';
  errors: Array<RequestTasksReportError>;
};

export type RequestTasksReportInput = {
  broadcast?: InputMaybe<BroadcastTasksReport>;
  currentMeetingDate?: InputMaybe<Scalars['timestamptz']['input']>;
  folderId: Scalars['uuid']['input'];
  format: Scalars['String']['input'];
  introduction?: InputMaybe<Scalars['String']['input']>;
  nextMeetingInvitationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  nextMeetingInvitationUsers?: InputMaybe<Array<InputMaybe<NextMeetingInvitationUsers>>>;
  options?: InputMaybe<OptionsTasksReport>;
  organization?: InputMaybe<OrganizationTasksReport>;
  presentUsers?: InputMaybe<Array<InputMaybe<PresentUsersTasksReport>>>;
  projectId: Scalars['uuid']['input'];
  taskIds: Array<Scalars['uuid']['input']>;
  taskReportEditor?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type RequestTasksReportResult = RequestTasksReportErrors | RequestTasksReportSuccess;

export type RequestTasksReportSuccess = {
  __typename?: 'RequestTasksReportSuccess';
  project_id: Scalars['uuid']['output'];
};

export type RequestUsersApprovalsFilesError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type RequestUsersApprovalsFilesErrors = {
  __typename?: 'RequestUsersApprovalsFilesErrors';
  errors: Array<RequestUsersApprovalsFilesError>;
};

export type RequestUsersApprovalsFilesInput = {
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  fileIds: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type RequestUsersApprovalsFilesResult = RequestUsersApprovalsFilesErrors | RequestUsersApprovalsFilesSuccess;

export type RequestUsersApprovalsFilesSuccess = {
  __typename?: 'RequestUsersApprovalsFilesSuccess';
  file_ids: Array<Scalars['uuid']['output']>;
};

export type RestoreFileVersionError = FileAccessDenied | FileVersionDoesNotExists | InputValidationError;

export type RestoreFileVersionErrors = {
  __typename?: 'RestoreFileVersionErrors';
  errors: Array<RestoreFileVersionError>;
};

export type RestoreFileVersionInput = {
  fileVersionId: Scalars['uuid']['input'];
};

export type RestoreFileVersionResult = RestoreFileVersionErrors | RestoreFileVersionSuccess;

export type RestoreFileVersionSuccess = {
  __typename?: 'RestoreFileVersionSuccess';
  file_version_id: Scalars['uuid']['output'];
};

export type SaveFirebaseTokenError = InputValidationError;

export type SaveFirebaseTokenErrors = {
  __typename?: 'SaveFirebaseTokenErrors';
  errors: Array<SaveFirebaseTokenError>;
};

export type SaveFirebaseTokenInput = {
  appVersion: Scalars['String']['input'];
  manufacturer: Scalars['String']['input'];
  model: Scalars['String']['input'];
  operatingSystem: Scalars['String']['input'];
  osVersion: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
  webViewVersion: Scalars['String']['input'];
};

export type SaveFirebaseTokenResult = SaveFirebaseTokenErrors | SaveFirebaseTokenSuccess;

export type SaveFirebaseTokenSuccess = {
  __typename?: 'SaveFirebaseTokenSuccess';
  user_device_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

export type SendUserEmailInvitationError = InputValidationError | OrgDoesNotExist | OrgOrProjectUserDoesNotExist | ProjectDoesNotExist | UserDoesNotExist;

export type SendUserEmailInvitationErrors = {
  __typename?: 'SendUserEmailInvitationErrors';
  errors: Array<SendUserEmailInvitationError>;
};

export type SendUserEmailInvitationInput = {
  orgId?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  userIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type SendUserEmailInvitationResult = SendUserEmailInvitationErrors | SendUserEmailInvitationSuccess;

export type SendUserEmailInvitationSuccess = {
  __typename?: 'SendUserEmailInvitationSuccess';
  emails_sent: Scalars['Boolean']['output'];
};

export type SignFileError = FileAccessDenied | FileFormatNotSupported | FileVersionDoesNotExists | InputValidationError;

export type SignFileErrors = {
  __typename?: 'SignFileErrors';
  errors: Array<SignFileError>;
};

export type SignFileInput = {
  file_version_id: Scalars['uuid']['input'];
  signature?: InputMaybe<SignFileSignatureInput>;
};

export type SignFileResult = SignFileErrors | SignFileSuccess;

export type SignFileSignatureCoordinatesInput = {
  page_number: Scalars['Int']['input'];
  x1: Scalars['Float']['input'];
  x2: Scalars['Float']['input'];
  y1: Scalars['Float']['input'];
  y2: Scalars['Float']['input'];
};

export type SignFileSignatureInput = {
  coordinates?: InputMaybe<SignFileSignatureCoordinatesInput>;
  image: Scalars['String']['input'];
};

export type SignFileSuccess = {
  __typename?: 'SignFileSuccess';
  file_version_id: Scalars['uuid']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SubtaskAccessDenied = {
  __typename?: 'SubtaskAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SubtaskDoesNotExist = {
  __typename?: 'SubtaskDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SuccessReportType = {
  __typename?: 'SuccessReportType';
  email: Scalars['String']['output'];
};

export type TaskAccessDenied = {
  __typename?: 'TaskAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TaskAssignationsNotAllowed = {
  __typename?: 'TaskAssignationsNotAllowed';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TaskAttachmentAccessDenied = {
  __typename?: 'TaskAttachmentAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TaskAttachmentDoesNotExist = {
  __typename?: 'TaskAttachmentDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TaskDoesNotExist = {
  __typename?: 'TaskDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TaskImportRequestExcelTemplateError = TaskRequestCarboneImportExcelTemplateVoid | UserDoesNotExist;

export type TaskImportRequestExcelTemplateErrors = {
  __typename?: 'TaskImportRequestExcelTemplateErrors';
  errors: Array<TaskImportRequestExcelTemplateError>;
};

export type TaskImportRequestExcelTemplateResult = TaskImportRequestExcelTemplateErrors | TaskImportRequestExcelTemplateSuccess;

export type TaskImportRequestExcelTemplateSuccess = {
  __typename?: 'TaskImportRequestExcelTemplateSuccess';
  url: Scalars['String']['output'];
};

export type TaskPermissionsNotAllowed = {
  __typename?: 'TaskPermissionsNotAllowed';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TaskRequestCarboneImportExcelTemplateVoid = {
  __typename?: 'TaskRequestCarboneImportExcelTemplateVoid';
  message: Scalars['String']['output'];
};

export type TeamAccessDenied = {
  __typename?: 'TeamAccessDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TeamDoesNotExist = {
  __typename?: 'TeamDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TeamNameAlreadyExist = {
  __typename?: 'TeamNameAlreadyExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TestMigrateAvatarPublicUrlError = TestMigrateAvatarPublicUrlFailed;

export type TestMigrateAvatarPublicUrlErrors = {
  __typename?: 'TestMigrateAvatarPublicUrlErrors';
  errors: Array<TestMigrateAvatarPublicUrlError>;
};

export type TestMigrateAvatarPublicUrlFailed = {
  __typename?: 'TestMigrateAvatarPublicUrlFailed';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TestMigrateAvatarPublicUrlResult = TestMigrateAvatarPublicUrlErrors | TestMigrateAvatarPublicUrlSuccess;

export type TestMigrateAvatarPublicUrlSuccess = {
  __typename?: 'TestMigrateAvatarPublicUrlSuccess';
  ok: Scalars['Boolean']['output'];
};

export type UnreadNotificationsError = InputValidationError | NotificationDoesNotExists;

export type UnreadNotificationsErrors = {
  __typename?: 'UnreadNotificationsErrors';
  errors: Array<UnreadNotificationsError>;
};

export type UnreadNotificationsInput = {
  notificationIds: Array<Scalars['uuid']['input']>;
};

export type UnreadNotificationsResult = UnreadNotificationsErrors | UnreadNotificationsSuccess;

export type UnreadNotificationsSuccess = {
  __typename?: 'UnreadNotificationsSuccess';
  notification_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateArchiveTaskError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type UpdateArchiveTaskErrors = {
  __typename?: 'UpdateArchiveTaskErrors';
  errors: Array<UpdateArchiveTaskError>;
};

export type UpdateArchiveTaskInput = {
  taskId: Scalars['uuid']['input'];
};

export type UpdateArchiveTaskResult = UpdateArchiveTaskErrors | UpdateArchiveTaskSuccess;

export type UpdateArchiveTaskSuccess = {
  __typename?: 'UpdateArchiveTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type UpdateAssignationTaskSuccess = {
  __typename?: 'UpdateAssignationTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type UpdateAssignationsFilesError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type UpdateAssignationsFilesErrors = {
  __typename?: 'UpdateAssignationsFilesErrors';
  errors: Array<UpdateAssignationsFilesError>;
};

export type UpdateAssignationsFilesFoldersError = FileAccessDenied | FileDoesNotExists | FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type UpdateAssignationsFilesFoldersErrors = {
  __typename?: 'UpdateAssignationsFilesFoldersErrors';
  errors: Array<UpdateAssignationsFilesFoldersError>;
};

export type UpdateAssignationsFilesFoldersInput = {
  fileIds: Array<Scalars['uuid']['input']>;
  folderIds: Array<Scalars['uuid']['input']>;
  orgs: Array<Scalars['uuid']['input']>;
  teams: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type UpdateAssignationsFilesFoldersResult = UpdateAssignationsFilesFoldersErrors | UpdateAssignationsFilesFoldersSuccess;

export type UpdateAssignationsFilesFoldersSuccess = {
  __typename?: 'UpdateAssignationsFilesFoldersSuccess';
  file_ids: Array<Scalars['uuid']['output']>;
  folder_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateAssignationsFilesInput = {
  fileIds: Array<Scalars['uuid']['input']>;
  orgs: Array<Scalars['uuid']['input']>;
  teams: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type UpdateAssignationsFilesResult = UpdateAssignationsFilesErrors | UpdateAssignationsFilesSuccess;

export type UpdateAssignationsFilesSuccess = {
  __typename?: 'UpdateAssignationsFilesSuccess';
  file_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateAssignationsFoldersError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type UpdateAssignationsFoldersErrors = {
  __typename?: 'UpdateAssignationsFoldersErrors';
  errors: Array<UpdateAssignationsFoldersError>;
};

export type UpdateAssignationsFoldersInput = {
  approvalAutomation: Scalars['Boolean']['input'];
  assigneeAutomation: Scalars['Boolean']['input'];
  childrenAutomation: Scalars['Boolean']['input'];
  dueDate: Scalars['String']['input'];
  folderIds: Array<Scalars['uuid']['input']>;
  orgs: Array<Scalars['uuid']['input']>;
  teams: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type UpdateAssignationsFoldersResult = UpdateAssignationsFoldersErrors | UpdateAssignationsFoldersSuccess;

export type UpdateAssignationsFoldersSuccess = {
  __typename?: 'UpdateAssignationsFoldersSuccess';
  folder_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateAssignationsTaskError = InputValidationError | TaskAccessDenied | TaskAssignationsNotAllowed | TaskDoesNotExist;

export type UpdateAssignationsTaskErrors = {
  __typename?: 'UpdateAssignationsTaskErrors';
  errors: Array<UpdateAssignationsTaskError>;
};

export type UpdateAssignationsTaskInput = {
  orgs: Array<InputMaybe<Scalars['uuid']['input']>>;
  taskId: Scalars['uuid']['input'];
  teams: Array<InputMaybe<Scalars['uuid']['input']>>;
  users: Array<InputMaybe<Scalars['uuid']['input']>>;
};

export type UpdateAssignationsTaskResult = UpdateAssignationTaskSuccess | UpdateAssignationsTaskErrors;

export type UpdateBrowserLanguageError = InputValidationError;

export type UpdateBrowserLanguageErrors = {
  __typename?: 'UpdateBrowserLanguageErrors';
  errors: Array<UpdateBrowserLanguageError>;
};

export type UpdateBrowserLanguageInput = {
  browser_language: Scalars['String']['input'];
};

export type UpdateBrowserLanguageResult = UpdateBrowserLanguageErrors | UpdateBrowserLanguageSuccess;

export type UpdateBrowserLanguageSuccess = {
  __typename?: 'UpdateBrowserLanguageSuccess';
  user_id: Scalars['ID']['output'];
};

export type UpdateBrowserTimezoneError = InputValidationError;

export type UpdateBrowserTimezoneErrors = {
  __typename?: 'UpdateBrowserTimezoneErrors';
  errors: Array<UpdateBrowserTimezoneError>;
};

export type UpdateBrowserTimezoneInput = {
  timezone: Scalars['String']['input'];
};

export type UpdateBrowserTimezoneResult = UpdateBrowserTimezoneErrors | UpdateBrowserTimezoneSuccess;

export type UpdateBrowserTimezoneSuccess = {
  __typename?: 'UpdateBrowserTimezoneSuccess';
  user_id: Scalars['ID']['output'];
};

export type UpdateDueDateFileError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type UpdateDueDateFileErrors = {
  __typename?: 'UpdateDueDateFileErrors';
  errors: Array<UpdateDueDateFileError>;
};

export type UpdateDueDateFileInput = {
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId: Scalars['uuid']['input'];
};

export type UpdateDueDateFileResult = UpdateDueDateFileErrors | UpdateDueDateFileSuccess;

export type UpdateDueDateFileSuccess = {
  __typename?: 'UpdateDueDateFileSuccess';
  file_id: Scalars['uuid']['output'];
};

export type UpdateEmailNotificationsError = InputValidationError;

export type UpdateEmailNotificationsErrors = {
  __typename?: 'UpdateEmailNotificationsErrors';
  errors: Array<UpdateEmailNotificationsError>;
};

export type UpdateEmailNotificationsInput = {
  invitation?: InputMaybe<Scalars['Boolean']['input']>;
  unread_notification_report?: InputMaybe<Scalars['Boolean']['input']>;
  weekly_report?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEmailNotificationsResult = UpdateEmailNotificationsErrors | UpdateEmailNotificationsSuccess;

export type UpdateEmailNotificationsSuccess = {
  __typename?: 'UpdateEmailNotificationsSuccess';
  email_notifications_id: Scalars['uuid']['output'];
};

export type UpdateFilesApprovalModeError = CannotRemoveApprovalOnFile | FileAccessDenied | FileDoesNotExists | InputValidationError;

export type UpdateFilesApprovalModeErrors = {
  __typename?: 'UpdateFilesApprovalModeErrors';
  errors: Array<UpdateFilesApprovalModeError>;
};

export type UpdateFilesApprovalModeInput = {
  fileIds: Array<Scalars['uuid']['input']>;
  isApprovalMode: Scalars['Boolean']['input'];
};

export type UpdateFilesApprovalModeResult = UpdateFilesApprovalModeErrors | UpdateFilesApprovalModeSuccess;

export type UpdateFilesApprovalModeSuccess = {
  __typename?: 'UpdateFilesApprovalModeSuccess';
  file_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateFilterError = FilterCannotBeUpdate | FilterDoesNotExist | FilterMultipleVisibility | FilterNeedToBeVisible | InputValidationError | OrgAccessDenied | OrgDoesNotExist | ProjectAccessDenied | ProjectDoesNotExist;

export type UpdateFilterErrors = {
  __typename?: 'UpdateFilterErrors';
  errors: Array<UpdateFilterError>;
};

export type UpdateFilterInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  filterId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  visibilityOrgId?: InputMaybe<Scalars['String']['input']>;
  visibilityProjectId?: InputMaybe<Scalars['String']['input']>;
  visibilityTeamId?: InputMaybe<Scalars['String']['input']>;
  visibilityUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFilterResult = UpdateFilterErrors | UpdateFilterSuccess;

export type UpdateFilterSuccess = {
  __typename?: 'UpdateFilterSuccess';
  filter_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type UpdateLabelsFilesError = FileAccessDenied | FileDoesNotExists | InputValidationError;

export type UpdateLabelsFilesErrors = {
  __typename?: 'UpdateLabelsFilesErrors';
  errors: Array<UpdateLabelsFilesError>;
};

export type UpdateLabelsFilesInput = {
  fileIds: Array<Scalars['uuid']['input']>;
  labelIds: Array<Scalars['uuid']['input']>;
};

export type UpdateLabelsFilesResult = UpdateLabelsFilesErrors | UpdateLabelsFilesSuccess;

export type UpdateLabelsFilesSuccess = {
  __typename?: 'UpdateLabelsFilesSuccess';
  file_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateLabelsFoldersError = FolderAccessDenied | FolderDoesNotExists | InputValidationError;

export type UpdateLabelsFoldersErrors = {
  __typename?: 'UpdateLabelsFoldersErrors';
  errors: Array<UpdateLabelsFoldersError>;
};

export type UpdateLabelsFoldersInput = {
  folderIds: Array<Scalars['uuid']['input']>;
  labelIds: Array<Scalars['uuid']['input']>;
};

export type UpdateLabelsFoldersResult = UpdateLabelsFoldersErrors | UpdateLabelsFoldersSuccess;

export type UpdateLabelsFoldersSuccess = {
  __typename?: 'UpdateLabelsFoldersSuccess';
  folder_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateLabelsTasksError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type UpdateLabelsTasksErrors = {
  __typename?: 'UpdateLabelsTasksErrors';
  errors: Array<UpdateLabelsTasksError>;
};

export type UpdateLabelsTasksInput = {
  labelIds: Array<Scalars['uuid']['input']>;
  taskIds: Array<Scalars['uuid']['input']>;
};

export type UpdateLabelsTasksResult = UpdateLabelsTasksErrors | UpdateLabelsTasksSuccess;

export type UpdateLabelsTasksSuccess = {
  __typename?: 'UpdateLabelsTasksSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateOrgProfileError = InputValidationError | OrgDoesNotExist | UpdateOrgProfilePermissionDenied;

export type UpdateOrgProfileErrors = {
  __typename?: 'UpdateOrgProfileErrors';
  errors: Array<UpdateOrgProfileError>;
};

export type UpdateOrgProfileInput = {
  address?: InputMaybe<OrgProfileAddress>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legal_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<OrgSettings>;
};

export type UpdateOrgProfilePermissionDenied = {
  __typename?: 'UpdateOrgProfilePermissionDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateOrgProfileResult = UpdateOrgProfileErrors | UpdateOrgProfileSuccess;

export type UpdateOrgProfileSuccess = {
  __typename?: 'UpdateOrgProfileSuccess';
  org_id: Scalars['ID']['output'];
};

export type UpdateOrgProjectSummaryArchiveError = InputValidationError | OrgDoesNotExist | OrgProjectSummaryDoesNotExist | ProjectDoesNotExist;

export type UpdateOrgProjectSummaryArchiveErrors = {
  __typename?: 'UpdateOrgProjectSummaryArchiveErrors';
  errors: Array<UpdateOrgProjectSummaryArchiveError>;
};

export type UpdateOrgProjectSummaryArchiveInput = {
  isArchived: Scalars['Boolean']['input'];
  orgId: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
};

export type UpdateOrgProjectSummaryArchiveResult = UpdateOrgProjectSummaryArchiveErrors | UpdateOrgProjectSummaryArchiveSuccess;

export type UpdateOrgProjectSummaryArchiveSuccess = {
  __typename?: 'UpdateOrgProjectSummaryArchiveSuccess';
  project_id: Scalars['uuid']['output'];
};

export type UpdateOrgProjectSummaryError = InputValidationError | OrgProjectSummaryDoesNotExist | ProjectAccessDenied | ProjectCategoryDoesNotExist | ProjectDoesNotExist | ProjectGroupDoesNotExist | UpdateOrgProjectSummaryPermissionDenied;

export type UpdateOrgProjectSummaryErrors = {
  __typename?: 'UpdateOrgProjectSummaryErrors';
  errors: Array<UpdateOrgProjectSummaryError>;
};

export type UpdateOrgProjectSummaryInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  client_email?: InputMaybe<Scalars['String']['input']>;
  client_fullname?: InputMaybe<Scalars['String']['input']>;
  client_phone_number?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  hours_done?: InputMaybe<Scalars['Float']['input']>;
  hours_expected?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['uuid']['input'];
  price_estimate?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type UpdateOrgProjectSummaryPermissionDenied = {
  __typename?: 'UpdateOrgProjectSummaryPermissionDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateOrgProjectSummaryResult = UpdateOrgProjectSummaryErrors | UpdateOrgProjectSummarySuccess;

export type UpdateOrgProjectSummarySuccess = {
  __typename?: 'UpdateOrgProjectSummarySuccess';
  org_project_summary_id: Scalars['uuid']['output'];
};

export type UpdatePermissionFileSuccess = {
  __typename?: 'UpdatePermissionFileSuccess';
  file_id: Scalars['uuid']['output'];
};

export type UpdatePermissionFolderSuccess = {
  __typename?: 'UpdatePermissionFolderSuccess';
  folder_id: Scalars['uuid']['output'];
};

export type UpdatePermissionTaskSuccess = {
  __typename?: 'UpdatePermissionTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type UpdatePermissionsFileError = FileAccessDenied | FileDoesNotExists | InputValidationError | PermissionsConflictError;

export type UpdatePermissionsFileErrors = {
  __typename?: 'UpdatePermissionsFileErrors';
  errors: Array<UpdatePermissionsFileError>;
};

export type UpdatePermissionsFileInput = {
  fileId: Scalars['uuid']['input'];
  orgs: Array<FilePermission>;
  teams: Array<FilePermission>;
  users: Array<FilePermission>;
};

export type UpdatePermissionsFileResult = UpdatePermissionFileSuccess | UpdatePermissionsFileErrors;

export type UpdatePermissionsFolderError = FolderAccessDenied | FolderDoesNotExists | InputValidationError | PermissionsConflictError;

export type UpdatePermissionsFolderErrors = {
  __typename?: 'UpdatePermissionsFolderErrors';
  errors: Array<UpdatePermissionsFolderError>;
};

export type UpdatePermissionsFolderInput = {
  folderId: Scalars['uuid']['input'];
  orgs: Array<FolderPermission>;
  teams: Array<FolderPermission>;
  users: Array<FolderPermission>;
};

export type UpdatePermissionsFolderResult = UpdatePermissionFolderSuccess | UpdatePermissionsFolderErrors;

export type UpdatePermissionsTaskError = InputValidationError | TaskAccessDenied | TaskDoesNotExist | TaskPermissionsNotAllowed;

export type UpdatePermissionsTaskErrors = {
  __typename?: 'UpdatePermissionsTaskErrors';
  errors: Array<UpdatePermissionsTaskError>;
};

export type UpdatePermissionsTaskInput = {
  orgs: Array<InputMaybe<Scalars['uuid']['input']>>;
  taskId: Scalars['uuid']['input'];
  teams: Array<InputMaybe<Scalars['uuid']['input']>>;
  users: Array<InputMaybe<Scalars['uuid']['input']>>;
};

export type UpdatePermissionsTaskResult = UpdatePermissionTaskSuccess | UpdatePermissionsTaskErrors;

export type UpdateProjectCategoryError = InputValidationError | ProjectCategoryAccessDenied | ProjectCategoryDoesNotExist;

export type UpdateProjectCategoryErrors = {
  __typename?: 'UpdateProjectCategoryErrors';
  errors: Array<UpdateProjectCategoryError>;
};

export type UpdateProjectCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectCategoryId: Scalars['uuid']['input'];
};

export type UpdateProjectCategoryResult = UpdateProjectCategoryErrors | UpdateProjectCategorySuccess;

export type UpdateProjectCategorySuccess = {
  __typename?: 'UpdateProjectCategorySuccess';
  project_category_id: Scalars['uuid']['output'];
};

export type UpdateProjectGroupError = InputValidationError | ProjectGroupAccessDenied | ProjectGroupDoesNotExist;

export type UpdateProjectGroupErrors = {
  __typename?: 'UpdateProjectGroupErrors';
  errors: Array<UpdateProjectGroupError>;
};

export type UpdateProjectGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectGroupId: Scalars['uuid']['input'];
};

export type UpdateProjectGroupResult = UpdateProjectGroupErrors | UpdateProjectGroupSuccess;

export type UpdateProjectGroupSuccess = {
  __typename?: 'UpdateProjectGroupSuccess';
  project_group_id: Scalars['uuid']['output'];
};

export type UpdateProjectLabelError = InputValidationError | ProjectLabelAccessDenied | ProjectLabelDoesNotExist;

export type UpdateProjectLabelErrors = {
  __typename?: 'UpdateProjectLabelErrors';
  errors: Array<UpdateProjectLabelError>;
};

export type UpdateProjectLabelInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectLabelId?: InputMaybe<Scalars['uuid']['input']>;
};

export type UpdateProjectLabelResult = UpdateProjectLabelErrors | UpdateProjectLabelSuccess;

export type UpdateProjectLabelSuccess = {
  __typename?: 'UpdateProjectLabelSuccess';
  project_label_id: Scalars['uuid']['output'];
};

export type UpdateProjectMembersRoleError = CannotModifyUserWithGreaterProjectRoleThanYours | CannotSetGreaterProjectRoleThanYours | InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | ProjectNeedsAtLeastOneOwner | UserDoesNotExist;

export type UpdateProjectMembersRoleErrors = {
  __typename?: 'UpdateProjectMembersRoleErrors';
  errors: Array<UpdateProjectMembersRoleError>;
};

export type UpdateProjectMembersRoleInput = {
  projectId: Scalars['uuid']['input'];
  role: Scalars['String']['input'];
  userIds: Array<InputMaybe<Scalars['uuid']['input']>>;
};

export type UpdateProjectMembersRoleResult = UpdateProjectMembersRoleErrors | UpdateProjectMembersRoleSuccess;

export type UpdateProjectMembersRoleSuccess = {
  __typename?: 'UpdateProjectMembersRoleSuccess';
  project_id: Scalars['uuid']['output'];
  user_ids: Array<Maybe<Scalars['uuid']['output']>>;
};

export type UpdateProjectProfileError = InputValidationError | ProjectDoesNotExist | UpdateProjectProfilePermissionDenied;

export type UpdateProjectProfileErrors = {
  __typename?: 'UpdateProjectProfileErrors';
  errors: Array<UpdateProjectProfileError>;
};

export type UpdateProjectProfileInput = {
  address?: InputMaybe<ProjectProfileAddress>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateProjectProfilePermissionDenied = {
  __typename?: 'UpdateProjectProfilePermissionDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateProjectProfileResult = UpdateProjectProfileErrors | UpdateProjectProfileSuccess;

export type UpdateProjectProfileSuccess = {
  __typename?: 'UpdateProjectProfileSuccess';
  project_id: Scalars['ID']['output'];
};

export type UpdateProjectRoleError = CannotModifyUserWithGreaterProjectRoleThanYours | CannotSetGreaterProjectRoleThanYours | InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | ProjectNeedsAtLeastOneOwner | UserDoesNotExist;

export type UpdateProjectRoleErrors = {
  __typename?: 'UpdateProjectRoleErrors';
  errors: Array<UpdateProjectRoleError>;
};

export type UpdateProjectRoleInput = {
  projectId: Scalars['uuid']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};

export type UpdateProjectRoleResult = UpdateProjectRoleErrors | UpdateProjectRoleSuccess;

export type UpdateProjectRoleSuccess = {
  __typename?: 'UpdateProjectRoleSuccess';
  project_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

export type UpdateProjectTemplateError = CannotConvertToTemplateOrgProject | InputValidationError | ProjectAccessDenied | ProjectDoesNotExist;

export type UpdateProjectTemplateErrors = {
  __typename?: 'UpdateProjectTemplateErrors';
  errors: Array<UpdateProjectTemplateError>;
};

export type UpdateProjectTemplateInput = {
  isProjectTemplate: Scalars['Boolean']['input'];
  projectId: Scalars['uuid']['input'];
};

export type UpdateProjectTemplateResult = UpdateProjectTemplateErrors | UpdateProjectTemplateSuccess;

export type UpdateProjectTemplateSuccess = {
  __typename?: 'UpdateProjectTemplateSuccess';
  project_id: Scalars['uuid']['output'];
};

export type UpdateProjectUserInfosError = CannotModifyEmailOfActiveUser | CannotSetGreaterProjectRoleThanYours | EmailAlreadyUsedByAnotherUser | InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | ProjectNeedsAtLeastOneOwner | TeamAccessDenied | TeamDoesNotExist | UpdateProjectUserInfosPermissionDenied | UserDoesNotExist;

export type UpdateProjectUserInfosErrors = {
  __typename?: 'UpdateProjectUserInfosErrors';
  errors: Array<UpdateProjectUserInfosError>;
};

export type UpdateProjectUserInfosInput = {
  companyData?: InputMaybe<UsersCompanyData>;
  email: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['uuid']['input'];
  role: Scalars['String']['input'];
  teamIds: Array<InputMaybe<Scalars['uuid']['input']>>;
  userId: Scalars['uuid']['input'];
};

export type UpdateProjectUserInfosPermissionDenied = {
  __typename?: 'UpdateProjectUserInfosPermissionDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateProjectUserInfosResult = UpdateProjectUserInfosErrors | UpdateProjectUserInfosSuccess;

export type UpdateProjectUserInfosSuccess = {
  __typename?: 'UpdateProjectUserInfosSuccess';
  project_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

export type UpdateProjectsCategoriesError = InputValidationError | OrgDoesNotExist | OrgProjectSummaryDoesNotExist | ProjectAccessDenied | ProjectCategoryDoesNotExist | ProjectDoesNotExist | UpdateOrgProjectSummaryPermissionDenied;

export type UpdateProjectsCategoriesErrors = {
  __typename?: 'UpdateProjectsCategoriesErrors';
  errors: Array<UpdateProjectsCategoriesError>;
};

export type UpdateProjectsCategoriesInput = {
  categories?: InputMaybe<Array<Scalars['uuid']['input']>>;
  orgId: Scalars['uuid']['input'];
  projects?: InputMaybe<Array<InputMaybe<UpdateProjectsCategoriesProjects>>>;
};

export type UpdateProjectsCategoriesProjects = {
  orgProjectSummaryId?: InputMaybe<Scalars['uuid']['input']>;
  projectId: Scalars['uuid']['input'];
};

export type UpdateProjectsCategoriesResult = UpdateProjectsCategoriesErrors | UpdateProjectsCategoriesSuccess;

export type UpdateProjectsCategoriesSuccess = {
  __typename?: 'UpdateProjectsCategoriesSuccess';
  categories?: Maybe<Array<Scalars['uuid']['output']>>;
  orgId: Scalars['uuid']['output'];
  projectIds?: Maybe<Array<Scalars['uuid']['output']>>;
};

export type UpdateProjectsClientError = InputValidationError | OrgDoesNotExist | OrgProjectSummaryDoesNotExist | ProjectAccessDenied | ProjectDoesNotExist | UpdateOrgProjectSummaryPermissionDenied;

export type UpdateProjectsClientErrors = {
  __typename?: 'UpdateProjectsClientErrors';
  errors: Array<UpdateProjectsClientError>;
};

export type UpdateProjectsClientInput = {
  client_email?: InputMaybe<Scalars['String']['input']>;
  client_fullname: Scalars['String']['input'];
  client_phone_number?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['uuid']['input'];
  projects?: InputMaybe<Array<InputMaybe<UpdateProjectsClientProjects>>>;
};

export type UpdateProjectsClientProjects = {
  orgProjectSummaryId?: InputMaybe<Scalars['uuid']['input']>;
  projectId: Scalars['uuid']['input'];
};

export type UpdateProjectsClientResult = UpdateProjectsClientErrors | UpdateProjectsClientSuccess;

export type UpdateProjectsClientSuccess = {
  __typename?: 'UpdateProjectsClientSuccess';
  client_email?: Maybe<Scalars['String']['output']>;
  client_fullname: Scalars['String']['output'];
  client_phone_number?: Maybe<Scalars['String']['output']>;
};

export type UpdatePushNotificationsError = InputValidationError | UserDoesNotExist;

export type UpdatePushNotificationsErrors = {
  __typename?: 'UpdatePushNotificationsErrors';
  errors: Array<UpdatePushNotificationsError>;
};

export type UpdatePushNotificationsInput = {
  chat_channel?: InputMaybe<Scalars['Boolean']['input']>;
  chat_direct_message?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePushNotificationsResult = UpdatePushNotificationsErrors | UpdatePushNotificationsSuccess;

export type UpdatePushNotificationsSuccess = {
  __typename?: 'UpdatePushNotificationsSuccess';
  user_id: Scalars['uuid']['output'];
};

export type UpdateReportBlocksError = InputValidationError | OrgAccessDenied | OrgDoesNotExist | ProjectAccessDenied | ProjectDoesNotExist | ReportBlockCannotBeUpdate | ReportBlockDoesNotExist | ReportBlockMultipleVisibility | ReportBlockNeedToBeVisible;

export type UpdateReportBlocksErrors = {
  __typename?: 'UpdateReportBlocksErrors';
  errors: Array<UpdateReportBlocksError>;
};

export type UpdateReportBlocksInput = {
  blockContent: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reportBlockId: Scalars['uuid']['input'];
  visibilityOrgId?: InputMaybe<Scalars['String']['input']>;
  visibilityProjectId?: InputMaybe<Scalars['String']['input']>;
  visibilityTeamId?: InputMaybe<Scalars['String']['input']>;
  visibilityUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportBlocksResult = UpdateReportBlocksErrors | UpdateReportBlocksSuccess;

export type UpdateReportBlocksSuccess = {
  __typename?: 'UpdateReportBlocksSuccess';
  name: Scalars['String']['output'];
  report_block_id: Scalars['uuid']['output'];
};

export type UpdateSubtaskError = InputValidationError | SubtaskAccessDenied | SubtaskDoesNotExist;

export type UpdateSubtaskErrors = {
  __typename?: 'UpdateSubtaskErrors';
  errors: Array<UpdateSubtaskError>;
};

export type UpdateSubtaskInput = {
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  subtaskId: Scalars['uuid']['input'];
};

export type UpdateSubtaskResult = UpdateSubtaskErrors | UpdateSubtaskSuccess;

export type UpdateSubtaskSuccess = {
  __typename?: 'UpdateSubtaskSuccess';
  subtask_id: Scalars['uuid']['output'];
  task_id: Scalars['uuid']['output'];
};

export type UpdateTaskAssignations = {
  orgs: Array<Scalars['uuid']['input']>;
  teams: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type UpdateTaskDependenciesError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type UpdateTaskDependenciesErrors = {
  __typename?: 'UpdateTaskDependenciesErrors';
  errors: Array<UpdateTaskDependenciesError>;
};

export type UpdateTaskDependenciesInput = {
  from_id: Scalars['String']['input'];
  from_side: Scalars['String']['input'];
  taskIds: Array<Scalars['uuid']['input']>;
  to_id: Scalars['String']['input'];
  to_side: Scalars['String']['input'];
};

export type UpdateTaskDependenciesResult = UpdateTaskDependenciesErrors | UpdateTaskDependenciesSuccess;

export type UpdateTaskDependenciesSuccess = {
  __typename?: 'UpdateTaskDependenciesSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateTaskError = InputValidationError | ProjectDoesNotExist | TaskAssignationsNotAllowed | TaskDoesNotExist | UpdateTaskPermissionDenied;

export type UpdateTaskErrors = {
  __typename?: 'UpdateTaskErrors';
  errors: Array<UpdateTaskError>;
};

export type UpdateTaskFileVersions = {
  file_version_id: Scalars['uuid']['input'];
  location?: InputMaybe<UpdateTaskFileVersionsLocation>;
};

export type UpdateTaskFileVersionsError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type UpdateTaskFileVersionsErrors = {
  __typename?: 'UpdateTaskFileVersionsErrors';
  errors: Array<UpdateTaskFileVersionsError>;
};

export type UpdateTaskFileVersionsInput = {
  file_version_id: Scalars['uuid']['input'];
  location?: InputMaybe<UpdateTaskFileVersionsLocation>;
  task_id: Scalars['uuid']['input'];
};

export type UpdateTaskFileVersionsLocation = {
  page_number: Scalars['Int']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTaskFileVersionsResult = UpdateTaskFileVersionsErrors | UpdateTaskFileVersionsSuccess;

export type UpdateTaskFileVersionsSuccess = {
  __typename?: 'UpdateTaskFileVersionsSuccess';
  task_id: Scalars['uuid']['output'];
};

export type UpdateTaskInput = {
  assignations?: InputMaybe<UpdateTaskAssignations>;
  dependencies?: InputMaybe<EditTaskDependencies>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  file_versions?: InputMaybe<Array<InputMaybe<UpdateTaskFileVersions>>>;
  hours_done?: InputMaybe<Scalars['Float']['input']>;
  hours_expected?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['uuid']['input'];
  label_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  location?: InputMaybe<UpdateTaskLocation>;
  movement_mode?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UpdateTaskPermissions>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type UpdateTaskLocation = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type UpdateTaskPermissionDenied = {
  __typename?: 'UpdateTaskPermissionDenied';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateTaskPermissions = {
  orgs: Array<Scalars['uuid']['input']>;
  teams: Array<Scalars['uuid']['input']>;
  users: Array<Scalars['uuid']['input']>;
};

export type UpdateTaskResult = UpdateTaskErrors | UpdateTaskSuccess;

export type UpdateTaskSuccess = {
  __typename?: 'UpdateTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type UpdateTasksAssignationsError = InputValidationError | TaskAccessDenied | TaskAssignationsNotAllowed | TaskDoesNotExist;

export type UpdateTasksAssignationsErrors = {
  __typename?: 'UpdateTasksAssignationsErrors';
  errors: Array<UpdateTasksAssignationsError>;
};

export type UpdateTasksAssignationsInput = {
  orgs: Array<InputMaybe<Scalars['uuid']['input']>>;
  taskIds: Array<Scalars['uuid']['input']>;
  teams: Array<InputMaybe<Scalars['uuid']['input']>>;
  users: Array<InputMaybe<Scalars['uuid']['input']>>;
};

export type UpdateTasksAssignationsResult = UpdateTasksAssignationsErrors | UpdateTasksAssignationsSuccess;

export type UpdateTasksAssignationsSuccess = {
  __typename?: 'UpdateTasksAssignationsSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateTasksDatesError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type UpdateTasksDatesErrors = {
  __typename?: 'UpdateTasksDatesErrors';
  errors: Array<UpdateTasksDatesError>;
};

export type UpdateTasksDatesInput = {
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  movement_mode?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  taskIds: Array<Scalars['uuid']['input']>;
};

export type UpdateTasksDatesResult = UpdateTasksDatesErrors | UpdateTasksDatesSuccess;

export type UpdateTasksDatesSuccess = {
  __typename?: 'UpdateTasksDatesSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateTeamError = InputValidationError | TeamAccessDenied | TeamDoesNotExist | TeamNameAlreadyExist;

export type UpdateTeamErrors = {
  __typename?: 'UpdateTeamErrors';
  errors: Array<UpdateTeamError>;
};

export type UpdateTeamInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['uuid']['input'];
};

export type UpdateTeamResult = UpdateTeamErrors | UpdateTeamSuccess;

export type UpdateTeamSuccess = {
  __typename?: 'UpdateTeamSuccess';
  project_id: Scalars['uuid']['output'];
  team_id: Scalars['uuid']['output'];
};

export type UpdateUserAppMetadataError = InputValidationError;

export type UpdateUserAppMetadataErrors = {
  __typename?: 'UpdateUserAppMetadataErrors';
  errors: Array<UpdateUserAppMetadataError>;
};

export type UpdateUserAppMetadataInput = {
  app_desktop_installed?: InputMaybe<Scalars['Boolean']['input']>;
  app_mobile_installed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserAppMetadataResult = UpdateUserAppMetadataErrors | UpdateUserAppMetadataSuccess;

export type UpdateUserAppMetadataSuccess = {
  __typename?: 'UpdateUserAppMetadataSuccess';
  user_id: Scalars['ID']['output'];
};

export type UpdateUserProfileError = InputValidationError | UserDoesNotExist;

export type UpdateUserProfileErrors = {
  __typename?: 'UpdateUserProfileErrors';
  errors: Array<UpdateUserProfileError>;
};

export type UpdateUserProfileInput = {
  country_code: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  language: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileResult = UpdateUserProfileErrors | UpdateUserProfileSuccess;

export type UpdateUserProfileSuccess = {
  __typename?: 'UpdateUserProfileSuccess';
  ok: Scalars['Boolean']['output'];
  user_id: Scalars['ID']['output'];
};

export type UpdateUserTeamsError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | TeamAccessDenied | TeamDoesNotExist | UserDoesNotExist;

export type UpdateUserTeamsErrors = {
  __typename?: 'UpdateUserTeamsErrors';
  errors: Array<UpdateUserTeamsError>;
};

export type UpdateUserTeamsInput = {
  projectId: Scalars['uuid']['input'];
  teamIds: Array<InputMaybe<Scalars['uuid']['input']>>;
  userId: Scalars['uuid']['input'];
};

export type UpdateUserTeamsResult = UpdateUserTeamsErrors | UpdateUserTeamsSuccess;

export type UpdateUserTeamsSuccess = {
  __typename?: 'UpdateUserTeamsSuccess';
  project_id: Scalars['uuid']['output'];
  team_ids: Array<Maybe<Scalars['uuid']['output']>>;
  user_id: Scalars['uuid']['output'];
};

export type UpdateUsersCompanyNameError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | UserDoesNotExist;

export type UpdateUsersCompanyNameErrors = {
  __typename?: 'UpdateUsersCompanyNameErrors';
  errors: Array<UpdateUsersCompanyNameError>;
};

export type UpdateUsersCompanyNameInput = {
  companyData?: InputMaybe<UsersCompanyData>;
  projectId: Scalars['uuid']['input'];
  userIds: Array<InputMaybe<Scalars['uuid']['input']>>;
};

export type UpdateUsersCompanyNameResult = UpdateUsersCompanyNameErrors | UpdateUsersCompanyNameSuccess;

export type UpdateUsersCompanyNameSuccess = {
  __typename?: 'UpdateUsersCompanyNameSuccess';
  company_name: Scalars['String']['output'];
  project_id: Scalars['uuid']['output'];
  user_ids: Array<Maybe<Scalars['uuid']['output']>>;
};

export type UpdateUsersInTeamError = InputValidationError | TeamAccessDenied | TeamDoesNotExist;

export type UpdateUsersInTeamErrors = {
  __typename?: 'UpdateUsersInTeamErrors';
  errors: Array<UpdateUsersInTeamError>;
};

export type UpdateUsersInTeamInput = {
  teamId: Scalars['uuid']['input'];
  userIds: Array<InputMaybe<Scalars['uuid']['input']>>;
};

export type UpdateUsersInTeamResult = UpdateUsersInTeamErrors | UpdateUsersInTeamSuccess;

export type UpdateUsersInTeamSuccess = {
  __typename?: 'UpdateUsersInTeamSuccess';
  project_id: Scalars['uuid']['output'];
  team_id: Scalars['uuid']['output'];
};

export type UpdateUsersTeamsError = InputValidationError | ProjectAccessDenied | ProjectDoesNotExist | TeamAccessDenied | TeamDoesNotExist | UserDoesNotExist;

export type UpdateUsersTeamsErrors = {
  __typename?: 'UpdateUsersTeamsErrors';
  errors: Array<UpdateUsersTeamsError>;
};

export type UpdateUsersTeamsInput = {
  projectId: Scalars['uuid']['input'];
  teamIds: Array<InputMaybe<Scalars['uuid']['input']>>;
  userIds: Array<InputMaybe<Scalars['uuid']['input']>>;
};

export type UpdateUsersTeamsResult = UpdateUsersTeamsErrors | UpdateUsersTeamsSuccess;

export type UpdateUsersTeamsSuccess = {
  __typename?: 'UpdateUsersTeamsSuccess';
  project_id: Scalars['uuid']['output'];
  team_ids: Array<Maybe<Scalars['uuid']['output']>>;
  user_ids: Array<Maybe<Scalars['uuid']['output']>>;
};

export type UpdateValidationTaskError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type UpdateValidationTaskErrors = {
  __typename?: 'UpdateValidationTaskErrors';
  errors: Array<UpdateValidationTaskError>;
};

export type UpdateValidationTaskInput = {
  orgScope?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['uuid']['input'];
};

export type UpdateValidationTaskResult = UpdateValidationTaskErrors | UpdateValidationTaskSuccess;

export type UpdateValidationTaskSuccess = {
  __typename?: 'UpdateValidationTaskSuccess';
  task_id: Scalars['uuid']['output'];
};

export type UpdateValidationsTasksError = InputValidationError | TaskAccessDenied | TaskDoesNotExist;

export type UpdateValidationsTasksErrors = {
  __typename?: 'UpdateValidationsTasksErrors';
  errors: Array<UpdateValidationsTasksError>;
};

export type UpdateValidationsTasksInput = {
  taskIds: Array<Scalars['uuid']['input']>;
  validate: Scalars['Boolean']['input'];
};

export type UpdateValidationsTasksResult = UpdateValidationsTasksErrors | UpdateValidationsTasksSuccess;

export type UpdateValidationsTasksSuccess = {
  __typename?: 'UpdateValidationsTasksSuccess';
  task_ids: Array<Scalars['uuid']['output']>;
};

export type UploadPartsInput = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type UploadPartsTaskAttachmentInput = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type UserAlreadyPartOfThisTeam = {
  __typename?: 'UserAlreadyPartOfThisTeam';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserCommentIsNecessaryToFile = {
  __typename?: 'UserCommentIsNecessaryToFile';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserDoesNotExist = {
  __typename?: 'UserDoesNotExist';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserNotAssignedToFile = {
  __typename?: 'UserNotAssignedToFile';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserNotModeratorOfThisChannel = {
  __typename?: 'UserNotModeratorOfThisChannel';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserNotPartOfThisTeam = {
  __typename?: 'UserNotPartOfThisTeam';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ValidateSubtaskError = InputValidationError | SubtaskAccessDenied | SubtaskDoesNotExist;

export type ValidateSubtaskErrors = {
  __typename?: 'ValidateSubtaskErrors';
  errors: Array<ValidateSubtaskError>;
};

export type ValidateSubtaskInput = {
  closed: Scalars['Boolean']['input'];
  subtaskId: Scalars['uuid']['input'];
};

export type ValidateSubtaskResult = ValidateSubtaskErrors | ValidateSubtaskSuccess;

export type ValidateSubtaskSuccess = {
  __typename?: 'ValidateSubtaskSuccess';
  subtask_id: Scalars['uuid']['output'];
  task_id: Scalars['uuid']['output'];
};

/** Boolean expression to compare columns of type "_uuid". All fields are combined with logical 'AND'. */
export type _Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_uuid']['input']>;
  _gt?: InputMaybe<Scalars['_uuid']['input']>;
  _gte?: InputMaybe<Scalars['_uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['_uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_uuid']['input']>;
  _lte?: InputMaybe<Scalars['_uuid']['input']>;
  _neq?: InputMaybe<Scalars['_uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['_uuid']['input']>>;
};

export type AssigneesSorting = {
  sortOn?: InputMaybe<Scalars['String']['input']>;
  sortType?: InputMaybe<Scalars['String']['input']>;
};

export type AssigneesTasksReport = {
  orgs?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  teams?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
};

export type AwsS3Part = {
  __typename?: 'awsS3Part';
  etag: Scalars['String']['output'];
  partNumber: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type AwsS3PartTaskAttachment = {
  __typename?: 'awsS3PartTaskAttachment';
  etag: Scalars['String']['output'];
  partNumber: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type BroadcastApprovalExport = {
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BroadcastApprovalReport = {
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BroadcastFilesTreeReport = {
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BroadcastTasksExport = {
  assignees?: InputMaybe<AssigneesInput>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BroadcastTasksReport = {
  assignees?: InputMaybe<AssigneesTasksReport>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentApprovalReport = {
  footer?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentFilesTreeReport = {
  footer?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CopyTaskAttachmentsUploadSuccess = {
  __typename?: 'copyTaskAttachmentsUploadSuccess';
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "email_notifications" */
export type Email_Notifications = {
  __typename?: 'email_notifications';
  id: Scalars['uuid']['output'];
  invitation: Scalars['Boolean']['output'];
  unread_notification_report: Scalars['Boolean']['output'];
  user_id: Scalars['uuid']['output'];
  weekly_report: Scalars['Boolean']['output'];
};

/** Boolean expression to filter rows from the table "email_notifications". All fields are combined with a logical 'AND'. */
export type Email_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Email_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Notifications_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invitation?: InputMaybe<Boolean_Comparison_Exp>;
  unread_notification_report?: InputMaybe<Boolean_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  weekly_report?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "email_notifications". */
export type Email_Notifications_Order_By = {
  id?: InputMaybe<Order_By>;
  invitation?: InputMaybe<Order_By>;
  unread_notification_report?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  weekly_report?: InputMaybe<Order_By>;
};

/** select columns of table "email_notifications" */
export enum Email_Notifications_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Invitation = 'invitation',
  /** column name */
  UnreadNotificationReport = 'unread_notification_report',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WeeklyReport = 'weekly_report'
}

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  created_at: Scalars['timestamptz']['output'];
  creator_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  payload?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "events" */
export type EventsPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Events_Max_Order_By>;
  min?: InputMaybe<Events_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Type = 'type'
}

/** Will be used to track the status of a designed events in our workers */
export type Events_Workers_Status = {
  __typename?: 'events_workers_status';
  created_at: Scalars['timestamptz']['output'];
  creator_id: Scalars['uuid']['output'];
  event_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  payload: Scalars['jsonb']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Will be used to track the status of a designed events in our workers */
export type Events_Workers_StatusPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "events_workers_status". All fields are combined with a logical 'AND'. */
export type Events_Workers_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Workers_Status_Bool_Exp>>;
  _not?: InputMaybe<Events_Workers_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Workers_Status_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "events_workers_status". */
export type Events_Workers_Status_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "events_workers_status" */
export enum Events_Workers_Status_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type FilePermission = {
  access: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
};

export enum File_Access_Enum_Enum {
  /** Read only */
  Read = 'read',
  /** All access */
  Write = 'write'
}

/** Boolean expression to compare columns of type "file_access_enum_enum". All fields are combined with logical 'AND'. */
export type File_Access_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<File_Access_Enum_Enum>;
  _in?: InputMaybe<Array<File_Access_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<File_Access_Enum_Enum>;
  _nin?: InputMaybe<Array<File_Access_Enum_Enum>>;
};

/** columns and relationships of "file_approval_attachments" */
export type File_Approval_Attachments = {
  __typename?: 'file_approval_attachments';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  creator_id: Scalars['uuid']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file_approval: File_Approvals;
  file_approval_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "file_approval_attachments" */
export type File_Approval_Attachments_Aggregate = {
  __typename?: 'file_approval_attachments_aggregate';
  aggregate?: Maybe<File_Approval_Attachments_Aggregate_Fields>;
  nodes: Array<File_Approval_Attachments>;
};

/** aggregate fields of "file_approval_attachments" */
export type File_Approval_Attachments_Aggregate_Fields = {
  __typename?: 'file_approval_attachments_aggregate_fields';
  avg?: Maybe<File_Approval_Attachments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<File_Approval_Attachments_Max_Fields>;
  min?: Maybe<File_Approval_Attachments_Min_Fields>;
  stddev?: Maybe<File_Approval_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<File_Approval_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_Approval_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<File_Approval_Attachments_Sum_Fields>;
  var_pop?: Maybe<File_Approval_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<File_Approval_Attachments_Var_Samp_Fields>;
  variance?: Maybe<File_Approval_Attachments_Variance_Fields>;
};


/** aggregate fields of "file_approval_attachments" */
export type File_Approval_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Approval_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "file_approval_attachments" */
export type File_Approval_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<File_Approval_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Approval_Attachments_Max_Order_By>;
  min?: InputMaybe<File_Approval_Attachments_Min_Order_By>;
  stddev?: InputMaybe<File_Approval_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<File_Approval_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<File_Approval_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<File_Approval_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<File_Approval_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<File_Approval_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<File_Approval_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type File_Approval_Attachments_Avg_Fields = {
  __typename?: 'file_approval_attachments_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_approval_attachments". All fields are combined with a logical 'AND'. */
export type File_Approval_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<File_Approval_Attachments_Bool_Exp>>;
  _not?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<File_Approval_Attachments_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  file_approval?: InputMaybe<File_Approvals_Bool_Exp>;
  file_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type File_Approval_Attachments_Max_Fields = {
  __typename?: 'file_approval_attachments_max_fields';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  file_approval_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Max_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type File_Approval_Attachments_Min_Fields = {
  __typename?: 'file_approval_attachments_min_fields';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  file_approval_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Min_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_approval_attachments". */
export type File_Approval_Attachments_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file_approval?: InputMaybe<File_Approvals_Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "file_approval_attachments" */
export enum File_Approval_Attachments_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Extension = 'extension',
  /** column name */
  FileApprovalId = 'file_approval_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type File_Approval_Attachments_Stddev_Fields = {
  __typename?: 'file_approval_attachments_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type File_Approval_Attachments_Stddev_Pop_Fields = {
  __typename?: 'file_approval_attachments_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type File_Approval_Attachments_Stddev_Samp_Fields = {
  __typename?: 'file_approval_attachments_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type File_Approval_Attachments_Sum_Fields = {
  __typename?: 'file_approval_attachments_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type File_Approval_Attachments_Var_Pop_Fields = {
  __typename?: 'file_approval_attachments_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type File_Approval_Attachments_Var_Samp_Fields = {
  __typename?: 'file_approval_attachments_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type File_Approval_Attachments_Variance_Fields = {
  __typename?: 'file_approval_attachments_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "file_approval_attachments" */
export type File_Approval_Attachments_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "file_approvals" */
export type File_Approvals = {
  __typename?: 'file_approvals';
  /** An array relationship */
  approval_attachments: Array<File_Approval_Attachments>;
  /** An aggregate relationship */
  approval_attachments_aggregate: File_Approval_Attachments_Aggregate;
  /** An array relationship */
  comments: Array<File_Comments>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  file_approvals_file_versions_attachment: Array<File_Approvals_File_Versions>;
  /** An object relationship */
  file_version: File_Versions;
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  status: File_Approvals_Status_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "file_approvals" */
export type File_ApprovalsApproval_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<File_Approval_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approval_Attachments_Order_By>>;
  where?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
};


/** columns and relationships of "file_approvals" */
export type File_ApprovalsApproval_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Approval_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approval_Attachments_Order_By>>;
  where?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
};


/** columns and relationships of "file_approvals" */
export type File_ApprovalsCommentsArgs = {
  distinct_on?: InputMaybe<Array<File_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Comments_Order_By>>;
  where?: InputMaybe<File_Comments_Bool_Exp>;
};


/** columns and relationships of "file_approvals" */
export type File_ApprovalsFile_Approvals_File_Versions_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_File_Versions_Order_By>>;
  where?: InputMaybe<File_Approvals_File_Versions_Bool_Exp>;
};

/** order by aggregate values of table "file_approvals" */
export type File_Approvals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Approvals_Max_Order_By>;
  min?: InputMaybe<File_Approvals_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_approvals". All fields are combined with a logical 'AND'. */
export type File_Approvals_Bool_Exp = {
  _and?: InputMaybe<Array<File_Approvals_Bool_Exp>>;
  _not?: InputMaybe<File_Approvals_Bool_Exp>;
  _or?: InputMaybe<Array<File_Approvals_Bool_Exp>>;
  approval_attachments?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
  comments?: InputMaybe<File_Comments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_approvals_file_versions_attachment?: InputMaybe<File_Approvals_File_Versions_Bool_Exp>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<File_Approvals_Status_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** File versions attached to a file approvals */
export type File_Approvals_File_Versions = {
  __typename?: 'file_approvals_file_versions';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_approval: File_Approvals;
  file_approval_id: Scalars['uuid']['output'];
  /** An object relationship */
  file_version: File_Versions;
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "file_approvals_file_versions" */
export type File_Approvals_File_Versions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Approvals_File_Versions_Max_Order_By>;
  min?: InputMaybe<File_Approvals_File_Versions_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_approvals_file_versions". All fields are combined with a logical 'AND'. */
export type File_Approvals_File_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<File_Approvals_File_Versions_Bool_Exp>>;
  _not?: InputMaybe<File_Approvals_File_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<File_Approvals_File_Versions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_approval?: InputMaybe<File_Approvals_Bool_Exp>;
  file_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "file_approvals_file_versions" */
export type File_Approvals_File_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_approvals_file_versions" */
export type File_Approvals_File_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_approvals_file_versions". */
export type File_Approvals_File_Versions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_approval?: InputMaybe<File_Approvals_Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "file_approvals_file_versions" */
export enum File_Approvals_File_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileApprovalId = 'file_approval_id',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by max() on columns of table "file_approvals" */
export type File_Approvals_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_approvals" */
export type File_Approvals_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_approvals". */
export type File_Approvals_Order_By = {
  approval_attachments_aggregate?: InputMaybe<File_Approval_Attachments_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<File_Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_approvals_file_versions_attachment_aggregate?: InputMaybe<File_Approvals_File_Versions_Aggregate_Order_By>;
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "file_approvals" */
export enum File_Approvals_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum File_Approvals_Status_Enum_Enum {
  /** approved without observations */
  ApprovedWithoutComments = 'APPROVED_WITHOUT_COMMENTS',
  /** approved with observations */
  ApprovedWithComments = 'APPROVED_WITH_COMMENTS',
  /** approval denied */
  Denied = 'DENIED',
  /** not concerned */
  Nc = 'NC'
}

/** Boolean expression to compare columns of type "file_approvals_status_enum_enum". All fields are combined with logical 'AND'. */
export type File_Approvals_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<File_Approvals_Status_Enum_Enum>;
  _in?: InputMaybe<Array<File_Approvals_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<File_Approvals_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<File_Approvals_Status_Enum_Enum>>;
};

/** columns and relationships of "file_assignations" */
export type File_Assignations = {
  __typename?: 'file_assignations';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  orgs: Array<File_Assignations_Orgs>;
  /** An array relationship */
  teams: Array<File_Assignations_Teams>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<File_Assignations_Users>;
};


/** columns and relationships of "file_assignations" */
export type File_AssignationsOrgsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<File_Assignations_Orgs_Bool_Exp>;
};


/** columns and relationships of "file_assignations" */
export type File_AssignationsTeamsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Teams_Order_By>>;
  where?: InputMaybe<File_Assignations_Teams_Bool_Exp>;
};


/** columns and relationships of "file_assignations" */
export type File_AssignationsUsersArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Users_Order_By>>;
  where?: InputMaybe<File_Assignations_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "file_assignations". All fields are combined with a logical 'AND'. */
export type File_Assignations_Bool_Exp = {
  _and?: InputMaybe<Array<File_Assignations_Bool_Exp>>;
  _not?: InputMaybe<File_Assignations_Bool_Exp>;
  _or?: InputMaybe<Array<File_Assignations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgs?: InputMaybe<File_Assignations_Orgs_Bool_Exp>;
  teams?: InputMaybe<File_Assignations_Teams_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<File_Assignations_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "file_assignations". */
export type File_Assignations_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgs_aggregate?: InputMaybe<File_Assignations_Orgs_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<File_Assignations_Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<File_Assignations_Users_Aggregate_Order_By>;
};

/** columns and relationships of "file_assignations_orgs" */
export type File_Assignations_Orgs = {
  __typename?: 'file_assignations_orgs';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  file_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  file_assignee: File_Assignations;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "file_assignations_orgs" */
export type File_Assignations_Orgs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Assignations_Orgs_Max_Order_By>;
  min?: InputMaybe<File_Assignations_Orgs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_assignations_orgs". All fields are combined with a logical 'AND'. */
export type File_Assignations_Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<File_Assignations_Orgs_Bool_Exp>>;
  _not?: InputMaybe<File_Assignations_Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<File_Assignations_Orgs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_assignee?: InputMaybe<File_Assignations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "file_assignations_orgs" */
export type File_Assignations_Orgs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_assignations_orgs" */
export type File_Assignations_Orgs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_assignations_orgs". */
export type File_Assignations_Orgs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  file_assignee?: InputMaybe<File_Assignations_Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "file_assignations_orgs" */
export enum File_Assignations_Orgs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FileAssignationId = 'file_assignation_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select columns of table "file_assignations" */
export enum File_Assignations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "file_assignations_teams" */
export type File_Assignations_Teams = {
  __typename?: 'file_assignations_teams';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  file_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  file_assignee: File_Assignations;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "file_assignations_teams" */
export type File_Assignations_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Assignations_Teams_Max_Order_By>;
  min?: InputMaybe<File_Assignations_Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_assignations_teams". All fields are combined with a logical 'AND'. */
export type File_Assignations_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<File_Assignations_Teams_Bool_Exp>>;
  _not?: InputMaybe<File_Assignations_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<File_Assignations_Teams_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_assignee?: InputMaybe<File_Assignations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "file_assignations_teams" */
export type File_Assignations_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_assignations_teams" */
export type File_Assignations_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_assignations_teams". */
export type File_Assignations_Teams_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  file_assignee?: InputMaybe<File_Assignations_Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "file_assignations_teams" */
export enum File_Assignations_Teams_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FileAssignationId = 'file_assignation_id',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "file_assignations_users" */
export type File_Assignations_Users = {
  __typename?: 'file_assignations_users';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  file_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  file_assignee: File_Assignations;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "file_assignations_users" */
export type File_Assignations_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Assignations_Users_Max_Order_By>;
  min?: InputMaybe<File_Assignations_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_assignations_users". All fields are combined with a logical 'AND'. */
export type File_Assignations_Users_Bool_Exp = {
  _and?: InputMaybe<Array<File_Assignations_Users_Bool_Exp>>;
  _not?: InputMaybe<File_Assignations_Users_Bool_Exp>;
  _or?: InputMaybe<Array<File_Assignations_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_assignee?: InputMaybe<File_Assignations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "file_assignations_users" */
export type File_Assignations_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_assignations_users" */
export type File_Assignations_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_assignations_users". */
export type File_Assignations_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_assignation_id?: InputMaybe<Order_By>;
  file_assignee?: InputMaybe<File_Assignations_Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "file_assignations_users" */
export enum File_Assignations_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FileAssignationId = 'file_assignation_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "file_comments" */
export type File_Comments = {
  __typename?: 'file_comments';
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator: Users;
  creator_id: Scalars['uuid']['output'];
  /** An object relationship */
  file_approval?: Maybe<File_Approvals>;
  file_approval_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  file_version: File_Versions;
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "file_comments" */
export type File_Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Comments_Max_Order_By>;
  min?: InputMaybe<File_Comments_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_comments". All fields are combined with a logical 'AND'. */
export type File_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<File_Comments_Bool_Exp>>;
  _not?: InputMaybe<File_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<File_Comments_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_approval?: InputMaybe<File_Approvals_Bool_Exp>;
  file_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "file_comments" */
export type File_Comments_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_comments" */
export type File_Comments_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_comments". */
export type File_Comments_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  file_approval?: InputMaybe<File_Approvals_Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "file_comments" */
export enum File_Comments_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FileApprovalId = 'file_approval_id',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Intermediate table to link file to users, orgs, teams permissions */
export type File_Permissions = {
  __typename?: 'file_permissions';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  orgs: Array<File_Permissions_Orgs>;
  /** An array relationship */
  teams: Array<File_Permissions_Teams>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<File_Permissions_Users>;
};


/** Intermediate table to link file to users, orgs, teams permissions */
export type File_PermissionsOrgsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<File_Permissions_Orgs_Bool_Exp>;
};


/** Intermediate table to link file to users, orgs, teams permissions */
export type File_PermissionsTeamsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Teams_Order_By>>;
  where?: InputMaybe<File_Permissions_Teams_Bool_Exp>;
};


/** Intermediate table to link file to users, orgs, teams permissions */
export type File_PermissionsUsersArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Users_Order_By>>;
  where?: InputMaybe<File_Permissions_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "file_permissions". All fields are combined with a logical 'AND'. */
export type File_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<File_Permissions_Bool_Exp>>;
  _not?: InputMaybe<File_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<File_Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgs?: InputMaybe<File_Permissions_Orgs_Bool_Exp>;
  teams?: InputMaybe<File_Permissions_Teams_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<File_Permissions_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "file_permissions". */
export type File_Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgs_aggregate?: InputMaybe<File_Permissions_Orgs_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<File_Permissions_Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<File_Permissions_Users_Aggregate_Order_By>;
};

/** columns and relationships of "file_permissions_orgs" */
export type File_Permissions_Orgs = {
  __typename?: 'file_permissions_orgs';
  access: File_Access_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_permission: File_Permissions;
  file_permission_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "file_permissions_orgs" */
export type File_Permissions_Orgs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Permissions_Orgs_Max_Order_By>;
  min?: InputMaybe<File_Permissions_Orgs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_permissions_orgs". All fields are combined with a logical 'AND'. */
export type File_Permissions_Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<File_Permissions_Orgs_Bool_Exp>>;
  _not?: InputMaybe<File_Permissions_Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<File_Permissions_Orgs_Bool_Exp>>;
  access?: InputMaybe<File_Access_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_permission?: InputMaybe<File_Permissions_Bool_Exp>;
  file_permission_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "file_permissions_orgs" */
export type File_Permissions_Orgs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_permissions_orgs" */
export type File_Permissions_Orgs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_permissions_orgs". */
export type File_Permissions_Orgs_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_permission?: InputMaybe<File_Permissions_Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "file_permissions_orgs" */
export enum File_Permissions_Orgs_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilePermissionId = 'file_permission_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select columns of table "file_permissions" */
export enum File_Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "file_permissions_teams" */
export type File_Permissions_Teams = {
  __typename?: 'file_permissions_teams';
  access: File_Access_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_permission: File_Permissions;
  file_permission_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "file_permissions_teams" */
export type File_Permissions_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Permissions_Teams_Max_Order_By>;
  min?: InputMaybe<File_Permissions_Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_permissions_teams". All fields are combined with a logical 'AND'. */
export type File_Permissions_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<File_Permissions_Teams_Bool_Exp>>;
  _not?: InputMaybe<File_Permissions_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<File_Permissions_Teams_Bool_Exp>>;
  access?: InputMaybe<File_Access_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_permission?: InputMaybe<File_Permissions_Bool_Exp>;
  file_permission_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "file_permissions_teams" */
export type File_Permissions_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_permissions_teams" */
export type File_Permissions_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_permissions_teams". */
export type File_Permissions_Teams_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_permission?: InputMaybe<File_Permissions_Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "file_permissions_teams" */
export enum File_Permissions_Teams_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilePermissionId = 'file_permission_id',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "file_permissions_users" */
export type File_Permissions_Users = {
  __typename?: 'file_permissions_users';
  access: File_Access_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_permission: File_Permissions;
  file_permission_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "file_permissions_users" */
export type File_Permissions_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Permissions_Users_Max_Order_By>;
  min?: InputMaybe<File_Permissions_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_permissions_users". All fields are combined with a logical 'AND'. */
export type File_Permissions_Users_Bool_Exp = {
  _and?: InputMaybe<Array<File_Permissions_Users_Bool_Exp>>;
  _not?: InputMaybe<File_Permissions_Users_Bool_Exp>;
  _or?: InputMaybe<Array<File_Permissions_Users_Bool_Exp>>;
  access?: InputMaybe<File_Access_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_permission?: InputMaybe<File_Permissions_Bool_Exp>;
  file_permission_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "file_permissions_users" */
export type File_Permissions_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_permissions_users" */
export type File_Permissions_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_permissions_users". */
export type File_Permissions_Users_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_permission?: InputMaybe<File_Permissions_Order_By>;
  file_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "file_permissions_users" */
export enum File_Permissions_Users_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilePermissionId = 'file_permission_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "file_signatures" */
export type File_Signatures = {
  __typename?: 'file_signatures';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_version: File_Versions;
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  signed_at: Scalars['timestamptz']['output'];
  signed_by: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "file_signatures" */
export type File_Signatures_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Signatures_Max_Order_By>;
  min?: InputMaybe<File_Signatures_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_signatures". All fields are combined with a logical 'AND'. */
export type File_Signatures_Bool_Exp = {
  _and?: InputMaybe<Array<File_Signatures_Bool_Exp>>;
  _not?: InputMaybe<File_Signatures_Bool_Exp>;
  _or?: InputMaybe<Array<File_Signatures_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  signed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  signed_by?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "file_signatures" */
export type File_Signatures_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  signed_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_signatures" */
export type File_Signatures_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  signed_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_signatures". */
export type File_Signatures_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  signed_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "file_signatures" */
export enum File_Signatures_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  SignedBy = 'signed_by',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Link -> file_version_approval_requests -> user */
export type File_Version_Approval_Request_Users = {
  __typename?: 'file_version_approval_request_users';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_approval?: Maybe<File_Approvals>;
  file_approval_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  file_version_approval_request: File_Version_Approval_Requests;
  file_version_approval_request_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "file_version_approval_request_users" */
export type File_Version_Approval_Request_Users_Aggregate = {
  __typename?: 'file_version_approval_request_users_aggregate';
  aggregate?: Maybe<File_Version_Approval_Request_Users_Aggregate_Fields>;
  nodes: Array<File_Version_Approval_Request_Users>;
};

/** aggregate fields of "file_version_approval_request_users" */
export type File_Version_Approval_Request_Users_Aggregate_Fields = {
  __typename?: 'file_version_approval_request_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<File_Version_Approval_Request_Users_Max_Fields>;
  min?: Maybe<File_Version_Approval_Request_Users_Min_Fields>;
};


/** aggregate fields of "file_version_approval_request_users" */
export type File_Version_Approval_Request_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "file_version_approval_request_users" */
export type File_Version_Approval_Request_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Version_Approval_Request_Users_Max_Order_By>;
  min?: InputMaybe<File_Version_Approval_Request_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "file_version_approval_request_users". All fields are combined with a logical 'AND'. */
export type File_Version_Approval_Request_Users_Bool_Exp = {
  _and?: InputMaybe<Array<File_Version_Approval_Request_Users_Bool_Exp>>;
  _not?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
  _or?: InputMaybe<Array<File_Version_Approval_Request_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_approval?: InputMaybe<File_Approvals_Bool_Exp>;
  file_approval_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_version_approval_request?: InputMaybe<File_Version_Approval_Requests_Bool_Exp>;
  file_version_approval_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type File_Version_Approval_Request_Users_Max_Fields = {
  __typename?: 'file_version_approval_request_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_approval_id?: Maybe<Scalars['uuid']['output']>;
  file_version_approval_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "file_version_approval_request_users" */
export type File_Version_Approval_Request_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version_approval_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type File_Version_Approval_Request_Users_Min_Fields = {
  __typename?: 'file_version_approval_request_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  file_approval_id?: Maybe<Scalars['uuid']['output']>;
  file_version_approval_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "file_version_approval_request_users" */
export type File_Version_Approval_Request_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version_approval_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_version_approval_request_users". */
export type File_Version_Approval_Request_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_approval?: InputMaybe<File_Approvals_Order_By>;
  file_approval_id?: InputMaybe<Order_By>;
  file_version_approval_request?: InputMaybe<File_Version_Approval_Requests_Order_By>;
  file_version_approval_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "file_version_approval_request_users" */
export enum File_Version_Approval_Request_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileApprovalId = 'file_approval_id',
  /** column name */
  FileVersionApprovalRequestId = 'file_version_approval_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Intermediate table that link approvals requests for differents entities (users, ...) */
export type File_Version_Approval_Requests = {
  __typename?: 'file_version_approval_requests';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_version: File_Versions;
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<File_Version_Approval_Request_Users>;
  /** An aggregate relationship */
  users_aggregate: File_Version_Approval_Request_Users_Aggregate;
};


/** Intermediate table that link approvals requests for differents entities (users, ...) */
export type File_Version_Approval_RequestsUsersArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};


/** Intermediate table that link approvals requests for differents entities (users, ...) */
export type File_Version_Approval_RequestsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "file_version_approval_requests". All fields are combined with a logical 'AND'. */
export type File_Version_Approval_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<File_Version_Approval_Requests_Bool_Exp>>;
  _not?: InputMaybe<File_Version_Approval_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<File_Version_Approval_Requests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "file_version_approval_requests". */
export type File_Version_Approval_Requests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<File_Version_Approval_Request_Users_Aggregate_Order_By>;
};

/** select columns of table "file_version_approval_requests" */
export enum File_Version_Approval_Requests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Table to store 3D Autodesk Cloud converted file urn (SVF2) */
export type File_Version_Autodesk = {
  __typename?: 'file_version_autodesk';
  conversion_progress?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  urn?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "file_version_autodesk". All fields are combined with a logical 'AND'. */
export type File_Version_Autodesk_Bool_Exp = {
  _and?: InputMaybe<Array<File_Version_Autodesk_Bool_Exp>>;
  _not?: InputMaybe<File_Version_Autodesk_Bool_Exp>;
  _or?: InputMaybe<Array<File_Version_Autodesk_Bool_Exp>>;
  conversion_progress?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  urn?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "file_version_autodesk". */
export type File_Version_Autodesk_Order_By = {
  conversion_progress?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  urn?: InputMaybe<Order_By>;
};

/** select columns of table "file_version_autodesk" */
export enum File_Version_Autodesk_Select_Column {
  /** column name */
  ConversionProgress = 'conversion_progress',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Urn = 'urn'
}

/** columns and relationships of "file_versions" */
export type File_Versions = {
  __typename?: 'file_versions';
  /** An object relationship */
  approval_requests?: Maybe<File_Version_Approval_Requests>;
  /** An array relationship */
  approvals: Array<File_Approvals>;
  /** An object relationship */
  approvals_overview?: Maybe<File_Versions_Approvals_Overview>;
  /** An object relationship */
  autodesk?: Maybe<File_Version_Autodesk>;
  /** An array relationship */
  comments: Array<File_Comments>;
  content_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator: Users;
  creator_id: Scalars['uuid']['output'];
  /** A computed field, executes function "get_file_version_extension" */
  current_extension?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  /** An object relationship */
  file: Files;
  /** An array relationship */
  file_approvals_file_versions_attachment: Array<File_Approvals_File_Versions>;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_annotated: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  original_url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  signatures: Array<File_Signatures>;
  size?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  tasks: Array<Tasks_File_Versions>;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** Get the approvals of the current user on this file_version */
  user_approvals?: Maybe<Array<File_Approvals>>;
  /** An array relationship */
  views: Array<File_Views>;
};


/** columns and relationships of "file_versions" */
export type File_VersionsApprovalsArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_Order_By>>;
  where?: InputMaybe<File_Approvals_Bool_Exp>;
};


/** columns and relationships of "file_versions" */
export type File_VersionsCommentsArgs = {
  distinct_on?: InputMaybe<Array<File_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Comments_Order_By>>;
  where?: InputMaybe<File_Comments_Bool_Exp>;
};


/** columns and relationships of "file_versions" */
export type File_VersionsFile_Approvals_File_Versions_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_File_Versions_Order_By>>;
  where?: InputMaybe<File_Approvals_File_Versions_Bool_Exp>;
};


/** columns and relationships of "file_versions" */
export type File_VersionsSignaturesArgs = {
  distinct_on?: InputMaybe<Array<File_Signatures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Signatures_Order_By>>;
  where?: InputMaybe<File_Signatures_Bool_Exp>;
};


/** columns and relationships of "file_versions" */
export type File_VersionsTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_File_Versions_Order_By>>;
  where?: InputMaybe<Tasks_File_Versions_Bool_Exp>;
};


/** columns and relationships of "file_versions" */
export type File_VersionsUser_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_Order_By>>;
  where?: InputMaybe<File_Approvals_Bool_Exp>;
};


/** columns and relationships of "file_versions" */
export type File_VersionsViewsArgs = {
  distinct_on?: InputMaybe<Array<File_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Views_Order_By>>;
  where?: InputMaybe<File_Views_Bool_Exp>;
};

/** order by aggregate values of table "file_versions" */
export type File_Versions_Aggregate_Order_By = {
  avg?: InputMaybe<File_Versions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Versions_Max_Order_By>;
  min?: InputMaybe<File_Versions_Min_Order_By>;
  stddev?: InputMaybe<File_Versions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<File_Versions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<File_Versions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<File_Versions_Sum_Order_By>;
  var_pop?: InputMaybe<File_Versions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<File_Versions_Var_Samp_Order_By>;
  variance?: InputMaybe<File_Versions_Variance_Order_By>;
};

/** columns and relationships of "file_versions_approvals_overview" */
export type File_Versions_Approvals_Overview = {
  __typename?: 'file_versions_approvals_overview';
  /** An object relationship */
  file_version?: Maybe<File_Versions>;
  file_version_id?: Maybe<Scalars['uuid']['output']>;
  is_approved_with_comments?: Maybe<Scalars['Boolean']['output']>;
  is_approved_without_comments?: Maybe<Scalars['Boolean']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  is_denied?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to filter rows from the table "file_versions_approvals_overview". All fields are combined with a logical 'AND'. */
export type File_Versions_Approvals_Overview_Bool_Exp = {
  _and?: InputMaybe<Array<File_Versions_Approvals_Overview_Bool_Exp>>;
  _not?: InputMaybe<File_Versions_Approvals_Overview_Bool_Exp>;
  _or?: InputMaybe<Array<File_Versions_Approvals_Overview_Bool_Exp>>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_approved_with_comments?: InputMaybe<Boolean_Comparison_Exp>;
  is_approved_without_comments?: InputMaybe<Boolean_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  is_denied?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "file_versions_approvals_overview". */
export type File_Versions_Approvals_Overview_Order_By = {
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  is_approved_with_comments?: InputMaybe<Order_By>;
  is_approved_without_comments?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  is_denied?: InputMaybe<Order_By>;
};

/** select columns of table "file_versions_approvals_overview" */
export enum File_Versions_Approvals_Overview_Select_Column {
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  IsApprovedWithComments = 'is_approved_with_comments',
  /** column name */
  IsApprovedWithoutComments = 'is_approved_without_comments',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  IsDenied = 'is_denied'
}

/** order by avg() on columns of table "file_versions" */
export type File_Versions_Avg_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_versions". All fields are combined with a logical 'AND'. */
export type File_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<File_Versions_Bool_Exp>>;
  _not?: InputMaybe<File_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<File_Versions_Bool_Exp>>;
  approval_requests?: InputMaybe<File_Version_Approval_Requests_Bool_Exp>;
  approvals?: InputMaybe<File_Approvals_Bool_Exp>;
  approvals_overview?: InputMaybe<File_Versions_Approvals_Overview_Bool_Exp>;
  autodesk?: InputMaybe<File_Version_Autodesk_Bool_Exp>;
  comments?: InputMaybe<File_Comments_Bool_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  current_extension?: InputMaybe<String_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_approvals_file_versions_attachment?: InputMaybe<File_Approvals_File_Versions_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_annotated?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  signatures?: InputMaybe<File_Signatures_Bool_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tasks?: InputMaybe<Tasks_File_Versions_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_approvals?: InputMaybe<File_Approvals_Bool_Exp>;
  views?: InputMaybe<File_Views_Bool_Exp>;
};

/** order by max() on columns of table "file_versions" */
export type File_Versions_Max_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_versions" */
export type File_Versions_Min_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_versions". */
export type File_Versions_Order_By = {
  approval_requests?: InputMaybe<File_Version_Approval_Requests_Order_By>;
  approvals_aggregate?: InputMaybe<File_Approvals_Aggregate_Order_By>;
  approvals_overview?: InputMaybe<File_Versions_Approvals_Overview_Order_By>;
  autodesk?: InputMaybe<File_Version_Autodesk_Order_By>;
  comments_aggregate?: InputMaybe<File_Comments_Aggregate_Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  current_extension?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_approvals_file_versions_attachment_aggregate?: InputMaybe<File_Approvals_File_Versions_Aggregate_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_annotated?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  signatures_aggregate?: InputMaybe<File_Signatures_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_File_Versions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_approvals_aggregate?: InputMaybe<File_Approvals_Aggregate_Order_By>;
  views_aggregate?: InputMaybe<File_Views_Aggregate_Order_By>;
};

/** select columns of table "file_versions" */
export enum File_Versions_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Extension = 'extension',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnnotated = 'is_annotated',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "file_versions" */
export type File_Versions_Stddev_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "file_versions" */
export type File_Versions_Stddev_Pop_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "file_versions" */
export type File_Versions_Stddev_Samp_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "file_versions" */
export type File_Versions_Sum_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "file_versions" */
export type File_Versions_Var_Pop_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "file_versions" */
export type File_Versions_Var_Samp_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "file_versions" */
export type File_Versions_Variance_Order_By = {
  number?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** This table record everytime a user viewed a specific version of a file */
export type File_Views = {
  __typename?: 'file_views';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_version: File_Versions;
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "file_views" */
export type File_Views_Aggregate_Order_By = {
  avg?: InputMaybe<File_Views_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Views_Max_Order_By>;
  min?: InputMaybe<File_Views_Min_Order_By>;
  stddev?: InputMaybe<File_Views_Stddev_Order_By>;
  stddev_pop?: InputMaybe<File_Views_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<File_Views_Stddev_Samp_Order_By>;
  sum?: InputMaybe<File_Views_Sum_Order_By>;
  var_pop?: InputMaybe<File_Views_Var_Pop_Order_By>;
  var_samp?: InputMaybe<File_Views_Var_Samp_Order_By>;
  variance?: InputMaybe<File_Views_Variance_Order_By>;
};

/** order by avg() on columns of table "file_views" */
export type File_Views_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_views". All fields are combined with a logical 'AND'. */
export type File_Views_Bool_Exp = {
  _and?: InputMaybe<Array<File_Views_Bool_Exp>>;
  _not?: InputMaybe<File_Views_Bool_Exp>;
  _or?: InputMaybe<Array<File_Views_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "file_views" */
export type File_Views_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_views" */
export type File_Views_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_views". */
export type File_Views_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "file_views" */
export enum File_Views_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "file_views" */
export type File_Views_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "file_views" */
export type File_Views_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "file_views" */
export type File_Views_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "file_views" */
export type File_Views_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "file_views" */
export type File_Views_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "file_views" */
export type File_Views_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "file_views" */
export type File_Views_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Table that define Files */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  assignation?: Maybe<File_Assignations>;
  created_at: Scalars['timestamptz']['output'];
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  /** file extension in lowercase extracted last_file_version extension */
  extension?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  folder: Folders;
  id: Scalars['uuid']['output'];
  is_approval_mode: Scalars['Boolean']['output'];
  /** Will be true if an approval has been created on any of the file versions */
  is_approved_on_a_version?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  labels: Array<Files_To_Project_Labels>;
  /** Get the last file_version of the file (the one with the greateast number) */
  last_version?: Maybe<Array<File_Versions>>;
  name: Scalars['String']['output'];
  parent_id: Scalars['uuid']['output'];
  /** An object relationship */
  permission?: Maybe<File_Permissions>;
  /** An object relationship */
  project: Projects;
  /** Used to display contextual orgs assignations suggestions depending of the file permissions */
  suggestions_assignations_orgs?: Maybe<Array<Orgs>>;
  /** Used to display contextual teams assignations suggestions depending of the file permissions */
  suggestions_assignations_teams?: Maybe<Array<Teams>>;
  /** Used to display contextual users assignations suggestions depending of the file permissions */
  suggestions_assignations_users?: Maybe<Array<Users>>;
  /** Used to display contextual orgs permissions suggestions depending of the file parent permissions */
  suggestions_permissions_orgs?: Maybe<Array<Orgs>>;
  /** Used to display contextual teams permissions suggestions depending of the file parent permissions */
  suggestions_permissions_teams?: Maybe<Array<Teams>>;
  /** Used to display contextual users permissions suggestions depending of the file parent permissions */
  suggestions_permissions_users?: Maybe<Array<Users>>;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  versions: Array<File_Versions>;
  versions_by_pk?: Maybe<Array<File_Versions>>;
};


/** Table that define Files */
export type FilesLabelsArgs = {
  distinct_on?: InputMaybe<Array<Files_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Files_To_Project_Labels_Bool_Exp>;
};


/** Table that define Files */
export type FilesLast_VersionArgs = {
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};


/** Table that define Files */
export type FilesSuggestions_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_Order_By>>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};


/** Table that define Files */
export type FilesSuggestions_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** Table that define Files */
export type FilesSuggestions_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Table that define Files */
export type FilesSuggestions_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_Order_By>>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};


/** Table that define Files */
export type FilesSuggestions_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** Table that define Files */
export type FilesSuggestions_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Table that define Files */
export type FilesVersionsArgs = {
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};


/** Table that define Files */
export type FilesVersions_By_PkArgs = {
  args: Versions_By_Pk_Files_Args;
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};

/** order by aggregate values of table "files" */
export type Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  assignation?: InputMaybe<File_Assignations_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  folder?: InputMaybe<Folders_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_approval_mode?: InputMaybe<Boolean_Comparison_Exp>;
  is_approved_on_a_version?: InputMaybe<Boolean_Comparison_Exp>;
  labels?: InputMaybe<Files_To_Project_Labels_Bool_Exp>;
  last_version?: InputMaybe<File_Versions_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<File_Permissions_Bool_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  suggestions_assignations_orgs?: InputMaybe<Orgs_Bool_Exp>;
  suggestions_assignations_teams?: InputMaybe<Teams_Bool_Exp>;
  suggestions_assignations_users?: InputMaybe<Users_Bool_Exp>;
  suggestions_permissions_orgs?: InputMaybe<Orgs_Bool_Exp>;
  suggestions_permissions_teams?: InputMaybe<Teams_Bool_Exp>;
  suggestions_permissions_users?: InputMaybe<Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  versions?: InputMaybe<File_Versions_Bool_Exp>;
};

/** order by max() on columns of table "files" */
export type Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "files" */
export type Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  assignation?: InputMaybe<File_Assignations_Order_By>;
  created_at?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  folder?: InputMaybe<Folders_Order_By>;
  id?: InputMaybe<Order_By>;
  is_approval_mode?: InputMaybe<Order_By>;
  is_approved_on_a_version?: InputMaybe<Order_By>;
  labels_aggregate?: InputMaybe<Files_To_Project_Labels_Aggregate_Order_By>;
  last_version_aggregate?: InputMaybe<File_Versions_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<File_Permissions_Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  suggestions_assignations_orgs_aggregate?: InputMaybe<Orgs_Aggregate_Order_By>;
  suggestions_assignations_teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  suggestions_assignations_users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  suggestions_permissions_orgs_aggregate?: InputMaybe<Orgs_Aggregate_Order_By>;
  suggestions_permissions_teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  suggestions_permissions_users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  versions_aggregate?: InputMaybe<File_Versions_Aggregate_Order_By>;
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsApprovalMode = 'is_approval_mode',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** relationship table between file and label */
export type Files_To_Project_Labels = {
  __typename?: 'files_to_project_labels';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  label: Project_Labels;
  order: Scalars['Int']['output'];
  project_label_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "files_to_project_labels" */
export type Files_To_Project_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Files_To_Project_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_To_Project_Labels_Max_Order_By>;
  min?: InputMaybe<Files_To_Project_Labels_Min_Order_By>;
  stddev?: InputMaybe<Files_To_Project_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_To_Project_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_To_Project_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_To_Project_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Files_To_Project_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_To_Project_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_To_Project_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "files_to_project_labels". All fields are combined with a logical 'AND'. */
export type Files_To_Project_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Files_To_Project_Labels_Bool_Exp>>;
  _not?: InputMaybe<Files_To_Project_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Files_To_Project_Labels_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<Project_Labels_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  project_label_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "files_to_project_labels". */
export type Files_To_Project_Labels_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Project_Labels_Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "files_to_project_labels" */
export enum Files_To_Project_Labels_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  ProjectLabelId = 'project_label_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "files_to_project_labels" */
export type Files_To_Project_Labels_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** user filter select as default */
export type Filter_User_Default = {
  __typename?: 'filter_user_default';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  filter?: Maybe<Filters>;
  filter_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "filter_user_default" */
export type Filter_User_Default_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Filter_User_Default_Max_Order_By>;
  min?: InputMaybe<Filter_User_Default_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "filter_user_default". All fields are combined with a logical 'AND'. */
export type Filter_User_Default_Bool_Exp = {
  _and?: InputMaybe<Array<Filter_User_Default_Bool_Exp>>;
  _not?: InputMaybe<Filter_User_Default_Bool_Exp>;
  _or?: InputMaybe<Array<Filter_User_Default_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  filter?: InputMaybe<Filters_Bool_Exp>;
  filter_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "filter_user_default" */
export type Filter_User_Default_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  filter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "filter_user_default" */
export type Filter_User_Default_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  filter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "filter_user_default". */
export type Filter_User_Default_Order_By = {
  created_at?: InputMaybe<Order_By>;
  filter?: InputMaybe<Filters_Order_By>;
  filter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "filter_user_default" */
export enum Filter_User_Default_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilterId = 'filter_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** This table saves the information about the saved filters. */
export type Filters = {
  __typename?: 'filters';
  color: Scalars['String']['output'];
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  creator_id: Scalars['uuid']['output'];
  /** An array relationship */
  filterDefault: Array<Filter_User_Default>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  visibility_org_id?: Maybe<Scalars['uuid']['output']>;
  visibility_project_id?: Maybe<Scalars['uuid']['output']>;
  visibility_team_id?: Maybe<Scalars['uuid']['output']>;
  visibility_user_id?: Maybe<Scalars['uuid']['output']>;
};


/** This table saves the information about the saved filters. */
export type FiltersFilterDefaultArgs = {
  distinct_on?: InputMaybe<Array<Filter_User_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Filter_User_Default_Order_By>>;
  where?: InputMaybe<Filter_User_Default_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "filters". All fields are combined with a logical 'AND'. */
export type Filters_Bool_Exp = {
  _and?: InputMaybe<Array<Filters_Bool_Exp>>;
  _not?: InputMaybe<Filters_Bool_Exp>;
  _or?: InputMaybe<Array<Filters_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  filterDefault?: InputMaybe<Filter_User_Default_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visibility_org_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "filters". */
export type Filters_Order_By = {
  color?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  filterDefault_aggregate?: InputMaybe<Filter_User_Default_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_org_id?: InputMaybe<Order_By>;
  visibility_project_id?: InputMaybe<Order_By>;
  visibility_team_id?: InputMaybe<Order_By>;
  visibility_user_id?: InputMaybe<Order_By>;
};

/** select columns of table "filters" */
export enum Filters_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibilityOrgId = 'visibility_org_id',
  /** column name */
  VisibilityProjectId = 'visibility_project_id',
  /** column name */
  VisibilityTeamId = 'visibility_team_id',
  /** column name */
  VisibilityUserId = 'visibility_user_id'
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type FolderPermission = {
  access: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
};

export enum Folder_Access_Enum_Enum {
  /** Read only */
  Read = 'read',
  /** All access */
  Write = 'write'
}

/** Boolean expression to compare columns of type "folder_access_enum_enum". All fields are combined with logical 'AND'. */
export type Folder_Access_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Folder_Access_Enum_Enum>;
  _in?: InputMaybe<Array<Folder_Access_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Folder_Access_Enum_Enum>;
  _nin?: InputMaybe<Array<Folder_Access_Enum_Enum>>;
};

/** Intermediate table that link folder to user, org, team assignation */
export type Folder_Assignations = {
  __typename?: 'folder_assignations';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  folder: Folders;
  folder_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  orgs: Array<Folder_Assignations_Orgs>;
  /** An array relationship */
  teams: Array<Folder_Assignations_Teams>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Folder_Assignations_Users>;
};


/** Intermediate table that link folder to user, org, team assignation */
export type Folder_AssignationsOrgsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
};


/** Intermediate table that link folder to user, org, team assignation */
export type Folder_AssignationsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
};


/** Intermediate table that link folder to user, org, team assignation */
export type Folder_AssignationsUsersArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Users_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "folder_assignations". All fields are combined with a logical 'AND'. */
export type Folder_Assignations_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Assignations_Bool_Exp>>;
  _not?: InputMaybe<Folder_Assignations_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Assignations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder?: InputMaybe<Folders_Bool_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgs?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
  teams?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "folder_assignations". */
export type Folder_Assignations_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder?: InputMaybe<Folders_Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgs_aggregate?: InputMaybe<Folder_Assignations_Orgs_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Folder_Assignations_Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Folder_Assignations_Users_Aggregate_Order_By>;
};

/** Link folder -> folder_assignations -> org */
export type Folder_Assignations_Orgs = {
  __typename?: 'folder_assignations_orgs';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  folder_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  folder_assignee: Folder_Assignations;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "folder_assignations_orgs" */
export type Folder_Assignations_Orgs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Assignations_Orgs_Max_Order_By>;
  min?: InputMaybe<Folder_Assignations_Orgs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "folder_assignations_orgs". All fields are combined with a logical 'AND'. */
export type Folder_Assignations_Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Assignations_Orgs_Bool_Exp>>;
  _not?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Assignations_Orgs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_assignee?: InputMaybe<Folder_Assignations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "folder_assignations_orgs" */
export type Folder_Assignations_Orgs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folder_assignations_orgs" */
export type Folder_Assignations_Orgs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folder_assignations_orgs". */
export type Folder_Assignations_Orgs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  folder_assignee?: InputMaybe<Folder_Assignations_Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "folder_assignations_orgs" */
export enum Folder_Assignations_Orgs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FolderAssignationId = 'folder_assignation_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select columns of table "folder_assignations" */
export enum Folder_Assignations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Link folder -> folder_assignations -> team */
export type Folder_Assignations_Teams = {
  __typename?: 'folder_assignations_teams';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  folder_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  folder_assignee: Folder_Assignations;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "folder_assignations_teams" */
export type Folder_Assignations_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Assignations_Teams_Max_Order_By>;
  min?: InputMaybe<Folder_Assignations_Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "folder_assignations_teams". All fields are combined with a logical 'AND'. */
export type Folder_Assignations_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Assignations_Teams_Bool_Exp>>;
  _not?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Assignations_Teams_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_assignee?: InputMaybe<Folder_Assignations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "folder_assignations_teams" */
export type Folder_Assignations_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folder_assignations_teams" */
export type Folder_Assignations_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folder_assignations_teams". */
export type Folder_Assignations_Teams_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  folder_assignee?: InputMaybe<Folder_Assignations_Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "folder_assignations_teams" */
export enum Folder_Assignations_Teams_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FolderAssignationId = 'folder_assignation_id',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Link folder -> folder_assignations -> user */
export type Folder_Assignations_Users = {
  __typename?: 'folder_assignations_users';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  folder_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  folder_assignee: Folder_Assignations;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "folder_assignations_users" */
export type Folder_Assignations_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Assignations_Users_Max_Order_By>;
  min?: InputMaybe<Folder_Assignations_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "folder_assignations_users". All fields are combined with a logical 'AND'. */
export type Folder_Assignations_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Assignations_Users_Bool_Exp>>;
  _not?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Assignations_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_assignee?: InputMaybe<Folder_Assignations_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "folder_assignations_users" */
export type Folder_Assignations_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folder_assignations_users" */
export type Folder_Assignations_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folder_assignations_users". */
export type Folder_Assignations_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_assignation_id?: InputMaybe<Order_By>;
  folder_assignee?: InputMaybe<Folder_Assignations_Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "folder_assignations_users" */
export enum Folder_Assignations_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FolderAssignationId = 'folder_assignation_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Intermediate table that link folder to user, org, team permission */
export type Folder_Permissions = {
  __typename?: 'folder_permissions';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  folder: Folders;
  folder_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  inherited_from?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  orgs: Array<Folder_Permissions_Orgs>;
  /** An array relationship */
  teams: Array<Folder_Permissions_Teams>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Folder_Permissions_Users>;
};


/** Intermediate table that link folder to user, org, team permission */
export type Folder_PermissionsOrgsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Orgs_Bool_Exp>;
};


/** Intermediate table that link folder to user, org, team permission */
export type Folder_PermissionsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Teams_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Teams_Bool_Exp>;
};


/** Intermediate table that link folder to user, org, team permission */
export type Folder_PermissionsUsersArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Users_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "folder_permissions". All fields are combined with a logical 'AND'. */
export type Folder_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Folder_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder?: InputMaybe<Folders_Bool_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inherited_from?: InputMaybe<Uuid_Comparison_Exp>;
  orgs?: InputMaybe<Folder_Permissions_Orgs_Bool_Exp>;
  teams?: InputMaybe<Folder_Permissions_Teams_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Folder_Permissions_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "folder_permissions". */
export type Folder_Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder?: InputMaybe<Folders_Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inherited_from?: InputMaybe<Order_By>;
  orgs_aggregate?: InputMaybe<Folder_Permissions_Orgs_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Folder_Permissions_Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Folder_Permissions_Users_Aggregate_Order_By>;
};

/** Link folder -> folder_permissions -> org */
export type Folder_Permissions_Orgs = {
  __typename?: 'folder_permissions_orgs';
  access: Folder_Access_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  folder_permission_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  /** An object relationship */
  permission: Folder_Permissions;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "folder_permissions_orgs" */
export type Folder_Permissions_Orgs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Permissions_Orgs_Max_Order_By>;
  min?: InputMaybe<Folder_Permissions_Orgs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "folder_permissions_orgs". All fields are combined with a logical 'AND'. */
export type Folder_Permissions_Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Permissions_Orgs_Bool_Exp>>;
  _not?: InputMaybe<Folder_Permissions_Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Permissions_Orgs_Bool_Exp>>;
  access?: InputMaybe<Folder_Access_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_permission_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<Folder_Permissions_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "folder_permissions_orgs" */
export type Folder_Permissions_Orgs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folder_permissions_orgs" */
export type Folder_Permissions_Orgs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folder_permissions_orgs". */
export type Folder_Permissions_Orgs_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Folder_Permissions_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "folder_permissions_orgs" */
export enum Folder_Permissions_Orgs_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FolderPermissionId = 'folder_permission_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select columns of table "folder_permissions" */
export enum Folder_Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  InheritedFrom = 'inherited_from',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Link folder -> folder_permissions -> team */
export type Folder_Permissions_Teams = {
  __typename?: 'folder_permissions_teams';
  access: Folder_Access_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  folder_permission_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  permission: Folder_Permissions;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "folder_permissions_teams" */
export type Folder_Permissions_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Permissions_Teams_Max_Order_By>;
  min?: InputMaybe<Folder_Permissions_Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "folder_permissions_teams". All fields are combined with a logical 'AND'. */
export type Folder_Permissions_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Permissions_Teams_Bool_Exp>>;
  _not?: InputMaybe<Folder_Permissions_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Permissions_Teams_Bool_Exp>>;
  access?: InputMaybe<Folder_Access_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_permission_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<Folder_Permissions_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "folder_permissions_teams" */
export type Folder_Permissions_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folder_permissions_teams" */
export type Folder_Permissions_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folder_permissions_teams". */
export type Folder_Permissions_Teams_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Folder_Permissions_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "folder_permissions_teams" */
export enum Folder_Permissions_Teams_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FolderPermissionId = 'folder_permission_id',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Link folder -> folder_permissions -> user */
export type Folder_Permissions_Users = {
  __typename?: 'folder_permissions_users';
  access: Folder_Access_Enum_Enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  folder_permission_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  permission: Folder_Permissions;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "folder_permissions_users" */
export type Folder_Permissions_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Permissions_Users_Max_Order_By>;
  min?: InputMaybe<Folder_Permissions_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "folder_permissions_users". All fields are combined with a logical 'AND'. */
export type Folder_Permissions_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Permissions_Users_Bool_Exp>>;
  _not?: InputMaybe<Folder_Permissions_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Permissions_Users_Bool_Exp>>;
  access?: InputMaybe<Folder_Access_Enum_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  folder_permission_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<Folder_Permissions_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "folder_permissions_users" */
export type Folder_Permissions_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folder_permissions_users" */
export type Folder_Permissions_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folder_permissions_users". */
export type Folder_Permissions_Users_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  folder_permission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Folder_Permissions_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "folder_permissions_users" */
export enum Folder_Permissions_Users_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  FolderPermissionId = 'folder_permission_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** This table record everytime a user viewed a specific folder */
export type Folder_Views = {
  __typename?: 'folder_views';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  folder: Folders;
  folder_id: Scalars['uuid']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "folder_views" */
export type Folder_Views_Aggregate_Order_By = {
  avg?: InputMaybe<Folder_Views_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folder_Views_Max_Order_By>;
  min?: InputMaybe<Folder_Views_Min_Order_By>;
  stddev?: InputMaybe<Folder_Views_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Folder_Views_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Folder_Views_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Folder_Views_Sum_Order_By>;
  var_pop?: InputMaybe<Folder_Views_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Folder_Views_Var_Samp_Order_By>;
  variance?: InputMaybe<Folder_Views_Variance_Order_By>;
};

/** order by avg() on columns of table "folder_views" */
export type Folder_Views_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "folder_views". All fields are combined with a logical 'AND'. */
export type Folder_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Folder_Views_Bool_Exp>>;
  _not?: InputMaybe<Folder_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Folder_Views_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder?: InputMaybe<Folders_Bool_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "folder_views" */
export type Folder_Views_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folder_views" */
export type Folder_Views_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folder_views". */
export type Folder_Views_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder?: InputMaybe<Folders_Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "folder_views" */
export enum Folder_Views_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "folder_views" */
export type Folder_Views_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "folder_views" */
export type Folder_Views_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "folder_views" */
export type Folder_Views_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "folder_views" */
export type Folder_Views_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "folder_views" */
export type Folder_Views_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "folder_views" */
export type Folder_Views_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "folder_views" */
export type Folder_Views_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Table of folders */
export type Folders = {
  __typename?: 'folders';
  approval_automation_mode: Scalars['Boolean']['output'];
  /** An object relationship */
  assignation?: Maybe<Folder_Assignations>;
  assignee_automation_mode: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  duedate_automation_mode?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  files: Array<Files>;
  /** An array relationship */
  folders: Array<Folders>;
  id: Scalars['uuid']['output'];
  /** true if the folder is currently in the bin of this project */
  is_in_bin?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  labels: Array<Folders_To_Project_Labels>;
  name: Scalars['String']['output'];
  /** A computed field, executes function "get_user_folder_notification" */
  notification_badge?: Maybe<Array<T_Folder_Notification_Badge>>;
  /** An object relationship */
  parent?: Maybe<Folders>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  parents_ids?: Maybe<Scalars['_uuid']['output']>;
  /** An object relationship */
  permission?: Maybe<Folder_Permissions>;
  /** An object relationship */
  project: Projects;
  /** The path of this folder from the nearest root */
  pwd?: Maybe<Array<T_Folder_Pwd>>;
  /** Used to display contextual orgs assignations suggestions depending of the folder permissions */
  suggestions_assignations_orgs?: Maybe<Array<Orgs>>;
  /** Used to display contextual teams assignations suggestions depending of the folder permissions */
  suggestions_assignations_teams?: Maybe<Array<Teams>>;
  /** Used to display contextual users assignations suggestions depending of the folder permissions */
  suggestions_assignations_users?: Maybe<Array<Users>>;
  /** Used to display contextual orgs permissions suggestions depending of the folder parent permissions */
  suggestions_permissions_orgs?: Maybe<Array<Orgs>>;
  /** Used to display contextual teams permissions suggestions depending of the folder parent permissions */
  suggestions_permissions_teams?: Maybe<Array<Teams>>;
  /** Used to display contextual users permissions suggestions depending of the folder parent permissions */
  suggestions_permissions_users?: Maybe<Array<Users>>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  views: Array<Folder_Views>;
};


/** Table of folders */
export type FoldersFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** Table of folders */
export type FoldersFoldersArgs = {
  distinct_on?: InputMaybe<Array<Folders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folders_Order_By>>;
  where?: InputMaybe<Folders_Bool_Exp>;
};


/** Table of folders */
export type FoldersLabelsArgs = {
  distinct_on?: InputMaybe<Array<Folders_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folders_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Folders_To_Project_Labels_Bool_Exp>;
};


/** Table of folders */
export type FoldersNotification_BadgeArgs = {
  distinct_on?: InputMaybe<Array<T_Folder_Notification_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<T_Folder_Notification_Badge_Order_By>>;
  where?: InputMaybe<T_Folder_Notification_Badge_Bool_Exp>;
};


/** Table of folders */
export type FoldersPwdArgs = {
  distinct_on?: InputMaybe<Array<T_Folder_Pwd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<T_Folder_Pwd_Order_By>>;
  where?: InputMaybe<T_Folder_Pwd_Bool_Exp>;
};


/** Table of folders */
export type FoldersSuggestions_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_Order_By>>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};


/** Table of folders */
export type FoldersSuggestions_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** Table of folders */
export type FoldersSuggestions_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Table of folders */
export type FoldersSuggestions_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_Order_By>>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};


/** Table of folders */
export type FoldersSuggestions_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** Table of folders */
export type FoldersSuggestions_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** Table of folders */
export type FoldersViewsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Views_Order_By>>;
  where?: InputMaybe<Folder_Views_Bool_Exp>;
};

/** order by aggregate values of table "folders" */
export type Folders_Aggregate_Order_By = {
  avg?: InputMaybe<Folders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folders_Max_Order_By>;
  min?: InputMaybe<Folders_Min_Order_By>;
  stddev?: InputMaybe<Folders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Folders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Folders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Folders_Sum_Order_By>;
  var_pop?: InputMaybe<Folders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Folders_Var_Samp_Order_By>;
  variance?: InputMaybe<Folders_Variance_Order_By>;
};

/** order by avg() on columns of table "folders" */
export type Folders_Avg_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "folders". All fields are combined with a logical 'AND'. */
export type Folders_Bool_Exp = {
  _and?: InputMaybe<Array<Folders_Bool_Exp>>;
  _not?: InputMaybe<Folders_Bool_Exp>;
  _or?: InputMaybe<Array<Folders_Bool_Exp>>;
  approval_automation_mode?: InputMaybe<Boolean_Comparison_Exp>;
  assignation?: InputMaybe<Folder_Assignations_Bool_Exp>;
  assignee_automation_mode?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  duedate_automation_mode?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  folders?: InputMaybe<Folders_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_in_bin?: InputMaybe<Boolean_Comparison_Exp>;
  labels?: InputMaybe<Folders_To_Project_Labels_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_badge?: InputMaybe<T_Folder_Notification_Badge_Bool_Exp>;
  parent?: InputMaybe<Folders_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  parents_ids?: InputMaybe<_Uuid_Comparison_Exp>;
  permission?: InputMaybe<Folder_Permissions_Bool_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  pwd?: InputMaybe<T_Folder_Pwd_Bool_Exp>;
  suggestions_assignations_orgs?: InputMaybe<Orgs_Bool_Exp>;
  suggestions_assignations_teams?: InputMaybe<Teams_Bool_Exp>;
  suggestions_assignations_users?: InputMaybe<Users_Bool_Exp>;
  suggestions_permissions_orgs?: InputMaybe<Orgs_Bool_Exp>;
  suggestions_permissions_teams?: InputMaybe<Teams_Bool_Exp>;
  suggestions_permissions_users?: InputMaybe<Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  views?: InputMaybe<Folder_Views_Bool_Exp>;
};

/** order by max() on columns of table "folders" */
export type Folders_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  duedate_automation_mode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folders" */
export type Folders_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  duedate_automation_mode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folders". */
export type Folders_Order_By = {
  approval_automation_mode?: InputMaybe<Order_By>;
  assignation?: InputMaybe<Folder_Assignations_Order_By>;
  assignee_automation_mode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  duedate_automation_mode?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  folders_aggregate?: InputMaybe<Folders_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_in_bin?: InputMaybe<Order_By>;
  labels_aggregate?: InputMaybe<Folders_To_Project_Labels_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  notification_badge_aggregate?: InputMaybe<T_Folder_Notification_Badge_Aggregate_Order_By>;
  parent?: InputMaybe<Folders_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  parents_ids?: InputMaybe<Order_By>;
  permission?: InputMaybe<Folder_Permissions_Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  pwd_aggregate?: InputMaybe<T_Folder_Pwd_Aggregate_Order_By>;
  suggestions_assignations_orgs_aggregate?: InputMaybe<Orgs_Aggregate_Order_By>;
  suggestions_assignations_teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  suggestions_assignations_users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  suggestions_permissions_orgs_aggregate?: InputMaybe<Orgs_Aggregate_Order_By>;
  suggestions_permissions_teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  suggestions_permissions_users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views_aggregate?: InputMaybe<Folder_Views_Aggregate_Order_By>;
};

/** select columns of table "folders" */
export enum Folders_Select_Column {
  /** column name */
  ApprovalAutomationMode = 'approval_automation_mode',
  /** column name */
  AssigneeAutomationMode = 'assignee_automation_mode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  DuedateAutomationMode = 'duedate_automation_mode',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ParentsIds = 'parents_ids',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "folders" */
export type Folders_Stddev_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "folders" */
export type Folders_Stddev_Pop_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "folders" */
export type Folders_Stddev_Samp_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "folders" */
export type Folders_Sum_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

/** relationship table between folder and label */
export type Folders_To_Project_Labels = {
  __typename?: 'folders_to_project_labels';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  folder: Folders;
  folder_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  label: Project_Labels;
  order: Scalars['Int']['output'];
  project_label_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Folders_To_Project_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Folders_To_Project_Labels_Max_Order_By>;
  min?: InputMaybe<Folders_To_Project_Labels_Min_Order_By>;
  stddev?: InputMaybe<Folders_To_Project_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Folders_To_Project_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Folders_To_Project_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Folders_To_Project_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Folders_To_Project_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Folders_To_Project_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Folders_To_Project_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "folders_to_project_labels". All fields are combined with a logical 'AND'. */
export type Folders_To_Project_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Folders_To_Project_Labels_Bool_Exp>>;
  _not?: InputMaybe<Folders_To_Project_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Folders_To_Project_Labels_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder?: InputMaybe<Folders_Bool_Exp>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<Project_Labels_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  project_label_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "folders_to_project_labels". */
export type Folders_To_Project_Labels_Order_By = {
  created_at?: InputMaybe<Order_By>;
  folder?: InputMaybe<Folders_Order_By>;
  folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Project_Labels_Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "folders_to_project_labels" */
export enum Folders_To_Project_Labels_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  ProjectLabelId = 'project_label_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "folders_to_project_labels" */
export type Folders_To_Project_Labels_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "folders" */
export type Folders_Var_Pop_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "folders" */
export type Folders_Var_Samp_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "folders" */
export type Folders_Variance_Order_By = {
  duedate_automation_mode?: InputMaybe<Order_By>;
};

export type GetAutodeskToken = {
  __typename?: 'getAutodeskToken';
  autodesk_access_token: Scalars['String']['output'];
};

export type Get_File_Version_Args = {
  file_row?: InputMaybe<Scalars['files_scalar']['input']>;
  file_version_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  FilterUserDefault?: Maybe<FilterUserDefaultResult>;
  FinalizeUploadedProjectGroupAvatar?: Maybe<FinalizeUploadedProjectGroupAvatarResult>;
  PrepareProjectGroupAssetForUpload?: Maybe<PrepareProjectGroupAssetForUploadResult>;
  ProjectInvitationRequestExcelTemplate?: Maybe<ProjectInvitationRequestExcelTemplateResult>;
  abortMultipartUpload?: Maybe<AbortMultipartUploadResult>;
  abortTaskAttachmentMultipartUpload?: Maybe<AbortTaskAttachmentMultipartUploadResult>;
  addFileApprovalsFileVersions?: Maybe<AddFileApprovalsFileVersionsResult>;
  addMembersToProjectChannel?: Maybe<AddMembersToProjectChannelResult>;
  addUserApprovalToFileVersion?: Maybe<AddUserApprovalToFileVersionResult>;
  addUserInTeam?: Maybe<AddUserInTeamResult>;
  addUserMultiApprovalToFilesVersion?: Maybe<AddUserMultiApprovalToFilesVersionResult>;
  addUserViewToFileVersion?: Maybe<AddUserViewToFileVersionResult>;
  addUserViewToFolder?: Maybe<AddUserViewToFolderResult>;
  addUserViewToProject?: Maybe<AddUserViewToProjectResult>;
  addUserViewToTask?: Maybe<AddUserViewToTaskResult>;
  annotateFile?: Maybe<AnnotateFileResult>;
  bulkDeleteTasks?: Maybe<BulkDeleteTasksResult>;
  completeMultipartUpload?: Maybe<CompleteMultipartUploadResult>;
  completeTaskAttachmentMultipartUpload?: Maybe<CompleteTaskAttachmentMultipartUploadResult>;
  convertFile?: Maybe<ConvertFileResult>;
  copyProject?: Maybe<CopyProjectResult>;
  copyTaskAttachmentsUpload?: Maybe<CopyTaskAttachmentsUploadResult>;
  createChannelForApproval?: Maybe<CreateChannelForApprovalResult>;
  createChannelForProject?: Maybe<CreateChannelForProjectResult>;
  createChannelForTask?: Maybe<CreateChannelForTaskResult>;
  createEmptyFile?: Maybe<CreateEmptyFileResult>;
  createFilter?: Maybe<CreateFilterResult>;
  createFolder?: Maybe<CreateFolderResult>;
  createMultipartUpload?: Maybe<CreateMultipartUploadResult>;
  createOrg?: Maybe<CreateOrgResult>;
  createOrgProjectSummary?: Maybe<CreateOrgProjectSummaryResult>;
  createProject?: Maybe<CreateProjectResult>;
  createProjectCategory?: Maybe<CreateProjectCategoryResult>;
  createProjectDirectMessage?: Maybe<CreateProjectDirectMessageResult>;
  createProjectGroup?: Maybe<CreateProjectGroupResult>;
  createProjectLabel?: Maybe<CreateProjectLabelResult>;
  createReportBlocks?: Maybe<CreateReportBlocksResult>;
  createSubtask?: Maybe<CreateSubtaskResult>;
  createTask?: Maybe<CreateTaskResult>;
  createTaskAttachmentMultipartUpload?: Maybe<CreateTaskAttachmentMultipartUploadResult>;
  createTeam?: Maybe<CreateTeamResult>;
  deleteFile?: Maybe<DeleteFileResult>;
  deleteFilter?: Maybe<DeleteFilterResult>;
  deleteFirebaseToken?: Maybe<DeleteFirebaseTokenResult>;
  deleteFolder?: Maybe<DeleteFolderResult>;
  deleteProject?: Maybe<DeleteProjectResult>;
  deleteProjectCategory?: Maybe<DeleteProjectCategoryResult>;
  deleteProjectGroup?: Maybe<DeleteProjectGroupResult>;
  deleteProjectLabel?: Maybe<DeleteProjectLabelResult>;
  deleteReportBlock?: Maybe<DeleteReportBlockResult>;
  deleteSubtask?: Maybe<DeleteSubtaskResult>;
  deleteTask?: Maybe<DeleteTaskResult>;
  deleteTaskAttachment?: Maybe<DeleteTaskAttachmentResult>;
  deleteTaskDependencies?: Maybe<DeleteTaskDependenciesResult>;
  deleteTasks?: Maybe<DeleteTasksResult>;
  deleteTeam?: Maybe<DeleteTeamResult>;
  downloadFolder?: Maybe<DownloadFolderResult>;
  duplicateFiles?: Maybe<DuplicateFilesResult>;
  finalizeUploadedChannelAsset?: Maybe<FinalizeUploadedChannelAssetResult>;
  finalizeUploadedFile?: Maybe<FinalizeUploadedFileResult>;
  finalizeUploadedFileApprovalsAttachment?: Maybe<FinalizeUploadedFileApprovalsAttachmentResult>;
  finalizeUploadedFileStructure?: Maybe<FinalizeUploadedFileStructureResult>;
  finalizeUploadedFileVersion?: Maybe<FinalizeUploadedFileVersionResult>;
  finalizeUploadedOrgAvatar?: Maybe<FinalizeUploadedOrgAvatarResult>;
  finalizeUploadedOrgBackground?: Maybe<FinalizeUploadedOrgBackgroundResult>;
  finalizeUploadedProjectAvatar?: Maybe<FinalizeUploadedProjectAvatarResult>;
  finalizeUploadedProjectBackground?: Maybe<FinalizeUploadedProjectBackgroundResult>;
  finalizeUploadedProjectBanner?: Maybe<FinalizeUploadedProjectBannerResult>;
  finalizeUploadedProjectSpreadsheet?: Maybe<FinalizeUploadedProjectSpreadsheetResult>;
  finalizeUploadedTaskAttachment?: Maybe<FinalizeUploadedTaskAttachmentResult>;
  finalizeUploadedTaskAttachmentAnnotation?: Maybe<FinalizeUploadedTaskAttachmentAnnotationResult>;
  finalizeUploadedTaskSpreadsheet?: Maybe<FinalizeUploadedTaskSpreadsheetResult>;
  finalizeUploadedUserAvatar?: Maybe<FinalizeUploadedUserAvatarResult>;
  generateApiToken?: Maybe<GenerateApiTokenResult>;
  joinOrgUserProject?: Maybe<JoinOrgUserProjectResult>;
  listMultipartUpload?: Maybe<ListMultipartUploadResult>;
  listTaskAttachmentMultipartUpload?: Maybe<ListTaskAttachmentMultipartUploadResult>;
  migrateAvatarPublicUrl?: Maybe<MigrateAvatarPublicUrlResult>;
  moveFiles?: Maybe<MoveFilesResult>;
  moveFolders?: Maybe<MoveFoldersResult>;
  prepareChannelAssetForUpload?: Maybe<PrepareChannelAssetForUploadResult>;
  prepareFileApprovalsAttachmentForUpload?: Maybe<PrepareFileApprovalsAttachmentForUploadResult>;
  prepareFileForAutodeskViewer?: Maybe<PrepareFileForAutodeskViewerResult>;
  prepareFileForUpload?: Maybe<PrepareFileForUploadResult>;
  prepareFileStructureForUpload?: Maybe<PrepareFileStructureForUploadResult>;
  prepareFileVersionAnnotationForUpload?: Maybe<PrepareFileVersionAnnotationForUploadResult>;
  prepareFileVersionForUpload?: Maybe<PrepareFileVersionForUploadResult>;
  prepareMultipartUpload?: Maybe<PrepareMultipartUploadResult>;
  prepareOrgAssetForUpload?: Maybe<PrepareOrgAssetForUploadResult>;
  prepareProjectAssetForUpload?: Maybe<PrepareProjectAssetForUploadResult>;
  prepareProjectSpreadsheetForUpload?: Maybe<PrepareProjectSpreadsheetForUploadResult>;
  prepareProjectUserAvatarForUpload?: Maybe<PrepareProjectUserAvatarForUploadResult>;
  prepareTaskAttachmentAnnotationForUpload?: Maybe<PrepareTaskAttachmentAnnotationForUploadResult>;
  prepareTaskAttachmentForUpload?: Maybe<PrepareTaskAttachmentForUploadResult>;
  prepareTaskAttachmentMultipartUpload?: Maybe<PrepareTaskAttachmentMultipartUploadResult>;
  prepareTaskSpreadsheetForUpload?: Maybe<PrepareTaskSpreadsheetForUploadResult>;
  prepareUserAvatarForUpload?: Maybe<PrepareUserAvatarForUploadResult>;
  projectImportRequestExcelTemplate?: Maybe<ProjectImportRequestExcelTemplateResult>;
  projectInvitations?: Maybe<ProjectInvitationsResult>;
  readNotifications?: Maybe<ReadNotificationsResult>;
  removeMembersFromProjectChannel?: Maybe<RemoveMembersFromProjectChannelResult>;
  removeUserInTeam?: Maybe<RemoveUserInTeamResult>;
  renameChannelForProject?: Maybe<RenameChannelForProjectResult>;
  renameFile?: Maybe<RenameFileResult>;
  renameFolder?: Maybe<RenameFolderResult>;
  requestApprovalExport?: Maybe<RequestApprovalExportResult>;
  requestApprovalReport?: Maybe<RequestApprovalReportResult>;
  requestFilesTreeReport?: Maybe<RequestFilesTreeReportResult>;
  requestProjectExport?: Maybe<RequestProjectExportResult>;
  requestTasksExport?: Maybe<RequestTasksExportResult>;
  requestTasksReport?: Maybe<RequestTasksReportResult>;
  requestUsersApprovalsFiles?: Maybe<RequestUsersApprovalsFilesResult>;
  restoreFileVersion?: Maybe<RestoreFileVersionResult>;
  saveFirebaseToken?: Maybe<SaveFirebaseTokenResult>;
  sendUserEmailInvitation?: Maybe<SendUserEmailInvitationResult>;
  signFile?: Maybe<SignFileResult>;
  taskImportRequestExcelTemplate?: Maybe<TaskImportRequestExcelTemplateResult>;
  testMigrateAvatarPublicUrl?: Maybe<TestMigrateAvatarPublicUrlResult>;
  unreadNotifications?: Maybe<UnreadNotificationsResult>;
  updateArchiveTask?: Maybe<UpdateArchiveTaskResult>;
  updateAssignationsFiles?: Maybe<UpdateAssignationsFilesResult>;
  updateAssignationsFilesFolders?: Maybe<UpdateAssignationsFilesFoldersResult>;
  updateAssignationsFolders?: Maybe<UpdateAssignationsFoldersResult>;
  updateAssignationsTask?: Maybe<UpdateAssignationsTaskResult>;
  updateBrowserLanguage?: Maybe<UpdateBrowserLanguageResult>;
  updateBrowserTimezone?: Maybe<UpdateBrowserTimezoneResult>;
  updateDueDateFile?: Maybe<UpdateDueDateFileResult>;
  updateEmailNotifications?: Maybe<UpdateEmailNotificationsResult>;
  updateFilesApprovalMode?: Maybe<UpdateFilesApprovalModeResult>;
  updateFilter?: Maybe<UpdateFilterResult>;
  updateLabelsFiles?: Maybe<UpdateLabelsFilesResult>;
  updateLabelsFolders?: Maybe<UpdateLabelsFoldersResult>;
  updateLabelsTasks?: Maybe<UpdateLabelsTasksResult>;
  updateOrgProfile?: Maybe<UpdateOrgProfileResult>;
  updateOrgProjectSummary?: Maybe<UpdateOrgProjectSummaryResult>;
  updateOrgProjectSummaryArchive?: Maybe<UpdateOrgProjectSummaryArchiveResult>;
  updatePermissionsFile?: Maybe<UpdatePermissionsFileResult>;
  updatePermissionsFolder?: Maybe<UpdatePermissionsFolderResult>;
  updatePermissionsTask?: Maybe<UpdatePermissionsTaskResult>;
  updateProjectCategory?: Maybe<UpdateProjectCategoryResult>;
  updateProjectGroup?: Maybe<UpdateProjectGroupResult>;
  updateProjectLabel?: Maybe<UpdateProjectLabelResult>;
  updateProjectMembersRole?: Maybe<UpdateProjectMembersRoleResult>;
  updateProjectProfile?: Maybe<UpdateProjectProfileResult>;
  updateProjectRole?: Maybe<UpdateProjectRoleResult>;
  updateProjectTemplate?: Maybe<UpdateProjectTemplateResult>;
  updateProjectUserInfos?: Maybe<UpdateProjectUserInfosResult>;
  updateProjectsCategories?: Maybe<UpdateProjectsCategoriesResult>;
  updateProjectsClient?: Maybe<UpdateProjectsClientResult>;
  updatePushNotifications?: Maybe<UpdatePushNotificationsResult>;
  updateReportBlocks?: Maybe<UpdateReportBlocksResult>;
  updateSubtask?: Maybe<UpdateSubtaskResult>;
  updateTask?: Maybe<UpdateTaskResult>;
  updateTaskDependencies?: Maybe<UpdateTaskDependenciesResult>;
  updateTaskFileVersions?: Maybe<UpdateTaskFileVersionsResult>;
  updateTasksAssignations?: Maybe<UpdateTasksAssignationsResult>;
  updateTasksDates?: Maybe<UpdateTasksDatesResult>;
  updateTeam?: Maybe<UpdateTeamResult>;
  updateUserAppMetadata?: Maybe<UpdateUserAppMetadataResult>;
  updateUserProfile?: Maybe<UpdateUserProfileResult>;
  updateUserTeams?: Maybe<UpdateUserTeamsResult>;
  updateUsersCompanyName?: Maybe<UpdateUsersCompanyNameResult>;
  updateUsersInTeam?: Maybe<UpdateUsersInTeamResult>;
  updateUsersTeams?: Maybe<UpdateUsersTeamsResult>;
  updateValidationTask?: Maybe<UpdateValidationTaskResult>;
  updateValidationsTasks?: Maybe<UpdateValidationsTasksResult>;
  validateSubtask?: Maybe<ValidateSubtaskResult>;
};


/** mutation root */
export type Mutation_RootFilterUserDefaultArgs = {
  input: FilterUserDefaultInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedProjectGroupAvatarArgs = {
  input: FinalizeUploadedProjectGroupAvatarInput;
};


/** mutation root */
export type Mutation_RootPrepareProjectGroupAssetForUploadArgs = {
  input: PrepareProjectGroupAssetForUploadInput;
};


/** mutation root */
export type Mutation_RootAbortMultipartUploadArgs = {
  input: AbortMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootAbortTaskAttachmentMultipartUploadArgs = {
  input: AbortTaskAttachmentMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootAddFileApprovalsFileVersionsArgs = {
  input: AddFileApprovalsFileVersionsInput;
};


/** mutation root */
export type Mutation_RootAddMembersToProjectChannelArgs = {
  input: AddMembersToProjectChannelInput;
};


/** mutation root */
export type Mutation_RootAddUserApprovalToFileVersionArgs = {
  input: AddUserApprovalToFileVersionInput;
};


/** mutation root */
export type Mutation_RootAddUserInTeamArgs = {
  input: AddUserInTeamInput;
};


/** mutation root */
export type Mutation_RootAddUserMultiApprovalToFilesVersionArgs = {
  input: AddUserMultiApprovalToFilesVersionInput;
};


/** mutation root */
export type Mutation_RootAddUserViewToFileVersionArgs = {
  input: AddUserViewToFileVersionInput;
};


/** mutation root */
export type Mutation_RootAddUserViewToFolderArgs = {
  input: AddUserViewToFolderInput;
};


/** mutation root */
export type Mutation_RootAddUserViewToProjectArgs = {
  input: AddUserViewToProjectInput;
};


/** mutation root */
export type Mutation_RootAddUserViewToTaskArgs = {
  input: AddUserViewToTaskInput;
};


/** mutation root */
export type Mutation_RootAnnotateFileArgs = {
  input: AnnotateFileInput;
};


/** mutation root */
export type Mutation_RootBulkDeleteTasksArgs = {
  input: BulkDeleteTasksInput;
};


/** mutation root */
export type Mutation_RootCompleteMultipartUploadArgs = {
  input: CompleteMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootCompleteTaskAttachmentMultipartUploadArgs = {
  input: CompleteTaskAttachmentMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootConvertFileArgs = {
  input: ConvertFileInput;
};


/** mutation root */
export type Mutation_RootCopyProjectArgs = {
  input: CopyProjectInput;
};


/** mutation root */
export type Mutation_RootCopyTaskAttachmentsUploadArgs = {
  input: CopyTaskAttachmentsUploadInput;
};


/** mutation root */
export type Mutation_RootCreateChannelForApprovalArgs = {
  input: CreateChannelForApprovalInput;
};


/** mutation root */
export type Mutation_RootCreateChannelForProjectArgs = {
  input: CreateChannelForProjectInput;
};


/** mutation root */
export type Mutation_RootCreateChannelForTaskArgs = {
  input: CreateChannelForTaskInput;
};


/** mutation root */
export type Mutation_RootCreateEmptyFileArgs = {
  input: CreateEmptyFileInput;
};


/** mutation root */
export type Mutation_RootCreateFilterArgs = {
  input: CreateFilterInput;
};


/** mutation root */
export type Mutation_RootCreateFolderArgs = {
  input: CreateFolderInput;
};


/** mutation root */
export type Mutation_RootCreateMultipartUploadArgs = {
  input: CreateMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootCreateOrgArgs = {
  input: CreateOrgInput;
};


/** mutation root */
export type Mutation_RootCreateOrgProjectSummaryArgs = {
  input: CreateOrgProjectSummaryInput;
};


/** mutation root */
export type Mutation_RootCreateProjectArgs = {
  input: CreateProjectInput;
};


/** mutation root */
export type Mutation_RootCreateProjectCategoryArgs = {
  input: CreateProjectCategoryInput;
};


/** mutation root */
export type Mutation_RootCreateProjectDirectMessageArgs = {
  input: CreateProjectDirectMessageInput;
};


/** mutation root */
export type Mutation_RootCreateProjectGroupArgs = {
  input: CreateProjectGroupInput;
};


/** mutation root */
export type Mutation_RootCreateProjectLabelArgs = {
  input: CreateProjectLabelInput;
};


/** mutation root */
export type Mutation_RootCreateReportBlocksArgs = {
  input: CreateReportBlocksInput;
};


/** mutation root */
export type Mutation_RootCreateSubtaskArgs = {
  input: CreateSubtaskInput;
};


/** mutation root */
export type Mutation_RootCreateTaskArgs = {
  input: CreateTaskInput;
};


/** mutation root */
export type Mutation_RootCreateTaskAttachmentMultipartUploadArgs = {
  input: CreateTaskAttachmentMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootCreateTeamArgs = {
  input: CreateTeamInput;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  input: DeleteFileInput;
};


/** mutation root */
export type Mutation_RootDeleteFilterArgs = {
  input: DeleteFilterInput;
};


/** mutation root */
export type Mutation_RootDeleteFirebaseTokenArgs = {
  input: DeleteFirebaseTokenInput;
};


/** mutation root */
export type Mutation_RootDeleteFolderArgs = {
  input: DeleteFolderInput;
};


/** mutation root */
export type Mutation_RootDeleteProjectArgs = {
  input: DeleteProjectInput;
};


/** mutation root */
export type Mutation_RootDeleteProjectCategoryArgs = {
  input: DeleteProjectCategoryInput;
};


/** mutation root */
export type Mutation_RootDeleteProjectGroupArgs = {
  input: DeleteProjectGroupInput;
};


/** mutation root */
export type Mutation_RootDeleteProjectLabelArgs = {
  input: DeleteProjectLabelInput;
};


/** mutation root */
export type Mutation_RootDeleteReportBlockArgs = {
  input: DeleteReportBlockInput;
};


/** mutation root */
export type Mutation_RootDeleteSubtaskArgs = {
  input: DeleteSubtaskInput;
};


/** mutation root */
export type Mutation_RootDeleteTaskArgs = {
  input: DeleteTaskInput;
};


/** mutation root */
export type Mutation_RootDeleteTaskAttachmentArgs = {
  input: DeleteTaskAttachmentInput;
};


/** mutation root */
export type Mutation_RootDeleteTaskDependenciesArgs = {
  input: DeleteTaskDependenciesInput;
};


/** mutation root */
export type Mutation_RootDeleteTasksArgs = {
  input: DeleteTasksInput;
};


/** mutation root */
export type Mutation_RootDeleteTeamArgs = {
  input: DeleteTeamInput;
};


/** mutation root */
export type Mutation_RootDownloadFolderArgs = {
  input: DownloadFolderInput;
};


/** mutation root */
export type Mutation_RootDuplicateFilesArgs = {
  input: DuplicateFilesInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedChannelAssetArgs = {
  input: FinalizeUploadedChannelAssetInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedFileArgs = {
  input: FinalizeUploadedFileInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedFileApprovalsAttachmentArgs = {
  input: FinalizeUploadedFileApprovalsAttachmentInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedFileStructureArgs = {
  input: FinalizeUploadedFileStructureInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedFileVersionArgs = {
  input: FinalizeUploadedFileVersionInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedOrgAvatarArgs = {
  input: FinalizeUploadedOrgAvatarInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedOrgBackgroundArgs = {
  input: FinalizeUploadedOrgBackgroundInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedProjectAvatarArgs = {
  input: FinalizeUploadedProjectAvatarInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedProjectBackgroundArgs = {
  input: FinalizeUploadedProjectBackgroundInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedProjectBannerArgs = {
  input: FinalizeUploadedProjectBannerInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedProjectSpreadsheetArgs = {
  input: FinalizeUploadedProjectSpreadsheetInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedTaskAttachmentArgs = {
  input: FinalizeUploadedTaskAttachmentInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedTaskAttachmentAnnotationArgs = {
  input: FinalizeUploadedTaskAttachmentAnnotationInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedTaskSpreadsheetArgs = {
  input: FinalizeUploadedTaskSpreadsheetInput;
};


/** mutation root */
export type Mutation_RootFinalizeUploadedUserAvatarArgs = {
  input: FinalizeUploadedUserAvatarInput;
};


/** mutation root */
export type Mutation_RootGenerateApiTokenArgs = {
  input: GenerateApiTokenInput;
};


/** mutation root */
export type Mutation_RootJoinOrgUserProjectArgs = {
  input: JoinOrgUserProjectInput;
};


/** mutation root */
export type Mutation_RootListMultipartUploadArgs = {
  input: ListMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootListTaskAttachmentMultipartUploadArgs = {
  input: ListTaskAttachmentMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootMoveFilesArgs = {
  input: MoveFilesInput;
};


/** mutation root */
export type Mutation_RootMoveFoldersArgs = {
  input: MoveFoldersInput;
};


/** mutation root */
export type Mutation_RootPrepareChannelAssetForUploadArgs = {
  input: PrepareChannelAssetForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareFileApprovalsAttachmentForUploadArgs = {
  input: PrepareFileApprovalsAttachmentForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareFileForAutodeskViewerArgs = {
  input: PrepareFileForAutodeskViewerInput;
};


/** mutation root */
export type Mutation_RootPrepareFileForUploadArgs = {
  input: PrepareFileForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareFileStructureForUploadArgs = {
  input: PrepareFileStructureForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareFileVersionAnnotationForUploadArgs = {
  input: PrepareFileVersionAnnotationForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareFileVersionForUploadArgs = {
  input: PrepareFileVersionForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareMultipartUploadArgs = {
  input: PrepareMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareOrgAssetForUploadArgs = {
  input: PrepareOrgAssetForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareProjectAssetForUploadArgs = {
  input: PrepareProjectAssetForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareProjectSpreadsheetForUploadArgs = {
  input: PrepareProjectSpreadsheetForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareProjectUserAvatarForUploadArgs = {
  input: PrepareProjectUserAvatarForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareTaskAttachmentAnnotationForUploadArgs = {
  input: PrepareTaskAttachmentAnnotationForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareTaskAttachmentForUploadArgs = {
  input: PrepareTaskAttachmentForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareTaskAttachmentMultipartUploadArgs = {
  input: PrepareTaskAttachmentMultipartUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareTaskSpreadsheetForUploadArgs = {
  input: PrepareTaskSpreadsheetForUploadInput;
};


/** mutation root */
export type Mutation_RootPrepareUserAvatarForUploadArgs = {
  input: PrepareUserAvatarForUploadInput;
};


/** mutation root */
export type Mutation_RootProjectInvitationsArgs = {
  input: ProjectInvitationsInput;
};


/** mutation root */
export type Mutation_RootReadNotificationsArgs = {
  input: ReadNotificationsInput;
};


/** mutation root */
export type Mutation_RootRemoveMembersFromProjectChannelArgs = {
  input: RemoveMembersFromProjectChannelInput;
};


/** mutation root */
export type Mutation_RootRemoveUserInTeamArgs = {
  input: RemoveUserInTeamInput;
};


/** mutation root */
export type Mutation_RootRenameChannelForProjectArgs = {
  input: RenameChannelForProjectInput;
};


/** mutation root */
export type Mutation_RootRenameFileArgs = {
  input: RenameFileInput;
};


/** mutation root */
export type Mutation_RootRenameFolderArgs = {
  input: RenameFolderInput;
};


/** mutation root */
export type Mutation_RootRequestApprovalExportArgs = {
  input: RequestApprovalExportInput;
};


/** mutation root */
export type Mutation_RootRequestApprovalReportArgs = {
  input: RequestApprovalReportInput;
};


/** mutation root */
export type Mutation_RootRequestFilesTreeReportArgs = {
  input: RequestFilesTreeReportInput;
};


/** mutation root */
export type Mutation_RootRequestProjectExportArgs = {
  input: RequestProjectExportInput;
};


/** mutation root */
export type Mutation_RootRequestTasksExportArgs = {
  input: RequestTasksExportInput;
};


/** mutation root */
export type Mutation_RootRequestTasksReportArgs = {
  input: RequestTasksReportInput;
};


/** mutation root */
export type Mutation_RootRequestUsersApprovalsFilesArgs = {
  input: RequestUsersApprovalsFilesInput;
};


/** mutation root */
export type Mutation_RootRestoreFileVersionArgs = {
  input: RestoreFileVersionInput;
};


/** mutation root */
export type Mutation_RootSaveFirebaseTokenArgs = {
  input: SaveFirebaseTokenInput;
};


/** mutation root */
export type Mutation_RootSendUserEmailInvitationArgs = {
  input: SendUserEmailInvitationInput;
};


/** mutation root */
export type Mutation_RootSignFileArgs = {
  input: SignFileInput;
};


/** mutation root */
export type Mutation_RootUnreadNotificationsArgs = {
  input: UnreadNotificationsInput;
};


/** mutation root */
export type Mutation_RootUpdateArchiveTaskArgs = {
  input: UpdateArchiveTaskInput;
};


/** mutation root */
export type Mutation_RootUpdateAssignationsFilesArgs = {
  input: UpdateAssignationsFilesInput;
};


/** mutation root */
export type Mutation_RootUpdateAssignationsFilesFoldersArgs = {
  input: UpdateAssignationsFilesFoldersInput;
};


/** mutation root */
export type Mutation_RootUpdateAssignationsFoldersArgs = {
  input: UpdateAssignationsFoldersInput;
};


/** mutation root */
export type Mutation_RootUpdateAssignationsTaskArgs = {
  input: UpdateAssignationsTaskInput;
};


/** mutation root */
export type Mutation_RootUpdateBrowserLanguageArgs = {
  input: UpdateBrowserLanguageInput;
};


/** mutation root */
export type Mutation_RootUpdateBrowserTimezoneArgs = {
  input: UpdateBrowserTimezoneInput;
};


/** mutation root */
export type Mutation_RootUpdateDueDateFileArgs = {
  input: UpdateDueDateFileInput;
};


/** mutation root */
export type Mutation_RootUpdateEmailNotificationsArgs = {
  input: UpdateEmailNotificationsInput;
};


/** mutation root */
export type Mutation_RootUpdateFilesApprovalModeArgs = {
  input: UpdateFilesApprovalModeInput;
};


/** mutation root */
export type Mutation_RootUpdateFilterArgs = {
  input: UpdateFilterInput;
};


/** mutation root */
export type Mutation_RootUpdateLabelsFilesArgs = {
  input: UpdateLabelsFilesInput;
};


/** mutation root */
export type Mutation_RootUpdateLabelsFoldersArgs = {
  input: UpdateLabelsFoldersInput;
};


/** mutation root */
export type Mutation_RootUpdateLabelsTasksArgs = {
  input: UpdateLabelsTasksInput;
};


/** mutation root */
export type Mutation_RootUpdateOrgProfileArgs = {
  input: UpdateOrgProfileInput;
};


/** mutation root */
export type Mutation_RootUpdateOrgProjectSummaryArgs = {
  input: UpdateOrgProjectSummaryInput;
};


/** mutation root */
export type Mutation_RootUpdateOrgProjectSummaryArchiveArgs = {
  input: UpdateOrgProjectSummaryArchiveInput;
};


/** mutation root */
export type Mutation_RootUpdatePermissionsFileArgs = {
  input: UpdatePermissionsFileInput;
};


/** mutation root */
export type Mutation_RootUpdatePermissionsFolderArgs = {
  input: UpdatePermissionsFolderInput;
};


/** mutation root */
export type Mutation_RootUpdatePermissionsTaskArgs = {
  input: UpdatePermissionsTaskInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectCategoryArgs = {
  input: UpdateProjectCategoryInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectGroupArgs = {
  input: UpdateProjectGroupInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectLabelArgs = {
  input: UpdateProjectLabelInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectMembersRoleArgs = {
  input: UpdateProjectMembersRoleInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectProfileArgs = {
  input: UpdateProjectProfileInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectRoleArgs = {
  input: UpdateProjectRoleInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectTemplateArgs = {
  input: UpdateProjectTemplateInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectUserInfosArgs = {
  input: UpdateProjectUserInfosInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectsCategoriesArgs = {
  input: UpdateProjectsCategoriesInput;
};


/** mutation root */
export type Mutation_RootUpdateProjectsClientArgs = {
  input: UpdateProjectsClientInput;
};


/** mutation root */
export type Mutation_RootUpdatePushNotificationsArgs = {
  input: UpdatePushNotificationsInput;
};


/** mutation root */
export type Mutation_RootUpdateReportBlocksArgs = {
  input: UpdateReportBlocksInput;
};


/** mutation root */
export type Mutation_RootUpdateSubtaskArgs = {
  input: UpdateSubtaskInput;
};


/** mutation root */
export type Mutation_RootUpdateTaskArgs = {
  input: UpdateTaskInput;
};


/** mutation root */
export type Mutation_RootUpdateTaskDependenciesArgs = {
  input: UpdateTaskDependenciesInput;
};


/** mutation root */
export type Mutation_RootUpdateTaskFileVersionsArgs = {
  input: UpdateTaskFileVersionsInput;
};


/** mutation root */
export type Mutation_RootUpdateTasksAssignationsArgs = {
  input: UpdateTasksAssignationsInput;
};


/** mutation root */
export type Mutation_RootUpdateTasksDatesArgs = {
  input: UpdateTasksDatesInput;
};


/** mutation root */
export type Mutation_RootUpdateTeamArgs = {
  input: UpdateTeamInput;
};


/** mutation root */
export type Mutation_RootUpdateUserAppMetadataArgs = {
  input: UpdateUserAppMetadataInput;
};


/** mutation root */
export type Mutation_RootUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


/** mutation root */
export type Mutation_RootUpdateUserTeamsArgs = {
  input: UpdateUserTeamsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersCompanyNameArgs = {
  input: UpdateUsersCompanyNameInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersInTeamArgs = {
  input: UpdateUsersInTeamInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersTeamsArgs = {
  input: UpdateUsersTeamsInput;
};


/** mutation root */
export type Mutation_RootUpdateValidationTaskArgs = {
  input: UpdateValidationTaskInput;
};


/** mutation root */
export type Mutation_RootUpdateValidationsTasksArgs = {
  input: UpdateValidationsTasksInput;
};


/** mutation root */
export type Mutation_RootValidateSubtaskArgs = {
  input: ValidateSubtaskInput;
};

export type NextMeetingInvitationUsers = {
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

export type OptionsApprovalExport = {
  allVersions?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionsApprovalReport = {
  allVersions?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionsFilesTreeReport = {
  allVersions?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionsInput = {
  invitationMemberByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['Boolean']['input']>;
  members?: InputMaybe<Scalars['Boolean']['input']>;
  publicDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  restrictedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  tasksAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  tasksComments?: InputMaybe<Scalars['Boolean']['input']>;
  teams?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptionsSuccess = {
  __typename?: 'optionsSuccess';
  labels?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Scalars['Boolean']['output']>;
  publicDocuments?: Maybe<Scalars['Boolean']['output']>;
  restrictedDocuments?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  tasksComments?: Maybe<Scalars['Boolean']['output']>;
  teams?: Maybe<Scalars['Boolean']['output']>;
};

export type OptionsTasksReport = {
  assigneesSorting?: InputMaybe<AssigneesSorting>;
  imageSize?: InputMaybe<Scalars['String']['input']>;
  projectInfos?: InputMaybe<Scalars['Boolean']['input']>;
  taskAssignees?: InputMaybe<Scalars['Boolean']['input']>;
  taskComments?: InputMaybe<Scalars['Boolean']['input']>;
  taskCommentsImages?: InputMaybe<Scalars['Boolean']['input']>;
  taskDeadLine?: InputMaybe<Scalars['Boolean']['input']>;
  taskFiles?: InputMaybe<Scalars['Boolean']['input']>;
  taskImages?: InputMaybe<Scalars['Boolean']['input']>;
  taskSubtasks?: InputMaybe<Scalars['Boolean']['input']>;
  taskTags?: InputMaybe<Scalars['Boolean']['input']>;
  taskViews?: InputMaybe<Scalars['Boolean']['input']>;
  tasksInfo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Address of an org */
export type Org_Address = {
  __typename?: 'org_address';
  administrative_area_level1?: Maybe<Scalars['String']['output']>;
  administrative_area_level2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "org_address". All fields are combined with a logical 'AND'. */
export type Org_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Address_Bool_Exp>>;
  _not?: InputMaybe<Org_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Address_Bool_Exp>>;
  administrative_area_level1?: InputMaybe<String_Comparison_Exp>;
  administrative_area_level2?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "org_address". */
export type Org_Address_Order_By = {
  administrative_area_level1?: InputMaybe<Order_By>;
  administrative_area_level2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "org_address" */
export enum Org_Address_Select_Column {
  /** column name */
  AdministrativeAreaLevel1 = 'administrative_area_level1',
  /** column name */
  AdministrativeAreaLevel2 = 'administrative_area_level2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "org_avatars" */
export type Org_Avatars = {
  __typename?: 'org_avatars';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  public_url: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "org_avatars". All fields are combined with a logical 'AND'. */
export type Org_Avatars_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Avatars_Bool_Exp>>;
  _not?: InputMaybe<Org_Avatars_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Avatars_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  public_url?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "org_avatars". */
export type Org_Avatars_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  public_url?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "org_avatars" */
export enum Org_Avatars_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Extension = 'extension',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PublicUrl = 'public_url',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** This table contain the custom data that an org have on a project */
export type Org_Project_Summary = {
  __typename?: 'org_project_summary';
  client_email?: Maybe<Scalars['String']['output']>;
  client_fullname?: Maybe<Scalars['String']['output']>;
  client_phone_number?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  hours_done?: Maybe<Scalars['float8']['output']>;
  hours_expected?: Maybe<Scalars['float8']['output']>;
  id: Scalars['uuid']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_project_template: Scalars['Boolean']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  price_estimate?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project: Projects;
  /** An array relationship */
  project_categories: Array<Org_Project_Summary_To_Project_Categories>;
  /** An array relationship */
  project_groups: Array<Org_Project_Summary_To_Project_Groups>;
  project_id: Scalars['uuid']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** This table contain the custom data that an org have on a project */
export type Org_Project_SummaryProject_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_To_Project_Categories_Bool_Exp>;
};


/** This table contain the custom data that an org have on a project */
export type Org_Project_SummaryProject_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_To_Project_Groups_Bool_Exp>;
};

/** order by aggregate values of table "org_project_summary" */
export type Org_Project_Summary_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Project_Summary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Project_Summary_Max_Order_By>;
  min?: InputMaybe<Org_Project_Summary_Min_Order_By>;
  stddev?: InputMaybe<Org_Project_Summary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Project_Summary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Project_Summary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Project_Summary_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Project_Summary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Project_Summary_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Project_Summary_Variance_Order_By>;
};

/** order by avg() on columns of table "org_project_summary" */
export type Org_Project_Summary_Avg_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_project_summary". All fields are combined with a logical 'AND'. */
export type Org_Project_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Project_Summary_Bool_Exp>>;
  _not?: InputMaybe<Org_Project_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Project_Summary_Bool_Exp>>;
  client_email?: InputMaybe<String_Comparison_Exp>;
  client_fullname?: InputMaybe<String_Comparison_Exp>;
  client_phone_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  hours_done?: InputMaybe<Float8_Comparison_Exp>;
  hours_expected?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_project_template?: InputMaybe<Boolean_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_estimate?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_categories?: InputMaybe<Org_Project_Summary_To_Project_Categories_Bool_Exp>;
  project_groups?: InputMaybe<Org_Project_Summary_To_Project_Groups_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "org_project_summary" */
export type Org_Project_Summary_Max_Order_By = {
  client_email?: InputMaybe<Order_By>;
  client_fullname?: InputMaybe<Order_By>;
  client_phone_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  price_estimate?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "org_project_summary" */
export type Org_Project_Summary_Min_Order_By = {
  client_email?: InputMaybe<Order_By>;
  client_fullname?: InputMaybe<Order_By>;
  client_phone_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  price_estimate?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "org_project_summary". */
export type Org_Project_Summary_Order_By = {
  client_email?: InputMaybe<Order_By>;
  client_fullname?: InputMaybe<Order_By>;
  client_phone_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_project_template?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  price_estimate?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_categories_aggregate?: InputMaybe<Org_Project_Summary_To_Project_Categories_Aggregate_Order_By>;
  project_groups_aggregate?: InputMaybe<Org_Project_Summary_To_Project_Groups_Aggregate_Order_By>;
  project_id?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "org_project_summary" */
export enum Org_Project_Summary_Select_Column {
  /** column name */
  ClientEmail = 'client_email',
  /** column name */
  ClientFullname = 'client_fullname',
  /** column name */
  ClientPhoneNumber = 'client_phone_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  HoursDone = 'hours_done',
  /** column name */
  HoursExpected = 'hours_expected',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsProjectTemplate = 'is_project_template',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PriceEstimate = 'price_estimate',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "org_project_summary" */
export type Org_Project_Summary_Stddev_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "org_project_summary" */
export type Org_Project_Summary_Stddev_Pop_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "org_project_summary" */
export type Org_Project_Summary_Stddev_Samp_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "org_project_summary" */
export type Org_Project_Summary_Sum_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** This relation table allow a org_project_summary to contain a subset of project_categories labels */
export type Org_Project_Summary_To_Project_Categories = {
  __typename?: 'org_project_summary_to_project_categories';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  org_project_summary: Org_Project_Summary;
  org_project_summary_id: Scalars['uuid']['output'];
  project_categories_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_category: Project_Categories;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Project_Summary_To_Project_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Project_Summary_To_Project_Categories_Max_Order_By>;
  min?: InputMaybe<Org_Project_Summary_To_Project_Categories_Min_Order_By>;
  stddev?: InputMaybe<Org_Project_Summary_To_Project_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Project_Summary_To_Project_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Project_Summary_To_Project_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Project_Summary_To_Project_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Project_Summary_To_Project_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Project_Summary_To_Project_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Project_Summary_To_Project_Categories_Variance_Order_By>;
};

/** order by avg() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_project_summary_to_project_categories". All fields are combined with a logical 'AND'. */
export type Org_Project_Summary_To_Project_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Bool_Exp>>;
  _not?: InputMaybe<Org_Project_Summary_To_Project_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  org_project_summary?: InputMaybe<Org_Project_Summary_Bool_Exp>;
  org_project_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_categories_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_category?: InputMaybe<Project_Categories_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  org_project_summary_id?: InputMaybe<Order_By>;
  project_categories_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  org_project_summary_id?: InputMaybe<Order_By>;
  project_categories_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "org_project_summary_to_project_categories". */
export type Org_Project_Summary_To_Project_Categories_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  org_project_summary?: InputMaybe<Org_Project_Summary_Order_By>;
  org_project_summary_id?: InputMaybe<Order_By>;
  project_categories_id?: InputMaybe<Order_By>;
  project_category?: InputMaybe<Project_Categories_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "org_project_summary_to_project_categories" */
export enum Org_Project_Summary_To_Project_Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  OrgProjectSummaryId = 'org_project_summary_id',
  /** column name */
  ProjectCategoriesId = 'project_categories_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "org_project_summary_to_project_categories" */
export type Org_Project_Summary_To_Project_Categories_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** This relation table allow a org_project_summary to contain a subset of project_groups labels */
export type Org_Project_Summary_To_Project_Groups = {
  __typename?: 'org_project_summary_to_project_groups';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  org_project_summary: Org_Project_Summary;
  org_project_summary_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_group: Project_Groups;
  project_group_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Project_Summary_To_Project_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Project_Summary_To_Project_Groups_Max_Order_By>;
  min?: InputMaybe<Org_Project_Summary_To_Project_Groups_Min_Order_By>;
  stddev?: InputMaybe<Org_Project_Summary_To_Project_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Project_Summary_To_Project_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Project_Summary_To_Project_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Project_Summary_To_Project_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Project_Summary_To_Project_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Project_Summary_To_Project_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Project_Summary_To_Project_Groups_Variance_Order_By>;
};

/** order by avg() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_project_summary_to_project_groups". All fields are combined with a logical 'AND'. */
export type Org_Project_Summary_To_Project_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Bool_Exp>>;
  _not?: InputMaybe<Org_Project_Summary_To_Project_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  org_project_summary?: InputMaybe<Org_Project_Summary_Bool_Exp>;
  org_project_summary_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_group?: InputMaybe<Project_Groups_Bool_Exp>;
  project_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  org_project_summary_id?: InputMaybe<Order_By>;
  project_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  org_project_summary_id?: InputMaybe<Order_By>;
  project_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "org_project_summary_to_project_groups". */
export type Org_Project_Summary_To_Project_Groups_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  org_project_summary?: InputMaybe<Org_Project_Summary_Order_By>;
  org_project_summary_id?: InputMaybe<Order_By>;
  project_group?: InputMaybe<Project_Groups_Order_By>;
  project_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "org_project_summary_to_project_groups" */
export enum Org_Project_Summary_To_Project_Groups_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  OrgProjectSummaryId = 'org_project_summary_id',
  /** column name */
  ProjectGroupId = 'project_group_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "org_project_summary_to_project_groups" */
export type Org_Project_Summary_To_Project_Groups_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "org_project_summary" */
export type Org_Project_Summary_Var_Pop_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "org_project_summary" */
export type Org_Project_Summary_Var_Samp_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "org_project_summary" */
export type Org_Project_Summary_Variance_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_roles" */
export type Org_Roles = {
  __typename?: 'org_roles';
  name: Scalars['String']['output'];
  /** An array relationship */
  orgs_to_users: Array<Orgs_To_Users>;
};


/** columns and relationships of "org_roles" */
export type Org_RolesOrgs_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Orgs_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_To_Users_Order_By>>;
  where?: InputMaybe<Orgs_To_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "org_roles". All fields are combined with a logical 'AND'. */
export type Org_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Roles_Bool_Exp>>;
  _not?: InputMaybe<Org_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Roles_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  orgs_to_users?: InputMaybe<Orgs_To_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "org_roles". */
export type Org_Roles_Order_By = {
  name?: InputMaybe<Order_By>;
  orgs_to_users_aggregate?: InputMaybe<Orgs_To_Users_Aggregate_Order_By>;
};

/** select columns of table "org_roles" */
export enum Org_Roles_Select_Column {
  /** column name */
  Name = 'name'
}

/** this table save the global settings for one organization, this table could be modified */
export type Org_Settings = {
  __typename?: 'org_settings';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  org_id: Scalars['uuid']['output'];
  show_menu_by_group: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "org_settings". All fields are combined with a logical 'AND'. */
export type Org_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Settings_Bool_Exp>>;
  _not?: InputMaybe<Org_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Settings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  show_menu_by_group?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "org_settings". */
export type Org_Settings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  show_menu_by_group?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "org_settings" */
export enum Org_Settings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  ShowMenuByGroup = 'show_menu_by_group',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type OrganizationTasksReport = {
  org?: InputMaybe<Scalars['Boolean']['input']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  tag?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  team?: InputMaybe<Scalars['Boolean']['input']>;
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  user?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
};

/** columns and relationships of "orgs" */
export type Orgs = {
  __typename?: 'orgs';
  /** An object relationship */
  address?: Maybe<Org_Address>;
  background?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  folder_assignations: Array<Folder_Assignations_Orgs>;
  /** An array relationship */
  folder_permissions: Array<Folder_Permissions_Orgs>;
  id: Scalars['uuid']['output'];
  legal_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  members: Array<Orgs_To_Users>;
  name: Scalars['String']['output'];
  /** An object relationship */
  org_avatar?: Maybe<Org_Avatars>;
  phone?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project?: Maybe<Projects>;
  /** An array relationship */
  project_categories: Array<Project_Categories>;
  /** An array relationship */
  project_groups: Array<Project_Groups>;
  public_api_token?: Maybe<Scalars['String']['output']>;
  public_api_token_creator_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  settings?: Maybe<Org_Settings>;
};


/** columns and relationships of "orgs" */
export type OrgsFolder_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
};


/** columns and relationships of "orgs" */
export type OrgsFolder_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Orgs_Bool_Exp>;
};


/** columns and relationships of "orgs" */
export type OrgsMembersArgs = {
  distinct_on?: InputMaybe<Array<Orgs_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_To_Users_Order_By>>;
  where?: InputMaybe<Orgs_To_Users_Bool_Exp>;
};


/** columns and relationships of "orgs" */
export type OrgsProject_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Categories_Order_By>>;
  where?: InputMaybe<Project_Categories_Bool_Exp>;
};


/** columns and relationships of "orgs" */
export type OrgsProject_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Project_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Groups_Order_By>>;
  where?: InputMaybe<Project_Groups_Bool_Exp>;
};

/** order by aggregate values of table "orgs" */
export type Orgs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orgs_Max_Order_By>;
  min?: InputMaybe<Orgs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "orgs". All fields are combined with a logical 'AND'. */
export type Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<Orgs_Bool_Exp>>;
  _not?: InputMaybe<Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<Orgs_Bool_Exp>>;
  address?: InputMaybe<Org_Address_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  folder_assignations?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
  folder_permissions?: InputMaybe<Folder_Permissions_Orgs_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legal_number?: InputMaybe<String_Comparison_Exp>;
  members?: InputMaybe<Orgs_To_Users_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_avatar?: InputMaybe<Org_Avatars_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_categories?: InputMaybe<Project_Categories_Bool_Exp>;
  project_groups?: InputMaybe<Project_Groups_Bool_Exp>;
  public_api_token?: InputMaybe<String_Comparison_Exp>;
  public_api_token_creator_id?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Org_Settings_Bool_Exp>;
};

/** order by max() on columns of table "orgs" */
export type Orgs_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_number?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  public_api_token?: InputMaybe<Order_By>;
  public_api_token_creator_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "orgs" */
export type Orgs_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_number?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  public_api_token?: InputMaybe<Order_By>;
  public_api_token_creator_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "orgs". */
export type Orgs_Order_By = {
  address?: InputMaybe<Org_Address_Order_By>;
  description?: InputMaybe<Order_By>;
  folder_assignations_aggregate?: InputMaybe<Folder_Assignations_Orgs_Aggregate_Order_By>;
  folder_permissions_aggregate?: InputMaybe<Folder_Permissions_Orgs_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  legal_number?: InputMaybe<Order_By>;
  members_aggregate?: InputMaybe<Orgs_To_Users_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  org_avatar?: InputMaybe<Org_Avatars_Order_By>;
  phone?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_categories_aggregate?: InputMaybe<Project_Categories_Aggregate_Order_By>;
  project_groups_aggregate?: InputMaybe<Project_Groups_Aggregate_Order_By>;
  public_api_token?: InputMaybe<Order_By>;
  public_api_token_creator_id?: InputMaybe<Order_By>;
  settings?: InputMaybe<Org_Settings_Order_By>;
};

/** select columns of table "orgs" */
export enum Orgs_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LegalNumber = 'legal_number',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PublicApiToken = 'public_api_token',
  /** column name */
  PublicApiTokenCreatorId = 'public_api_token_creator_id'
}

/** columns and relationships of "orgs_to_users" */
export type Orgs_To_Users = {
  __typename?: 'orgs_to_users';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  inviter?: Maybe<Users>;
  inviter_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  /** An object relationship */
  role: Org_Roles;
  role_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updater?: Maybe<Users>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "orgs_to_users" */
export type Orgs_To_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orgs_To_Users_Max_Order_By>;
  min?: InputMaybe<Orgs_To_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "orgs_to_users". All fields are combined with a logical 'AND'. */
export type Orgs_To_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Orgs_To_Users_Bool_Exp>>;
  _not?: InputMaybe<Orgs_To_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Orgs_To_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  inviter?: InputMaybe<Users_Bool_Exp>;
  inviter_id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Org_Roles_Bool_Exp>;
  role_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updater?: InputMaybe<Users_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "orgs_to_users" */
export type Orgs_To_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  inviter_id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "orgs_to_users" */
export type Orgs_To_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  inviter_id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "orgs_to_users". */
export type Orgs_To_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  inviter?: InputMaybe<Users_Order_By>;
  inviter_id?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Org_Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updater?: InputMaybe<Users_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "orgs_to_users" */
export enum Orgs_To_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  InviterId = 'inviter_id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type PresentUsersTasksReport = {
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Address of a project */
export type Project_Address = {
  __typename?: 'project_address';
  administrative_area_level1?: Maybe<Scalars['String']['output']>;
  administrative_area_level2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid']['output'];
  street?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "project_address". All fields are combined with a logical 'AND'. */
export type Project_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Address_Bool_Exp>>;
  _not?: InputMaybe<Project_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Address_Bool_Exp>>;
  administrative_area_level1?: InputMaybe<String_Comparison_Exp>;
  administrative_area_level2?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "project_address". */
export type Project_Address_Order_By = {
  administrative_area_level1?: InputMaybe<Order_By>;
  administrative_area_level2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "project_address" */
export enum Project_Address_Select_Column {
  /** column name */
  AdministrativeAreaLevel1 = 'administrative_area_level1',
  /** column name */
  AdministrativeAreaLevel2 = 'administrative_area_level2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "project_avatars" */
export type Project_Avatars = {
  __typename?: 'project_avatars';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid']['output'];
  public_url: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "project_avatars". All fields are combined with a logical 'AND'. */
export type Project_Avatars_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Avatars_Bool_Exp>>;
  _not?: InputMaybe<Project_Avatars_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Avatars_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  public_url?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "project_avatars". */
export type Project_Avatars_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  public_url?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "project_avatars" */
export enum Project_Avatars_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Extension = 'extension',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  PublicUrl = 'public_url',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** This table regroup all project_categories */
export type Project_Categories = {
  __typename?: 'project_categories';
  color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  org_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "project_categories" */
export type Project_Categories_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Categories_Max_Order_By>;
  min?: InputMaybe<Project_Categories_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "project_categories". All fields are combined with a logical 'AND'. */
export type Project_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Categories_Bool_Exp>>;
  _not?: InputMaybe<Project_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Categories_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "project_categories" */
export type Project_Categories_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "project_categories" */
export type Project_Categories_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "project_categories". */
export type Project_Categories_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "project_categories" */
export enum Project_Categories_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Avatar of project groups */
export type Project_Group_Avatars = {
  __typename?: 'project_group_avatars';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  project_group_id: Scalars['uuid']['output'];
  public_url: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "project_group_avatars". All fields are combined with a logical 'AND'. */
export type Project_Group_Avatars_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Group_Avatars_Bool_Exp>>;
  _not?: InputMaybe<Project_Group_Avatars_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Group_Avatars_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  public_url?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "project_group_avatars". */
export type Project_Group_Avatars_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_group_id?: InputMaybe<Order_By>;
  public_url?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "project_group_avatars" */
export enum Project_Group_Avatars_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Extension = 'extension',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectGroupId = 'project_group_id',
  /** column name */
  PublicUrl = 'public_url',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "project_groups" */
export type Project_Groups = {
  __typename?: 'project_groups';
  color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_group_avatar?: Maybe<Project_Group_Avatars>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "project_groups" */
export type Project_Groups_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Groups_Max_Order_By>;
  min?: InputMaybe<Project_Groups_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "project_groups". All fields are combined with a logical 'AND'. */
export type Project_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Groups_Bool_Exp>>;
  _not?: InputMaybe<Project_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Groups_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_group_avatar?: InputMaybe<Project_Group_Avatars_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "project_groups" */
export type Project_Groups_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "project_groups" */
export type Project_Groups_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "project_groups". */
export type Project_Groups_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  project_group_avatar?: InputMaybe<Project_Group_Avatars_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "project_groups" */
export enum Project_Groups_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** This table regroup all project_labels */
export type Project_Labels = {
  __typename?: 'project_labels';
  color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  normalized_name: Scalars['String']['output'];
  project_id: Scalars['uuid']['output'];
  /** An array relationship */
  tasks: Array<Tasks_To_Project_Labels>;
  updated_at: Scalars['timestamptz']['output'];
};


/** This table regroup all project_labels */
export type Project_LabelsTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Tasks_To_Project_Labels_Bool_Exp>;
};

/** order by aggregate values of table "project_labels" */
export type Project_Labels_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Labels_Max_Order_By>;
  min?: InputMaybe<Project_Labels_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "project_labels". All fields are combined with a logical 'AND'. */
export type Project_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Labels_Bool_Exp>>;
  _not?: InputMaybe<Project_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Labels_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  normalized_name?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  tasks?: InputMaybe<Tasks_To_Project_Labels_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "project_labels" */
export type Project_Labels_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  normalized_name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "project_labels" */
export type Project_Labels_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  normalized_name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "project_labels". */
export type Project_Labels_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  normalized_name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_To_Project_Labels_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "project_labels" */
export enum Project_Labels_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NormalizedName = 'normalized_name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "project_roles" */
export type Project_Roles = {
  __typename?: 'project_roles';
  name: Scalars['String']['output'];
  /** An array relationship */
  projects_to_users: Array<Projects_To_Users>;
};


/** columns and relationships of "project_roles" */
export type Project_RolesProjects_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Projects_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_To_Users_Order_By>>;
  where?: InputMaybe<Projects_To_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "project_roles". All fields are combined with a logical 'AND'. */
export type Project_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Roles_Bool_Exp>>;
  _not?: InputMaybe<Project_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Roles_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  projects_to_users?: InputMaybe<Projects_To_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "project_roles". */
export type Project_Roles_Order_By = {
  name?: InputMaybe<Order_By>;
  projects_to_users_aggregate?: InputMaybe<Projects_To_Users_Aggregate_Order_By>;
};

/** select columns of table "project_roles" */
export enum Project_Roles_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "project_templates_overview" */
export type Project_Templates_Overview = {
  __typename?: 'project_templates_overview';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "project_templates_overview". All fields are combined with a logical 'AND'. */
export type Project_Templates_Overview_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Templates_Overview_Bool_Exp>>;
  _not?: InputMaybe<Project_Templates_Overview_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Templates_Overview_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_demo?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "project_templates_overview". */
export type Project_Templates_Overview_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_demo?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "project_templates_overview" */
export enum Project_Templates_Overview_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsDemo = 'is_demo',
  /** column name */
  Language = 'language',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** This table record everytime a user viewed a specific project url (docs/infos/tasks/...) */
export type Project_Views = {
  __typename?: 'project_views';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "project_views" */
export type Project_Views_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Views_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Views_Max_Order_By>;
  min?: InputMaybe<Project_Views_Min_Order_By>;
  stddev?: InputMaybe<Project_Views_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Views_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Views_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Views_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Views_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Views_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Views_Variance_Order_By>;
};

/** order by avg() on columns of table "project_views" */
export type Project_Views_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_views". All fields are combined with a logical 'AND'. */
export type Project_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Views_Bool_Exp>>;
  _not?: InputMaybe<Project_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Views_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "project_views" */
export type Project_Views_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "project_views" */
export type Project_Views_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "project_views". */
export type Project_Views_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "project_views" */
export enum Project_Views_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "project_views" */
export type Project_Views_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "project_views" */
export type Project_Views_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "project_views" */
export type Project_Views_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "project_views" */
export type Project_Views_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "project_views" */
export type Project_Views_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "project_views" */
export type Project_Views_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "project_views" */
export type Project_Views_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "projects" */
export type Projects = {
  __typename?: 'projects';
  /** An object relationship */
  address?: Maybe<Project_Address>;
  background?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  folders: Array<Folders>;
  id: Scalars['uuid']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_demo: Scalars['Boolean']['output'];
  /** An array relationship */
  labels: Array<Project_Labels>;
  /** An array relationship */
  members: Array<Projects_To_Users>;
  name: Scalars['String']['output'];
  /** An array relationship */
  org: Array<Orgs>;
  /** An array relationship */
  org_project_summaries: Array<Org_Project_Summary>;
  /** Get the org_project_summary for the current user depending on his org */
  org_project_summary?: Maybe<Array<Org_Project_Summary>>;
  /** An object relationship */
  project_avatar?: Maybe<Project_Avatars>;
  /** Get the bin root folder id for the project */
  root_bin_folder_id?: Maybe<Scalars['uuid']['output']>;
  /** Get the root folder for the project */
  root_folder_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** An array relationship */
  teams: Array<Teams>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  views: Array<Project_Views>;
};


/** columns and relationships of "projects" */
export type ProjectsFoldersArgs = {
  distinct_on?: InputMaybe<Array<Folders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folders_Order_By>>;
  where?: InputMaybe<Folders_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsLabelsArgs = {
  distinct_on?: InputMaybe<Array<Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Labels_Order_By>>;
  where?: InputMaybe<Project_Labels_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsMembersArgs = {
  distinct_on?: InputMaybe<Array<Projects_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_To_Users_Order_By>>;
  where?: InputMaybe<Projects_To_Users_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsOrgArgs = {
  distinct_on?: InputMaybe<Array<Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_Order_By>>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsOrg_Project_SummariesArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsOrg_Project_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsViewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Views_Order_By>>;
  where?: InputMaybe<Project_Views_Bool_Exp>;
};

/** order by aggregate values of table "projects" */
export type Projects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projects_Max_Order_By>;
  min?: InputMaybe<Projects_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "projects". All fields are combined with a logical 'AND'. */
export type Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Bool_Exp>>;
  _not?: InputMaybe<Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Bool_Exp>>;
  address?: InputMaybe<Project_Address_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  folders?: InputMaybe<Folders_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_demo?: InputMaybe<Boolean_Comparison_Exp>;
  labels?: InputMaybe<Project_Labels_Bool_Exp>;
  members?: InputMaybe<Projects_To_Users_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_project_summaries?: InputMaybe<Org_Project_Summary_Bool_Exp>;
  org_project_summary?: InputMaybe<Org_Project_Summary_Bool_Exp>;
  project_avatar?: InputMaybe<Project_Avatars_Bool_Exp>;
  root_bin_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  root_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  tasks?: InputMaybe<Tasks_Bool_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  views?: InputMaybe<Project_Views_Bool_Exp>;
};

/**
 * columns type override of view "projects_map_overview"
 * hasura mark all the fields as nullables for a view, here we define the real types for them
 */
export type Projects_Map_Overview = {
  __typename?: 'projects_map_overview';
  /** An object relationship */
  address?: Maybe<Project_Address>;
  avatar?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_archived: Scalars['Boolean']['output'];
  /** Get if the creator is member of the active org of the current user */
  is_creator_in_my_org?: Maybe<Scalars['Boolean']['output']>;
  is_demo: Scalars['Boolean']['output'];
  /** A computed field, executes function "get_user_is_member_project_map_overview" */
  is_member?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** Get the org_project_summary for the current user depending on his org */
  org_project_summary?: Maybe<Array<Org_Project_Summary>>;
  updated_at: Scalars['timestamptz']['output'];
};


/**
 * columns type override of view "projects_map_overview"
 * hasura mark all the fields as nullables for a view, here we define the real types for them
 */
export type Projects_Map_OverviewOrg_Project_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_Bool_Exp>;
};

/** aggregated selection of "projects_map_overview" */
export type Projects_Map_Overview_Aggregate = {
  __typename?: 'projects_map_overview_aggregate';
  aggregate?: Maybe<Projects_Map_Overview_Aggregate_Fields>;
  nodes: Array<Projects_Map_Overview>;
};

/** aggregate fields of "projects_map_overview" */
export type Projects_Map_Overview_Aggregate_Fields = {
  __typename?: 'projects_map_overview_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_Map_Overview_Max_Fields>;
  min?: Maybe<Projects_Map_Overview_Min_Fields>;
};


/** aggregate fields of "projects_map_overview" */
export type Projects_Map_Overview_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Map_Overview_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "projects_map_overview". All fields are combined with a logical 'AND'. */
export type Projects_Map_Overview_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Map_Overview_Bool_Exp>>;
  _not?: InputMaybe<Projects_Map_Overview_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Map_Overview_Bool_Exp>>;
  address?: InputMaybe<Project_Address_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_creator_in_my_org?: InputMaybe<Boolean_Comparison_Exp>;
  is_demo?: InputMaybe<Boolean_Comparison_Exp>;
  is_member?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_project_summary?: InputMaybe<Org_Project_Summary_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Projects_Map_Overview_Max_Fields = {
  __typename?: 'projects_map_overview_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Projects_Map_Overview_Min_Fields = {
  __typename?: 'projects_map_overview_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "projects_map_overview". */
export type Projects_Map_Overview_Order_By = {
  address?: InputMaybe<Project_Address_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_creator_in_my_org?: InputMaybe<Order_By>;
  is_demo?: InputMaybe<Order_By>;
  is_member?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_project_summary_aggregate?: InputMaybe<Org_Project_Summary_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "projects_map_overview" */
export enum Projects_Map_Overview_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsDemo = 'is_demo',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by max() on columns of table "projects" */
export type Projects_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "projects" */
export type Projects_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "projects". */
export type Projects_Order_By = {
  address?: InputMaybe<Project_Address_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  folders_aggregate?: InputMaybe<Folders_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_demo?: InputMaybe<Order_By>;
  labels_aggregate?: InputMaybe<Project_Labels_Aggregate_Order_By>;
  members_aggregate?: InputMaybe<Projects_To_Users_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  org_aggregate?: InputMaybe<Orgs_Aggregate_Order_By>;
  org_project_summaries_aggregate?: InputMaybe<Org_Project_Summary_Aggregate_Order_By>;
  org_project_summary_aggregate?: InputMaybe<Org_Project_Summary_Aggregate_Order_By>;
  project_avatar?: InputMaybe<Project_Avatars_Order_By>;
  root_bin_folder_id?: InputMaybe<Order_By>;
  root_folder_id?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views_aggregate?: InputMaybe<Project_Views_Aggregate_Order_By>;
};

/** select columns of table "projects" */
export enum Projects_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsDemo = 'is_demo',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "projects_to_users" */
export type Projects_To_Users = {
  __typename?: 'projects_to_users';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  inviter?: Maybe<Users>;
  /** An object relationship */
  project: Projects;
  /** An object relationship */
  role: Project_Roles;
  /** An object relationship */
  updater?: Maybe<Users>;
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "projects_to_users" */
export type Projects_To_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projects_To_Users_Max_Order_By>;
  min?: InputMaybe<Projects_To_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "projects_to_users". All fields are combined with a logical 'AND'. */
export type Projects_To_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_To_Users_Bool_Exp>>;
  _not?: InputMaybe<Projects_To_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_To_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  inviter?: InputMaybe<Users_Bool_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  role?: InputMaybe<Project_Roles_Bool_Exp>;
  updater?: InputMaybe<Users_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "projects_to_users" */
export type Projects_To_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "projects_to_users" */
export type Projects_To_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "projects_to_users". */
export type Projects_To_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  inviter?: InputMaybe<Users_Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  role?: InputMaybe<Project_Roles_Order_By>;
  updater?: InputMaybe<Users_Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "projects_to_users" */
export enum Projects_To_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at'
}

/** columns and relationships of "push_notifications" */
export type Push_Notifications = {
  __typename?: 'push_notifications';
  chat_channel: Scalars['Boolean']['output'];
  chat_direct_message: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "push_notifications". All fields are combined with a logical 'AND'. */
export type Push_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Push_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Push_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Push_Notifications_Bool_Exp>>;
  chat_channel?: InputMaybe<Boolean_Comparison_Exp>;
  chat_direct_message?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "push_notifications". */
export type Push_Notifications_Order_By = {
  chat_channel?: InputMaybe<Order_By>;
  chat_direct_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "push_notifications" */
export enum Push_Notifications_Select_Column {
  /** column name */
  ChatChannel = 'chat_channel',
  /** column name */
  ChatDirectMessage = 'chat_direct_message',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "email_notifications" */
  email_notifications: Array<Email_Notifications>;
  /** fetch data from the table: "email_notifications" using primary key columns */
  email_notifications_by_pk?: Maybe<Email_Notifications>;
  /** An array relationship */
  events: Array<Events>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table: "events_workers_status" */
  events_workers_status: Array<Events_Workers_Status>;
  /** fetch data from the table: "events_workers_status" using primary key columns */
  events_workers_status_by_pk?: Maybe<Events_Workers_Status>;
  /** fetch data from the table: "file_approval_attachments" */
  file_approval_attachments: Array<File_Approval_Attachments>;
  /** fetch aggregated fields from the table: "file_approval_attachments" */
  file_approval_attachments_aggregate: File_Approval_Attachments_Aggregate;
  /** fetch data from the table: "file_approval_attachments" using primary key columns */
  file_approval_attachments_by_pk?: Maybe<File_Approval_Attachments>;
  /** An array relationship */
  file_approvals: Array<File_Approvals>;
  /** fetch data from the table: "file_approvals" using primary key columns */
  file_approvals_by_pk?: Maybe<File_Approvals>;
  /** fetch data from the table: "file_approvals_file_versions" */
  file_approvals_file_versions: Array<File_Approvals_File_Versions>;
  /** fetch data from the table: "file_approvals_file_versions" using primary key columns */
  file_approvals_file_versions_by_pk?: Maybe<File_Approvals_File_Versions>;
  /** fetch data from the table: "file_assignations" */
  file_assignations: Array<File_Assignations>;
  /** fetch data from the table: "file_assignations" using primary key columns */
  file_assignations_by_pk?: Maybe<File_Assignations>;
  /** An array relationship */
  file_assignations_orgs: Array<File_Assignations_Orgs>;
  /** fetch data from the table: "file_assignations_orgs" using primary key columns */
  file_assignations_orgs_by_pk?: Maybe<File_Assignations_Orgs>;
  /** An array relationship */
  file_assignations_teams: Array<File_Assignations_Teams>;
  /** fetch data from the table: "file_assignations_teams" using primary key columns */
  file_assignations_teams_by_pk?: Maybe<File_Assignations_Teams>;
  /** An array relationship */
  file_assignations_users: Array<File_Assignations_Users>;
  /** fetch data from the table: "file_assignations_users" using primary key columns */
  file_assignations_users_by_pk?: Maybe<File_Assignations_Users>;
  /** An array relationship */
  file_comments: Array<File_Comments>;
  /** fetch data from the table: "file_comments" using primary key columns */
  file_comments_by_pk?: Maybe<File_Comments>;
  /** fetch data from the table: "file_permissions" */
  file_permissions: Array<File_Permissions>;
  /** fetch data from the table: "file_permissions" using primary key columns */
  file_permissions_by_pk?: Maybe<File_Permissions>;
  /** fetch data from the table: "file_permissions_orgs" */
  file_permissions_orgs: Array<File_Permissions_Orgs>;
  /** fetch data from the table: "file_permissions_orgs" using primary key columns */
  file_permissions_orgs_by_pk?: Maybe<File_Permissions_Orgs>;
  /** fetch data from the table: "file_permissions_teams" */
  file_permissions_teams: Array<File_Permissions_Teams>;
  /** fetch data from the table: "file_permissions_teams" using primary key columns */
  file_permissions_teams_by_pk?: Maybe<File_Permissions_Teams>;
  /** An array relationship */
  file_permissions_users: Array<File_Permissions_Users>;
  /** fetch data from the table: "file_permissions_users" using primary key columns */
  file_permissions_users_by_pk?: Maybe<File_Permissions_Users>;
  /** An array relationship */
  file_signatures: Array<File_Signatures>;
  /** fetch data from the table: "file_signatures" using primary key columns */
  file_signatures_by_pk?: Maybe<File_Signatures>;
  /** An array relationship */
  file_version_approval_request_users: Array<File_Version_Approval_Request_Users>;
  /** An aggregate relationship */
  file_version_approval_request_users_aggregate: File_Version_Approval_Request_Users_Aggregate;
  /** fetch data from the table: "file_version_approval_request_users" using primary key columns */
  file_version_approval_request_users_by_pk?: Maybe<File_Version_Approval_Request_Users>;
  /** fetch data from the table: "file_version_approval_requests" */
  file_version_approval_requests: Array<File_Version_Approval_Requests>;
  /** fetch data from the table: "file_version_approval_requests" using primary key columns */
  file_version_approval_requests_by_pk?: Maybe<File_Version_Approval_Requests>;
  /** fetch data from the table: "file_version_autodesk" */
  file_version_autodesk: Array<File_Version_Autodesk>;
  /** fetch data from the table: "file_version_autodesk" using primary key columns */
  file_version_autodesk_by_pk?: Maybe<File_Version_Autodesk>;
  /** An array relationship */
  file_versions: Array<File_Versions>;
  /** fetch data from the table: "file_versions_approvals_overview" */
  file_versions_approvals_overview: Array<File_Versions_Approvals_Overview>;
  /** fetch data from the table: "file_versions" using primary key columns */
  file_versions_by_pk?: Maybe<File_Versions>;
  /** An array relationship */
  file_views: Array<File_Views>;
  /** fetch data from the table: "file_views" using primary key columns */
  file_views_by_pk?: Maybe<File_Views>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table: "files_to_project_labels" */
  files_to_project_labels: Array<Files_To_Project_Labels>;
  /** fetch data from the table: "files_to_project_labels" using primary key columns */
  files_to_project_labels_by_pk?: Maybe<Files_To_Project_Labels>;
  /** fetch data from the table: "filter_user_default" */
  filter_user_default: Array<Filter_User_Default>;
  /** fetch data from the table: "filter_user_default" using primary key columns */
  filter_user_default_by_pk?: Maybe<Filter_User_Default>;
  /** fetch data from the table: "filters" */
  filters: Array<Filters>;
  /** fetch data from the table: "filters" using primary key columns */
  filters_by_pk?: Maybe<Filters>;
  /** fetch data from the table: "folder_assignations" */
  folder_assignations: Array<Folder_Assignations>;
  /** fetch data from the table: "folder_assignations" using primary key columns */
  folder_assignations_by_pk?: Maybe<Folder_Assignations>;
  /** An array relationship */
  folder_assignations_orgs: Array<Folder_Assignations_Orgs>;
  /** fetch data from the table: "folder_assignations_orgs" using primary key columns */
  folder_assignations_orgs_by_pk?: Maybe<Folder_Assignations_Orgs>;
  /** An array relationship */
  folder_assignations_teams: Array<Folder_Assignations_Teams>;
  /** fetch data from the table: "folder_assignations_teams" using primary key columns */
  folder_assignations_teams_by_pk?: Maybe<Folder_Assignations_Teams>;
  /** An array relationship */
  folder_assignations_users: Array<Folder_Assignations_Users>;
  /** fetch data from the table: "folder_assignations_users" using primary key columns */
  folder_assignations_users_by_pk?: Maybe<Folder_Assignations_Users>;
  /** fetch data from the table: "folder_permissions" */
  folder_permissions: Array<Folder_Permissions>;
  /** fetch data from the table: "folder_permissions" using primary key columns */
  folder_permissions_by_pk?: Maybe<Folder_Permissions>;
  /** fetch data from the table: "folder_permissions_orgs" */
  folder_permissions_orgs: Array<Folder_Permissions_Orgs>;
  /** fetch data from the table: "folder_permissions_orgs" using primary key columns */
  folder_permissions_orgs_by_pk?: Maybe<Folder_Permissions_Orgs>;
  /** fetch data from the table: "folder_permissions_teams" */
  folder_permissions_teams: Array<Folder_Permissions_Teams>;
  /** fetch data from the table: "folder_permissions_teams" using primary key columns */
  folder_permissions_teams_by_pk?: Maybe<Folder_Permissions_Teams>;
  /** fetch data from the table: "folder_permissions_users" */
  folder_permissions_users: Array<Folder_Permissions_Users>;
  /** fetch data from the table: "folder_permissions_users" using primary key columns */
  folder_permissions_users_by_pk?: Maybe<Folder_Permissions_Users>;
  /** An array relationship */
  folder_views: Array<Folder_Views>;
  /** fetch data from the table: "folder_views" using primary key columns */
  folder_views_by_pk?: Maybe<Folder_Views>;
  /** An array relationship */
  folders: Array<Folders>;
  /** fetch data from the table: "folders" using primary key columns */
  folders_by_pk?: Maybe<Folders>;
  /** fetch data from the table: "folders_to_project_labels" */
  folders_to_project_labels: Array<Folders_To_Project_Labels>;
  /** fetch data from the table: "folders_to_project_labels" using primary key columns */
  folders_to_project_labels_by_pk?: Maybe<Folders_To_Project_Labels>;
  getAlgoliaUserApiKey?: Maybe<GetAlgoliaUserApiKeySuccess>;
  getAutodeskToken?: Maybe<GetAutodeskToken>;
  getCapawesomeChannels?: Maybe<Array<Maybe<CapawesomeChannel>>>;
  getCapgoChannels?: Maybe<Array<Maybe<CapgoChannel>>>;
  getOrgBackgroundUrl?: Maybe<Scalars['String']['output']>;
  getOrgProjectTemplates?: Maybe<GetOrgProejectTemplate>;
  getPresignedFileApprovalAttachmentUrl?: Maybe<Scalars['String']['output']>;
  getPresignedFileUrl?: Maybe<Scalars['String']['output']>;
  getPresignedFileVersionUrl?: Maybe<Scalars['String']['output']>;
  getPresignedOriginalFileVersionUrl?: Maybe<Scalars['String']['output']>;
  getPresignedTaskAttachmentUrl?: Maybe<Scalars['String']['output']>;
  getProjectAvatarUrl?: Maybe<Scalars['String']['output']>;
  getProjectBackgroundUrl?: Maybe<Scalars['String']['output']>;
  getProjectBannerUrl?: Maybe<Scalars['String']['output']>;
  getStreamChatUserToken?: Maybe<GetStreamChatUserTokenSuccess>;
  getSubFolderCount?: Maybe<Array<Maybe<SubFolderCountType>>>;
  getUserAuthLink?: Maybe<Scalars['String']['output']>;
  /** execute function "get_file_version" which returns "file_versions" */
  get_file_version: Array<File_Versions>;
  /** fetch data from the table: "org_address" */
  org_address: Array<Org_Address>;
  /** fetch data from the table: "org_address" using primary key columns */
  org_address_by_pk?: Maybe<Org_Address>;
  /** fetch data from the table: "org_avatars" */
  org_avatars: Array<Org_Avatars>;
  /** fetch data from the table: "org_avatars" using primary key columns */
  org_avatars_by_pk?: Maybe<Org_Avatars>;
  /** fetch data from the table: "org_project_summary" */
  org_project_summary: Array<Org_Project_Summary>;
  /** fetch data from the table: "org_project_summary" using primary key columns */
  org_project_summary_by_pk?: Maybe<Org_Project_Summary>;
  /** fetch data from the table: "org_project_summary_to_project_categories" */
  org_project_summary_to_project_categories: Array<Org_Project_Summary_To_Project_Categories>;
  /** fetch data from the table: "org_project_summary_to_project_categories" using primary key columns */
  org_project_summary_to_project_categories_by_pk?: Maybe<Org_Project_Summary_To_Project_Categories>;
  /** fetch data from the table: "org_project_summary_to_project_groups" */
  org_project_summary_to_project_groups: Array<Org_Project_Summary_To_Project_Groups>;
  /** fetch data from the table: "org_project_summary_to_project_groups" using primary key columns */
  org_project_summary_to_project_groups_by_pk?: Maybe<Org_Project_Summary_To_Project_Groups>;
  /** fetch data from the table: "org_roles" */
  org_roles: Array<Org_Roles>;
  /** fetch data from the table: "org_roles" using primary key columns */
  org_roles_by_pk?: Maybe<Org_Roles>;
  /** fetch data from the table: "org_settings" */
  org_settings: Array<Org_Settings>;
  /** fetch data from the table: "org_settings" using primary key columns */
  org_settings_by_pk?: Maybe<Org_Settings>;
  /** fetch data from the table: "orgs" */
  orgs: Array<Orgs>;
  /** fetch data from the table: "orgs" using primary key columns */
  orgs_by_pk?: Maybe<Orgs>;
  /** An array relationship */
  orgs_to_users: Array<Orgs_To_Users>;
  /** fetch data from the table: "orgs_to_users" using primary key columns */
  orgs_to_users_by_pk?: Maybe<Orgs_To_Users>;
  /** fetch data from the table: "project_address" */
  project_address: Array<Project_Address>;
  /** fetch data from the table: "project_address" using primary key columns */
  project_address_by_pk?: Maybe<Project_Address>;
  /** fetch data from the table: "project_avatars" */
  project_avatars: Array<Project_Avatars>;
  /** fetch data from the table: "project_avatars" using primary key columns */
  project_avatars_by_pk?: Maybe<Project_Avatars>;
  /** An array relationship */
  project_categories: Array<Project_Categories>;
  /** fetch data from the table: "project_categories" using primary key columns */
  project_categories_by_pk?: Maybe<Project_Categories>;
  /** fetch data from the table: "project_group_avatars" */
  project_group_avatars: Array<Project_Group_Avatars>;
  /** fetch data from the table: "project_group_avatars" using primary key columns */
  project_group_avatars_by_pk?: Maybe<Project_Group_Avatars>;
  /** An array relationship */
  project_groups: Array<Project_Groups>;
  /** fetch data from the table: "project_groups" using primary key columns */
  project_groups_by_pk?: Maybe<Project_Groups>;
  /** fetch data from the table: "project_labels" */
  project_labels: Array<Project_Labels>;
  /** fetch data from the table: "project_labels" using primary key columns */
  project_labels_by_pk?: Maybe<Project_Labels>;
  /** fetch data from the table: "project_roles" */
  project_roles: Array<Project_Roles>;
  /** fetch data from the table: "project_roles" using primary key columns */
  project_roles_by_pk?: Maybe<Project_Roles>;
  /** fetch data from the table: "project_templates_overview" */
  project_templates_overview: Array<Project_Templates_Overview>;
  /** An array relationship */
  project_views: Array<Project_Views>;
  /** fetch data from the table: "project_views" using primary key columns */
  project_views_by_pk?: Maybe<Project_Views>;
  /** fetch data from the table: "projects" */
  projects: Array<Projects>;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "projects_map_overview" */
  projects_map_overview: Array<Projects_Map_Overview>;
  /** fetch aggregated fields from the table: "projects_map_overview" */
  projects_map_overview_aggregate: Projects_Map_Overview_Aggregate;
  /** An array relationship */
  projects_to_users: Array<Projects_To_Users>;
  /** fetch data from the table: "push_notifications" */
  push_notifications: Array<Push_Notifications>;
  /** fetch data from the table: "push_notifications" using primary key columns */
  push_notifications_by_pk?: Maybe<Push_Notifications>;
  /** fetch data from the table: "report_blocks" */
  report_blocks: Array<Report_Blocks>;
  /** fetch data from the table: "report_blocks" using primary key columns */
  report_blocks_by_pk?: Maybe<Report_Blocks>;
  /** fetch data from the table: "t_folder_notification_badge" */
  t_folder_notification_badge: Array<T_Folder_Notification_Badge>;
  /** fetch data from the table: "t_folder_notification_badge" using primary key columns */
  t_folder_notification_badge_by_pk?: Maybe<T_Folder_Notification_Badge>;
  /** fetch data from the table: "t_folder_pwd" */
  t_folder_pwd: Array<T_Folder_Pwd>;
  /** fetch data from the table: "t_folder_pwd" using primary key columns */
  t_folder_pwd_by_pk?: Maybe<T_Folder_Pwd>;
  /** fetch data from the table: "task_assignations" */
  task_assignations: Array<Task_Assignations>;
  /** fetch data from the table: "task_assignations" using primary key columns */
  task_assignations_by_pk?: Maybe<Task_Assignations>;
  /** fetch data from the table: "task_assignations_orgs" */
  task_assignations_orgs: Array<Task_Assignations_Orgs>;
  /** fetch data from the table: "task_assignations_orgs" using primary key columns */
  task_assignations_orgs_by_pk?: Maybe<Task_Assignations_Orgs>;
  /** fetch data from the table: "task_assignations_teams" */
  task_assignations_teams: Array<Task_Assignations_Teams>;
  /** fetch data from the table: "task_assignations_teams" using primary key columns */
  task_assignations_teams_by_pk?: Maybe<Task_Assignations_Teams>;
  /** An array relationship */
  task_assignations_users: Array<Task_Assignations_Users>;
  /** fetch data from the table: "task_assignations_users" using primary key columns */
  task_assignations_users_by_pk?: Maybe<Task_Assignations_Users>;
  /** fetch data from the table: "task_attachments" */
  task_attachments: Array<Task_Attachments>;
  /** fetch data from the table: "task_attachments" using primary key columns */
  task_attachments_by_pk?: Maybe<Task_Attachments>;
  /** fetch data from the table: "task_dependencies" */
  task_dependencies: Array<Task_Dependencies>;
  /** fetch data from the table: "task_file_version_location" */
  task_file_version_location: Array<Task_File_Version_Location>;
  /** fetch data from the table: "task_file_version_location" using primary key columns */
  task_file_version_location_by_pk?: Maybe<Task_File_Version_Location>;
  /** fetch data from the table: "task_locations" */
  task_locations: Array<Task_Locations>;
  /** fetch data from the table: "task_locations" using primary key columns */
  task_locations_by_pk?: Maybe<Task_Locations>;
  /** fetch data from the table: "task_permissions" */
  task_permissions: Array<Task_Permissions>;
  /** fetch data from the table: "task_permissions" using primary key columns */
  task_permissions_by_pk?: Maybe<Task_Permissions>;
  /** fetch data from the table: "task_permissions_orgs" */
  task_permissions_orgs: Array<Task_Permissions_Orgs>;
  /** fetch data from the table: "task_permissions_orgs" using primary key columns */
  task_permissions_orgs_by_pk?: Maybe<Task_Permissions_Orgs>;
  /** fetch data from the table: "task_permissions_teams" */
  task_permissions_teams: Array<Task_Permissions_Teams>;
  /** fetch data from the table: "task_permissions_teams" using primary key columns */
  task_permissions_teams_by_pk?: Maybe<Task_Permissions_Teams>;
  /** fetch data from the table: "task_permissions_users" */
  task_permissions_users: Array<Task_Permissions_Users>;
  /** fetch data from the table: "task_permissions_users" using primary key columns */
  task_permissions_users_by_pk?: Maybe<Task_Permissions_Users>;
  /** An array relationship */
  task_subtasks: Array<Task_Subtasks>;
  /** fetch data from the table: "task_subtasks" using primary key columns */
  task_subtasks_by_pk?: Maybe<Task_Subtasks>;
  /** An array relationship */
  task_validations: Array<Task_Validations>;
  /** fetch data from the table: "task_validations" using primary key columns */
  task_validations_by_pk?: Maybe<Task_Validations>;
  /** An array relationship */
  task_views: Array<Task_Views>;
  /** fetch data from the table: "task_views" using primary key columns */
  task_views_by_pk?: Maybe<Task_Views>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** fetch data from the table: "tasks_file_versions" */
  tasks_file_versions: Array<Tasks_File_Versions>;
  /** fetch data from the table: "tasks_file_versions" using primary key columns */
  tasks_file_versions_by_pk?: Maybe<Tasks_File_Versions>;
  /** fetch data from the table: "tasks_to_project_labels" */
  tasks_to_project_labels: Array<Tasks_To_Project_Labels>;
  /** fetch data from the table: "tasks_to_project_labels" using primary key columns */
  tasks_to_project_labels_by_pk?: Maybe<Tasks_To_Project_Labels>;
  /** An array relationship */
  teams: Array<Teams>;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table: "teams_to_users" */
  teams_to_users: Array<Teams_To_Users>;
  /** fetch data from the table: "teams_to_users" using primary key columns */
  teams_to_users_by_pk?: Maybe<Teams_To_Users>;
  /** fetch data from the table: "uptime_test" */
  uptime_test: Array<Uptime_Test>;
  /** fetch data from the table: "uptime_test" using primary key columns */
  uptime_test_by_pk?: Maybe<Uptime_Test>;
  /** fetch data from the table: "user_avatars" */
  user_avatars: Array<User_Avatars>;
  /** fetch data from the table: "user_avatars" using primary key columns */
  user_avatars_by_pk?: Maybe<User_Avatars>;
  /** fetch data from the table: "user_connections" */
  user_connections: Array<User_Connections>;
  /** fetch data from the table: "user_connections" using primary key columns */
  user_connections_by_pk?: Maybe<User_Connections>;
  /** fetch data from the table: "user_contact" */
  user_contact: Array<User_Contact>;
  /** An array relationship */
  user_locations: Array<User_Locations>;
  /** fetch data from the table: "user_locations" using primary key columns */
  user_locations_by_pk?: Maybe<User_Locations>;
  /** fetch data from the table: "user_metadatas" */
  user_metadatas: Array<User_Metadatas>;
  /** An array relationship */
  user_notifications: Array<User_Notifications>;
  /** fetch data from the table: "user_notifications" using primary key columns */
  user_notifications_by_pk?: Maybe<User_Notifications>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Notifications_Order_By>>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};


export type Query_RootEmail_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEvents_Workers_StatusArgs = {
  distinct_on?: InputMaybe<Array<Events_Workers_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Workers_Status_Order_By>>;
  where?: InputMaybe<Events_Workers_Status_Bool_Exp>;
};


export type Query_RootEvents_Workers_Status_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Approval_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<File_Approval_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approval_Attachments_Order_By>>;
  where?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
};


export type Query_RootFile_Approval_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Approval_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approval_Attachments_Order_By>>;
  where?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
};


export type Query_RootFile_Approval_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_Order_By>>;
  where?: InputMaybe<File_Approvals_Bool_Exp>;
};


export type Query_RootFile_Approvals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Approvals_File_VersionsArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_File_Versions_Order_By>>;
  where?: InputMaybe<File_Approvals_File_Versions_Bool_Exp>;
};


export type Query_RootFile_Approvals_File_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Order_By>>;
  where?: InputMaybe<File_Assignations_Bool_Exp>;
};


export type Query_RootFile_Assignations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<File_Assignations_Orgs_Bool_Exp>;
};


export type Query_RootFile_Assignations_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Teams_Order_By>>;
  where?: InputMaybe<File_Assignations_Teams_Bool_Exp>;
};


export type Query_RootFile_Assignations_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Users_Order_By>>;
  where?: InputMaybe<File_Assignations_Users_Bool_Exp>;
};


export type Query_RootFile_Assignations_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_CommentsArgs = {
  distinct_on?: InputMaybe<Array<File_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Comments_Order_By>>;
  where?: InputMaybe<File_Comments_Bool_Exp>;
};


export type Query_RootFile_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Order_By>>;
  where?: InputMaybe<File_Permissions_Bool_Exp>;
};


export type Query_RootFile_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<File_Permissions_Orgs_Bool_Exp>;
};


export type Query_RootFile_Permissions_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Teams_Order_By>>;
  where?: InputMaybe<File_Permissions_Teams_Bool_Exp>;
};


export type Query_RootFile_Permissions_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Users_Order_By>>;
  where?: InputMaybe<File_Permissions_Users_Bool_Exp>;
};


export type Query_RootFile_Permissions_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_SignaturesArgs = {
  distinct_on?: InputMaybe<Array<File_Signatures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Signatures_Order_By>>;
  where?: InputMaybe<File_Signatures_Bool_Exp>;
};


export type Query_RootFile_Signatures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Version_Approval_Request_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};


export type Query_RootFile_Version_Approval_Request_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};


export type Query_RootFile_Version_Approval_Request_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Version_Approval_RequestsArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Requests_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Requests_Bool_Exp>;
};


export type Query_RootFile_Version_Approval_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_Version_AutodeskArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Autodesk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Autodesk_Order_By>>;
  where?: InputMaybe<File_Version_Autodesk_Bool_Exp>;
};


export type Query_RootFile_Version_Autodesk_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_VersionsArgs = {
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};


export type Query_RootFile_Versions_Approvals_OverviewArgs = {
  distinct_on?: InputMaybe<Array<File_Versions_Approvals_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Approvals_Overview_Order_By>>;
  where?: InputMaybe<File_Versions_Approvals_Overview_Bool_Exp>;
};


export type Query_RootFile_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_ViewsArgs = {
  distinct_on?: InputMaybe<Array<File_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Views_Order_By>>;
  where?: InputMaybe<File_Views_Bool_Exp>;
};


export type Query_RootFile_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFiles_To_Project_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Files_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Files_To_Project_Labels_Bool_Exp>;
};


export type Query_RootFiles_To_Project_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilter_User_DefaultArgs = {
  distinct_on?: InputMaybe<Array<Filter_User_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Filter_User_Default_Order_By>>;
  where?: InputMaybe<Filter_User_Default_Bool_Exp>;
};


export type Query_RootFilter_User_Default_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFiltersArgs = {
  distinct_on?: InputMaybe<Array<Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Filters_Order_By>>;
  where?: InputMaybe<Filters_Bool_Exp>;
};


export type Query_RootFilters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Bool_Exp>;
};


export type Query_RootFolder_Assignations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
};


export type Query_RootFolder_Assignations_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
};


export type Query_RootFolder_Assignations_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Users_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
};


export type Query_RootFolder_Assignations_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Bool_Exp>;
};


export type Query_RootFolder_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Orgs_Bool_Exp>;
};


export type Query_RootFolder_Permissions_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Teams_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Teams_Bool_Exp>;
};


export type Query_RootFolder_Permissions_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Users_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Users_Bool_Exp>;
};


export type Query_RootFolder_Permissions_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolder_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Views_Order_By>>;
  where?: InputMaybe<Folder_Views_Bool_Exp>;
};


export type Query_RootFolder_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFoldersArgs = {
  distinct_on?: InputMaybe<Array<Folders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folders_Order_By>>;
  where?: InputMaybe<Folders_Bool_Exp>;
};


export type Query_RootFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFolders_To_Project_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Folders_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folders_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Folders_To_Project_Labels_Bool_Exp>;
};


export type Query_RootFolders_To_Project_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetAutodeskTokenArgs = {
  userId: Scalars['uuid']['input'];
};


export type Query_RootGetCapawesomeChannelsArgs = {
  app_id: Scalars['String']['input'];
};


export type Query_RootGetCapgoChannelsArgs = {
  app_id: Scalars['String']['input'];
};


export type Query_RootGetOrgBackgroundUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetOrgProjectTemplatesArgs = {
  orgId: Scalars['uuid']['input'];
};


export type Query_RootGetPresignedFileApprovalAttachmentUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetPresignedFileUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetPresignedFileVersionUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetPresignedOriginalFileVersionUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetPresignedTaskAttachmentUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetProjectAvatarUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetProjectBackgroundUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetProjectBannerUrlArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetSubFolderCountArgs = {
  id: Array<Scalars['uuid']['input']>;
};


export type Query_RootGetUserAuthLinkArgs = {
  redirect?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['uuid']['input'];
};


export type Query_RootGet_File_VersionArgs = {
  args: Get_File_Version_Args;
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};


export type Query_RootOrg_AddressArgs = {
  distinct_on?: InputMaybe<Array<Org_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Address_Order_By>>;
  where?: InputMaybe<Org_Address_Bool_Exp>;
};


export type Query_RootOrg_Address_By_PkArgs = {
  org_id: Scalars['uuid']['input'];
};


export type Query_RootOrg_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<Org_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Avatars_Order_By>>;
  where?: InputMaybe<Org_Avatars_Bool_Exp>;
};


export type Query_RootOrg_Avatars_By_PkArgs = {
  org_id: Scalars['uuid']['input'];
};


export type Query_RootOrg_Project_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_Bool_Exp>;
};


export type Query_RootOrg_Project_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrg_Project_Summary_To_Project_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_To_Project_Categories_Bool_Exp>;
};


export type Query_RootOrg_Project_Summary_To_Project_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrg_Project_Summary_To_Project_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_To_Project_Groups_Bool_Exp>;
};


export type Query_RootOrg_Project_Summary_To_Project_Groups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrg_RolesArgs = {
  distinct_on?: InputMaybe<Array<Org_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Roles_Order_By>>;
  where?: InputMaybe<Org_Roles_Bool_Exp>;
};


export type Query_RootOrg_Roles_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootOrg_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Org_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Settings_Order_By>>;
  where?: InputMaybe<Org_Settings_Bool_Exp>;
};


export type Query_RootOrg_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrgsArgs = {
  distinct_on?: InputMaybe<Array<Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_Order_By>>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};


export type Query_RootOrgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrgs_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Orgs_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_To_Users_Order_By>>;
  where?: InputMaybe<Orgs_To_Users_Bool_Exp>;
};


export type Query_RootOrgs_To_Users_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootProject_AddressArgs = {
  distinct_on?: InputMaybe<Array<Project_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Address_Order_By>>;
  where?: InputMaybe<Project_Address_Bool_Exp>;
};


export type Query_RootProject_Address_By_PkArgs = {
  project_id: Scalars['uuid']['input'];
};


export type Query_RootProject_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<Project_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Avatars_Order_By>>;
  where?: InputMaybe<Project_Avatars_Bool_Exp>;
};


export type Query_RootProject_Avatars_By_PkArgs = {
  project_id: Scalars['uuid']['input'];
};


export type Query_RootProject_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Categories_Order_By>>;
  where?: InputMaybe<Project_Categories_Bool_Exp>;
};


export type Query_RootProject_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_Group_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<Project_Group_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Group_Avatars_Order_By>>;
  where?: InputMaybe<Project_Group_Avatars_Bool_Exp>;
};


export type Query_RootProject_Group_Avatars_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Project_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Groups_Order_By>>;
  where?: InputMaybe<Project_Groups_Bool_Exp>;
};


export type Query_RootProject_Groups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Labels_Order_By>>;
  where?: InputMaybe<Project_Labels_Bool_Exp>;
};


export type Query_RootProject_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProject_RolesArgs = {
  distinct_on?: InputMaybe<Array<Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Roles_Order_By>>;
  where?: InputMaybe<Project_Roles_Bool_Exp>;
};


export type Query_RootProject_Roles_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootProject_Templates_OverviewArgs = {
  distinct_on?: InputMaybe<Array<Project_Templates_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Templates_Overview_Order_By>>;
  where?: InputMaybe<Project_Templates_Overview_Bool_Exp>;
};


export type Query_RootProject_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Views_Order_By>>;
  where?: InputMaybe<Project_Views_Bool_Exp>;
};


export type Query_RootProject_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjects_Map_OverviewArgs = {
  distinct_on?: InputMaybe<Array<Projects_Map_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Map_Overview_Order_By>>;
  where?: InputMaybe<Projects_Map_Overview_Bool_Exp>;
};


export type Query_RootProjects_Map_Overview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Map_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Map_Overview_Order_By>>;
  where?: InputMaybe<Projects_Map_Overview_Bool_Exp>;
};


export type Query_RootProjects_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Projects_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_To_Users_Order_By>>;
  where?: InputMaybe<Projects_To_Users_Bool_Exp>;
};


export type Query_RootPush_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Push_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notifications_Order_By>>;
  where?: InputMaybe<Push_Notifications_Bool_Exp>;
};


export type Query_RootPush_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReport_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Report_Blocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Report_Blocks_Order_By>>;
  where?: InputMaybe<Report_Blocks_Bool_Exp>;
};


export type Query_RootReport_Blocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootT_Folder_Notification_BadgeArgs = {
  distinct_on?: InputMaybe<Array<T_Folder_Notification_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<T_Folder_Notification_Badge_Order_By>>;
  where?: InputMaybe<T_Folder_Notification_Badge_Bool_Exp>;
};


export type Query_RootT_Folder_Notification_Badge_By_PkArgs = {
  folder_id: Scalars['uuid']['input'];
};


export type Query_RootT_Folder_PwdArgs = {
  distinct_on?: InputMaybe<Array<T_Folder_Pwd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<T_Folder_Pwd_Order_By>>;
  where?: InputMaybe<T_Folder_Pwd_Bool_Exp>;
};


export type Query_RootT_Folder_Pwd_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Order_By>>;
  where?: InputMaybe<Task_Assignations_Bool_Exp>;
};


export type Query_RootTask_Assignations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Task_Assignations_Orgs_Bool_Exp>;
};


export type Query_RootTask_Assignations_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Task_Assignations_Teams_Bool_Exp>;
};


export type Query_RootTask_Assignations_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Users_Order_By>>;
  where?: InputMaybe<Task_Assignations_Users_Bool_Exp>;
};


export type Query_RootTask_Assignations_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Task_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Attachments_Order_By>>;
  where?: InputMaybe<Task_Attachments_Bool_Exp>;
};


export type Query_RootTask_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_DependenciesArgs = {
  distinct_on?: InputMaybe<Array<Task_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Dependencies_Order_By>>;
  where?: InputMaybe<Task_Dependencies_Bool_Exp>;
};


export type Query_RootTask_File_Version_LocationArgs = {
  distinct_on?: InputMaybe<Array<Task_File_Version_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_File_Version_Location_Order_By>>;
  where?: InputMaybe<Task_File_Version_Location_Bool_Exp>;
};


export type Query_RootTask_File_Version_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Locations_Order_By>>;
  where?: InputMaybe<Task_Locations_Bool_Exp>;
};


export type Query_RootTask_Locations_By_PkArgs = {
  task_id: Scalars['uuid']['input'];
};


export type Query_RootTask_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Order_By>>;
  where?: InputMaybe<Task_Permissions_Bool_Exp>;
};


export type Query_RootTask_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<Task_Permissions_Orgs_Bool_Exp>;
};


export type Query_RootTask_Permissions_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Teams_Order_By>>;
  where?: InputMaybe<Task_Permissions_Teams_Bool_Exp>;
};


export type Query_RootTask_Permissions_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Users_Order_By>>;
  where?: InputMaybe<Task_Permissions_Users_Bool_Exp>;
};


export type Query_RootTask_Permissions_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_SubtasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Subtasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Subtasks_Order_By>>;
  where?: InputMaybe<Task_Subtasks_Bool_Exp>;
};


export type Query_RootTask_Subtasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_ValidationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Validations_Order_By>>;
  where?: InputMaybe<Task_Validations_Bool_Exp>;
};


export type Query_RootTask_Validations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTask_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Task_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Views_Order_By>>;
  where?: InputMaybe<Task_Views_Bool_Exp>;
};


export type Query_RootTask_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTasks_File_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tasks_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_File_Versions_Order_By>>;
  where?: InputMaybe<Tasks_File_Versions_Bool_Exp>;
};


export type Query_RootTasks_File_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTasks_To_Project_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Tasks_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Tasks_To_Project_Labels_Bool_Exp>;
};


export type Query_RootTasks_To_Project_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeams_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_To_Users_Order_By>>;
  where?: InputMaybe<Teams_To_Users_Bool_Exp>;
};


export type Query_RootTeams_To_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUptime_TestArgs = {
  distinct_on?: InputMaybe<Array<Uptime_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uptime_Test_Order_By>>;
  where?: InputMaybe<Uptime_Test_Bool_Exp>;
};


export type Query_RootUptime_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUser_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<User_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Avatars_Order_By>>;
  where?: InputMaybe<User_Avatars_Bool_Exp>;
};


export type Query_RootUser_Avatars_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootUser_ConnectionsArgs = {
  distinct_on?: InputMaybe<Array<User_Connections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Connections_Order_By>>;
  where?: InputMaybe<User_Connections_Bool_Exp>;
};


export type Query_RootUser_Connections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_ContactArgs = {
  distinct_on?: InputMaybe<Array<User_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Contact_Order_By>>;
  where?: InputMaybe<User_Contact_Bool_Exp>;
};


export type Query_RootUser_LocationsArgs = {
  distinct_on?: InputMaybe<Array<User_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Locations_Order_By>>;
  where?: InputMaybe<User_Locations_Bool_Exp>;
};


export type Query_RootUser_Locations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_MetadatasArgs = {
  distinct_on?: InputMaybe<Array<User_Metadatas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Metadatas_Order_By>>;
  where?: InputMaybe<User_Metadatas_Bool_Exp>;
};


export type Query_RootUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};


export type Query_RootUser_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** This table stores the report templates created by users. It is supposed to receive information from EditorJS. */
export type Report_Blocks = {
  __typename?: 'report_blocks';
  block_content: Scalars['String']['output'];
  color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  creator_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  scope_org_id?: Maybe<Scalars['uuid']['output']>;
  scope_project_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamp']['output'];
  visibility_org_id?: Maybe<Scalars['uuid']['output']>;
  visibility_project_id?: Maybe<Scalars['uuid']['output']>;
  visibility_team_id?: Maybe<Scalars['uuid']['output']>;
  visibility_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "report_blocks". All fields are combined with a logical 'AND'. */
export type Report_Blocks_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Blocks_Bool_Exp>>;
  _not?: InputMaybe<Report_Blocks_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Blocks_Bool_Exp>>;
  block_content?: InputMaybe<String_Comparison_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  scope_org_id?: InputMaybe<Uuid_Comparison_Exp>;
  scope_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  visibility_org_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "report_blocks". */
export type Report_Blocks_Order_By = {
  block_content?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scope_org_id?: InputMaybe<Order_By>;
  scope_project_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_org_id?: InputMaybe<Order_By>;
  visibility_project_id?: InputMaybe<Order_By>;
  visibility_team_id?: InputMaybe<Order_By>;
  visibility_user_id?: InputMaybe<Order_By>;
};

/** select columns of table "report_blocks" */
export enum Report_Blocks_Select_Column {
  /** column name */
  BlockContent = 'block_content',
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ScopeOrgId = 'scope_org_id',
  /** column name */
  ScopeProjectId = 'scope_project_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibilityOrgId = 'visibility_org_id',
  /** column name */
  VisibilityProjectId = 'visibility_project_id',
  /** column name */
  VisibilityTeamId = 'visibility_team_id',
  /** column name */
  VisibilityUserId = 'visibility_user_id'
}

export type SubFolderCountType = {
  __typename?: 'subFolderCountType';
  subFileCount?: Maybe<Scalars['Int']['output']>;
  subFolderCount?: Maybe<Scalars['Int']['output']>;
  subFolderId?: Maybe<Scalars['String']['output']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "email_notifications" */
  email_notifications: Array<Email_Notifications>;
  /** fetch data from the table: "email_notifications" using primary key columns */
  email_notifications_by_pk?: Maybe<Email_Notifications>;
  /** An array relationship */
  events: Array<Events>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table: "events_workers_status" */
  events_workers_status: Array<Events_Workers_Status>;
  /** fetch data from the table: "events_workers_status" using primary key columns */
  events_workers_status_by_pk?: Maybe<Events_Workers_Status>;
  /** fetch data from the table: "file_approval_attachments" */
  file_approval_attachments: Array<File_Approval_Attachments>;
  /** fetch aggregated fields from the table: "file_approval_attachments" */
  file_approval_attachments_aggregate: File_Approval_Attachments_Aggregate;
  /** fetch data from the table: "file_approval_attachments" using primary key columns */
  file_approval_attachments_by_pk?: Maybe<File_Approval_Attachments>;
  /** An array relationship */
  file_approvals: Array<File_Approvals>;
  /** fetch data from the table: "file_approvals" using primary key columns */
  file_approvals_by_pk?: Maybe<File_Approvals>;
  /** fetch data from the table: "file_approvals_file_versions" */
  file_approvals_file_versions: Array<File_Approvals_File_Versions>;
  /** fetch data from the table: "file_approvals_file_versions" using primary key columns */
  file_approvals_file_versions_by_pk?: Maybe<File_Approvals_File_Versions>;
  /** fetch data from the table: "file_assignations" */
  file_assignations: Array<File_Assignations>;
  /** fetch data from the table: "file_assignations" using primary key columns */
  file_assignations_by_pk?: Maybe<File_Assignations>;
  /** An array relationship */
  file_assignations_orgs: Array<File_Assignations_Orgs>;
  /** fetch data from the table: "file_assignations_orgs" using primary key columns */
  file_assignations_orgs_by_pk?: Maybe<File_Assignations_Orgs>;
  /** An array relationship */
  file_assignations_teams: Array<File_Assignations_Teams>;
  /** fetch data from the table: "file_assignations_teams" using primary key columns */
  file_assignations_teams_by_pk?: Maybe<File_Assignations_Teams>;
  /** An array relationship */
  file_assignations_users: Array<File_Assignations_Users>;
  /** fetch data from the table: "file_assignations_users" using primary key columns */
  file_assignations_users_by_pk?: Maybe<File_Assignations_Users>;
  /** An array relationship */
  file_comments: Array<File_Comments>;
  /** fetch data from the table: "file_comments" using primary key columns */
  file_comments_by_pk?: Maybe<File_Comments>;
  /** fetch data from the table: "file_permissions" */
  file_permissions: Array<File_Permissions>;
  /** fetch data from the table: "file_permissions" using primary key columns */
  file_permissions_by_pk?: Maybe<File_Permissions>;
  /** fetch data from the table: "file_permissions_orgs" */
  file_permissions_orgs: Array<File_Permissions_Orgs>;
  /** fetch data from the table: "file_permissions_orgs" using primary key columns */
  file_permissions_orgs_by_pk?: Maybe<File_Permissions_Orgs>;
  /** fetch data from the table: "file_permissions_teams" */
  file_permissions_teams: Array<File_Permissions_Teams>;
  /** fetch data from the table: "file_permissions_teams" using primary key columns */
  file_permissions_teams_by_pk?: Maybe<File_Permissions_Teams>;
  /** An array relationship */
  file_permissions_users: Array<File_Permissions_Users>;
  /** fetch data from the table: "file_permissions_users" using primary key columns */
  file_permissions_users_by_pk?: Maybe<File_Permissions_Users>;
  /** An array relationship */
  file_signatures: Array<File_Signatures>;
  /** fetch data from the table: "file_signatures" using primary key columns */
  file_signatures_by_pk?: Maybe<File_Signatures>;
  /** An array relationship */
  file_version_approval_request_users: Array<File_Version_Approval_Request_Users>;
  /** An aggregate relationship */
  file_version_approval_request_users_aggregate: File_Version_Approval_Request_Users_Aggregate;
  /** fetch data from the table: "file_version_approval_request_users" using primary key columns */
  file_version_approval_request_users_by_pk?: Maybe<File_Version_Approval_Request_Users>;
  /** fetch data from the table: "file_version_approval_requests" */
  file_version_approval_requests: Array<File_Version_Approval_Requests>;
  /** fetch data from the table: "file_version_approval_requests" using primary key columns */
  file_version_approval_requests_by_pk?: Maybe<File_Version_Approval_Requests>;
  /** fetch data from the table: "file_version_autodesk" */
  file_version_autodesk: Array<File_Version_Autodesk>;
  /** fetch data from the table: "file_version_autodesk" using primary key columns */
  file_version_autodesk_by_pk?: Maybe<File_Version_Autodesk>;
  /** An array relationship */
  file_versions: Array<File_Versions>;
  /** fetch data from the table: "file_versions_approvals_overview" */
  file_versions_approvals_overview: Array<File_Versions_Approvals_Overview>;
  /** fetch data from the table: "file_versions" using primary key columns */
  file_versions_by_pk?: Maybe<File_Versions>;
  /** An array relationship */
  file_views: Array<File_Views>;
  /** fetch data from the table: "file_views" using primary key columns */
  file_views_by_pk?: Maybe<File_Views>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table: "files_to_project_labels" */
  files_to_project_labels: Array<Files_To_Project_Labels>;
  /** fetch data from the table: "files_to_project_labels" using primary key columns */
  files_to_project_labels_by_pk?: Maybe<Files_To_Project_Labels>;
  /** fetch data from the table: "filter_user_default" */
  filter_user_default: Array<Filter_User_Default>;
  /** fetch data from the table: "filter_user_default" using primary key columns */
  filter_user_default_by_pk?: Maybe<Filter_User_Default>;
  /** fetch data from the table: "filters" */
  filters: Array<Filters>;
  /** fetch data from the table: "filters" using primary key columns */
  filters_by_pk?: Maybe<Filters>;
  /** fetch data from the table: "folder_assignations" */
  folder_assignations: Array<Folder_Assignations>;
  /** fetch data from the table: "folder_assignations" using primary key columns */
  folder_assignations_by_pk?: Maybe<Folder_Assignations>;
  /** An array relationship */
  folder_assignations_orgs: Array<Folder_Assignations_Orgs>;
  /** fetch data from the table: "folder_assignations_orgs" using primary key columns */
  folder_assignations_orgs_by_pk?: Maybe<Folder_Assignations_Orgs>;
  /** An array relationship */
  folder_assignations_teams: Array<Folder_Assignations_Teams>;
  /** fetch data from the table: "folder_assignations_teams" using primary key columns */
  folder_assignations_teams_by_pk?: Maybe<Folder_Assignations_Teams>;
  /** An array relationship */
  folder_assignations_users: Array<Folder_Assignations_Users>;
  /** fetch data from the table: "folder_assignations_users" using primary key columns */
  folder_assignations_users_by_pk?: Maybe<Folder_Assignations_Users>;
  /** fetch data from the table: "folder_permissions" */
  folder_permissions: Array<Folder_Permissions>;
  /** fetch data from the table: "folder_permissions" using primary key columns */
  folder_permissions_by_pk?: Maybe<Folder_Permissions>;
  /** fetch data from the table: "folder_permissions_orgs" */
  folder_permissions_orgs: Array<Folder_Permissions_Orgs>;
  /** fetch data from the table: "folder_permissions_orgs" using primary key columns */
  folder_permissions_orgs_by_pk?: Maybe<Folder_Permissions_Orgs>;
  /** fetch data from the table: "folder_permissions_teams" */
  folder_permissions_teams: Array<Folder_Permissions_Teams>;
  /** fetch data from the table: "folder_permissions_teams" using primary key columns */
  folder_permissions_teams_by_pk?: Maybe<Folder_Permissions_Teams>;
  /** fetch data from the table: "folder_permissions_users" */
  folder_permissions_users: Array<Folder_Permissions_Users>;
  /** fetch data from the table: "folder_permissions_users" using primary key columns */
  folder_permissions_users_by_pk?: Maybe<Folder_Permissions_Users>;
  /** An array relationship */
  folder_views: Array<Folder_Views>;
  /** fetch data from the table: "folder_views" using primary key columns */
  folder_views_by_pk?: Maybe<Folder_Views>;
  /** An array relationship */
  folders: Array<Folders>;
  /** fetch data from the table: "folders" using primary key columns */
  folders_by_pk?: Maybe<Folders>;
  /** fetch data from the table: "folders_to_project_labels" */
  folders_to_project_labels: Array<Folders_To_Project_Labels>;
  /** fetch data from the table: "folders_to_project_labels" using primary key columns */
  folders_to_project_labels_by_pk?: Maybe<Folders_To_Project_Labels>;
  /** execute function "get_file_version" which returns "file_versions" */
  get_file_version: Array<File_Versions>;
  /** fetch data from the table: "org_address" */
  org_address: Array<Org_Address>;
  /** fetch data from the table: "org_address" using primary key columns */
  org_address_by_pk?: Maybe<Org_Address>;
  /** fetch data from the table: "org_avatars" */
  org_avatars: Array<Org_Avatars>;
  /** fetch data from the table: "org_avatars" using primary key columns */
  org_avatars_by_pk?: Maybe<Org_Avatars>;
  /** fetch data from the table: "org_project_summary" */
  org_project_summary: Array<Org_Project_Summary>;
  /** fetch data from the table: "org_project_summary" using primary key columns */
  org_project_summary_by_pk?: Maybe<Org_Project_Summary>;
  /** fetch data from the table: "org_project_summary_to_project_categories" */
  org_project_summary_to_project_categories: Array<Org_Project_Summary_To_Project_Categories>;
  /** fetch data from the table: "org_project_summary_to_project_categories" using primary key columns */
  org_project_summary_to_project_categories_by_pk?: Maybe<Org_Project_Summary_To_Project_Categories>;
  /** fetch data from the table: "org_project_summary_to_project_groups" */
  org_project_summary_to_project_groups: Array<Org_Project_Summary_To_Project_Groups>;
  /** fetch data from the table: "org_project_summary_to_project_groups" using primary key columns */
  org_project_summary_to_project_groups_by_pk?: Maybe<Org_Project_Summary_To_Project_Groups>;
  /** fetch data from the table: "org_roles" */
  org_roles: Array<Org_Roles>;
  /** fetch data from the table: "org_roles" using primary key columns */
  org_roles_by_pk?: Maybe<Org_Roles>;
  /** fetch data from the table: "org_settings" */
  org_settings: Array<Org_Settings>;
  /** fetch data from the table: "org_settings" using primary key columns */
  org_settings_by_pk?: Maybe<Org_Settings>;
  /** fetch data from the table: "orgs" */
  orgs: Array<Orgs>;
  /** fetch data from the table: "orgs" using primary key columns */
  orgs_by_pk?: Maybe<Orgs>;
  /** An array relationship */
  orgs_to_users: Array<Orgs_To_Users>;
  /** fetch data from the table: "orgs_to_users" using primary key columns */
  orgs_to_users_by_pk?: Maybe<Orgs_To_Users>;
  /** fetch data from the table: "project_address" */
  project_address: Array<Project_Address>;
  /** fetch data from the table: "project_address" using primary key columns */
  project_address_by_pk?: Maybe<Project_Address>;
  /** fetch data from the table: "project_avatars" */
  project_avatars: Array<Project_Avatars>;
  /** fetch data from the table: "project_avatars" using primary key columns */
  project_avatars_by_pk?: Maybe<Project_Avatars>;
  /** An array relationship */
  project_categories: Array<Project_Categories>;
  /** fetch data from the table: "project_categories" using primary key columns */
  project_categories_by_pk?: Maybe<Project_Categories>;
  /** fetch data from the table: "project_group_avatars" */
  project_group_avatars: Array<Project_Group_Avatars>;
  /** fetch data from the table: "project_group_avatars" using primary key columns */
  project_group_avatars_by_pk?: Maybe<Project_Group_Avatars>;
  /** An array relationship */
  project_groups: Array<Project_Groups>;
  /** fetch data from the table: "project_groups" using primary key columns */
  project_groups_by_pk?: Maybe<Project_Groups>;
  /** fetch data from the table: "project_labels" */
  project_labels: Array<Project_Labels>;
  /** fetch data from the table: "project_labels" using primary key columns */
  project_labels_by_pk?: Maybe<Project_Labels>;
  /** fetch data from the table: "project_roles" */
  project_roles: Array<Project_Roles>;
  /** fetch data from the table: "project_roles" using primary key columns */
  project_roles_by_pk?: Maybe<Project_Roles>;
  /** fetch data from the table: "project_templates_overview" */
  project_templates_overview: Array<Project_Templates_Overview>;
  /** An array relationship */
  project_views: Array<Project_Views>;
  /** fetch data from the table: "project_views" using primary key columns */
  project_views_by_pk?: Maybe<Project_Views>;
  /** fetch data from the table: "projects" */
  projects: Array<Projects>;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "projects_map_overview" */
  projects_map_overview: Array<Projects_Map_Overview>;
  /** fetch aggregated fields from the table: "projects_map_overview" */
  projects_map_overview_aggregate: Projects_Map_Overview_Aggregate;
  /** An array relationship */
  projects_to_users: Array<Projects_To_Users>;
  /** fetch data from the table: "push_notifications" */
  push_notifications: Array<Push_Notifications>;
  /** fetch data from the table: "push_notifications" using primary key columns */
  push_notifications_by_pk?: Maybe<Push_Notifications>;
  /** fetch data from the table: "report_blocks" */
  report_blocks: Array<Report_Blocks>;
  /** fetch data from the table: "report_blocks" using primary key columns */
  report_blocks_by_pk?: Maybe<Report_Blocks>;
  /** fetch data from the table: "t_folder_notification_badge" */
  t_folder_notification_badge: Array<T_Folder_Notification_Badge>;
  /** fetch data from the table: "t_folder_notification_badge" using primary key columns */
  t_folder_notification_badge_by_pk?: Maybe<T_Folder_Notification_Badge>;
  /** fetch data from the table: "t_folder_pwd" */
  t_folder_pwd: Array<T_Folder_Pwd>;
  /** fetch data from the table: "t_folder_pwd" using primary key columns */
  t_folder_pwd_by_pk?: Maybe<T_Folder_Pwd>;
  /** fetch data from the table: "task_assignations" */
  task_assignations: Array<Task_Assignations>;
  /** fetch data from the table: "task_assignations" using primary key columns */
  task_assignations_by_pk?: Maybe<Task_Assignations>;
  /** fetch data from the table: "task_assignations_orgs" */
  task_assignations_orgs: Array<Task_Assignations_Orgs>;
  /** fetch data from the table: "task_assignations_orgs" using primary key columns */
  task_assignations_orgs_by_pk?: Maybe<Task_Assignations_Orgs>;
  /** fetch data from the table: "task_assignations_teams" */
  task_assignations_teams: Array<Task_Assignations_Teams>;
  /** fetch data from the table: "task_assignations_teams" using primary key columns */
  task_assignations_teams_by_pk?: Maybe<Task_Assignations_Teams>;
  /** An array relationship */
  task_assignations_users: Array<Task_Assignations_Users>;
  /** fetch data from the table: "task_assignations_users" using primary key columns */
  task_assignations_users_by_pk?: Maybe<Task_Assignations_Users>;
  /** fetch data from the table: "task_attachments" */
  task_attachments: Array<Task_Attachments>;
  /** fetch data from the table: "task_attachments" using primary key columns */
  task_attachments_by_pk?: Maybe<Task_Attachments>;
  /** fetch data from the table: "task_dependencies" */
  task_dependencies: Array<Task_Dependencies>;
  /** fetch data from the table: "task_file_version_location" */
  task_file_version_location: Array<Task_File_Version_Location>;
  /** fetch data from the table: "task_file_version_location" using primary key columns */
  task_file_version_location_by_pk?: Maybe<Task_File_Version_Location>;
  /** fetch data from the table: "task_locations" */
  task_locations: Array<Task_Locations>;
  /** fetch data from the table: "task_locations" using primary key columns */
  task_locations_by_pk?: Maybe<Task_Locations>;
  /** fetch data from the table: "task_permissions" */
  task_permissions: Array<Task_Permissions>;
  /** fetch data from the table: "task_permissions" using primary key columns */
  task_permissions_by_pk?: Maybe<Task_Permissions>;
  /** fetch data from the table: "task_permissions_orgs" */
  task_permissions_orgs: Array<Task_Permissions_Orgs>;
  /** fetch data from the table: "task_permissions_orgs" using primary key columns */
  task_permissions_orgs_by_pk?: Maybe<Task_Permissions_Orgs>;
  /** fetch data from the table: "task_permissions_teams" */
  task_permissions_teams: Array<Task_Permissions_Teams>;
  /** fetch data from the table: "task_permissions_teams" using primary key columns */
  task_permissions_teams_by_pk?: Maybe<Task_Permissions_Teams>;
  /** fetch data from the table: "task_permissions_users" */
  task_permissions_users: Array<Task_Permissions_Users>;
  /** fetch data from the table: "task_permissions_users" using primary key columns */
  task_permissions_users_by_pk?: Maybe<Task_Permissions_Users>;
  /** An array relationship */
  task_subtasks: Array<Task_Subtasks>;
  /** fetch data from the table: "task_subtasks" using primary key columns */
  task_subtasks_by_pk?: Maybe<Task_Subtasks>;
  /** An array relationship */
  task_validations: Array<Task_Validations>;
  /** fetch data from the table: "task_validations" using primary key columns */
  task_validations_by_pk?: Maybe<Task_Validations>;
  /** An array relationship */
  task_views: Array<Task_Views>;
  /** fetch data from the table: "task_views" using primary key columns */
  task_views_by_pk?: Maybe<Task_Views>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** fetch data from the table: "tasks_file_versions" */
  tasks_file_versions: Array<Tasks_File_Versions>;
  /** fetch data from the table: "tasks_file_versions" using primary key columns */
  tasks_file_versions_by_pk?: Maybe<Tasks_File_Versions>;
  /** fetch data from the table: "tasks_to_project_labels" */
  tasks_to_project_labels: Array<Tasks_To_Project_Labels>;
  /** fetch data from the table: "tasks_to_project_labels" using primary key columns */
  tasks_to_project_labels_by_pk?: Maybe<Tasks_To_Project_Labels>;
  /** An array relationship */
  teams: Array<Teams>;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table: "teams_to_users" */
  teams_to_users: Array<Teams_To_Users>;
  /** fetch data from the table: "teams_to_users" using primary key columns */
  teams_to_users_by_pk?: Maybe<Teams_To_Users>;
  /** fetch data from the table: "uptime_test" */
  uptime_test: Array<Uptime_Test>;
  /** fetch data from the table: "uptime_test" using primary key columns */
  uptime_test_by_pk?: Maybe<Uptime_Test>;
  /** fetch data from the table: "user_avatars" */
  user_avatars: Array<User_Avatars>;
  /** fetch data from the table: "user_avatars" using primary key columns */
  user_avatars_by_pk?: Maybe<User_Avatars>;
  /** fetch data from the table: "user_connections" */
  user_connections: Array<User_Connections>;
  /** fetch data from the table: "user_connections" using primary key columns */
  user_connections_by_pk?: Maybe<User_Connections>;
  /** fetch data from the table: "user_contact" */
  user_contact: Array<User_Contact>;
  /** An array relationship */
  user_locations: Array<User_Locations>;
  /** fetch data from the table: "user_locations" using primary key columns */
  user_locations_by_pk?: Maybe<User_Locations>;
  /** fetch data from the table: "user_metadatas" */
  user_metadatas: Array<User_Metadatas>;
  /** An array relationship */
  user_notifications: Array<User_Notifications>;
  /** fetch data from the table: "user_notifications" using primary key columns */
  user_notifications_by_pk?: Maybe<User_Notifications>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Subscription_RootEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Notifications_Order_By>>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};


export type Subscription_RootEmail_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvents_Workers_StatusArgs = {
  distinct_on?: InputMaybe<Array<Events_Workers_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Workers_Status_Order_By>>;
  where?: InputMaybe<Events_Workers_Status_Bool_Exp>;
};


export type Subscription_RootEvents_Workers_Status_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Approval_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<File_Approval_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approval_Attachments_Order_By>>;
  where?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
};


export type Subscription_RootFile_Approval_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Approval_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approval_Attachments_Order_By>>;
  where?: InputMaybe<File_Approval_Attachments_Bool_Exp>;
};


export type Subscription_RootFile_Approval_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_Order_By>>;
  where?: InputMaybe<File_Approvals_Bool_Exp>;
};


export type Subscription_RootFile_Approvals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Approvals_File_VersionsArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_File_Versions_Order_By>>;
  where?: InputMaybe<File_Approvals_File_Versions_Bool_Exp>;
};


export type Subscription_RootFile_Approvals_File_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Order_By>>;
  where?: InputMaybe<File_Assignations_Bool_Exp>;
};


export type Subscription_RootFile_Assignations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<File_Assignations_Orgs_Bool_Exp>;
};


export type Subscription_RootFile_Assignations_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Teams_Order_By>>;
  where?: InputMaybe<File_Assignations_Teams_Bool_Exp>;
};


export type Subscription_RootFile_Assignations_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Users_Order_By>>;
  where?: InputMaybe<File_Assignations_Users_Bool_Exp>;
};


export type Subscription_RootFile_Assignations_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_CommentsArgs = {
  distinct_on?: InputMaybe<Array<File_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Comments_Order_By>>;
  where?: InputMaybe<File_Comments_Bool_Exp>;
};


export type Subscription_RootFile_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Order_By>>;
  where?: InputMaybe<File_Permissions_Bool_Exp>;
};


export type Subscription_RootFile_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<File_Permissions_Orgs_Bool_Exp>;
};


export type Subscription_RootFile_Permissions_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Teams_Order_By>>;
  where?: InputMaybe<File_Permissions_Teams_Bool_Exp>;
};


export type Subscription_RootFile_Permissions_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Users_Order_By>>;
  where?: InputMaybe<File_Permissions_Users_Bool_Exp>;
};


export type Subscription_RootFile_Permissions_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_SignaturesArgs = {
  distinct_on?: InputMaybe<Array<File_Signatures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Signatures_Order_By>>;
  where?: InputMaybe<File_Signatures_Bool_Exp>;
};


export type Subscription_RootFile_Signatures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Version_Approval_Request_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};


export type Subscription_RootFile_Version_Approval_Request_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};


export type Subscription_RootFile_Version_Approval_Request_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Version_Approval_RequestsArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Requests_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Requests_Bool_Exp>;
};


export type Subscription_RootFile_Version_Approval_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_Version_AutodeskArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Autodesk_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Autodesk_Order_By>>;
  where?: InputMaybe<File_Version_Autodesk_Bool_Exp>;
};


export type Subscription_RootFile_Version_Autodesk_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_VersionsArgs = {
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};


export type Subscription_RootFile_Versions_Approvals_OverviewArgs = {
  distinct_on?: InputMaybe<Array<File_Versions_Approvals_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Approvals_Overview_Order_By>>;
  where?: InputMaybe<File_Versions_Approvals_Overview_Bool_Exp>;
};


export type Subscription_RootFile_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_ViewsArgs = {
  distinct_on?: InputMaybe<Array<File_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Views_Order_By>>;
  where?: InputMaybe<File_Views_Bool_Exp>;
};


export type Subscription_RootFile_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFiles_To_Project_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Files_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Files_To_Project_Labels_Bool_Exp>;
};


export type Subscription_RootFiles_To_Project_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilter_User_DefaultArgs = {
  distinct_on?: InputMaybe<Array<Filter_User_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Filter_User_Default_Order_By>>;
  where?: InputMaybe<Filter_User_Default_Bool_Exp>;
};


export type Subscription_RootFilter_User_Default_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFiltersArgs = {
  distinct_on?: InputMaybe<Array<Filters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Filters_Order_By>>;
  where?: InputMaybe<Filters_Bool_Exp>;
};


export type Subscription_RootFilters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Bool_Exp>;
};


export type Subscription_RootFolder_Assignations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
};


export type Subscription_RootFolder_Assignations_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
};


export type Subscription_RootFolder_Assignations_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Users_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
};


export type Subscription_RootFolder_Assignations_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Bool_Exp>;
};


export type Subscription_RootFolder_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Orgs_Bool_Exp>;
};


export type Subscription_RootFolder_Permissions_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Teams_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Teams_Bool_Exp>;
};


export type Subscription_RootFolder_Permissions_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Users_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Users_Bool_Exp>;
};


export type Subscription_RootFolder_Permissions_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolder_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Views_Order_By>>;
  where?: InputMaybe<Folder_Views_Bool_Exp>;
};


export type Subscription_RootFolder_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFoldersArgs = {
  distinct_on?: InputMaybe<Array<Folders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folders_Order_By>>;
  where?: InputMaybe<Folders_Bool_Exp>;
};


export type Subscription_RootFolders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFolders_To_Project_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Folders_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folders_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Folders_To_Project_Labels_Bool_Exp>;
};


export type Subscription_RootFolders_To_Project_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootGet_File_VersionArgs = {
  args: Get_File_Version_Args;
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};


export type Subscription_RootOrg_AddressArgs = {
  distinct_on?: InputMaybe<Array<Org_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Address_Order_By>>;
  where?: InputMaybe<Org_Address_Bool_Exp>;
};


export type Subscription_RootOrg_Address_By_PkArgs = {
  org_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrg_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<Org_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Avatars_Order_By>>;
  where?: InputMaybe<Org_Avatars_Bool_Exp>;
};


export type Subscription_RootOrg_Avatars_By_PkArgs = {
  org_id: Scalars['uuid']['input'];
};


export type Subscription_RootOrg_Project_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_Bool_Exp>;
};


export type Subscription_RootOrg_Project_Summary_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrg_Project_Summary_To_Project_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_To_Project_Categories_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_To_Project_Categories_Bool_Exp>;
};


export type Subscription_RootOrg_Project_Summary_To_Project_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrg_Project_Summary_To_Project_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Project_Summary_To_Project_Groups_Order_By>>;
  where?: InputMaybe<Org_Project_Summary_To_Project_Groups_Bool_Exp>;
};


export type Subscription_RootOrg_Project_Summary_To_Project_Groups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrg_RolesArgs = {
  distinct_on?: InputMaybe<Array<Org_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Roles_Order_By>>;
  where?: InputMaybe<Org_Roles_Bool_Exp>;
};


export type Subscription_RootOrg_Roles_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootOrg_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Org_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Org_Settings_Order_By>>;
  where?: InputMaybe<Org_Settings_Bool_Exp>;
};


export type Subscription_RootOrg_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrgsArgs = {
  distinct_on?: InputMaybe<Array<Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_Order_By>>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};


export type Subscription_RootOrgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrgs_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Orgs_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_To_Users_Order_By>>;
  where?: InputMaybe<Orgs_To_Users_Bool_Exp>;
};


export type Subscription_RootOrgs_To_Users_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_AddressArgs = {
  distinct_on?: InputMaybe<Array<Project_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Address_Order_By>>;
  where?: InputMaybe<Project_Address_Bool_Exp>;
};


export type Subscription_RootProject_Address_By_PkArgs = {
  project_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<Project_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Avatars_Order_By>>;
  where?: InputMaybe<Project_Avatars_Bool_Exp>;
};


export type Subscription_RootProject_Avatars_By_PkArgs = {
  project_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Project_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Categories_Order_By>>;
  where?: InputMaybe<Project_Categories_Bool_Exp>;
};


export type Subscription_RootProject_Categories_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Group_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<Project_Group_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Group_Avatars_Order_By>>;
  where?: InputMaybe<Project_Group_Avatars_Bool_Exp>;
};


export type Subscription_RootProject_Group_Avatars_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Project_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Groups_Order_By>>;
  where?: InputMaybe<Project_Groups_Bool_Exp>;
};


export type Subscription_RootProject_Groups_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Labels_Order_By>>;
  where?: InputMaybe<Project_Labels_Bool_Exp>;
};


export type Subscription_RootProject_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_RolesArgs = {
  distinct_on?: InputMaybe<Array<Project_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Roles_Order_By>>;
  where?: InputMaybe<Project_Roles_Bool_Exp>;
};


export type Subscription_RootProject_Roles_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootProject_Templates_OverviewArgs = {
  distinct_on?: InputMaybe<Array<Project_Templates_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Templates_Overview_Order_By>>;
  where?: InputMaybe<Project_Templates_Overview_Bool_Exp>;
};


export type Subscription_RootProject_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Views_Order_By>>;
  where?: InputMaybe<Project_Views_Bool_Exp>;
};


export type Subscription_RootProject_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProjects_Map_OverviewArgs = {
  distinct_on?: InputMaybe<Array<Projects_Map_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Map_Overview_Order_By>>;
  where?: InputMaybe<Projects_Map_Overview_Bool_Exp>;
};


export type Subscription_RootProjects_Map_Overview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Map_Overview_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Map_Overview_Order_By>>;
  where?: InputMaybe<Projects_Map_Overview_Bool_Exp>;
};


export type Subscription_RootProjects_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Projects_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_To_Users_Order_By>>;
  where?: InputMaybe<Projects_To_Users_Bool_Exp>;
};


export type Subscription_RootPush_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Push_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notifications_Order_By>>;
  where?: InputMaybe<Push_Notifications_Bool_Exp>;
};


export type Subscription_RootPush_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReport_BlocksArgs = {
  distinct_on?: InputMaybe<Array<Report_Blocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Report_Blocks_Order_By>>;
  where?: InputMaybe<Report_Blocks_Bool_Exp>;
};


export type Subscription_RootReport_Blocks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootT_Folder_Notification_BadgeArgs = {
  distinct_on?: InputMaybe<Array<T_Folder_Notification_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<T_Folder_Notification_Badge_Order_By>>;
  where?: InputMaybe<T_Folder_Notification_Badge_Bool_Exp>;
};


export type Subscription_RootT_Folder_Notification_Badge_By_PkArgs = {
  folder_id: Scalars['uuid']['input'];
};


export type Subscription_RootT_Folder_PwdArgs = {
  distinct_on?: InputMaybe<Array<T_Folder_Pwd_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<T_Folder_Pwd_Order_By>>;
  where?: InputMaybe<T_Folder_Pwd_Bool_Exp>;
};


export type Subscription_RootT_Folder_Pwd_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Order_By>>;
  where?: InputMaybe<Task_Assignations_Bool_Exp>;
};


export type Subscription_RootTask_Assignations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Task_Assignations_Orgs_Bool_Exp>;
};


export type Subscription_RootTask_Assignations_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Task_Assignations_Teams_Bool_Exp>;
};


export type Subscription_RootTask_Assignations_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Users_Order_By>>;
  where?: InputMaybe<Task_Assignations_Users_Bool_Exp>;
};


export type Subscription_RootTask_Assignations_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Task_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Attachments_Order_By>>;
  where?: InputMaybe<Task_Attachments_Bool_Exp>;
};


export type Subscription_RootTask_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_DependenciesArgs = {
  distinct_on?: InputMaybe<Array<Task_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Dependencies_Order_By>>;
  where?: InputMaybe<Task_Dependencies_Bool_Exp>;
};


export type Subscription_RootTask_File_Version_LocationArgs = {
  distinct_on?: InputMaybe<Array<Task_File_Version_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_File_Version_Location_Order_By>>;
  where?: InputMaybe<Task_File_Version_Location_Bool_Exp>;
};


export type Subscription_RootTask_File_Version_Location_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Locations_Order_By>>;
  where?: InputMaybe<Task_Locations_Bool_Exp>;
};


export type Subscription_RootTask_Locations_By_PkArgs = {
  task_id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Order_By>>;
  where?: InputMaybe<Task_Permissions_Bool_Exp>;
};


export type Subscription_RootTask_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Permissions_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<Task_Permissions_Orgs_Bool_Exp>;
};


export type Subscription_RootTask_Permissions_Orgs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Permissions_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Teams_Order_By>>;
  where?: InputMaybe<Task_Permissions_Teams_Bool_Exp>;
};


export type Subscription_RootTask_Permissions_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Users_Order_By>>;
  where?: InputMaybe<Task_Permissions_Users_Bool_Exp>;
};


export type Subscription_RootTask_Permissions_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_SubtasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Subtasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Subtasks_Order_By>>;
  where?: InputMaybe<Task_Subtasks_Bool_Exp>;
};


export type Subscription_RootTask_Subtasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_ValidationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Validations_Order_By>>;
  where?: InputMaybe<Task_Validations_Bool_Exp>;
};


export type Subscription_RootTask_Validations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Task_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Views_Order_By>>;
  where?: InputMaybe<Task_Views_Bool_Exp>;
};


export type Subscription_RootTask_Views_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTasks_File_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tasks_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_File_Versions_Order_By>>;
  where?: InputMaybe<Tasks_File_Versions_Bool_Exp>;
};


export type Subscription_RootTasks_File_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTasks_To_Project_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Tasks_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Tasks_To_Project_Labels_Bool_Exp>;
};


export type Subscription_RootTasks_To_Project_Labels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeams_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_To_Users_Order_By>>;
  where?: InputMaybe<Teams_To_Users_Bool_Exp>;
};


export type Subscription_RootTeams_To_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUptime_TestArgs = {
  distinct_on?: InputMaybe<Array<Uptime_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uptime_Test_Order_By>>;
  where?: InputMaybe<Uptime_Test_Bool_Exp>;
};


export type Subscription_RootUptime_Test_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_AvatarsArgs = {
  distinct_on?: InputMaybe<Array<User_Avatars_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Avatars_Order_By>>;
  where?: InputMaybe<User_Avatars_Bool_Exp>;
};


export type Subscription_RootUser_Avatars_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_ConnectionsArgs = {
  distinct_on?: InputMaybe<Array<User_Connections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Connections_Order_By>>;
  where?: InputMaybe<User_Connections_Bool_Exp>;
};


export type Subscription_RootUser_Connections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_ContactArgs = {
  distinct_on?: InputMaybe<Array<User_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Contact_Order_By>>;
  where?: InputMaybe<User_Contact_Bool_Exp>;
};


export type Subscription_RootUser_LocationsArgs = {
  distinct_on?: InputMaybe<Array<User_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Locations_Order_By>>;
  where?: InputMaybe<User_Locations_Bool_Exp>;
};


export type Subscription_RootUser_Locations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_MetadatasArgs = {
  distinct_on?: InputMaybe<Array<User_Metadatas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Metadatas_Order_By>>;
  where?: InputMaybe<User_Metadatas_Bool_Exp>;
};


export type Subscription_RootUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};


export type Subscription_RootUser_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** Empty table to have type into folders->notification_badge */
export type T_Folder_Notification_Badge = {
  __typename?: 't_folder_notification_badge';
  folder_id: Scalars['uuid']['output'];
  strong_notification_count: Scalars['numeric']['output'];
  weak_notification: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Aggregate_Order_By = {
  avg?: InputMaybe<T_Folder_Notification_Badge_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<T_Folder_Notification_Badge_Max_Order_By>;
  min?: InputMaybe<T_Folder_Notification_Badge_Min_Order_By>;
  stddev?: InputMaybe<T_Folder_Notification_Badge_Stddev_Order_By>;
  stddev_pop?: InputMaybe<T_Folder_Notification_Badge_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<T_Folder_Notification_Badge_Stddev_Samp_Order_By>;
  sum?: InputMaybe<T_Folder_Notification_Badge_Sum_Order_By>;
  var_pop?: InputMaybe<T_Folder_Notification_Badge_Var_Pop_Order_By>;
  var_samp?: InputMaybe<T_Folder_Notification_Badge_Var_Samp_Order_By>;
  variance?: InputMaybe<T_Folder_Notification_Badge_Variance_Order_By>;
};

/** order by avg() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Avg_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "t_folder_notification_badge". All fields are combined with a logical 'AND'. */
export type T_Folder_Notification_Badge_Bool_Exp = {
  _and?: InputMaybe<Array<T_Folder_Notification_Badge_Bool_Exp>>;
  _not?: InputMaybe<T_Folder_Notification_Badge_Bool_Exp>;
  _or?: InputMaybe<Array<T_Folder_Notification_Badge_Bool_Exp>>;
  folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  strong_notification_count?: InputMaybe<Numeric_Comparison_Exp>;
  weak_notification?: InputMaybe<Boolean_Comparison_Exp>;
};

/** order by max() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Max_Order_By = {
  folder_id?: InputMaybe<Order_By>;
  strong_notification_count?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Min_Order_By = {
  folder_id?: InputMaybe<Order_By>;
  strong_notification_count?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "t_folder_notification_badge". */
export type T_Folder_Notification_Badge_Order_By = {
  folder_id?: InputMaybe<Order_By>;
  strong_notification_count?: InputMaybe<Order_By>;
  weak_notification?: InputMaybe<Order_By>;
};

/** select columns of table "t_folder_notification_badge" */
export enum T_Folder_Notification_Badge_Select_Column {
  /** column name */
  FolderId = 'folder_id',
  /** column name */
  StrongNotificationCount = 'strong_notification_count',
  /** column name */
  WeakNotification = 'weak_notification'
}

/** order by stddev() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Stddev_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Stddev_Pop_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Stddev_Samp_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Sum_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Var_Pop_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Var_Samp_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "t_folder_notification_badge" */
export type T_Folder_Notification_Badge_Variance_Order_By = {
  strong_notification_count?: InputMaybe<Order_By>;
};

/** Empty table to have type into folders->pwd */
export type T_Folder_Pwd = {
  __typename?: 't_folder_pwd';
  id: Scalars['uuid']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** order by aggregate values of table "t_folder_pwd" */
export type T_Folder_Pwd_Aggregate_Order_By = {
  avg?: InputMaybe<T_Folder_Pwd_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<T_Folder_Pwd_Max_Order_By>;
  min?: InputMaybe<T_Folder_Pwd_Min_Order_By>;
  stddev?: InputMaybe<T_Folder_Pwd_Stddev_Order_By>;
  stddev_pop?: InputMaybe<T_Folder_Pwd_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<T_Folder_Pwd_Stddev_Samp_Order_By>;
  sum?: InputMaybe<T_Folder_Pwd_Sum_Order_By>;
  var_pop?: InputMaybe<T_Folder_Pwd_Var_Pop_Order_By>;
  var_samp?: InputMaybe<T_Folder_Pwd_Var_Samp_Order_By>;
  variance?: InputMaybe<T_Folder_Pwd_Variance_Order_By>;
};

/** order by avg() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Avg_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "t_folder_pwd". All fields are combined with a logical 'AND'. */
export type T_Folder_Pwd_Bool_Exp = {
  _and?: InputMaybe<Array<T_Folder_Pwd_Bool_Exp>>;
  _not?: InputMaybe<T_Folder_Pwd_Bool_Exp>;
  _or?: InputMaybe<Array<T_Folder_Pwd_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "t_folder_pwd". */
export type T_Folder_Pwd_Order_By = {
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "t_folder_pwd" */
export enum T_Folder_Pwd_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name'
}

/** order by stddev() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Stddev_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Stddev_Pop_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Stddev_Samp_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Sum_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Var_Pop_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Var_Samp_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "t_folder_pwd" */
export type T_Folder_Pwd_Variance_Order_By = {
  level?: InputMaybe<Order_By>;
};

/** columns and relationships of "task_assignations" */
export type Task_Assignations = {
  __typename?: 'task_assignations';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  orgs: Array<Task_Assignations_Orgs>;
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  /** An array relationship */
  teams: Array<Task_Assignations_Teams>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Task_Assignations_Users>;
};


/** columns and relationships of "task_assignations" */
export type Task_AssignationsOrgsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Task_Assignations_Orgs_Bool_Exp>;
};


/** columns and relationships of "task_assignations" */
export type Task_AssignationsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Task_Assignations_Teams_Bool_Exp>;
};


/** columns and relationships of "task_assignations" */
export type Task_AssignationsUsersArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Users_Order_By>>;
  where?: InputMaybe<Task_Assignations_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "task_assignations". All fields are combined with a logical 'AND'. */
export type Task_Assignations_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Assignations_Bool_Exp>>;
  _not?: InputMaybe<Task_Assignations_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Assignations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgs?: InputMaybe<Task_Assignations_Orgs_Bool_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams?: InputMaybe<Task_Assignations_Teams_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Task_Assignations_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "task_assignations". */
export type Task_Assignations_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgs_aggregate?: InputMaybe<Task_Assignations_Orgs_Aggregate_Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Task_Assignations_Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Task_Assignations_Users_Aggregate_Order_By>;
};

/** columns and relationships of "task_assignations_orgs" */
export type Task_Assignations_Orgs = {
  __typename?: 'task_assignations_orgs';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  task_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  task_assignee: Task_Assignations;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "task_assignations_orgs" */
export type Task_Assignations_Orgs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Assignations_Orgs_Max_Order_By>;
  min?: InputMaybe<Task_Assignations_Orgs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_assignations_orgs". All fields are combined with a logical 'AND'. */
export type Task_Assignations_Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Assignations_Orgs_Bool_Exp>>;
  _not?: InputMaybe<Task_Assignations_Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Assignations_Orgs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_assignee?: InputMaybe<Task_Assignations_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "task_assignations_orgs" */
export type Task_Assignations_Orgs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_assignations_orgs" */
export type Task_Assignations_Orgs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_assignations_orgs". */
export type Task_Assignations_Orgs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  task_assignee?: InputMaybe<Task_Assignations_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "task_assignations_orgs" */
export enum Task_Assignations_Orgs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  TaskAssignationId = 'task_assignation_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select columns of table "task_assignations" */
export enum Task_Assignations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "task_assignations_teams" */
export type Task_Assignations_Teams = {
  __typename?: 'task_assignations_teams';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  task_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  task_assignee: Task_Assignations;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "task_assignations_teams" */
export type Task_Assignations_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Assignations_Teams_Max_Order_By>;
  min?: InputMaybe<Task_Assignations_Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_assignations_teams". All fields are combined with a logical 'AND'. */
export type Task_Assignations_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Assignations_Teams_Bool_Exp>>;
  _not?: InputMaybe<Task_Assignations_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Assignations_Teams_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_assignee?: InputMaybe<Task_Assignations_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "task_assignations_teams" */
export type Task_Assignations_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_assignations_teams" */
export type Task_Assignations_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_assignations_teams". */
export type Task_Assignations_Teams_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  task_assignee?: InputMaybe<Task_Assignations_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "task_assignations_teams" */
export enum Task_Assignations_Teams_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  TaskAssignationId = 'task_assignation_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "task_assignations_users" */
export type Task_Assignations_Users = {
  __typename?: 'task_assignations_users';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  task_assignation_id: Scalars['uuid']['output'];
  /** An object relationship */
  task_assignee: Task_Assignations;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "task_assignations_users" */
export type Task_Assignations_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Assignations_Users_Max_Order_By>;
  min?: InputMaybe<Task_Assignations_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_assignations_users". All fields are combined with a logical 'AND'. */
export type Task_Assignations_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Assignations_Users_Bool_Exp>>;
  _not?: InputMaybe<Task_Assignations_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Assignations_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task_assignation_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_assignee?: InputMaybe<Task_Assignations_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "task_assignations_users" */
export type Task_Assignations_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_assignations_users" */
export type Task_Assignations_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_assignations_users". */
export type Task_Assignations_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_assignation_id?: InputMaybe<Order_By>;
  task_assignee?: InputMaybe<Task_Assignations_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "task_assignations_users" */
export enum Task_Assignations_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  TaskAssignationId = 'task_assignation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** This table is the attachment task part */
export type Task_Attachments = {
  __typename?: 'task_attachments';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "task_attachments" */
export type Task_Attachments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Attachments_Max_Order_By>;
  min?: InputMaybe<Task_Attachments_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_attachments". All fields are combined with a logical 'AND'. */
export type Task_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Task_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Attachments_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "task_attachments" */
export type Task_Attachments_Max_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_attachments" */
export type Task_Attachments_Min_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_attachments". */
export type Task_Attachments_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "task_attachments" */
export enum Task_Attachments_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Links between tasks configured on the gantt */
export type Task_Dependencies = {
  __typename?: 'task_dependencies';
  /** An object relationship */
  ancestor: Tasks;
  created_at: Scalars['timestamptz']['output'];
  from_id: Scalars['uuid']['output'];
  from_side: Scalars['String']['output'];
  /** An object relationship */
  predecessor: Tasks;
  relationship_type?: Maybe<Scalars['String']['output']>;
  to_id: Scalars['uuid']['output'];
  to_side: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "task_dependencies" */
export type Task_Dependencies_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Dependencies_Max_Order_By>;
  min?: InputMaybe<Task_Dependencies_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_dependencies". All fields are combined with a logical 'AND'. */
export type Task_Dependencies_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Dependencies_Bool_Exp>>;
  _not?: InputMaybe<Task_Dependencies_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Dependencies_Bool_Exp>>;
  ancestor?: InputMaybe<Tasks_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_side?: InputMaybe<String_Comparison_Exp>;
  predecessor?: InputMaybe<Tasks_Bool_Exp>;
  relationship_type?: InputMaybe<String_Comparison_Exp>;
  to_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_side?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "task_dependencies" */
export type Task_Dependencies_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_id?: InputMaybe<Order_By>;
  from_side?: InputMaybe<Order_By>;
  relationship_type?: InputMaybe<Order_By>;
  to_id?: InputMaybe<Order_By>;
  to_side?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_dependencies" */
export type Task_Dependencies_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_id?: InputMaybe<Order_By>;
  from_side?: InputMaybe<Order_By>;
  relationship_type?: InputMaybe<Order_By>;
  to_id?: InputMaybe<Order_By>;
  to_side?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_dependencies". */
export type Task_Dependencies_Order_By = {
  ancestor?: InputMaybe<Tasks_Order_By>;
  created_at?: InputMaybe<Order_By>;
  from_id?: InputMaybe<Order_By>;
  from_side?: InputMaybe<Order_By>;
  predecessor?: InputMaybe<Tasks_Order_By>;
  relationship_type?: InputMaybe<Order_By>;
  to_id?: InputMaybe<Order_By>;
  to_side?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "task_dependencies" */
export enum Task_Dependencies_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FromId = 'from_id',
  /** column name */
  FromSide = 'from_side',
  /** column name */
  RelationshipType = 'relationship_type',
  /** column name */
  ToId = 'to_id',
  /** column name */
  ToSide = 'to_side',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Location of a task on a file version */
export type Task_File_Version_Location = {
  __typename?: 'task_file_version_location';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  page_number: Scalars['Int']['output'];
  pdf_location: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  x: Scalars['numeric']['output'];
  y: Scalars['numeric']['output'];
};

/** Boolean expression to filter rows from the table "task_file_version_location". All fields are combined with a logical 'AND'. */
export type Task_File_Version_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Task_File_Version_Location_Bool_Exp>>;
  _not?: InputMaybe<Task_File_Version_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Task_File_Version_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  page_number?: InputMaybe<Int_Comparison_Exp>;
  pdf_location?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  x?: InputMaybe<Numeric_Comparison_Exp>;
  y?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "task_file_version_location". */
export type Task_File_Version_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
  pdf_location?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
};

/** select columns of table "task_file_version_location" */
export enum Task_File_Version_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PageNumber = 'page_number',
  /** column name */
  PdfLocation = 'pdf_location',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  X = 'x',
  /** column name */
  Y = 'y'
}

/** GPS location of a task */
export type Task_Locations = {
  __typename?: 'task_locations';
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  task_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "task_locations". All fields are combined with a logical 'AND'. */
export type Task_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Locations_Bool_Exp>>;
  _not?: InputMaybe<Task_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Locations_Bool_Exp>>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "task_locations". */
export type Task_Locations_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
};

/** select columns of table "task_locations" */
export enum Task_Locations_Select_Column {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  TaskId = 'task_id'
}

/** this table is used to permit te task become privates */
export type Task_Permissions = {
  __typename?: 'task_permissions';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  orgs: Array<Task_Permissions_Orgs>;
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  /** An array relationship */
  teams: Array<Task_Permissions_Teams>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Task_Permissions_Users>;
};


/** this table is used to permit te task become privates */
export type Task_PermissionsOrgsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Orgs_Order_By>>;
  where?: InputMaybe<Task_Permissions_Orgs_Bool_Exp>;
};


/** this table is used to permit te task become privates */
export type Task_PermissionsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Teams_Order_By>>;
  where?: InputMaybe<Task_Permissions_Teams_Bool_Exp>;
};


/** this table is used to permit te task become privates */
export type Task_PermissionsUsersArgs = {
  distinct_on?: InputMaybe<Array<Task_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Permissions_Users_Order_By>>;
  where?: InputMaybe<Task_Permissions_Users_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "task_permissions". All fields are combined with a logical 'AND'. */
export type Task_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Task_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgs?: InputMaybe<Task_Permissions_Orgs_Bool_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams?: InputMaybe<Task_Permissions_Teams_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Task_Permissions_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "task_permissions". */
export type Task_Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgs_aggregate?: InputMaybe<Task_Permissions_Orgs_Aggregate_Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Task_Permissions_Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Task_Permissions_Users_Aggregate_Order_By>;
};

/** columns and relationships of "task_permissions_orgs" */
export type Task_Permissions_Orgs = {
  __typename?: 'task_permissions_orgs';
  created_at: Scalars['timestamptz']['output'];
  creator_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  org: Orgs;
  org_id: Scalars['uuid']['output'];
  /** An object relationship */
  task_permission: Task_Permissions;
  task_permissions_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "task_permissions_orgs" */
export type Task_Permissions_Orgs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Permissions_Orgs_Max_Order_By>;
  min?: InputMaybe<Task_Permissions_Orgs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_permissions_orgs". All fields are combined with a logical 'AND'. */
export type Task_Permissions_Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Permissions_Orgs_Bool_Exp>>;
  _not?: InputMaybe<Task_Permissions_Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Permissions_Orgs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_permission?: InputMaybe<Task_Permissions_Bool_Exp>;
  task_permissions_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "task_permissions_orgs" */
export type Task_Permissions_Orgs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_permissions_orgs" */
export type Task_Permissions_Orgs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_permissions_orgs". */
export type Task_Permissions_Orgs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  org_id?: InputMaybe<Order_By>;
  task_permission?: InputMaybe<Task_Permissions_Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "task_permissions_orgs" */
export enum Task_Permissions_Orgs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  TaskPermissionsId = 'task_permissions_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select columns of table "task_permissions" */
export enum Task_Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "task_permissions_teams" */
export type Task_Permissions_Teams = {
  __typename?: 'task_permissions_teams';
  created_at: Scalars['timestamptz']['output'];
  creator_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  task_permission: Task_Permissions;
  task_permissions_id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "task_permissions_teams" */
export type Task_Permissions_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Permissions_Teams_Max_Order_By>;
  min?: InputMaybe<Task_Permissions_Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_permissions_teams". All fields are combined with a logical 'AND'. */
export type Task_Permissions_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Permissions_Teams_Bool_Exp>>;
  _not?: InputMaybe<Task_Permissions_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Permissions_Teams_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task_permission?: InputMaybe<Task_Permissions_Bool_Exp>;
  task_permissions_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "task_permissions_teams" */
export type Task_Permissions_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_permissions_teams" */
export type Task_Permissions_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_permissions_teams". */
export type Task_Permissions_Teams_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_permission?: InputMaybe<Task_Permissions_Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "task_permissions_teams" */
export enum Task_Permissions_Teams_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  TaskPermissionsId = 'task_permissions_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "task_permissions_users" */
export type Task_Permissions_Users = {
  __typename?: 'task_permissions_users';
  created_at: Scalars['timestamptz']['output'];
  creator_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  task_permission: Task_Permissions;
  task_permissions_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userByUserId: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "task_permissions_users" */
export type Task_Permissions_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Permissions_Users_Max_Order_By>;
  min?: InputMaybe<Task_Permissions_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_permissions_users". All fields are combined with a logical 'AND'. */
export type Task_Permissions_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Permissions_Users_Bool_Exp>>;
  _not?: InputMaybe<Task_Permissions_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Permissions_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task_permission?: InputMaybe<Task_Permissions_Bool_Exp>;
  task_permissions_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByUserId?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "task_permissions_users" */
export type Task_Permissions_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_permissions_users" */
export type Task_Permissions_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_permissions_users". */
export type Task_Permissions_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_permission?: InputMaybe<Task_Permissions_Order_By>;
  task_permissions_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByUserId?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "task_permissions_users" */
export enum Task_Permissions_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Id = 'id',
  /** column name */
  TaskPermissionsId = 'task_permissions_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** This table groups the subtasks */
export type Task_Subtasks = {
  __typename?: 'task_subtasks';
  closed?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  creator_id: Scalars['uuid']['output'];
  description: Scalars['String']['output'];
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  last_user_to_validate?: Maybe<Users>;
  last_validated_at?: Maybe<Scalars['date']['output']>;
  last_validated_by?: Maybe<Scalars['uuid']['output']>;
  order: Scalars['Int']['output'];
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  task_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "task_subtasks" */
export type Task_Subtasks_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Subtasks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Subtasks_Max_Order_By>;
  min?: InputMaybe<Task_Subtasks_Min_Order_By>;
  stddev?: InputMaybe<Task_Subtasks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Subtasks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Subtasks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Subtasks_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Subtasks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Subtasks_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Subtasks_Variance_Order_By>;
};

/** order by avg() on columns of table "task_subtasks" */
export type Task_Subtasks_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task_subtasks". All fields are combined with a logical 'AND'. */
export type Task_Subtasks_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Subtasks_Bool_Exp>>;
  _not?: InputMaybe<Task_Subtasks_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Subtasks_Bool_Exp>>;
  closed?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_user_to_validate?: InputMaybe<Users_Bool_Exp>;
  last_validated_at?: InputMaybe<Date_Comparison_Exp>;
  last_validated_by?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "task_subtasks" */
export type Task_Subtasks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_validated_at?: InputMaybe<Order_By>;
  last_validated_by?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_subtasks" */
export type Task_Subtasks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_validated_at?: InputMaybe<Order_By>;
  last_validated_by?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_subtasks". */
export type Task_Subtasks_Order_By = {
  closed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_user_to_validate?: InputMaybe<Users_Order_By>;
  last_validated_at?: InputMaybe<Order_By>;
  last_validated_by?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "task_subtasks" */
export enum Task_Subtasks_Select_Column {
  /** column name */
  Closed = 'closed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastValidatedAt = 'last_validated_at',
  /** column name */
  LastValidatedBy = 'last_validated_by',
  /** column name */
  Order = 'order',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "task_subtasks" */
export type Task_Subtasks_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "task_subtasks" */
export type Task_Subtasks_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "task_subtasks" */
export type Task_Subtasks_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "task_subtasks" */
export type Task_Subtasks_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "task_subtasks" */
export type Task_Subtasks_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "task_subtasks" */
export type Task_Subtasks_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "task_subtasks" */
export type Task_Subtasks_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** This table groups the users validated task */
export type Task_Validations = {
  __typename?: 'task_validations';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  task_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "task_validations" */
export type Task_Validations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Validations_Max_Order_By>;
  min?: InputMaybe<Task_Validations_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "task_validations". All fields are combined with a logical 'AND'. */
export type Task_Validations_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Validations_Bool_Exp>>;
  _not?: InputMaybe<Task_Validations_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Validations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "task_validations" */
export type Task_Validations_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_validations" */
export type Task_Validations_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_validations". */
export type Task_Validations_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "task_validations" */
export enum Task_Validations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** This table record everytime a user viewed a specific task */
export type Task_Views = {
  __typename?: 'task_views';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "task_views" */
export type Task_Views_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Views_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Views_Max_Order_By>;
  min?: InputMaybe<Task_Views_Min_Order_By>;
  stddev?: InputMaybe<Task_Views_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Views_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Views_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Views_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Views_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Views_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Views_Variance_Order_By>;
};

/** order by avg() on columns of table "task_views" */
export type Task_Views_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task_views". All fields are combined with a logical 'AND'. */
export type Task_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Views_Bool_Exp>>;
  _not?: InputMaybe<Task_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Views_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "task_views" */
export type Task_Views_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "task_views" */
export type Task_Views_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_views". */
export type Task_Views_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "task_views" */
export enum Task_Views_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "task_views" */
export type Task_Views_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "task_views" */
export type Task_Views_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "task_views" */
export type Task_Views_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "task_views" */
export type Task_Views_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "task_views" */
export type Task_Views_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "task_views" */
export type Task_Views_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "task_views" */
export type Task_Views_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type Tasks = {
  __typename?: 'tasks';
  /** An array relationship */
  ancestors: Array<Task_Dependencies>;
  /** An object relationship */
  assignations?: Maybe<Task_Assignations>;
  /** An array relationship */
  attachments: Array<Task_Attachments>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator: Users;
  creator_id: Scalars['uuid']['output'];
  deleted: Scalars['Boolean']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  file_versions: Array<Tasks_File_Versions>;
  hours_done?: Maybe<Scalars['float8']['output']>;
  hours_expected?: Maybe<Scalars['float8']['output']>;
  id: Scalars['uuid']['output'];
  /** This field will show by who the task is validated, if it is : « none » if non validated, « user » if validated only by the user, « org » if validated by someone of his/her org, or « external » if validated by one user not in user org. */
  is_validated_by?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  labels: Array<Tasks_To_Project_Labels>;
  /** An object relationship */
  location?: Maybe<Task_Locations>;
  number: Scalars['Int']['output'];
  /** An object relationship */
  permissions?: Maybe<Task_Permissions>;
  /** An array relationship */
  predecessors: Array<Task_Dependencies>;
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid']['output'];
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  subtasks: Array<Task_Subtasks>;
  /** This field will show the progress (in percentage) of the closed subtasks */
  subtasks_progress?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** true if the user should be able to see this task row */
  user_can_read?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  validations: Array<Task_Validations>;
  /** An array relationship */
  views: Array<Task_Views>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksAncestorsArgs = {
  distinct_on?: InputMaybe<Array<Task_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Dependencies_Order_By>>;
  where?: InputMaybe<Task_Dependencies_Bool_Exp>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Task_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Attachments_Order_By>>;
  where?: InputMaybe<Task_Attachments_Bool_Exp>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksFile_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Tasks_File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_File_Versions_Order_By>>;
  where?: InputMaybe<Tasks_File_Versions_Bool_Exp>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksLabelsArgs = {
  distinct_on?: InputMaybe<Array<Tasks_To_Project_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_To_Project_Labels_Order_By>>;
  where?: InputMaybe<Tasks_To_Project_Labels_Bool_Exp>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksPredecessorsArgs = {
  distinct_on?: InputMaybe<Array<Task_Dependencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Dependencies_Order_By>>;
  where?: InputMaybe<Task_Dependencies_Bool_Exp>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksSubtasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Subtasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Subtasks_Order_By>>;
  where?: InputMaybe<Task_Subtasks_Bool_Exp>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksValidationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Validations_Order_By>>;
  where?: InputMaybe<Task_Validations_Bool_Exp>;
};


/** This table groups the tasks, they are then linked to projects or orgs by relationship tables */
export type TasksViewsArgs = {
  distinct_on?: InputMaybe<Array<Task_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Views_Order_By>>;
  where?: InputMaybe<Task_Views_Bool_Exp>;
};

/** aggregated selection of "tasks" */
export type Tasks_Aggregate = {
  __typename?: 'tasks_aggregate';
  aggregate?: Maybe<Tasks_Aggregate_Fields>;
  nodes: Array<Tasks>;
};

/** aggregate fields of "tasks" */
export type Tasks_Aggregate_Fields = {
  __typename?: 'tasks_aggregate_fields';
  avg?: Maybe<Tasks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tasks_Max_Fields>;
  min?: Maybe<Tasks_Min_Fields>;
  stddev?: Maybe<Tasks_Stddev_Fields>;
  stddev_pop?: Maybe<Tasks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tasks_Stddev_Samp_Fields>;
  sum?: Maybe<Tasks_Sum_Fields>;
  var_pop?: Maybe<Tasks_Var_Pop_Fields>;
  var_samp?: Maybe<Tasks_Var_Samp_Fields>;
  variance?: Maybe<Tasks_Variance_Fields>;
};


/** aggregate fields of "tasks" */
export type Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tasks" */
export type Tasks_Aggregate_Order_By = {
  avg?: InputMaybe<Tasks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tasks_Max_Order_By>;
  min?: InputMaybe<Tasks_Min_Order_By>;
  stddev?: InputMaybe<Tasks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tasks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tasks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tasks_Sum_Order_By>;
  var_pop?: InputMaybe<Tasks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tasks_Var_Samp_Order_By>;
  variance?: InputMaybe<Tasks_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Tasks_Avg_Fields = {
  __typename?: 'tasks_avg_fields';
  hours_done?: Maybe<Scalars['Float']['output']>;
  hours_expected?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tasks" */
export type Tasks_Avg_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export type Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Tasks_Bool_Exp>>;
  _not?: InputMaybe<Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Tasks_Bool_Exp>>;
  ancestors?: InputMaybe<Task_Dependencies_Bool_Exp>;
  assignations?: InputMaybe<Task_Assignations_Bool_Exp>;
  attachments?: InputMaybe<Task_Attachments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_versions?: InputMaybe<Tasks_File_Versions_Bool_Exp>;
  hours_done?: InputMaybe<Float8_Comparison_Exp>;
  hours_expected?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_validated_by?: InputMaybe<String_Comparison_Exp>;
  labels?: InputMaybe<Tasks_To_Project_Labels_Bool_Exp>;
  location?: InputMaybe<Task_Locations_Bool_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  permissions?: InputMaybe<Task_Permissions_Bool_Exp>;
  predecessors?: InputMaybe<Task_Dependencies_Bool_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  subtasks?: InputMaybe<Task_Subtasks_Bool_Exp>;
  subtasks_progress?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_can_read?: InputMaybe<Boolean_Comparison_Exp>;
  validations?: InputMaybe<Task_Validations_Bool_Exp>;
  views?: InputMaybe<Task_Views_Bool_Exp>;
};

/** File versions attached to a task */
export type Tasks_File_Versions = {
  __typename?: 'tasks_file_versions';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file_version: File_Versions;
  file_version_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  location?: Maybe<Task_File_Version_Location>;
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  task_location_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "tasks_file_versions" */
export type Tasks_File_Versions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tasks_File_Versions_Max_Order_By>;
  min?: InputMaybe<Tasks_File_Versions_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "tasks_file_versions". All fields are combined with a logical 'AND'. */
export type Tasks_File_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Tasks_File_Versions_Bool_Exp>>;
  _not?: InputMaybe<Tasks_File_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Tasks_File_Versions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_version?: InputMaybe<File_Versions_Bool_Exp>;
  file_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Task_File_Version_Location_Bool_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_location_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "tasks_file_versions" */
export type Tasks_File_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_location_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tasks_file_versions" */
export type Tasks_File_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_location_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tasks_file_versions". */
export type Tasks_File_Versions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_version?: InputMaybe<File_Versions_Order_By>;
  file_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Task_File_Version_Location_Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_location_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "tasks_file_versions" */
export enum Tasks_File_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileVersionId = 'file_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TaskLocationId = 'task_location_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate max on columns */
export type Tasks_Max_Fields = {
  __typename?: 'tasks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  hours_done?: Maybe<Scalars['float8']['output']>;
  hours_expected?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "tasks" */
export type Tasks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tasks_Min_Fields = {
  __typename?: 'tasks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  hours_done?: Maybe<Scalars['float8']['output']>;
  hours_expected?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "tasks" */
export type Tasks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tasks". */
export type Tasks_Order_By = {
  ancestors_aggregate?: InputMaybe<Task_Dependencies_Aggregate_Order_By>;
  assignations?: InputMaybe<Task_Assignations_Order_By>;
  attachments_aggregate?: InputMaybe<Task_Attachments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  file_versions_aggregate?: InputMaybe<Tasks_File_Versions_Aggregate_Order_By>;
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_validated_by?: InputMaybe<Order_By>;
  labels_aggregate?: InputMaybe<Tasks_To_Project_Labels_Aggregate_Order_By>;
  location?: InputMaybe<Task_Locations_Order_By>;
  number?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Task_Permissions_Order_By>;
  predecessors_aggregate?: InputMaybe<Task_Dependencies_Aggregate_Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subtasks_aggregate?: InputMaybe<Task_Subtasks_Aggregate_Order_By>;
  subtasks_progress?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_can_read?: InputMaybe<Order_By>;
  validations_aggregate?: InputMaybe<Task_Validations_Aggregate_Order_By>;
  views_aggregate?: InputMaybe<Task_Views_Aggregate_Order_By>;
};

/** select columns of table "tasks" */
export enum Tasks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  HoursDone = 'hours_done',
  /** column name */
  HoursExpected = 'hours_expected',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Tasks_Stddev_Fields = {
  __typename?: 'tasks_stddev_fields';
  hours_done?: Maybe<Scalars['Float']['output']>;
  hours_expected?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tasks" */
export type Tasks_Stddev_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tasks_Stddev_Pop_Fields = {
  __typename?: 'tasks_stddev_pop_fields';
  hours_done?: Maybe<Scalars['Float']['output']>;
  hours_expected?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tasks" */
export type Tasks_Stddev_Pop_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tasks_Stddev_Samp_Fields = {
  __typename?: 'tasks_stddev_samp_fields';
  hours_done?: Maybe<Scalars['Float']['output']>;
  hours_expected?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tasks" */
export type Tasks_Stddev_Samp_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Tasks_Sum_Fields = {
  __typename?: 'tasks_sum_fields';
  hours_done?: Maybe<Scalars['float8']['output']>;
  hours_expected?: Maybe<Scalars['float8']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tasks" */
export type Tasks_Sum_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Relationship table between task and label */
export type Tasks_To_Project_Labels = {
  __typename?: 'tasks_to_project_labels';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  label: Project_Labels;
  order: Scalars['Int']['output'];
  project_label_id: Scalars['uuid']['output'];
  /** An object relationship */
  task: Tasks;
  task_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Tasks_To_Project_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tasks_To_Project_Labels_Max_Order_By>;
  min?: InputMaybe<Tasks_To_Project_Labels_Min_Order_By>;
  stddev?: InputMaybe<Tasks_To_Project_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tasks_To_Project_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tasks_To_Project_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tasks_To_Project_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Tasks_To_Project_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tasks_To_Project_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Tasks_To_Project_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tasks_to_project_labels". All fields are combined with a logical 'AND'. */
export type Tasks_To_Project_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Tasks_To_Project_Labels_Bool_Exp>>;
  _not?: InputMaybe<Tasks_To_Project_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Tasks_To_Project_Labels_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<Project_Labels_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  project_label_id?: InputMaybe<Uuid_Comparison_Exp>;
  task?: InputMaybe<Tasks_Bool_Exp>;
  task_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tasks_to_project_labels". */
export type Tasks_To_Project_Labels_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Project_Labels_Order_By>;
  order?: InputMaybe<Order_By>;
  project_label_id?: InputMaybe<Order_By>;
  task?: InputMaybe<Tasks_Order_By>;
  task_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "tasks_to_project_labels" */
export enum Tasks_To_Project_Labels_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  ProjectLabelId = 'project_label_id',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tasks_to_project_labels" */
export type Tasks_To_Project_Labels_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Tasks_Var_Pop_Fields = {
  __typename?: 'tasks_var_pop_fields';
  hours_done?: Maybe<Scalars['Float']['output']>;
  hours_expected?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tasks" */
export type Tasks_Var_Pop_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tasks_Var_Samp_Fields = {
  __typename?: 'tasks_var_samp_fields';
  hours_done?: Maybe<Scalars['Float']['output']>;
  hours_expected?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tasks" */
export type Tasks_Var_Samp_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tasks_Variance_Fields = {
  __typename?: 'tasks_variance_fields';
  hours_done?: Maybe<Scalars['Float']['output']>;
  hours_expected?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tasks" */
export type Tasks_Variance_Order_By = {
  hours_done?: InputMaybe<Order_By>;
  hours_expected?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Define a user group (like role) */
export type Teams = {
  __typename?: 'teams';
  color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  folder_assignations: Array<Folder_Assignations_Teams>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Teams_To_Users>;
};


/** Define a user group (like role) */
export type TeamsFolder_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
};


/** Define a user group (like role) */
export type TeamsUsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_To_Users_Order_By>>;
  where?: InputMaybe<Teams_To_Users_Bool_Exp>;
};

/** order by aggregate values of table "teams" */
export type Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Max_Order_By>;
  min?: InputMaybe<Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  folder_assignations?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Teams_To_Users_Bool_Exp>;
};

/** order by max() on columns of table "teams" */
export type Teams_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "teams" */
export type Teams_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  folder_assignations_aggregate?: InputMaybe<Folder_Assignations_Teams_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Teams_To_Users_Aggregate_Order_By>;
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "teams_to_users" */
export type Teams_To_Users = {
  __typename?: 'teams_to_users';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "teams_to_users" */
export type Teams_To_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_To_Users_Max_Order_By>;
  min?: InputMaybe<Teams_To_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "teams_to_users". All fields are combined with a logical 'AND'. */
export type Teams_To_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_To_Users_Bool_Exp>>;
  _not?: InputMaybe<Teams_To_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_To_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "teams_to_users" */
export type Teams_To_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "teams_to_users" */
export type Teams_To_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "teams_to_users". */
export type Teams_To_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "teams_to_users" */
export enum Teams_To_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "uptime_test" */
export type Uptime_Test = {
  __typename?: 'uptime_test';
  id: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "uptime_test". All fields are combined with a logical 'AND'. */
export type Uptime_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Uptime_Test_Bool_Exp>>;
  _not?: InputMaybe<Uptime_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Uptime_Test_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "uptime_test". */
export type Uptime_Test_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "uptime_test" */
export enum Uptime_Test_Select_Column {
  /** column name */
  Id = 'id'
}

/** columns and relationships of "user_avatars" */
export type User_Avatars = {
  __typename?: 'user_avatars';
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  public_url: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "user_avatars". All fields are combined with a logical 'AND'. */
export type User_Avatars_Bool_Exp = {
  _and?: InputMaybe<Array<User_Avatars_Bool_Exp>>;
  _not?: InputMaybe<User_Avatars_Bool_Exp>;
  _or?: InputMaybe<Array<User_Avatars_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  public_url?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "user_avatars". */
export type User_Avatars_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  public_url?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_avatars" */
export enum User_Avatars_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Extension = 'extension',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  PublicUrl = 'public_url',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "user_connections" */
export type User_Connections = {
  __typename?: 'user_connections';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  /** An array relationship */
  user_locations: Array<User_Locations>;
};


/** columns and relationships of "user_connections" */
export type User_ConnectionsUser_LocationsArgs = {
  distinct_on?: InputMaybe<Array<User_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Locations_Order_By>>;
  where?: InputMaybe<User_Locations_Bool_Exp>;
};

/** order by aggregate values of table "user_connections" */
export type User_Connections_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Connections_Max_Order_By>;
  min?: InputMaybe<User_Connections_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_connections". All fields are combined with a logical 'AND'. */
export type User_Connections_Bool_Exp = {
  _and?: InputMaybe<Array<User_Connections_Bool_Exp>>;
  _not?: InputMaybe<User_Connections_Bool_Exp>;
  _or?: InputMaybe<Array<User_Connections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_locations?: InputMaybe<User_Locations_Bool_Exp>;
};

/** order by max() on columns of table "user_connections" */
export type User_Connections_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_connections" */
export type User_Connections_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_connections". */
export type User_Connections_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_locations_aggregate?: InputMaybe<User_Locations_Aggregate_Order_By>;
};

/** select columns of table "user_connections" */
export enum User_Connections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "user_contact" */
export type User_Contact = {
  __typename?: 'user_contact';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** Boolean expression to filter rows from the table "user_contact". All fields are combined with a logical 'AND'. */
export type User_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<User_Contact_Bool_Exp>>;
  _not?: InputMaybe<User_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<User_Contact_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "user_contact". */
export type User_Contact_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "user_contact" */
export enum User_Contact_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone'
}

/** columns and relationships of "user_locations" */
export type User_Locations = {
  __typename?: 'user_locations';
  city_name?: Maybe<Scalars['String']['output']>;
  continent_code?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_code3?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  user_connection: User_Connections;
  user_connection_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_locations" */
export type User_Locations_Aggregate_Order_By = {
  avg?: InputMaybe<User_Locations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Locations_Max_Order_By>;
  min?: InputMaybe<User_Locations_Min_Order_By>;
  stddev?: InputMaybe<User_Locations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Locations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Locations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Locations_Sum_Order_By>;
  var_pop?: InputMaybe<User_Locations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Locations_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Locations_Variance_Order_By>;
};

/** order by avg() on columns of table "user_locations" */
export type User_Locations_Avg_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_locations". All fields are combined with a logical 'AND'. */
export type User_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<User_Locations_Bool_Exp>>;
  _not?: InputMaybe<User_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<User_Locations_Bool_Exp>>;
  city_name?: InputMaybe<String_Comparison_Exp>;
  continent_code?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_code3?: InputMaybe<String_Comparison_Exp>;
  country_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  time_zone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_connection?: InputMaybe<User_Connections_Bool_Exp>;
  user_connection_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "user_locations" */
export type User_Locations_Max_Order_By = {
  city_name?: InputMaybe<Order_By>;
  continent_code?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_code3?: InputMaybe<Order_By>;
  country_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_connection_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_locations" */
export type User_Locations_Min_Order_By = {
  city_name?: InputMaybe<Order_By>;
  continent_code?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_code3?: InputMaybe<Order_By>;
  country_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_connection_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_locations". */
export type User_Locations_Order_By = {
  city_name?: InputMaybe<Order_By>;
  continent_code?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_code3?: InputMaybe<Order_By>;
  country_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_connection?: InputMaybe<User_Connections_Order_By>;
  user_connection_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_locations" */
export enum User_Locations_Select_Column {
  /** column name */
  CityName = 'city_name',
  /** column name */
  ContinentCode = 'continent_code',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryCode3 = 'country_code3',
  /** column name */
  CountryName = 'country_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  TimeZone = 'time_zone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserConnectionId = 'user_connection_id',
  /** column name */
  UserId = 'user_id'
}

/** order by stddev() on columns of table "user_locations" */
export type User_Locations_Stddev_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_locations" */
export type User_Locations_Stddev_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_locations" */
export type User_Locations_Stddev_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "user_locations" */
export type User_Locations_Sum_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "user_locations" */
export type User_Locations_Var_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_locations" */
export type User_Locations_Var_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_locations" */
export type User_Locations_Variance_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** External metadatas for users like placeholder company */
export type User_Metadatas = {
  __typename?: 'user_metadatas';
  country_code?: Maybe<Scalars['String']['output']>;
  placeholder_company_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
};

/** Boolean expression to filter rows from the table "user_metadatas". All fields are combined with a logical 'AND'. */
export type User_Metadatas_Bool_Exp = {
  _and?: InputMaybe<Array<User_Metadatas_Bool_Exp>>;
  _not?: InputMaybe<User_Metadatas_Bool_Exp>;
  _or?: InputMaybe<Array<User_Metadatas_Bool_Exp>>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  placeholder_company_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "user_metadatas". */
export type User_Metadatas_Order_By = {
  country_code?: InputMaybe<Order_By>;
  placeholder_company_name?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "user_metadatas" */
export enum User_Metadatas_Select_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  PlaceholderCompanyName = 'placeholder_company_name'
}

/** columns and relationships of "user_notifications" */
export type User_Notifications = {
  __typename?: 'user_notifications';
  created_at: Scalars['timestamptz']['output'];
  creator_id: Scalars['uuid']['output'];
  event_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_strong: Scalars['Boolean']['output'];
  payload: Scalars['jsonb']['output'];
  read_at?: Maybe<Scalars['timestamptz']['output']>;
  recipient_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "user_notifications" */
export type User_NotificationsPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "user_notifications" */
export type User_Notifications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Notifications_Max_Order_By>;
  min?: InputMaybe<User_Notifications_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_notifications". All fields are combined with a logical 'AND'. */
export type User_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<User_Notifications_Bool_Exp>>;
  _not?: InputMaybe<User_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<User_Notifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_strong?: InputMaybe<Boolean_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  read_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  recipient_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "user_notifications" */
export type User_Notifications_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  recipient_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_notifications" */
export type User_Notifications_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  recipient_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_notifications". */
export type User_Notifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_strong?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  recipient_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "user_notifications" */
export enum User_Notifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsStrong = 'is_strong',
  /** column name */
  Payload = 'payload',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  RecipientId = 'recipient_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An object relationship */
  active_org?: Maybe<Orgs_To_Users>;
  algolia_key?: Maybe<GetAlgoliaUserApiKeySuccess>;
  auth0_id: Scalars['String']['output'];
  /** Retrieve either the org name or the user placeholder_company_name */
  company_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  connections: Array<User_Connections>;
  /** An object relationship */
  contact?: Maybe<User_Contact>;
  /** Retrieve either the user metadatas country_code or the user locations country_code or null */
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  /** An object relationship */
  email_notifications?: Maybe<Email_Notifications>;
  /** An array relationship */
  events: Array<Events>;
  /** An array relationship */
  file_approvals: Array<File_Approvals>;
  /** An array relationship */
  file_assignations_orgs: Array<File_Assignations_Orgs>;
  /** An array relationship */
  file_assignations_teams: Array<File_Assignations_Teams>;
  /** An array relationship */
  file_assignations_users: Array<File_Assignations_Users>;
  /** An array relationship */
  file_comments: Array<File_Comments>;
  /** An array relationship */
  file_permissions_users: Array<File_Permissions_Users>;
  /** An array relationship */
  file_signatures: Array<File_Signatures>;
  /** An array relationship */
  file_version_approval_request_users: Array<File_Version_Approval_Request_Users>;
  /** An aggregate relationship */
  file_version_approval_request_users_aggregate: File_Version_Approval_Request_Users_Aggregate;
  /** An array relationship */
  file_versions: Array<File_Versions>;
  /** An array relationship */
  file_views: Array<File_Views>;
  first_name: Scalars['String']['output'];
  /** An array relationship */
  folder_assignations: Array<Folder_Assignations_Users>;
  /** An array relationship */
  folder_assignations_orgs: Array<Folder_Assignations_Orgs>;
  /** An array relationship */
  folder_assignations_teams: Array<Folder_Assignations_Teams>;
  /** An array relationship */
  folder_assignations_users: Array<Folder_Assignations_Users>;
  /** An array relationship */
  folder_permissions: Array<Folder_Permissions_Users>;
  /** An array relationship */
  folder_views: Array<Folder_Views>;
  /** A computed field, executes function "user_full_name" */
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  is_connected: Scalars['Boolean']['output'];
  is_legacy_user: Scalars['Boolean']['output'];
  is_locked: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  /** An array relationship */
  locations: Array<User_Locations>;
  /** An object relationship */
  metadatas?: Maybe<User_Metadatas>;
  /** An array relationship */
  org_invitations: Array<Orgs_To_Users>;
  /** An array relationship */
  project_views: Array<Project_Views>;
  /** An array relationship */
  projects: Array<Projects_To_Users>;
  /** An array relationship */
  projectsByCreatorId: Array<Projects>;
  /** An array relationship */
  projects_invited: Array<Projects_To_Users>;
  /** An array relationship */
  projects_to_users: Array<Projects_To_Users>;
  /** An object relationship */
  public_api_token_creator_id?: Maybe<Orgs>;
  /** An object relationship */
  push_notifications?: Maybe<Push_Notifications>;
  stream_chat_token?: Maybe<GetStreamChatUserTokenSuccess>;
  stream_user_id: Scalars['String']['output'];
  /** An array relationship */
  task_assignations_users: Array<Task_Assignations_Users>;
  /** An array relationship */
  task_subtasks: Array<Task_Subtasks>;
  /** An array relationship */
  task_validations: Array<Task_Validations>;
  /** An array relationship */
  task_views: Array<Task_Views>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** An array relationship */
  teams: Array<Teams_To_Users>;
  timezone: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_avatar?: Maybe<User_Avatars>;
  /** An array relationship */
  user_notifications: Array<User_Notifications>;
};


/** columns and relationships of "users" */
export type UsersConnectionsArgs = {
  distinct_on?: InputMaybe<Array<User_Connections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Connections_Order_By>>;
  where?: InputMaybe<User_Connections_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<File_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Approvals_Order_By>>;
  where?: InputMaybe<File_Approvals_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<File_Assignations_Orgs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Teams_Order_By>>;
  where?: InputMaybe<File_Assignations_Teams_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Assignations_Users_Order_By>>;
  where?: InputMaybe<File_Assignations_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_CommentsArgs = {
  distinct_on?: InputMaybe<Array<File_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Comments_Order_By>>;
  where?: InputMaybe<File_Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_Permissions_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Permissions_Users_Order_By>>;
  where?: InputMaybe<File_Permissions_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_SignaturesArgs = {
  distinct_on?: InputMaybe<Array<File_Signatures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Signatures_Order_By>>;
  where?: InputMaybe<File_Signatures_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_Version_Approval_Request_UsersArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_Version_Approval_Request_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Version_Approval_Request_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Version_Approval_Request_Users_Order_By>>;
  where?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_VersionsArgs = {
  distinct_on?: InputMaybe<Array<File_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Versions_Order_By>>;
  where?: InputMaybe<File_Versions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_ViewsArgs = {
  distinct_on?: InputMaybe<Array<File_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Views_Order_By>>;
  where?: InputMaybe<File_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFolder_AssignationsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Users_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFolder_Assignations_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Orgs_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFolder_Assignations_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Teams_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFolder_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Folder_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Assignations_Users_Order_By>>;
  where?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFolder_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Permissions_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Permissions_Users_Order_By>>;
  where?: InputMaybe<Folder_Permissions_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFolder_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Folder_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Folder_Views_Order_By>>;
  where?: InputMaybe<Folder_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLocationsArgs = {
  distinct_on?: InputMaybe<Array<User_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Locations_Order_By>>;
  where?: InputMaybe<User_Locations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrg_InvitationsArgs = {
  distinct_on?: InputMaybe<Array<Orgs_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orgs_To_Users_Order_By>>;
  where?: InputMaybe<Orgs_To_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProject_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Project_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Views_Order_By>>;
  where?: InputMaybe<Project_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_To_Users_Order_By>>;
  where?: InputMaybe<Projects_To_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProjectsByCreatorIdArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProjects_InvitedArgs = {
  distinct_on?: InputMaybe<Array<Projects_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_To_Users_Order_By>>;
  where?: InputMaybe<Projects_To_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProjects_To_UsersArgs = {
  distinct_on?: InputMaybe<Array<Projects_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_To_Users_Order_By>>;
  where?: InputMaybe<Projects_To_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTask_Assignations_UsersArgs = {
  distinct_on?: InputMaybe<Array<Task_Assignations_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Assignations_Users_Order_By>>;
  where?: InputMaybe<Task_Assignations_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTask_SubtasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Subtasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Subtasks_Order_By>>;
  where?: InputMaybe<Task_Subtasks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTask_ValidationsArgs = {
  distinct_on?: InputMaybe<Array<Task_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Validations_Order_By>>;
  where?: InputMaybe<Task_Validations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTask_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Task_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Views_Order_By>>;
  where?: InputMaybe<Task_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_To_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_To_Users_Order_By>>;
  where?: InputMaybe<Teams_To_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

export type UsersCompanyData = {
  city?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  creation_date?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_number?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  size_max?: InputMaybe<Scalars['Int']['input']>;
  size_min?: InputMaybe<Scalars['Int']['input']>;
  standard_industrial_classification?: InputMaybe<Scalars['String']['input']>;
};

export type UsersProjectInvitation = {
  company_data?: InputMaybe<UsersCompanyData>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  active_org?: InputMaybe<Orgs_To_Users_Bool_Exp>;
  auth0_id?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  connections?: InputMaybe<User_Connections_Bool_Exp>;
  contact?: InputMaybe<User_Contact_Bool_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_notifications?: InputMaybe<Email_Notifications_Bool_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  file_approvals?: InputMaybe<File_Approvals_Bool_Exp>;
  file_assignations_orgs?: InputMaybe<File_Assignations_Orgs_Bool_Exp>;
  file_assignations_teams?: InputMaybe<File_Assignations_Teams_Bool_Exp>;
  file_assignations_users?: InputMaybe<File_Assignations_Users_Bool_Exp>;
  file_comments?: InputMaybe<File_Comments_Bool_Exp>;
  file_permissions_users?: InputMaybe<File_Permissions_Users_Bool_Exp>;
  file_signatures?: InputMaybe<File_Signatures_Bool_Exp>;
  file_version_approval_request_users?: InputMaybe<File_Version_Approval_Request_Users_Bool_Exp>;
  file_versions?: InputMaybe<File_Versions_Bool_Exp>;
  file_views?: InputMaybe<File_Views_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  folder_assignations?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
  folder_assignations_orgs?: InputMaybe<Folder_Assignations_Orgs_Bool_Exp>;
  folder_assignations_teams?: InputMaybe<Folder_Assignations_Teams_Bool_Exp>;
  folder_assignations_users?: InputMaybe<Folder_Assignations_Users_Bool_Exp>;
  folder_permissions?: InputMaybe<Folder_Permissions_Users_Bool_Exp>;
  folder_views?: InputMaybe<Folder_Views_Bool_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_connected?: InputMaybe<Boolean_Comparison_Exp>;
  is_legacy_user?: InputMaybe<Boolean_Comparison_Exp>;
  is_locked?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  locations?: InputMaybe<User_Locations_Bool_Exp>;
  metadatas?: InputMaybe<User_Metadatas_Bool_Exp>;
  org_invitations?: InputMaybe<Orgs_To_Users_Bool_Exp>;
  project_views?: InputMaybe<Project_Views_Bool_Exp>;
  projects?: InputMaybe<Projects_To_Users_Bool_Exp>;
  projectsByCreatorId?: InputMaybe<Projects_Bool_Exp>;
  projects_invited?: InputMaybe<Projects_To_Users_Bool_Exp>;
  projects_to_users?: InputMaybe<Projects_To_Users_Bool_Exp>;
  public_api_token_creator_id?: InputMaybe<Orgs_Bool_Exp>;
  push_notifications?: InputMaybe<Push_Notifications_Bool_Exp>;
  stream_user_id?: InputMaybe<String_Comparison_Exp>;
  task_assignations_users?: InputMaybe<Task_Assignations_Users_Bool_Exp>;
  task_subtasks?: InputMaybe<Task_Subtasks_Bool_Exp>;
  task_validations?: InputMaybe<Task_Validations_Bool_Exp>;
  task_views?: InputMaybe<Task_Views_Bool_Exp>;
  tasks?: InputMaybe<Tasks_Bool_Exp>;
  teams?: InputMaybe<Teams_To_Users_Bool_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_avatar?: InputMaybe<User_Avatars_Bool_Exp>;
  user_notifications?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  stream_user_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  stream_user_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  active_org?: InputMaybe<Orgs_To_Users_Order_By>;
  auth0_id?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  connections_aggregate?: InputMaybe<User_Connections_Aggregate_Order_By>;
  contact?: InputMaybe<User_Contact_Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_notifications?: InputMaybe<Email_Notifications_Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  file_approvals_aggregate?: InputMaybe<File_Approvals_Aggregate_Order_By>;
  file_assignations_orgs_aggregate?: InputMaybe<File_Assignations_Orgs_Aggregate_Order_By>;
  file_assignations_teams_aggregate?: InputMaybe<File_Assignations_Teams_Aggregate_Order_By>;
  file_assignations_users_aggregate?: InputMaybe<File_Assignations_Users_Aggregate_Order_By>;
  file_comments_aggregate?: InputMaybe<File_Comments_Aggregate_Order_By>;
  file_permissions_users_aggregate?: InputMaybe<File_Permissions_Users_Aggregate_Order_By>;
  file_signatures_aggregate?: InputMaybe<File_Signatures_Aggregate_Order_By>;
  file_version_approval_request_users_aggregate?: InputMaybe<File_Version_Approval_Request_Users_Aggregate_Order_By>;
  file_versions_aggregate?: InputMaybe<File_Versions_Aggregate_Order_By>;
  file_views_aggregate?: InputMaybe<File_Views_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  folder_assignations_aggregate?: InputMaybe<Folder_Assignations_Users_Aggregate_Order_By>;
  folder_assignations_orgs_aggregate?: InputMaybe<Folder_Assignations_Orgs_Aggregate_Order_By>;
  folder_assignations_teams_aggregate?: InputMaybe<Folder_Assignations_Teams_Aggregate_Order_By>;
  folder_assignations_users_aggregate?: InputMaybe<Folder_Assignations_Users_Aggregate_Order_By>;
  folder_permissions_aggregate?: InputMaybe<Folder_Permissions_Users_Aggregate_Order_By>;
  folder_views_aggregate?: InputMaybe<Folder_Views_Aggregate_Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_connected?: InputMaybe<Order_By>;
  is_legacy_user?: InputMaybe<Order_By>;
  is_locked?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  locations_aggregate?: InputMaybe<User_Locations_Aggregate_Order_By>;
  metadatas?: InputMaybe<User_Metadatas_Order_By>;
  org_invitations_aggregate?: InputMaybe<Orgs_To_Users_Aggregate_Order_By>;
  project_views_aggregate?: InputMaybe<Project_Views_Aggregate_Order_By>;
  projectsByCreatorId_aggregate?: InputMaybe<Projects_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Projects_To_Users_Aggregate_Order_By>;
  projects_invited_aggregate?: InputMaybe<Projects_To_Users_Aggregate_Order_By>;
  projects_to_users_aggregate?: InputMaybe<Projects_To_Users_Aggregate_Order_By>;
  public_api_token_creator_id?: InputMaybe<Orgs_Order_By>;
  push_notifications?: InputMaybe<Push_Notifications_Order_By>;
  stream_user_id?: InputMaybe<Order_By>;
  task_assignations_users_aggregate?: InputMaybe<Task_Assignations_Users_Aggregate_Order_By>;
  task_subtasks_aggregate?: InputMaybe<Task_Subtasks_Aggregate_Order_By>;
  task_validations_aggregate?: InputMaybe<Task_Validations_Aggregate_Order_By>;
  task_views_aggregate?: InputMaybe<Task_Views_Aggregate_Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Teams_To_Users_Aggregate_Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_avatar?: InputMaybe<User_Avatars_Order_By>;
  user_notifications_aggregate?: InputMaybe<User_Notifications_Aggregate_Order_By>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsConnected = 'is_connected',
  /** column name */
  IsLegacyUser = 'is_legacy_user',
  /** column name */
  IsLocked = 'is_locked',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  StreamUserId = 'stream_user_id',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type Versions_By_Pk_Files_Args = {
  file_version_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type SaveFirebaseTokenMutationVariables = Exact<{
  input: SaveFirebaseTokenInput;
}>;


export type SaveFirebaseTokenMutation = { __typename?: 'mutation_root', saveFirebaseToken?: { __typename: 'SaveFirebaseTokenErrors', errors: Array<{ __typename: 'InputValidationError' }> } | { __typename: 'SaveFirebaseTokenSuccess', user_device_id: string } | null };

export type FinalizeUploadedFileMutationVariables = Exact<{
  input: FinalizeUploadedFileInput;
}>;


export type FinalizeUploadedFileMutation = { __typename?: 'mutation_root', finalizeUploadedFile?: { __typename: 'FinalizeUploadedFileErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedFileSuccess', file_id: string } | null };

export type FinalizeUploadedFileVersionMutationVariables = Exact<{
  input: FinalizeUploadedFileVersionInput;
}>;


export type FinalizeUploadedFileVersionMutation = { __typename?: 'mutation_root', finalizeUploadedFileVersion?: { __typename: 'FinalizeUploadedFileVersionErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'FileDoesNotExists' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedFileVersionSuccess', file_version_id: string } | null };

export type UppyFinalizeUploadedFileApprovalsAttachmentMutationVariables = Exact<{
  input: FinalizeUploadedFileApprovalsAttachmentInput;
}>;


export type UppyFinalizeUploadedFileApprovalsAttachmentMutation = { __typename?: 'mutation_root', finalizeUploadedFileApprovalsAttachment?: { __typename: 'FinalizeUploadedFileApprovalsAttachmentErrors', errors: Array<{ __typename: 'CannotRemoveApprovalOnFile' } | { __typename: 'DuplicateApprovalOnFileVersion' } | { __typename: 'FileApprovalNotExist' } | { __typename: 'FileNotInApprovalMode' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' } | { __typename: 'NotFoundFilesInApprovalMode' } | { __typename: 'UserNotAssignedToFile' }> } | { __typename: 'FinalizeUploadedFileApprovalsAttachmentSuccess', file_approval_attachment_id: string } | null };

export type FinalizeUploadedTaskAttachmentMutationVariables = Exact<{
  input: FinalizeUploadedTaskAttachmentInput;
}>;


export type FinalizeUploadedTaskAttachmentMutation = { __typename?: 'mutation_root', finalizeUploadedTaskAttachment?: { __typename: 'FinalizeUploadedTaskAttachmentErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedTaskAttachmentSuccess', task_attachment_id: string } | null };

export type FinalizeUploadedTaskAttachmentAnnotationMutationVariables = Exact<{
  input: FinalizeUploadedTaskAttachmentAnnotationInput;
}>;


export type FinalizeUploadedTaskAttachmentAnnotationMutation = { __typename?: 'mutation_root', finalizeUploadedTaskAttachmentAnnotation?: { __typename: 'FinalizeUploadedTaskAttachmentAnnotationErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' } | { __typename: 'TaskAttachmentDoesNotExist' }> } | { __typename: 'FinalizeUploadedTaskAttachmentAnnotationSuccess', task_attachment_id: string } | null };

export type FinalizeUploadedOrgAvatarMutationVariables = Exact<{
  input: FinalizeUploadedOrgAvatarInput;
}>;


export type FinalizeUploadedOrgAvatarMutation = { __typename?: 'mutation_root', finalizeUploadedOrgAvatar?: { __typename: 'FinalizeUploadedOrgAvatarErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedOrgAvatarSuccess', org_id: string } | null };

export type FinalizeUploadedOrgBackgroundMutationVariables = Exact<{
  input: FinalizeUploadedOrgBackgroundInput;
}>;


export type FinalizeUploadedOrgBackgroundMutation = { __typename?: 'mutation_root', finalizeUploadedOrgBackground?: { __typename: 'FinalizeUploadedOrgBackgroundErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedOrgBackgroundSuccess', org_id: string } | null };

export type FinalizeUploadedProjectAvatarMutationVariables = Exact<{
  input: FinalizeUploadedProjectAvatarInput;
}>;


export type FinalizeUploadedProjectAvatarMutation = { __typename?: 'mutation_root', finalizeUploadedProjectAvatar?: { __typename: 'FinalizeUploadedProjectAvatarErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedProjectAvatarSuccess', project_id: string } | null };

export type FinalizeUploadedProjectGroupAvatarMutationVariables = Exact<{
  input: FinalizeUploadedProjectGroupAvatarInput;
}>;


export type FinalizeUploadedProjectGroupAvatarMutation = { __typename?: 'mutation_root', FinalizeUploadedProjectGroupAvatar?: { __typename: 'FinalizeUploadedProjectGroupAvatarErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedProjectGroupAvatarSuccess', project_group_id: string } | null };

export type FinalizeUploadedProjectBackgroundMutationVariables = Exact<{
  input: FinalizeUploadedProjectBackgroundInput;
}>;


export type FinalizeUploadedProjectBackgroundMutation = { __typename?: 'mutation_root', finalizeUploadedProjectBackground?: { __typename: 'FinalizeUploadedProjectBackgroundErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedProjectBackgroundSuccess', project_id: string } | null };

export type FinalizeUploadedProjectBannerMutationVariables = Exact<{
  input: FinalizeUploadedProjectBannerInput;
}>;


export type FinalizeUploadedProjectBannerMutation = { __typename?: 'mutation_root', finalizeUploadedProjectBanner?: { __typename: 'FinalizeUploadedProjectBannerErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedProjectBannerSuccess', project_id: string } | null };

export type FinalizeUploadedUserAvatarMutationVariables = Exact<{
  input: FinalizeUploadedUserAvatarInput;
}>;


export type FinalizeUploadedUserAvatarMutation = { __typename?: 'mutation_root', finalizeUploadedUserAvatar?: { __typename: 'FinalizeUploadedUserAvatarErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' }> } | { __typename: 'FinalizeUploadedUserAvatarSuccess', user_id: string } | null };

export type FinalizeUploadedChannelAssetMutationVariables = Exact<{
  input: FinalizeUploadedChannelAssetInput;
}>;


export type FinalizeUploadedChannelAssetMutation = { __typename?: 'mutation_root', finalizeUploadedChannelAsset?: { __typename: 'FinalizeUploadedChannelAssetErrors', errors: Array<{ __typename: 'CopyFromTemporaryBucketFailed' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedChannelAssetSuccess', channel_id: string, public_url: string } | null };

export type FinalizeUploadedFileStructureMutationVariables = Exact<{
  input: FinalizeUploadedFileStructureInput;
}>;


export type FinalizeUploadedFileStructureMutation = { __typename?: 'mutation_root', finalizeUploadedFileStructure?: { __typename: 'FinalizeUploadedFileStructureErrors', errors: Array<{ __typename: 'FileTooLarge' } | { __typename: 'InputValidationError' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedFileStructureSuccess', parent_id: string } | null };

export type FinalizeUploadedTaskSpreadsheetMutationVariables = Exact<{
  input: FinalizeUploadedTaskSpreadsheetInput;
}>;


export type FinalizeUploadedTaskSpreadsheetMutation = { __typename?: 'mutation_root', finalizeUploadedTaskSpreadsheet?: { __typename: 'FinalizeUploadedTaskSpreadsheetErrors', errors: Array<{ __typename: 'FileTooLarge' } | { __typename: 'InputValidationError' } | { __typename: 'InvalidContentType' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedTaskSpreadsheetSuccess', project_id: string } | null };

export type FinalizeUploadedProjectSpreadsheetMutationVariables = Exact<{
  input: FinalizeUploadedProjectSpreadsheetInput;
}>;


export type FinalizeUploadedProjectSpreadsheetMutation = { __typename?: 'mutation_root', finalizeUploadedProjectSpreadsheet?: { __typename: 'FinalizeUploadedProjectSpreadsheetErrors', errors: Array<{ __typename: 'FileTooLarge' } | { __typename: 'InputValidationError' } | { __typename: 'InvalidContentType' } | { __typename: 'KeyDoesNotExists' } | { __typename: 'MissingMetadata' } | { __typename: 'NotAuthorOfTheUpload' }> } | { __typename: 'FinalizeUploadedProjectSpreadsheetSuccess', org_id: string } | null };

export type FinalizeFileVersionAnnotationsForUploadMutationVariables = Exact<{ [key: string]: never; }>;


export type FinalizeFileVersionAnnotationsForUploadMutation = { __typename: 'mutation_root' };

export type UserActiveOrgRole_DataFragment = { __typename?: 'orgs_to_users', role: { __typename?: 'org_roles', name: string } } & { ' $fragmentName'?: 'UserActiveOrgRole_DataFragment' };

export type UserActiveOrg_DataFragment = { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', id: string, name: string, background?: string | null, address?: { __typename?: 'org_address', lat?: number | null, lng?: number | null } | null, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null, project?: { __typename?: 'projects', id: string } | null } } & { ' $fragmentName'?: 'UserActiveOrg_DataFragment' };

export type UserProvider_UserQueryVariables = Exact<{
  auth0_id: Scalars['String']['input'];
}>;


export type UserProvider_UserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, full_name?: string | null, language: string, stream_user_id: string, auth0_id: string, is_locked: boolean, country_code?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null, phone?: string | null } | null, teams: Array<(
      { __typename?: 'teams_to_users' }
      & { ' $fragmentRefs'?: { 'UserTeams_DataFragment': UserTeams_DataFragment } }
    )>, algolia_key?: { __typename?: 'GetAlgoliaUserApiKeySuccess', key: string } | null, active_org?: (
      { __typename?: 'orgs_to_users' }
      & { ' $fragmentRefs'?: { 'UserActiveOrgRole_DataFragment': UserActiveOrgRole_DataFragment;'UserActiveOrg_DataFragment': UserActiveOrg_DataFragment } }
    ) | null, stream_chat_token?: { __typename?: 'GetStreamChatUserTokenSuccess', token: string } | null }> };

export type UserTeams_DataFragment = { __typename?: 'teams_to_users', id: string, team_id: string, team: { __typename?: 'teams', project_id: string } } & { ' $fragmentName'?: 'UserTeams_DataFragment' };

export type UserNotification_BadgeNotificationFragment = { __typename?: 'user_notifications', id: string, is_strong: boolean, type: string, payload: any } & { ' $fragmentName'?: 'UserNotification_BadgeNotificationFragment' };

export type UserNotification_NotificationFragment = (
  { __typename?: 'user_notifications', created_at: string, creator_id: string, event_id?: string | null, read_at?: string | null, updated_at: string, id: string }
  & { ' $fragmentRefs'?: { 'UserNotification_BadgeNotificationFragment': UserNotification_BadgeNotificationFragment } }
) & { ' $fragmentName'?: 'UserNotification_NotificationFragment' };

export type UserNotifcationsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UserNotifcationsQuery = { __typename?: 'query_root', unreadNotifications: Array<(
    { __typename?: 'user_notifications' }
    & { ' $fragmentRefs'?: { 'UserNotification_NotificationFragment': UserNotification_NotificationFragment } }
  )> };

export type ReadNotificationsMutationVariables = Exact<{
  notificationIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ReadNotificationsMutation = { __typename?: 'mutation_root', readNotifications?: { __typename: 'ReadNotificationsErrors' } | { __typename: 'ReadNotificationsSuccess' } | null };

export type UnreadNotificationsMutationVariables = Exact<{
  notificationIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnreadNotificationsMutation = { __typename?: 'mutation_root', unreadNotifications?: { __typename: 'UnreadNotificationsErrors' } | { __typename: 'UnreadNotificationsSuccess' } | null };

export type WorkerStatus_StatusFragment = { __typename?: 'events_workers_status', id: string, created_at: string, updated_at: string, creator_id: string, event_id: string, payload: any, type: string, status: string } & { ' $fragmentName'?: 'WorkerStatus_StatusFragment' };

export type WorkerStatusQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type WorkerStatusQuery = { __typename?: 'query_root', workerStatus: Array<(
    { __typename?: 'events_workers_status' }
    & { ' $fragmentRefs'?: { 'WorkerStatus_StatusFragment': WorkerStatus_StatusFragment } }
  )> };

export type GetCapawesomeChannelsQueryVariables = Exact<{
  app_id: Scalars['String']['input'];
}>;


export type GetCapawesomeChannelsQuery = { __typename?: 'query_root', getCapawesomeChannels?: Array<{ __typename?: 'CapawesomeChannel', id: string, name: string } | null> | null };

export type GetCapgoChannelsQueryVariables = Exact<{
  app_id: Scalars['String']['input'];
}>;


export type GetCapgoChannelsQuery = { __typename?: 'query_root', getCapgoChannels?: Array<{ __typename?: 'CapgoChannel', label: string, value: string } | null> | null };

export type GetProjectMembersQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetProjectMembersQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, stream_user_id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type AddMembersToProjectChannelMutationVariables = Exact<{
  input: AddMembersToProjectChannelInput;
}>;


export type AddMembersToProjectChannelMutation = { __typename?: 'mutation_root', addMembersToProjectChannel?: { __typename: 'AddMembersToProjectChannelErrors' } | { __typename: 'AddMembersToProjectChannelSuccess', channel_id: string } | null };

export type RemoveMembersFromProjectChannelMutationVariables = Exact<{
  input: RemoveMembersFromProjectChannelInput;
}>;


export type RemoveMembersFromProjectChannelMutation = { __typename?: 'mutation_root', removeMembersFromProjectChannel?: { __typename: 'RemoveMembersFromProjectChannelErrors', errors: Array<{ __typename: 'ChannelDoesNotExist' } | { __typename: 'InputValidationError' } | { __typename: 'NotMemberOfThisChannel' } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' } | { __typename: 'UserNotModeratorOfThisChannel' }> } | { __typename: 'RemoveMembersFromProjectChannelSuccess', channel_id: string, project_id: string } | null };

export type RenameChannelForProjectMutationVariables = Exact<{
  input: RenameChannelForProjectInput;
}>;


export type RenameChannelForProjectMutation = { __typename?: 'mutation_root', renameChannelForProject?: { __typename: 'RenameChannelForProjectErrors' } | { __typename: 'RenameChannelForProjectSuccess', channel_id: string } | null };

export type CreateChannelForProjectMutationVariables = Exact<{
  input: CreateChannelForProjectInput;
}>;


export type CreateChannelForProjectMutation = { __typename?: 'mutation_root', createChannelForProject?: { __typename: 'CreateChannelForProjectErrors' } | { __typename: 'CreateChannelForProjectSuccess', channel_id: string } | null };

export type CreateProjectDirectMessageMutationVariables = Exact<{
  input: CreateProjectDirectMessageInput;
}>;


export type CreateProjectDirectMessageMutation = { __typename?: 'mutation_root', createProjectDirectMessage?: { __typename: 'CreateProjectDirectMessageErrors', errors: Array<{ __typename: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' } | { __typename: 'UserDoesNotExist', message: string, type: string }> } | { __typename: 'CreateProjectDirectMessageSuccess', channel_id: string } | null };

export type PrepareChannelAssetForUploadMutationVariables = Exact<{
  input: PrepareChannelAssetForUploadInput;
}>;


export type PrepareChannelAssetForUploadMutation = { __typename?: 'mutation_root', prepareChannelAssetForUpload?: { __typename: 'PrepareChannelAssetForUploadErrors', errors: Array<{ __typename: 'ChannelDoesNotExist' } | { __typename: 'InputValidationError' } | { __typename: 'NotMemberOfThisChannel' }> } | { __typename: 'PrepareChannelAssetForUploadSuccess', key: string, url: string } | null };

export type CreateDemoProjectForm_DataFragment = { __typename?: 'project_templates_overview', id?: string | null, type?: string | null } & { ' $fragmentName'?: 'CreateDemoProjectForm_DataFragment' };

export type CreateDemoProjectFormQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type CreateDemoProjectFormQuery = { __typename?: 'query_root', templates: Array<(
    { __typename?: 'project_templates_overview' }
    & { ' $fragmentRefs'?: { 'CreateDemoProjectForm_DataFragment': CreateDemoProjectForm_DataFragment } }
  )> };

export type CopyProjectMutationVariables = Exact<{
  input: CopyProjectInput;
}>;


export type CopyProjectMutation = { __typename?: 'mutation_root', copyProject?: { __typename: 'CopyProjectErrors' } | { __typename: 'CopyProjectSuccess', project_id: string } | null };

export type CreateOrgMutationVariables = Exact<{
  input: CreateOrgInput;
}>;


export type CreateOrgMutation = { __typename?: 'mutation_root', createOrg?: { __typename: 'CreateOrgErrors' } | { __typename: 'CreateOrgSuccess', org_id: string } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'mutation_root', createProject?: { __typename: 'CreateProjectErrors' } | { __typename: 'CreateProjectSuccess', project_id: string } | null };

export type TaskFileVersionFragment = { __typename?: 'tasks_file_versions', location?: { __typename?: 'task_file_version_location', page_number: number } | null, task: { __typename?: 'tasks', id: string, number: number, description: string, is_validated_by?: string | null, start_date?: string | null, end_date?: string | null, created_at: string, deleted: boolean, deleted_at?: string | null, subtasks_progress?: number | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }>, assignations?: { __typename?: 'task_assignations', teams: Array<{ __typename?: 'task_assignations_teams', created_at: string, team_id: string, team: { __typename?: 'teams', name: string, color: string } }>, users: Array<{ __typename?: 'task_assignations_users', created_at: string, user_id: string, user: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }>, orgs: Array<{ __typename?: 'task_assignations_orgs', created_at: string, org_id: string, org: { __typename?: 'orgs', name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } }> } | null, attachments: Array<{ __typename?: 'task_attachments', id: string, name: string, url?: string | null, content_type?: string | null }>, ancestors: Array<{ __typename?: 'task_dependencies', from_id: string, from_side: string, to_id: string, to_side: string }>, predecessors: Array<{ __typename?: 'task_dependencies', from_id: string, from_side: string, to_id: string, to_side: string }>, permissions?: { __typename?: 'task_permissions', orgs: Array<{ __typename?: 'task_permissions_orgs', org_id: string, org: { __typename?: 'orgs', name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } }>, teams: Array<{ __typename?: 'task_permissions_teams', team_id: string, team: { __typename?: 'teams', color: string, name: string } }>, users: Array<{ __typename?: 'task_permissions_users', user_id: string, user?: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }> } | null, project: { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null } } } & { ' $fragmentName'?: 'TaskFileVersionFragment' };

export type FileVersionsFragment = { __typename?: 'file_versions', id: string, tasks: Array<(
    { __typename?: 'tasks_file_versions' }
    & { ' $fragmentRefs'?: { 'TaskFileVersionFragment': TaskFileVersionFragment } }
  )> } & { ' $fragmentName'?: 'FileVersionsFragment' };

export type FileTasksDrawerContent_DataQueryVariables = Exact<{
  fileId: Scalars['uuid']['input'];
  tasksFilter?: InputMaybe<Tasks_Bool_Exp>;
}>;


export type FileTasksDrawerContent_DataQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', id: string, versions: Array<(
      { __typename?: 'file_versions' }
      & { ' $fragmentRefs'?: { 'FileVersionsFragment': FileVersionsFragment } }
    )> } | null };

export type UpdateTaskFileVersionsMutationVariables = Exact<{
  input: UpdateTaskFileVersionsInput;
}>;


export type UpdateTaskFileVersionsMutation = { __typename?: 'mutation_root', updateTaskFileVersions?: { __typename: 'UpdateTaskFileVersionsErrors' } | { __typename: 'UpdateTaskFileVersionsSuccess', task_id: string } | null };

export type FileViewer_FileVersionFragment = { __typename?: 'file_versions', id: string, number: number, url?: string | null, original_url?: string | null, current_extension?: string | null, created_at: string, updated_at: string, is_annotated: boolean, creator: { __typename?: 'users', id: string, full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string, id: string } } | null }, approvals_overview?: { __typename?: 'file_versions_approvals_overview', is_approved_with_comments?: boolean | null, is_approved_without_comments?: boolean | null, is_denied?: boolean | null } | null, approvals: Array<{ __typename?: 'file_approvals', status: File_Approvals_Status_Enum_Enum, user_id: string, created_at: string }>, views: Array<{ __typename?: 'file_views', user_id: string, created_at: string }>, tasks: Array<{ __typename?: 'tasks_file_versions', task: { __typename?: 'tasks', is_validated_by?: string | null } }> } & { ' $fragmentName'?: 'FileViewer_FileVersionFragment' };

export type FileViewer_FileFragment = { __typename?: 'files', id: string, name: string, is_approved_on_a_version?: boolean | null, is_approval_mode: boolean, url?: string | null, parent_id: string, due_date?: string | null, versions: Array<{ __typename?: 'file_versions', id: string, name: string, tasks: Array<{ __typename?: 'tasks_file_versions', location?: { __typename?: 'task_file_version_location', x: number, y: number, page_number: number, pdf_location: boolean } | null, task: { __typename?: 'tasks', number: number, is_validated_by?: string | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', color: string } }> } }>, autodesk?: { __typename?: 'file_version_autodesk', urn?: string | null, conversion_progress?: string | null } | null }>, project: { __typename?: 'projects', id: string }, folder: { __typename?: 'folders', id: string, parents_ids?: any | null }, assignation?: { __typename?: 'file_assignations', users: Array<{ __typename?: 'file_assignations_users', created_at: string, user: { __typename?: 'users', id: string, full_name?: string | null } }> } | null, last_version?: Array<(
    { __typename?: 'file_versions', number: number, id: string, updated_at: string, url?: string | null, original_url?: string | null, approvals_overview?: { __typename?: 'file_versions_approvals_overview', is_approved_with_comments?: boolean | null, is_approved_without_comments?: boolean | null, is_denied?: boolean | null } | null, approval_requests?: { __typename?: 'file_version_approval_requests', users: Array<{ __typename?: 'file_version_approval_request_users', id: string }> } | null, approvals: Array<{ __typename?: 'file_approvals', user_id: string, status: File_Approvals_Status_Enum_Enum, created_at: string, user: { __typename?: 'users', full_name?: string | null }, comments: Array<{ __typename?: 'file_comments', content: string }> }>, views: Array<{ __typename?: 'file_views', user_id: string, created_at: string }>, autodesk?: { __typename?: 'file_version_autodesk', urn?: string | null, conversion_progress?: string | null } | null }
    & { ' $fragmentRefs'?: { 'FileViewer_FileVersionFragment': FileViewer_FileVersionFragment } }
  )> | null, labels: Array<{ __typename?: 'files_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }> } & { ' $fragmentName'?: 'FileViewer_FileFragment' };

export type FileViewer_DataQueryVariables = Exact<{
  fileId: Scalars['uuid']['input'];
  fileVersionId: Scalars['uuid']['input'];
}>;


export type FileViewer_DataQuery = { __typename?: 'query_root', files_by_pk?: (
    { __typename?: 'files', version?: Array<(
      { __typename?: 'file_versions' }
      & { ' $fragmentRefs'?: { 'FileViewer_FileVersionFragment': FileViewer_FileVersionFragment } }
    )> | null }
    & { ' $fragmentRefs'?: { 'FileViewer_FileFragment': FileViewer_FileFragment } }
  ) | null };

export type AddUserViewToFileVersionMutationVariables = Exact<{
  input: AddUserViewToFileVersionInput;
}>;


export type AddUserViewToFileVersionMutation = { __typename?: 'mutation_root', addUserViewToFileVersion?: { __typename: 'AddUserViewToFileVersionErrors' } | { __typename: 'AddUserViewToFileVersionSuccess' } | null };

export type PrepareFileForAutodeskViewerMutationVariables = Exact<{
  input: PrepareFileForAutodeskViewerInput;
}>;


export type PrepareFileForAutodeskViewerMutation = { __typename?: 'mutation_root', prepareFileForAutodeskViewer?: { __typename: 'PrepareFileForAutodeskViewerErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'PrepareFileForAutodeskViewerSuccess' } | null };

export type ConvertFileMutationVariables = Exact<{
  input: ConvertFileInput;
}>;


export type ConvertFileMutation = { __typename?: 'mutation_root', convertFile?: { __typename: 'ConvertFileErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileDoesNotExists' } | { __typename: 'FileFormatNotSupported' } | { __typename: 'FileVersionDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'ConvertFileSuccess', url: string, key: string } | null };

export type PrepareFileVersionAnnotationForUploadMutationVariables = Exact<{
  input: PrepareFileVersionAnnotationForUploadInput;
}>;


export type PrepareFileVersionAnnotationForUploadMutation = { __typename?: 'mutation_root', prepareFileVersionAnnotationForUpload?: { __typename: 'PrepareFileVersionAnnotationForUploadErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileVersionDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'PrepareFileVersionAnnotationForUploadSuccess', key: string, url: string } | null };

export type GetAutodeskTokenQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetAutodeskTokenQuery = { __typename?: 'query_root', getAutodeskToken?: { __typename?: 'getAutodeskToken', autodesk_access_token: string } | null };

export type ApprovalMode_DataQueryVariables = Exact<{
  fileVersionId: Scalars['uuid']['input'];
}>;


export type ApprovalMode_DataQuery = { __typename?: 'query_root', file_versions_by_pk?: { __typename?: 'file_versions', id: string, updated_at: string, user_approvals?: Array<{ __typename?: 'file_approvals', user_id: string }> | null, file: { __typename?: 'files', is_approval_mode: boolean, assignation?: { __typename?: 'file_assignations', users: Array<{ __typename?: 'file_assignations_users', user_id: string }> } | null } } | null };

export type AddUserApprovalToFileVersionMutationVariables = Exact<{
  input: AddUserApprovalToFileVersionInput;
}>;


export type AddUserApprovalToFileVersionMutation = { __typename?: 'mutation_root', addUserApprovalToFileVersion?: { __typename: 'AddUserApprovalToFileVersionErrors' } | { __typename: 'AddUserApprovalToFileVersionSuccess', file_approval_id: string } | null };

export type PrepareFileApprovalsAttachmentForUploadMutationVariables = Exact<{
  input: PrepareFileApprovalsAttachmentForUploadInput;
}>;


export type PrepareFileApprovalsAttachmentForUploadMutation = { __typename?: 'mutation_root', prepareFileApprovalsAttachmentForUpload?: { __typename: 'PrepareFileApprovalsAttachmentForUploadErrors' } | { __typename: 'PrepareFileApprovalsAttachmentForUploadSuccess', key: string, url: string } | null };

export type AddFileApprovalsFileVersionsMutationVariables = Exact<{
  input: AddFileApprovalsFileVersionsInput;
}>;


export type AddFileApprovalsFileVersionsMutation = { __typename?: 'mutation_root', addFileApprovalsFileVersions?: { __typename?: 'AddFileApprovalsFileVersionsErrors' } | { __typename?: 'AddFileApprovalsFileVersionsSuccess', saved: boolean } | null };

export type FinalizeUploadedFileApprovalsAttachmentMutationVariables = Exact<{
  input: FinalizeUploadedFileApprovalsAttachmentInput;
}>;


export type FinalizeUploadedFileApprovalsAttachmentMutation = { __typename?: 'mutation_root', finalizeUploadedFileApprovalsAttachment?: { __typename?: 'FinalizeUploadedFileApprovalsAttachmentErrors' } | { __typename?: 'FinalizeUploadedFileApprovalsAttachmentSuccess', file_approval_attachment_id: string } | null };

export type AddUserMultiApprovalToFilesVersionMutationVariables = Exact<{
  input: AddUserMultiApprovalToFilesVersionInput;
}>;


export type AddUserMultiApprovalToFilesVersionMutation = { __typename?: 'mutation_root', addUserMultiApprovalToFilesVersion?: { __typename: 'AddMultiUserApprovalToFileVersionSuccess', file_ids: Array<{ __typename?: 'FileMultipleApprovalIds', file_approval_id: string, file_version_id: string }> } | { __typename: 'AddUserMultiApprovalToFilesVersionErrors' } | null };

export type AnnotateFileMutationVariables = Exact<{
  input: AnnotateFileInput;
}>;


export type AnnotateFileMutation = { __typename?: 'mutation_root', annotateFile?: { __typename: 'AnnotateFileErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileFormatNotSupported' } | { __typename: 'FileVersionDoesNotExists' }> } | { __typename: 'AnnotateFileSuccess', file_version_id: string } | null };

export type SignFileMutationVariables = Exact<{
  input: SignFileInput;
}>;


export type SignFileMutation = { __typename?: 'mutation_root', signFile?: { __typename: 'SignFileErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileFormatNotSupported' } | { __typename: 'FileVersionDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'SignFileSuccess', file_version_id: string } | null };

export type TasksAnnotations_DataQueryVariables = Exact<{
  fileId: Scalars['uuid']['input'];
  tasksFilter: Tasks_Bool_Exp;
}>;


export type TasksAnnotations_DataQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', id: string, name: string, versions: Array<(
      { __typename?: 'file_versions' }
      & { ' $fragmentRefs'?: { 'TaskAnnotations_FileVersionsFragment': TaskAnnotations_FileVersionsFragment } }
    )> } | null };

export type TaskAnnotations_FileVersionsFragment = { __typename?: 'file_versions', id: string, tasks: Array<{ __typename?: 'tasks_file_versions', location?: { __typename?: 'task_file_version_location', x: number, y: number, page_number: number, pdf_location: boolean } | null, task: { __typename?: 'tasks', id: string, number: number, is_validated_by?: string | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', color: string } }> } }> } & { ' $fragmentName'?: 'TaskAnnotations_FileVersionsFragment' };

export type FileViewersDetailsDrawerContent_DataQueryVariables = Exact<{
  fileVersionId: Scalars['uuid']['input'];
}>;


export type FileViewersDetailsDrawerContent_DataQuery = { __typename?: 'query_root', file_versions_by_pk?: { __typename?: 'file_versions', id: string, views: Array<{ __typename?: 'file_views', created_at: string, updated_at: string, user: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type FilterList_DataQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  orgId?: InputMaybe<Scalars['uuid']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  type: Scalars['String']['input'];
}>;


export type FilterList_DataQuery = { __typename?: 'query_root', filters: Array<{ __typename?: 'filters', visibility_user_id?: string | null, visibility_team_id?: string | null, visibility_project_id?: string | null, visibility_org_id?: string | null, type: string, name: string, id: string, creator_id: string, created_at: string, content: string, color: string, filterDefault: Array<{ __typename?: 'filter_user_default', id: string, filter_id?: string | null, user_id: string }> }> };

export type GetUserAuthenticatedLinkQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  redirect?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserAuthenticatedLinkQuery = { __typename?: 'query_root', link?: string | null };

export type LabelsMultiSelect_ProjectFragment = { __typename?: 'project_labels', id: string, name: string, color: string } & { ' $fragmentName'?: 'LabelsMultiSelect_ProjectFragment' };

export type GetLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLabelsQuery = { __typename?: 'query_root', project_labels: Array<(
    { __typename?: 'project_labels' }
    & { ' $fragmentRefs'?: { 'LabelsMultiSelect_ProjectFragment': LabelsMultiSelect_ProjectFragment } }
  )> };

export type GetProjectLabelsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectLabelsQuery = { __typename?: 'query_root', project_labels: Array<(
    { __typename?: 'project_labels' }
    & { ' $fragmentRefs'?: { 'LabelsMultiSelect_ProjectFragment': LabelsMultiSelect_ProjectFragment } }
  )> };

export type CreateProjectLabelMutationVariables = Exact<{
  input: CreateProjectLabelInput;
}>;


export type CreateProjectLabelMutation = { __typename?: 'mutation_root', createProjectLabel?: { __typename: 'CreateProjectLabelErrors' } | { __typename: 'CreateProjectLabelSuccess', project_label_id: string } | null };

export type CreateMultipartUploadMutationVariables = Exact<{
  input: CreateMultipartUploadInput;
}>;


export type CreateMultipartUploadMutation = { __typename?: 'mutation_root', createMultipartUpload?: { __typename: 'CreateMultipartUploadErrors', errors: Array<{ __typename?: 'FolderAccessDenied', type: string } | { __typename?: 'FolderDoesNotExists', type: string } | { __typename?: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> }> } | { __typename: 'CreateMultipartUploadSuccess', key: string, uploadId: string } | null };

export type ListMultipartUploadMutationVariables = Exact<{
  input: ListMultipartUploadInput;
}>;


export type ListMultipartUploadMutation = { __typename?: 'mutation_root', listMultipartUpload?: { __typename: 'ListMultipartUploadErrors', errors: Array<{ __typename?: 'FolderAccessDenied', type: string } | { __typename?: 'FolderDoesNotExists', type: string } | { __typename?: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> }> } | { __typename: 'ListMultipartUploadSuccess', parts: Array<{ __typename?: 'awsS3Part', partNumber: number, size: number, etag: string }> } | null };

export type PrepareMultipartUploadMutationVariables = Exact<{
  input: PrepareMultipartUploadInput;
}>;


export type PrepareMultipartUploadMutation = { __typename?: 'mutation_root', prepareMultipartUpload?: { __typename: 'PrepareMultipartUploadErrors', errors: Array<{ __typename?: 'FolderAccessDenied', type: string } | { __typename?: 'FolderDoesNotExists', type: string } | { __typename?: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> }> } | { __typename: 'PrepareMultipartUploadSuccess', key: string, uploadId: string, presignedUrls: any } | null };

export type CompleteMultipartUploadMutationVariables = Exact<{
  input: CompleteMultipartUploadInput;
}>;


export type CompleteMultipartUploadMutation = { __typename?: 'mutation_root', completeMultipartUpload?: { __typename: 'CompleteMultipartUploadErrors', errors: Array<{ __typename?: 'FolderAccessDenied', type: string } | { __typename?: 'FolderDoesNotExists', type: string } | { __typename?: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> }> } | { __typename: 'CompleteMultipartUploadSuccess', location: string } | null };

export type AbortMultipartUploadMutationVariables = Exact<{
  input: AbortMultipartUploadInput;
}>;


export type AbortMultipartUploadMutation = { __typename?: 'mutation_root', abortMultipartUpload?: { __typename: 'AbortMultipartUploadErrors', errors: Array<{ __typename?: 'FolderAccessDenied' } | { __typename?: 'FolderDoesNotExists' } | { __typename?: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> }> } | { __typename: 'AbortMultipartUploadSuccess', isAborted: boolean } | null };

export type OriginalInviterFragment = { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null } & { ' $fragmentName'?: 'OriginalInviterFragment' };

export type NavigationDrawer_UserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type NavigationDrawer_UserQuery = { __typename?: 'query_root', user?: { __typename?: 'users', id: string, first_name: string, last_name: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null } | null, active_org?: (
      { __typename?: 'orgs_to_users' }
      & { ' $fragmentRefs'?: { 'UserActiveOrg_DataFragment': UserActiveOrg_DataFragment } }
    ) | null, projects: Array<{ __typename?: 'projects_to_users', project: { __typename?: 'projects', id: string, name: string, is_demo: boolean, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, labels: Array<{ __typename?: 'project_labels', id: string, color: string, name: string }>, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, is_project_template: boolean, is_archived: boolean, project_groups: Array<{ __typename?: 'org_project_summary_to_project_groups', project_group: { __typename?: 'project_groups', color: string, name: string, project_group_avatar?: { __typename?: 'project_group_avatars', public_url: string } | null } }>, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', id: string, project_category: { __typename?: 'project_categories', color: string, name: string, id: string } }> }> | null } }>, originalInviter: Array<{ __typename?: 'projects_to_users', inviter?: (
        { __typename?: 'users' }
        & { ' $fragmentRefs'?: { 'OriginalInviterFragment': OriginalInviterFragment } }
      ) | null }> } | null };

export type NavigationDrawer_OrgQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type NavigationDrawer_OrgQuery = { __typename?: 'query_root', org?: { __typename?: 'orgs', id: string, project_groups: Array<{ __typename?: 'project_groups', color: string, name: string, project_group_avatar?: { __typename?: 'project_group_avatars', public_url: string } | null }>, settings?: { __typename?: 'org_settings', show_menu_by_group: boolean } | null } | null };

export type GetPwdOfFilesAndFoldersQueryVariables = Exact<{
  files_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  folders_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPwdOfFilesAndFoldersQuery = { __typename?: 'query_root', files: Array<{ __typename?: 'files', id: string, folder: { __typename?: 'folders', id: string, parents_ids?: any | null } }>, folders: Array<{ __typename?: 'folders', id: string, parents_ids?: any | null }> };

export type GetValuedProjectUsersQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  project_id: Scalars['uuid']['input'];
}>;


export type GetValuedProjectUsersQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null }, inviter?: { __typename?: 'users', id: string, full_name?: string | null } | null, role: { __typename?: 'project_roles', name: string } }> } | null };

export type ProjectInfoContainer_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectInfoContainer_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, description?: string | null, name: string, background?: string | null, banner?: string | null, created_at: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, client_email?: string | null, client_fullname?: string | null, client_phone_number?: string | null, start_date?: string | null, end_date?: string | null, reference?: string | null }> | null, address?: { __typename?: 'project_address', city?: string | null, country?: string | null, created_at: string, postal_code?: string | null, street?: string | null, lat?: number | null, lng?: number | null } | null, org: Array<{ __typename?: 'orgs', id: string }> } | null };

export type ProjectProfileContainer_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectProfileContainer_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', description?: string | null, id: string, name: string, address?: { __typename?: 'project_address', postal_code?: string | null, city?: string | null, country?: string | null, street?: string | null } | null, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string } }>, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, is_archived: boolean, reference?: string | null, start_date?: string | null, end_date?: string | null }> | null } | null };

export type ProjectsMultiSelect_ProjectFragment = { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, org_project_summaries: Array<{ __typename?: 'org_project_summary', id: string, is_project_template: boolean }> } & { ' $fragmentName'?: 'ProjectsMultiSelect_ProjectFragment' };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'query_root', projects: Array<(
    { __typename?: 'projects' }
    & { ' $fragmentRefs'?: { 'ProjectsMultiSelect_ProjectFragment': ProjectsMultiSelect_ProjectFragment } }
  )> };

export type GetOrgProjectTemplatesQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetOrgProjectTemplatesQuery = { __typename?: 'query_root', getOrgProjectTemplates?: { __typename?: 'GetOrgProejectTemplate', templates?: Array<{ __typename?: 'OrgProjectTemplate', avatar?: string | null, description?: string | null, id: string, name: string }> | null } | null };

export type QueryExample_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryExample_QueryQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', name: string, description?: string | null }> };

export type UpdateTasksSchedulerDatesMutationVariables = Exact<{
  input: UpdateTasksDatesInput;
}>;


export type UpdateTasksSchedulerDatesMutation = { __typename?: 'mutation_root', updateTasksDates?: { __typename: 'UpdateTasksDatesErrors' } | { __typename: 'UpdateTasksDatesSuccess' } | null };

export type UpdateTasksSchedulerAssignationsMutationVariables = Exact<{
  input: UpdateTasksAssignationsInput;
}>;


export type UpdateTasksSchedulerAssignationsMutation = { __typename?: 'mutation_root', updateTasksAssignations?: { __typename: 'UpdateTasksAssignationsErrors' } | { __typename: 'UpdateTasksAssignationsSuccess' } | null };

export type CopyTaskAttachmentsUploadMutationVariables = Exact<{
  input: CopyTaskAttachmentsUploadInput;
}>;


export type CopyTaskAttachmentsUploadMutation = { __typename?: 'mutation_root', copyTaskAttachmentsUpload?: { __typename: 'CopyTaskAttachmentsUploadErrors' } | { __typename: 'copyTaskAttachmentsUploadSuccess', success: boolean } | null };

export type PrepareTaskAttachmentMultipartUploadMutationVariables = Exact<{
  input: PrepareTaskAttachmentMultipartUploadInput;
}>;


export type PrepareTaskAttachmentMultipartUploadMutation = { __typename?: 'mutation_root', prepareTaskAttachmentMultipartUpload?: { __typename: 'PrepareTaskAttachmentMultipartUploadErrors', errors: Array<{ __typename: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> } | { __typename: 'TaskAccessDenied', type: string } | { __typename: 'TaskDoesNotExist', type: string }> } | { __typename: 'PrepareTaskAttachmentMultipartUploadSuccess', key: string, uploadId: string, presignedUrls: any } | null };

export type CreateTaskAttachmentMultipartUploadMutationVariables = Exact<{
  input: CreateTaskAttachmentMultipartUploadInput;
}>;


export type CreateTaskAttachmentMultipartUploadMutation = { __typename?: 'mutation_root', createTaskAttachmentMultipartUpload?: { __typename: 'CreateTaskAttachmentMultipartUploadErrors', errors: Array<{ __typename: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> } | { __typename: 'TaskAccessDenied', type: string, message: string } | { __typename: 'TaskDoesNotExist', type: string, message: string }> } | { __typename: 'CreateTaskAttachmentMultipartUploadSuccess', key: string, uploadId: string } | null };

export type ListTaskAttachmentMultipartUploadMutationVariables = Exact<{
  input: ListTaskAttachmentMultipartUploadInput;
}>;


export type ListTaskAttachmentMultipartUploadMutation = { __typename?: 'mutation_root', listTaskAttachmentMultipartUpload?: { __typename: 'ListTaskAttachmentMultipartUploadErrors', errors: Array<{ __typename: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> } | { __typename: 'TaskAccessDenied', type: string, message: string } | { __typename: 'TaskDoesNotExist', type: string, message: string }> } | { __typename: 'ListTaskAttachmentMultipartUploadSuccess', parts: Array<{ __typename?: 'awsS3PartTaskAttachment', partNumber: number, size: number, etag: string }> } | null };

export type CompleteTaskAttachmentMultipartUploadMutationVariables = Exact<{
  input: CompleteTaskAttachmentMultipartUploadInput;
}>;


export type CompleteTaskAttachmentMultipartUploadMutation = { __typename?: 'mutation_root', completeTaskAttachmentMultipartUpload?: { __typename: 'CompleteTaskAttachmentMultipartUploadErrors', errors: Array<{ __typename: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> } | { __typename: 'TaskAccessDenied', type: string, message: string } | { __typename: 'TaskDoesNotExist', type: string, message: string }> } | { __typename: 'CompleteTaskAttachmentMultipartUploadSuccess', location: string } | null };

export type AbortTaskAttachmentMultipartUploadMutationVariables = Exact<{
  input: AbortTaskAttachmentMultipartUploadInput;
}>;


export type AbortTaskAttachmentMultipartUploadMutation = { __typename?: 'mutation_root', abortTaskAttachmentMultipartUpload?: { __typename: 'AbortTaskAttachmentMultipartUploadErrors', errors: Array<{ __typename: 'InputValidationError', fieldErrors: any, formErrors: Array<string | null> } | { __typename: 'TaskAccessDenied', type: string, message: string } | { __typename: 'TaskDoesNotExist', type: string, message: string }> } | { __typename: 'AbortTaskAttachmentMultipartUploadSuccess', isAborted: boolean } | null };

export type UpdateUserAppMetadataInfosMutationVariables = Exact<{
  appMobile?: InputMaybe<Scalars['Boolean']['input']>;
  appDesktop?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserAppMetadataInfosMutation = { __typename?: 'mutation_root', updateUserAppMetadata?: { __typename: 'UpdateUserAppMetadataErrors' } | { __typename: 'UpdateUserAppMetadataSuccess', user_id: string } | null };

export type UpdateBrowserTimezoneMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type UpdateBrowserTimezoneMutation = { __typename?: 'mutation_root', updateBrowserTimezone?: { __typename: 'UpdateBrowserTimezoneErrors' } | { __typename: 'UpdateBrowserTimezoneSuccess', user_id: string } | null };

export type UpdateBrowserLanguageMutationVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type UpdateBrowserLanguageMutation = { __typename?: 'mutation_root', updateBrowserLanguage?: { __typename: 'UpdateBrowserLanguageErrors' } | { __typename: 'UpdateBrowserLanguageSuccess', user_id: string } | null };

export type GetUserEmailSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEmailSuggestionsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, full_name?: string | null, first_name: string, last_name: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, metadatas?: { __typename?: 'user_metadatas', placeholder_company_name?: string | null } | null, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null, phone?: string | null } | null, active_org?: { __typename?: 'orgs_to_users', org_id: string, org: { __typename?: 'orgs', org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null, projects: Array<{ __typename?: 'projects_to_users', project: { __typename?: 'projects', id: string } }> }> };

export type GetOrgsNamesQueryVariables = Exact<{
  orgs_id?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetOrgsNamesQuery = { __typename?: 'query_root', orgs: Array<{ __typename?: 'orgs', name: string, id: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null }> };

export type UserFragment = { __typename?: 'users', id: string, full_name?: string | null, is_connected: boolean, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string, id: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null, phone?: string | null } | null, metadatas?: { __typename?: 'user_metadatas', placeholder_company_name?: string | null } | null, connections: Array<{ __typename?: 'user_connections', created_at: string }> } & { ' $fragmentName'?: 'UserFragment' };

export type UserProfileContainer_DataQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UserProfileContainer_DataQuery = { __typename?: 'query_root', users_by_pk?: (
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'UserFragment': UserFragment } }
  ) | null };

export type UserProjectInfo_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type UserProjectInfo_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, name: string, members: Array<{ __typename?: 'projects_to_users', created_at: string, role: { __typename?: 'project_roles', name: string }, user: (
        { __typename?: 'users', first_name: string, last_name: string, is_active: boolean, teams: Array<{ __typename?: 'teams_to_users', team_id: string, team: { __typename?: 'teams', name: string, color: string } }>, metadatas?: { __typename?: 'user_metadatas', placeholder_company_name?: string | null } | null }
        & { ' $fragmentRefs'?: { 'UserFragment': UserFragment } }
      ), inviter?: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }> } | null };

export type VisasApprovalsContainer_DataQueryVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type VisasApprovalsContainer_DataQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', id: string, name: string, versions: Array<{ __typename?: 'file_versions', id: string, approvals: Array<{ __typename?: 'file_approvals', id: string, status: File_Approvals_Status_Enum_Enum, created_at: string, user: { __typename?: 'users', id: string, full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, comments: Array<{ __typename?: 'file_comments', id: string, content: string }> }> }> } | null };

export type ProjectCategoryFilterFragment = { __typename?: 'project_categories', id: string, color: string, name: string } & { ' $fragmentName'?: 'ProjectCategoryFilterFragment' };

export type UserProjectInfoFilterFragment = { __typename?: 'projects', name: string, id: string, created_at: string, org_project_summary?: Array<{ __typename?: 'org_project_summary', is_archived: boolean, client_fullname?: string | null, end_date?: string | null, id: string, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: (
        { __typename?: 'project_categories' }
        & { ' $fragmentRefs'?: { 'ProjectCategoryFilterFragment': ProjectCategoryFilterFragment } }
      ) }> }> | null } & { ' $fragmentName'?: 'UserProjectInfoFilterFragment' };

export type OrgProjectInfoFilterFragment = { __typename?: 'projects_map_overview', name: string, id: string, created_at: string, org_project_summary?: Array<{ __typename?: 'org_project_summary', is_archived: boolean, client_fullname?: string | null, end_date?: string | null, id: string, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: (
        { __typename?: 'project_categories' }
        & { ' $fragmentRefs'?: { 'ProjectCategoryFilterFragment': ProjectCategoryFilterFragment } }
      ) }> }> | null } & { ' $fragmentName'?: 'OrgProjectInfoFilterFragment' };

export type UserProjectMembersFilterFragment = { __typename?: 'projects', members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } & { ' $fragmentName'?: 'UserProjectMembersFilterFragment' };

export type GetFilterProjectFormOptionsQueryVariables = Exact<{
  project_archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFilterProjectFormOptionsQuery = { __typename?: 'query_root', projects: Array<(
    { __typename?: 'projects' }
    & { ' $fragmentRefs'?: { 'UserProjectInfoFilterFragment': UserProjectInfoFilterFragment;'UserProjectMembersFilterFragment': UserProjectMembersFilterFragment } }
  )>, projects_map_overview: Array<(
    { __typename?: 'projects_map_overview' }
    & { ' $fragmentRefs'?: { 'OrgProjectInfoFilterFragment': OrgProjectInfoFilterFragment } }
  )> };

export type GetOrgMembersQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetOrgMembersQuery = { __typename?: 'query_root', orgs: Array<{ __typename?: 'orgs', id: string, members: Array<{ __typename?: 'orgs_to_users', user: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> }> };

export type UpdateProjectsCategoriesMutationVariables = Exact<{
  input: UpdateProjectsCategoriesInput;
}>;


export type UpdateProjectsCategoriesMutation = { __typename?: 'mutation_root', updateProjectsCategories?: { __typename: 'UpdateProjectsCategoriesErrors' } | { __typename: 'UpdateProjectsCategoriesSuccess', categories?: Array<string> | null } | null };

export type UpdateProjectsClientMutationVariables = Exact<{
  input: UpdateProjectsClientInput;
}>;


export type UpdateProjectsClientMutation = { __typename?: 'mutation_root', updateProjectsClient?: { __typename: 'UpdateProjectsClientErrors' } | { __typename: 'UpdateProjectsClientSuccess', client_email?: string | null, client_fullname: string, client_phone_number?: string | null } | null };

export type Tasks_DataFragment = { __typename?: 'tasks', id: string, number: number, description: string, end_date?: string | null, start_date?: string | null, project_id: string, assignations?: { __typename?: 'task_assignations', users: Array<{ __typename?: 'task_assignations_users', user_id: string, user: { __typename?: 'users', id: string, full_name?: string | null, first_name: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null, ancestors: Array<{ __typename?: 'task_dependencies', from_id: string, from_side: string, to_side: string, to_id: string }>, predecessors: Array<{ __typename?: 'task_dependencies', from_id: string, from_side: string, to_side: string, to_id: string }>, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', color: string, name: string } }>, project: { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null } } & { ' $fragmentName'?: 'Tasks_DataFragment' };

export type ProjectInvitationForm_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectInvitationForm_DataQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null } }>, org: Array<{ __typename?: 'orgs', id: string }> }> };

export type ProjectBasicInfoQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectBasicInfoQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', name: string, id: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null } | null };

export type TasksAssignationsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type TasksAssignationsQuery = { __typename?: 'query_root', task_assignations_orgs: Array<{ __typename?: 'task_assignations_orgs', id: string, task_assignee: { __typename?: 'task_assignations', task: (
        { __typename?: 'tasks' }
        & { ' $fragmentRefs'?: { 'Tasks_DataFragment': Tasks_DataFragment } }
      ) }, org: { __typename?: 'orgs', members: Array<{ __typename?: 'orgs_to_users', user: { __typename?: 'users', id: string } }> } }>, task_assignations_teams: Array<{ __typename?: 'task_assignations_teams', id: string, task_assignee: { __typename?: 'task_assignations', task: (
        { __typename?: 'tasks' }
        & { ' $fragmentRefs'?: { 'Tasks_DataFragment': Tasks_DataFragment } }
      ), teams: Array<{ __typename?: 'task_assignations_teams', team: { __typename?: 'teams', name: string, users: Array<{ __typename?: 'teams_to_users', user: { __typename?: 'users', id: string } }> } }> } }> };

export type CalendarTasksUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type CalendarTasksUserQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', full_name?: string | null, id: string, first_name: string, last_name: string, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null, phone?: string | null } | null } | null, tasks: Array<(
    { __typename?: 'tasks' }
    & { ' $fragmentRefs'?: { 'Tasks_DataFragment': Tasks_DataFragment } }
  )> };

export type UsersByOrgQueryVariables = Exact<{
  orgUserId: Scalars['uuid']['input'];
}>;


export type UsersByOrgQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, projects: Array<{ __typename?: 'projects_to_users', project: { __typename?: 'projects', id: string } }> }> };

export type UpdateTaskDatesMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskDatesMutation = { __typename?: 'mutation_root', updateTask?: { __typename: 'UpdateTaskErrors', errors: Array<{ __typename?: 'InputValidationError', formErrors: Array<string | null>, fieldErrors: any } | { __typename?: 'ProjectDoesNotExist' } | { __typename?: 'TaskAssignationsNotAllowed' } | { __typename?: 'TaskDoesNotExist' } | { __typename: 'UpdateTaskPermissionDenied', message: string, type: string }> } | { __typename: 'UpdateTaskSuccess', task_id: string } | null };

export type UpdateTaskUserMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskUserMutation = { __typename?: 'mutation_root', updateTask?: { __typename: 'UpdateTaskErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'ProjectDoesNotExist' } | { __typename: 'TaskAssignationsNotAllowed' } | { __typename: 'TaskDoesNotExist' } | { __typename: 'UpdateTaskPermissionDenied' }> } | { __typename: 'UpdateTaskSuccess', task_id: string } | null };

export type ProjectInvitationsMutationVariables = Exact<{
  input: ProjectInvitationsInput;
}>;


export type ProjectInvitationsMutation = { __typename?: 'mutation_root', projectInvitations?: { __typename: 'ProjectInvitationsErrors', errors: Array<{ __typename?: 'CannotUpdateProjectRole', type: string } | { __typename?: 'InputValidationError', formErrors: Array<string | null>, fieldErrors: any } | { __typename?: 'ProjectAccessDenied', type: string }> } | { __typename: 'ProjectInvitationsSuccess', ok: boolean, errorReport: Array<{ __typename?: 'ErrorReportType', email: string, project_id: string, project_name: string, org_id?: string | null, org_name?: string | null, user_already_org_project_member?: boolean | null, user_already_project_member?: boolean | null }>, successReport: Array<{ __typename?: 'SuccessReportType', email: string }> } | null };

export type ProjectCategories_DataFragment = { __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', color: string, name: string } } & { ' $fragmentName'?: 'ProjectCategories_DataFragment' };

export type ProjectsGantt_DataFragment = { __typename?: 'projects', id: string, name: string, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, start_date?: string | null, end_date?: string | null, hours_expected?: number | null, hours_done?: number | null, project_categories: Array<(
      { __typename?: 'org_project_summary_to_project_categories' }
      & { ' $fragmentRefs'?: { 'ProjectCategories_DataFragment': ProjectCategories_DataFragment } }
    )> }> | null } & { ' $fragmentName'?: 'ProjectsGantt_DataFragment' };

export type ProjectsGanttQueryVariables = Exact<{
  filters?: InputMaybe<Projects_Bool_Exp>;
}>;


export type ProjectsGanttQuery = { __typename?: 'query_root', projects: Array<(
    { __typename?: 'projects' }
    & { ' $fragmentRefs'?: { 'ProjectsGantt_DataFragment': ProjectsGantt_DataFragment } }
  )> };

export type UpdateOrgProjectSummaryDataMutationVariables = Exact<{
  input: UpdateOrgProjectSummaryInput;
}>;


export type UpdateOrgProjectSummaryDataMutation = { __typename?: 'mutation_root', updateOrgProjectSummary?: { __typename: 'UpdateOrgProjectSummaryErrors' } | { __typename: 'UpdateOrgProjectSummarySuccess', org_project_summary_id: string } | null };

export type ProjectsList_DataQueryVariables = Exact<{
  filters?: InputMaybe<Projects_Map_Overview_Bool_Exp>;
  sort?: InputMaybe<Array<Projects_Map_Overview_Order_By> | Projects_Map_Overview_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectsList_DataQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects_map_overview', name: string, id: string, avatar?: string | null, created_at: string, is_member?: boolean | null, is_creator_in_my_org?: boolean | null, org_project_summary?: Array<{ __typename?: 'org_project_summary', is_archived: boolean, end_date?: string | null, id: string, client_fullname?: string | null, reference?: string | null, price_estimate?: string | null, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', color: string, id: string, name: string } }>, project_groups: Array<{ __typename?: 'org_project_summary_to_project_groups', project_group: { __typename?: 'project_groups', color: string, name: string, project_group_avatar?: { __typename?: 'project_group_avatars', public_url: string } | null } }> }> | null }>, projects_count_filtered: { __typename?: 'projects_map_overview_aggregate', aggregate?: { __typename?: 'projects_map_overview_aggregate_fields', count: number } | null }, projects_count: { __typename?: 'projects_map_overview_aggregate', aggregate?: { __typename?: 'projects_map_overview_aggregate_fields', count: number } | null } };

export type UserProjectsRolesQueryVariables = Exact<{
  projectIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type UserProjectsRolesQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', role: { __typename?: 'project_roles', name: string } }> }> };

export type ProjectGroupsData_ProjectGroupsCategoriesQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectGroupsData_ProjectGroupsCategoriesQuery = { __typename?: 'query_root', org_project_summary: Array<{ __typename?: 'org_project_summary', id: string, project_groups: Array<{ __typename?: 'org_project_summary_to_project_groups', project_group: { __typename?: 'project_groups', color: string, name: string, project_group_avatar?: { __typename?: 'project_group_avatars', public_url: string } | null } }> }> };

export type ProjectOrgData_ProjectCategoriesQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectOrgData_ProjectCategoriesQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', color: string, name: string, id: string } }> }> | null } | null };

export type ProjectsMaps_ProjectsFragment = { __typename?: 'projects_map_overview', id: string, name: string, avatar?: string | null, address?: { __typename?: 'project_address', lat?: number | null, lng?: number | null } | null, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', color: string, id: string, name: string } }> }> | null } & { ' $fragmentName'?: 'ProjectsMaps_ProjectsFragment' };

export type ProjectMapsScreenQueryVariables = Exact<{
  filters?: InputMaybe<Projects_Map_Overview_Bool_Exp>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectMapsScreenQuery = { __typename?: 'query_root', projects_map_overview: Array<(
    { __typename?: 'projects_map_overview' }
    & { ' $fragmentRefs'?: { 'ProjectsMaps_ProjectsFragment': ProjectsMaps_ProjectsFragment } }
  )>, projects_count: { __typename?: 'projects_map_overview_aggregate', aggregate?: { __typename?: 'projects_map_overview_aggregate_fields', count: number } | null } };

export type MetricsDataQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MetricsDataQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: string, file_version_approval_request_users: Array<(
      { __typename?: 'file_version_approval_request_users' }
      & { ' $fragmentRefs'?: { 'ApprovalRequestItem_DataFragment': ApprovalRequestItem_DataFragment } }
    )>, file_version_approval_request_users_aggregate: { __typename?: 'file_version_approval_request_users_aggregate', aggregate?: { __typename?: 'file_version_approval_request_users_aggregate_fields', count: number } | null } } | null, tasks: Array<(
    { __typename?: 'tasks' }
    & { ' $fragmentRefs'?: { 'MetricsData_TaskFragment': MetricsData_TaskFragment } }
  )>, tasks_aggregate: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null } };

export type ApprovalRequestItem_DataFragment = { __typename?: 'file_version_approval_request_users', file_version_approval_request: { __typename?: 'file_version_approval_requests', id: string, created_at: string, file_version: { __typename?: 'file_versions', id: string, file_id: string, name: string, extension: string, url?: string | null, file: { __typename?: 'files', due_date?: string | null, project: { __typename?: 'projects', name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null }, assignation?: { __typename?: 'file_assignations', users: Array<{ __typename?: 'file_assignations_users', creator?: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }> } | null } } } } & { ' $fragmentName'?: 'ApprovalRequestItem_DataFragment' };

export type GetProjectCategoriesQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectCategoriesQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', id: string, color: string } }> }> | null } | null };

export type MetricsData_TaskFragment = { __typename?: 'tasks', is_validated_by?: string | null, number: number, id: string, description: string, subtasks_progress?: number | null, start_date?: string | null, hours_done?: number | null, hours_expected?: number | null, end_date?: string | null, labels: Array<{ __typename?: 'tasks_to_project_labels', id: string, label: { __typename?: 'project_labels', id: string, color: string } }>, project: { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string }, role: { __typename?: 'project_roles', name: string } }> }, assignations?: { __typename?: 'task_assignations', users: Array<{ __typename?: 'task_assignations_users', creator?: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }>, teams: Array<{ __typename?: 'task_assignations_teams', creator?: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }>, orgs: Array<{ __typename?: 'task_assignations_orgs', creator?: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }> } | null } & { ' $fragmentName'?: 'MetricsData_TaskFragment' };

export type CreateTaskTwoStepsOnDbClickDialog_DataFragment = { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string }, role: { __typename?: 'project_roles', name: string } }> } & { ' $fragmentName'?: 'CreateTaskTwoStepsOnDbClickDialog_DataFragment' };

export type CreateTaskTwoStepsOnDbClickDialogQueryVariables = Exact<{
  firstUserId: Scalars['uuid']['input'];
  secondUserId: Scalars['uuid']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateTaskTwoStepsOnDbClickDialogQuery = { __typename?: 'query_root', projects: Array<(
    { __typename?: 'projects' }
    & { ' $fragmentRefs'?: { 'CreateTaskTwoStepsOnDbClickDialog_DataFragment': CreateTaskTwoStepsOnDbClickDialog_DataFragment } }
  )> };

export type CreateTaskTwoStepsDialog_DataFragment = { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, members: Array<{ __typename?: 'projects_to_users', role: { __typename?: 'project_roles', name: string } }> } & { ' $fragmentName'?: 'CreateTaskTwoStepsDialog_DataFragment' };

export type CreateTaskTwoStepsDialogQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CreateTaskTwoStepsDialogQuery = { __typename?: 'query_root', projects: Array<(
    { __typename?: 'projects' }
    & { ' $fragmentRefs'?: { 'CreateTaskTwoStepsDialog_DataFragment': CreateTaskTwoStepsDialog_DataFragment } }
  )> };

export type TasksListGlobalTask_DataFragment = { __typename?: 'tasks', id: string, number: number, is_validated_by?: string | null, start_date?: string | null, end_date?: string | null, deleted_at?: string | null, created_at: string, description: string, subtasks_progress?: number | null, project: { __typename?: 'projects', id: string, name: string }, predecessors: Array<{ __typename?: 'task_dependencies', from_id: string, to_id: string, from_side: string, to_side: string, relationship_type?: string | null }>, ancestors: Array<{ __typename?: 'task_dependencies', from_id: string, to_id: string, from_side: string, to_side: string, relationship_type?: string | null }>, creator: { __typename?: 'users', id: string, full_name?: string | null }, assignations?: { __typename?: 'task_assignations', users: Array<{ __typename?: 'task_assignations_users', user_id: string, user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }>, teams: Array<{ __typename?: 'task_assignations_teams', team_id: string, team: { __typename?: 'teams', name: string, color: string, id: string, users: Array<{ __typename?: 'teams_to_users', user: { __typename?: 'users', id: string, full_name?: string | null } }> } }>, orgs: Array<{ __typename?: 'task_assignations_orgs', org_id: string, org: { __typename?: 'orgs', id: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null, members: Array<{ __typename?: 'orgs_to_users', user: { __typename?: 'users', id: string, full_name?: string | null } }> } }> } | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', id: string, color: string, name: string } }>, attachments: Array<{ __typename?: 'task_attachments', id: string, name: string, url?: string | null, content_type?: string | null }> } & { ' $fragmentName'?: 'TasksListGlobalTask_DataFragment' };

export type TasksListGlobalQueryVariables = Exact<{
  filters: Tasks_Bool_Exp;
  sort?: InputMaybe<Array<Tasks_Order_By> | Tasks_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type TasksListGlobalQuery = { __typename?: 'query_root', tasks: Array<(
    { __typename?: 'tasks' }
    & { ' $fragmentRefs'?: { 'TasksListGlobalTask_DataFragment': TasksListGlobalTask_DataFragment } }
  )>, tasks_count_filtered: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null }, tasks_count_total: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null }, projects: Array<{ __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, members: Array<{ __typename?: 'projects_to_users', role: { __typename?: 'project_roles', name: string } }> }> };

export type ProjectsSchedulerTask_DataFragment = { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string }, role: { __typename?: 'project_roles', name: string } }> } & { ' $fragmentName'?: 'ProjectsSchedulerTask_DataFragment' };

export type TasksSchedulerTask_DataFragment = { __typename?: 'tasks', id: string, number: number, is_validated_by?: string | null, start_date?: string | null, end_date?: string | null, description: string, subtasks_progress?: number | null, predecessors: Array<{ __typename?: 'task_dependencies', from_id: string, to_id: string, from_side: string, to_side: string, relationship_type?: string | null }>, ancestors: Array<{ __typename?: 'task_dependencies', from_id: string, to_id: string, from_side: string, to_side: string, relationship_type?: string | null }>, creator: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, assignations?: { __typename?: 'task_assignations', users: Array<{ __typename?: 'task_assignations_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }>, teams: Array<{ __typename?: 'task_assignations_teams', team: { __typename?: 'teams', id: string, users: Array<{ __typename?: 'teams_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } }>, orgs: Array<{ __typename?: 'task_assignations_orgs', org: { __typename?: 'orgs', id: string, members: Array<{ __typename?: 'orgs_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } }> } | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', id: string, color: string, name: string } }>, project: { __typename?: 'projects', project_avatar?: { __typename?: 'project_avatars', public_url: string } | null } } & { ' $fragmentName'?: 'TasksSchedulerTask_DataFragment' };

export type TasksSchedulerDataQueryVariables = Exact<{
  filters: Tasks_Bool_Exp;
  cursor_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksSchedulerDataQuery = { __typename?: 'query_root', tasks: Array<(
    { __typename?: 'tasks', id: string, project: (
      { __typename?: 'projects' }
      & { ' $fragmentRefs'?: { 'ProjectsSchedulerTask_DataFragment': ProjectsSchedulerTask_DataFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TasksSchedulerTask_DataFragment': TasksSchedulerTask_DataFragment } }
  )> };

export type TasksSchedulerDataPastQueryVariables = Exact<{
  filters: Tasks_Bool_Exp;
  cursor_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksSchedulerDataPastQuery = { __typename?: 'query_root', tasks: Array<(
    { __typename?: 'tasks', project: (
      { __typename?: 'projects' }
      & { ' $fragmentRefs'?: { 'ProjectsSchedulerTask_DataFragment': ProjectsSchedulerTask_DataFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TasksSchedulerTask_DataFragment': TasksSchedulerTask_DataFragment } }
  )> };

export type TasksByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TasksByPkQuery = { __typename?: 'query_root', tasks: Array<(
    { __typename?: 'tasks', project: (
      { __typename?: 'projects' }
      & { ' $fragmentRefs'?: { 'ProjectsSchedulerTask_DataFragment': ProjectsSchedulerTask_DataFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TasksSchedulerTask_DataFragment': TasksSchedulerTask_DataFragment } }
  )> };

export type TasksSchedulerDateRangeQueryVariables = Exact<{
  filters: Tasks_Bool_Exp;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksSchedulerDateRangeQuery = { __typename?: 'query_root', tasks: Array<(
    { __typename?: 'tasks', project: (
      { __typename?: 'projects' }
      & { ' $fragmentRefs'?: { 'ProjectsSchedulerTask_DataFragment': ProjectsSchedulerTask_DataFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TasksSchedulerTask_DataFragment': TasksSchedulerTask_DataFragment } }
  )> };

export type TasksSchedulerQueryVariables = Exact<{
  filters: Tasks_Bool_Exp;
}>;


export type TasksSchedulerQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string }, role: { __typename?: 'project_roles', name: string } }>, tasks: Array<(
      { __typename?: 'tasks' }
      & { ' $fragmentRefs'?: { 'TasksSchedulerTask_DataFragment': TasksSchedulerTask_DataFragment } }
    )> }> };

export type UpdateTaskAssignationsMutationVariables = Exact<{
  input: UpdateAssignationsTaskInput;
}>;


export type UpdateTaskAssignationsMutation = { __typename?: 'mutation_root', updateAssignationsTask?: { __typename: 'UpdateAssignationTaskSuccess', task_id: string } | { __typename: 'UpdateAssignationsTaskErrors' } | null };

export type InvitationConfirmationDialog_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type InvitationConfirmationDialog_DataQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: string, name: string }>, users: Array<{ __typename?: 'users', id: string, full_name?: string | null, first_name: string, last_name: string, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null } | null }> };

export type UserOrgRoleQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type UserOrgRoleQuery = { __typename?: 'query_root', orgs_by_pk?: { __typename?: 'orgs', id: string, members: Array<{ __typename?: 'orgs_to_users', role: { __typename?: 'org_roles', name: string } }> } | null };

export type PrepareProjectSpreadsheetForUploadMutationVariables = Exact<{
  input: PrepareProjectSpreadsheetForUploadInput;
}>;


export type PrepareProjectSpreadsheetForUploadMutation = { __typename?: 'mutation_root', prepareProjectSpreadsheetForUpload?: { __typename: 'PrepareProjectSpreadsheetForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'OrgAccessDenied' } | { __typename: 'OrgDoesNotExist' }> } | { __typename: 'PrepareProjectSpreadsheetForUploadSuccess', key: string, url: string } | null };

export type ProjectImportRequestExcelTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type ProjectImportRequestExcelTemplateMutation = { __typename?: 'mutation_root', projectImportRequestExcelTemplate?: { __typename: 'ProjectImportRequestExcelTemplateErrors' } | { __typename: 'ProjectImportRequestExcelTemplateSuccess', url: string } | null };

export type OrgNavigation_UserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type OrgNavigation_UserQuery = { __typename?: 'query_root', user?: { __typename?: 'users', id: string, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string, id: string } } | null } | null };

export type OrgProfileContainerQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type OrgProfileContainerQuery = { __typename: 'query_root', orgs_by_pk?: { __typename?: 'orgs', id: string, name: string, phone?: string | null, legal_number?: string | null, description?: string | null, background?: string | null, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null, address?: { __typename?: 'org_address', street?: string | null, postal_code?: string | null, city?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null } | null };

export type ProjectInfosQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectInfosQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, name: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type CategoriesList_DataQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type CategoriesList_DataQuery = { __typename?: 'query_root', orgs_by_pk?: { __typename?: 'orgs', id: string, project_categories: Array<(
      { __typename?: 'project_categories' }
      & { ' $fragmentRefs'?: { 'CategoriesList_ItemFragment': CategoriesList_ItemFragment } }
    )> } | null };

export type CreateProjectCategoryMutationVariables = Exact<{
  input: CreateProjectCategoryInput;
}>;


export type CreateProjectCategoryMutation = { __typename?: 'mutation_root', createProjectCategory?: { __typename: 'CreateProjectCategoryErrors' } | { __typename: 'CreateProjectCategorySuccess', project_category_id: string } | null };

export type CategoriesList_ItemFragment = { __typename?: 'project_categories', id: string, name: string, color: string } & { ' $fragmentName'?: 'CategoriesList_ItemFragment' };

export type UpdateProjectCategoryMutationVariables = Exact<{
  input: UpdateProjectCategoryInput;
}>;


export type UpdateProjectCategoryMutation = { __typename?: 'mutation_root', updateProjectCategory?: { __typename: 'UpdateProjectCategoryErrors' } | { __typename: 'UpdateProjectCategorySuccess', project_category_id: string } | null };

export type DeleteProjectCategoryMutationVariables = Exact<{
  input: DeleteProjectCategoryInput;
}>;


export type DeleteProjectCategoryMutation = { __typename?: 'mutation_root', deleteProjectCategory?: { __typename: 'DeleteProjectCategoryErrors' } | { __typename: 'DeleteProjectCategorySuccess', project_category_id: string } | null };

export type GroupsList_DataQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GroupsList_DataQuery = { __typename?: 'query_root', orgs_by_pk?: { __typename?: 'orgs', id: string, project_groups: Array<(
      { __typename?: 'project_groups' }
      & { ' $fragmentRefs'?: { 'GroupsList_ItemFragment': GroupsList_ItemFragment } }
    )> } | null };

export type CreateProjectGroupMutationVariables = Exact<{
  input: CreateProjectGroupInput;
}>;


export type CreateProjectGroupMutation = { __typename?: 'mutation_root', createProjectGroup?: { __typename: 'CreateProjectGroupErrors' } | { __typename: 'CreateProjectGroupSuccess', project_group_id: string } | null };

export type PrepareProjectGroupAssetForUploadMutationVariables = Exact<{
  input: PrepareProjectGroupAssetForUploadInput;
}>;


export type PrepareProjectGroupAssetForUploadMutation = { __typename?: 'mutation_root', PrepareProjectGroupAssetForUpload?: { __typename: 'PrepareProjectGroupAssetForUploadErrors' } | { __typename: 'PrepareProjectGroupAssetForUploadSuccess', url: string, key: string } | null };

export type GroupsList_ItemFragment = { __typename?: 'project_groups', id: string, name: string, color: string, project_group_avatar?: { __typename?: 'project_group_avatars', public_url: string } | null } & { ' $fragmentName'?: 'GroupsList_ItemFragment' };

export type UpdateProjectGroupMutationVariables = Exact<{
  input: UpdateProjectGroupInput;
}>;


export type UpdateProjectGroupMutation = { __typename?: 'mutation_root', updateProjectGroup?: { __typename: 'UpdateProjectGroupErrors' } | { __typename: 'UpdateProjectGroupSuccess', project_group_id: string } | null };

export type DeleteProjectGroupMutationVariables = Exact<{
  input: DeleteProjectGroupInput;
}>;


export type DeleteProjectGroupMutation = { __typename?: 'mutation_root', deleteProjectGroup?: { __typename: 'DeleteProjectGroupErrors' } | { __typename: 'DeleteProjectGroupSuccess', project_group_id: string } | null };

export type OrgAccessDeniedScreen_DataQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type OrgAccessDeniedScreen_DataQuery = { __typename?: 'query_root', org?: { __typename?: 'orgs', id: string, members: Array<{ __typename?: 'orgs_to_users', updater?: { __typename?: 'users', full_name?: string | null } | null }> } | null };

export type OrgMembersList_DataQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  filters?: InputMaybe<Orgs_To_Users_Bool_Exp>;
}>;


export type OrgMembersList_DataQuery = { __typename?: 'query_root', orgs_by_pk?: { __typename?: 'orgs', id: string, members: Array<{ __typename?: 'orgs_to_users', inviter_id?: string | null, user: { __typename?: 'users', id: string, full_name?: string | null, first_name: string, last_name: string, is_active: boolean, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null, phone?: string | null } | null, connections: Array<{ __typename?: 'user_connections', created_at: string }> }, role: { __typename?: 'org_roles', name: string } }> } | null };

export type OrgProfileScreen_OrgQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type OrgProfileScreen_OrgQuery = { __typename: 'query_root', org?: (
    { __typename?: 'orgs' }
    & { ' $fragmentRefs'?: { 'ProfileForm_OrgFragment': ProfileForm_OrgFragment } }
  ) | null };

export type ProfileForm_OrgFragment = { __typename?: 'orgs', id: string, name: string, phone?: string | null, legal_number?: string | null, description?: string | null, background?: string | null, public_api_token?: string | null, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null, address?: { __typename?: 'org_address', street?: string | null, postal_code?: string | null, city?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null, project_categories: Array<{ __typename?: 'project_categories', id: string }>, members: Array<{ __typename?: 'orgs_to_users', user: { __typename?: 'users', id: string } }>, settings?: { __typename?: 'org_settings', show_menu_by_group: boolean } | null } & { ' $fragmentName'?: 'ProfileForm_OrgFragment' };

export type UpdateOrgProfileMutationVariables = Exact<{
  input: UpdateOrgProfileInput;
}>;


export type UpdateOrgProfileMutation = { __typename?: 'mutation_root', updateOrgProfile?: { __typename: 'UpdateOrgProfileErrors' } | { __typename: 'UpdateOrgProfileSuccess', org_id: string } | null };

export type GenerateApiTokenMutationVariables = Exact<{
  input: GenerateApiTokenInput;
}>;


export type GenerateApiTokenMutation = { __typename?: 'mutation_root', generateApiToken?: { __typename: 'GenerateApiTokenErrors' } | { __typename: 'GenerateApiTokenSuccess', token: string } | null };

export type PrepareOrgAssetForUploadMutationVariables = Exact<{
  input: PrepareOrgAssetForUploadInput;
}>;


export type PrepareOrgAssetForUploadMutation = { __typename?: 'mutation_root', prepareOrgAssetForUpload?: { __typename: 'PrepareOrgAssetForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'OrgAccessDenied' } | { __typename: 'OrgDoesNotExist' }> } | { __typename: 'PrepareOrgAssetForUploadSuccess', key: string, url: string } | null };

export type ProjectMembers_DataQueryVariables = Exact<{
  projetId: Scalars['uuid']['input'];
}>;


export type ProjectMembers_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', stream_user_id: string } }> } | null };

export type ProjectChatHeader_DataQueryVariables = Exact<{
  projetId: Scalars['uuid']['input'];
}>;


export type ProjectChatHeader_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org: Array<{ __typename?: 'orgs', id: string }> } | null };

export type GetProjectDocumentFolderRootQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
}>;


export type GetProjectDocumentFolderRootQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, root_folder_id?: string | null, root_bin_folder_id?: string | null } | null };

export type RestoreFileVersionMutationVariables = Exact<{
  input: RestoreFileVersionInput;
}>;


export type RestoreFileVersionMutation = { __typename?: 'mutation_root', restoreFileVersion?: { __typename: 'RestoreFileVersionErrors' } | { __typename: 'RestoreFileVersionSuccess', file_version_id: string } | null };

export type FileVersionsVirtualList_VersionsFragment = { __typename?: 'file_versions', number: number, name: string, id: string, created_at: string, extension: string, url?: string | null, file_id: string, original_url?: string | null, creator: { __typename?: 'users', full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null }, approvals_overview?: { __typename?: 'file_versions_approvals_overview', is_approved_with_comments?: boolean | null, is_approved_without_comments?: boolean | null, is_denied?: boolean | null, is_completed?: boolean | null } | null, approval_requests?: { __typename?: 'file_version_approval_requests', users: Array<{ __typename?: 'file_version_approval_request_users', id: string, user: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, file_approval?: { __typename?: 'file_approvals', status: File_Approvals_Status_Enum_Enum } | null }> } | null } & { ' $fragmentName'?: 'FileVersionsVirtualList_VersionsFragment' };

export type GetFileVersionsQueryVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type GetFileVersionsQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', versions: Array<(
      { __typename?: 'file_versions' }
      & { ' $fragmentRefs'?: { 'FileVersionsVirtualList_VersionsFragment': FileVersionsVirtualList_VersionsFragment } }
    )> } | null };

export type FilesFoldersNavigatorsData_FolderFragment = { __typename?: 'folders', id: string, name: string } & { ' $fragmentName'?: 'FilesFoldersNavigatorsData_FolderFragment' };

export type FilesFoldersNavigatorsData_FileFragment = { __typename?: 'files', id: string, name: string, extension?: string | null, due_date?: string | null, last_version?: Array<{ __typename?: 'file_versions', id: string, created_at: string, updated_at: string, size?: number | null, url?: string | null, creator: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> | null } & { ' $fragmentName'?: 'FilesFoldersNavigatorsData_FileFragment' };

export type GetFilesFoldersNavigatorQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
}>;


export type GetFilesFoldersNavigatorQuery = { __typename?: 'query_root', folders_by_pk?: { __typename?: 'folders', id: string, name: string, parents_ids?: any | null, folders: Array<(
      { __typename?: 'folders' }
      & { ' $fragmentRefs'?: { 'FilesFoldersNavigatorsData_FolderFragment': FilesFoldersNavigatorsData_FolderFragment } }
    )>, files: Array<(
      { __typename?: 'files' }
      & { ' $fragmentRefs'?: { 'FilesFoldersNavigatorsData_FileFragment': FilesFoldersNavigatorsData_FileFragment } }
    )> } | null };

export type GetProjectFileRootQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
}>;


export type GetProjectFileRootQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, root_bin_folder_id?: string | null, root_folder_id?: string | null } | null };

export type GetFileLastVersionQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFileLastVersionQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', last_version?: Array<{ __typename?: 'file_versions', id: string }> | null } | null };

export type GetFileVersionByPkQueryVariables = Exact<{
  fileVersionId: Scalars['uuid']['input'];
}>;


export type GetFileVersionByPkQuery = { __typename?: 'query_root', file_versions_by_pk?: { __typename?: 'file_versions', id: string, name: string, file: { __typename?: 'files', id: string, folder: { __typename?: 'folders', id: string, is_in_bin?: boolean | null } } } | null };

export type BinFilesFoldersData_FolderFragment = { __typename?: 'folders', id: string, name: string, assignee_automation_mode: boolean, approval_automation_mode: boolean, permission?: { __typename?: 'folder_permissions', orgs: Array<{ __typename?: 'folder_permissions_orgs', id: string }>, teams: Array<{ __typename?: 'folder_permissions_teams', id: string }>, users: Array<{ __typename?: 'folder_permissions_users', id: string }> } | null, assignation?: { __typename?: 'folder_assignations', users: Array<{ __typename?: 'folder_assignations_users', created_at: string, user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, creator?: { __typename?: 'users', full_name?: string | null } | null }> } | null, labels: Array<{ __typename?: 'folders_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }> } & { ' $fragmentName'?: 'BinFilesFoldersData_FolderFragment' };

export type BinFilesFoldersData_FileFragment = { __typename?: 'files', id: string, name: string, extension?: string | null, versions: Array<{ __typename?: 'file_versions', id: string, name: string, url?: string | null }> } & { ' $fragmentName'?: 'BinFilesFoldersData_FileFragment' };

export type GetBinFolderFilesQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
}>;


export type GetBinFolderFilesQuery = { __typename?: 'query_root', folders_by_pk?: { __typename?: 'folders', id: string, name: string, parents_ids?: any | null, folders: Array<(
      { __typename?: 'folders' }
      & { ' $fragmentRefs'?: { 'BinFilesFoldersData_FolderFragment': BinFilesFoldersData_FolderFragment } }
    )>, files: Array<(
      { __typename?: 'files' }
      & { ' $fragmentRefs'?: { 'BinFilesFoldersData_FileFragment': BinFilesFoldersData_FileFragment } }
    )> } | null };

export type GetProjectFoldersRootQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
}>;


export type GetProjectFoldersRootQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, root_folder_id?: string | null } | null };

export type RestoreFileMutationVariables = Exact<{
  input: MoveFilesInput;
}>;


export type RestoreFileMutation = { __typename?: 'mutation_root', moveFiles?: { __typename: 'MoveFilesErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileDoesNotExists' } | { __typename: 'InputValidationError' } | { __typename: 'PermissionsConflictError' }> } | { __typename: 'MoveFilesSuccess', file_ids: Array<string> } | null };

export type RestoreFolderMutationVariables = Exact<{
  input: MoveFoldersInput;
}>;


export type RestoreFolderMutation = { __typename?: 'mutation_root', moveFolders?: { __typename: 'MoveFoldersErrors', errors: Array<{ __typename: 'FolderAccessDenied' } | { __typename: 'FolderCannotBeMoveInAnotherProject' } | { __typename: 'FolderDoesNotExists' } | { __typename: 'InputValidationError' } | { __typename: 'PermissionsConflictError' }> } | { __typename: 'MoveFoldersSuccess', folder_ids: Array<string> } | null };

export type FilesFoldersData_FolderFragment = { __typename?: 'folders', id: string, name: string, assignee_automation_mode: boolean, approval_automation_mode: boolean, assignation?: { __typename?: 'folder_assignations', users: Array<{ __typename?: 'folder_assignations_users', created_at: string, user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, creator?: { __typename?: 'users', full_name?: string | null } | null }> } | null, labels: Array<{ __typename?: 'folders_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }>, permission?: { __typename?: 'folder_permissions', orgs: Array<{ __typename?: 'folder_permissions_orgs', id: string }>, teams: Array<{ __typename?: 'folder_permissions_teams', id: string }>, users: Array<{ __typename?: 'folder_permissions_users', id: string }> } | null, creator?: { __typename?: 'users', full_name?: string | null, id: string, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', id: string } } | null } | null } & { ' $fragmentName'?: 'FilesFoldersData_FolderFragment' };

export type FilesFoldersData_FileFragment = { __typename?: 'files', id: string, name: string, extension?: string | null, due_date?: string | null, url?: string | null, is_approved_on_a_version?: boolean | null, is_approval_mode: boolean, versions: Array<{ __typename?: 'file_versions', id: string, name: string }>, assignation?: { __typename?: 'file_assignations', users: Array<{ __typename?: 'file_assignations_users', created_at: string, user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, creator?: { __typename?: 'users', full_name?: string | null } | null }> } | null, permission?: { __typename?: 'file_permissions', orgs: Array<{ __typename?: 'file_permissions_orgs', org_id: string, org: { __typename?: 'orgs', name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } }>, teams: Array<{ __typename?: 'file_permissions_teams', team_id: string, team: { __typename?: 'teams', color: string, name: string } }>, users: Array<{ __typename?: 'file_permissions_users', user_id: string, user: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null, project: { __typename?: 'projects', id: string }, last_version?: Array<{ __typename?: 'file_versions', number: number, id: string, updated_at: string, url?: string | null, original_url?: string | null, size?: number | null, created_at: string, creator: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string, id: string } } | null }, approvals_overview?: { __typename?: 'file_versions_approvals_overview', is_approved_with_comments?: boolean | null, is_approved_without_comments?: boolean | null, is_denied?: boolean | null } | null, approval_requests?: { __typename?: 'file_version_approval_requests', users: Array<{ __typename?: 'file_version_approval_request_users', id: string }> } | null, approvals: Array<{ __typename?: 'file_approvals', user_id: string, status: File_Approvals_Status_Enum_Enum, created_at: string, comments: Array<{ __typename?: 'file_comments', content: string }>, approval_attachments: Array<(
        { __typename?: 'file_approval_attachments' }
        & { ' $fragmentRefs'?: { 'FileApproval_AttachmentFragment': FileApproval_AttachmentFragment } }
      )> }>, views: Array<{ __typename?: 'file_views', user_id: string, created_at: string }>, tasks: Array<{ __typename?: 'tasks_file_versions', task: { __typename?: 'tasks', is_validated_by?: string | null } }> }> | null, labels: Array<{ __typename?: 'files_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }> } & { ' $fragmentName'?: 'FilesFoldersData_FileFragment' };

export type GetFolderFilesQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
  fileFilters?: InputMaybe<Files_Bool_Exp>;
  folderFilters?: InputMaybe<Folders_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFolderFilesQuery = { __typename?: 'query_root', folders_by_pk?: { __typename?: 'folders', id: string, name: string, is_in_bin?: boolean | null, parents_ids?: any | null, folders: Array<(
      { __typename?: 'folders' }
      & { ' $fragmentRefs'?: { 'FilesFoldersData_FolderFragment': FilesFoldersData_FolderFragment;'RenameFolderForm_FolderFragment': RenameFolderForm_FolderFragment } }
    )>, files: Array<(
      { __typename?: 'files' }
      & { ' $fragmentRefs'?: { 'FilesFoldersData_FileFragment': FilesFoldersData_FileFragment;'RenameFileForm_FileFragment': RenameFileForm_FileFragment;'UpdateDueDateFileForm_FileFragment': UpdateDueDateFileForm_FileFragment;'AssigneesApprovalsAndViewsDrawer_FileFragment': AssigneesApprovalsAndViewsDrawer_FileFragment } }
    )> } | null };

export type SearchFilesAndFoldersByFilterQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
  fileFilters: Files_Bool_Exp;
  folderFilters: Folders_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchFilesAndFoldersByFilterQuery = { __typename?: 'query_root', files: Array<(
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'FilesFoldersData_FileFragment': FilesFoldersData_FileFragment;'RenameFileForm_FileFragment': RenameFileForm_FileFragment;'UpdateDueDateFileForm_FileFragment': UpdateDueDateFileForm_FileFragment;'AssigneesApprovalsAndViewsDrawer_FileFragment': AssigneesApprovalsAndViewsDrawer_FileFragment } }
  )>, folders: Array<(
    { __typename?: 'folders', id: string, name: string, is_in_bin?: boolean | null, parent_id?: string | null, parents_ids?: any | null }
    & { ' $fragmentRefs'?: { 'FilesFoldersData_FolderFragment': FilesFoldersData_FolderFragment;'RenameFolderForm_FolderFragment': RenameFolderForm_FolderFragment } }
  )> };

export type GetSubFolderCountQueryVariables = Exact<{
  id: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetSubFolderCountQuery = { __typename?: 'query_root', getSubFolderCount?: Array<{ __typename?: 'subFolderCountType', subFileCount?: number | null, subFolderCount?: number | null, subFolderId?: string | null } | null> | null };

export type AddUserViewToFolderMutationVariables = Exact<{
  input: AddUserViewToFolderInput;
}>;


export type AddUserViewToFolderMutation = { __typename?: 'mutation_root', addUserViewToFolder?: { __typename: 'AddUserViewToFolderErrors' } | { __typename: 'AddUserViewToFolderSuccess' } | null };

export type GetFileLastVersionIdQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFileLastVersionIdQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', last_version?: Array<{ __typename?: 'file_versions', id: string }> | null } | null };

export type GetFolderNamesQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
}>;


export type GetFolderNamesQuery = { __typename?: 'query_root', folders: Array<{ __typename?: 'folders', id: string, name: string }> };

export type PrepareFileVersionForUploadMutationVariables = Exact<{
  input: PrepareFileVersionForUploadInput;
}>;


export type PrepareFileVersionForUploadMutation = { __typename?: 'mutation_root', prepareFileVersionForUpload?: { __typename: 'PrepareFileVersionForUploadErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'PrepareFileVersionForUploadSuccess', key: string, url: string } | null };

export type RenameNewFileMutationVariables = Exact<{
  input: RenameFileInput;
}>;


export type RenameNewFileMutation = { __typename?: 'mutation_root', renameFile?: { __typename: 'RenameFileErrors' } | { __typename: 'RenameFileSuccess', file_id: string } | null };

export type PrepareFileStructureForUploadMutationVariables = Exact<{
  input: PrepareFileStructureForUploadInput;
}>;


export type PrepareFileStructureForUploadMutation = { __typename?: 'mutation_root', prepareFileStructureForUpload?: { __typename: 'PrepareFileStructureForUploadErrors', errors: Array<{ __typename: 'FolderAccessDenied' } | { __typename: 'FolderDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'PrepareFileStructureForUploadSuccess', key: string, url: string } | null };

export type AssigneesApprovalsAndViewsDrawer_FileVersionFragment = { __typename?: 'file_versions', id: string, number: number, updated_at: string, approvals_overview?: { __typename?: 'file_versions_approvals_overview', is_approved_with_comments?: boolean | null, is_approved_without_comments?: boolean | null, is_denied?: boolean | null } | null, file: { __typename?: 'files', project: { __typename?: 'projects', id: string } }, approval_requests?: { __typename?: 'file_version_approval_requests', users: Array<{ __typename?: 'file_version_approval_request_users', id: string }> } | null, approvals: Array<{ __typename?: 'file_approvals', id: string, user_id: string, status: File_Approvals_Status_Enum_Enum, created_at: string, user: { __typename?: 'users', full_name?: string | null }, approval_attachments: Array<(
      { __typename?: 'file_approval_attachments' }
      & { ' $fragmentRefs'?: { 'FileApproval_AttachmentFragment': FileApproval_AttachmentFragment } }
    )>, comments: Array<{ __typename?: 'file_comments', content: string }>, file_approvals_file_versions_attachment: Array<{ __typename?: 'file_approvals_file_versions', file_version_id: string, file_approval_id: string, file_version: { __typename?: 'file_versions', content_type: string, file_id: string, id: string, name: string, url?: string | null } }> }>, views: Array<{ __typename?: 'file_views', user_id: string, created_at: string }>, creator: (
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'AssigneesApprovalsAndViewsDrawer_CreatorFragment': AssigneesApprovalsAndViewsDrawer_CreatorFragment } }
  ) } & { ' $fragmentName'?: 'AssigneesApprovalsAndViewsDrawer_FileVersionFragment' };

export type AssigneesApprovalsAndViewsDrawer_CreatorFragment = { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } & { ' $fragmentName'?: 'AssigneesApprovalsAndViewsDrawer_CreatorFragment' };

export type AssigneesApprovalsAndViewsDrawer_FileFragment = { __typename?: 'files', id: string, name: string, is_approved_on_a_version?: boolean | null, is_approval_mode: boolean, due_date?: string | null, assignation?: { __typename?: 'file_assignations', users: Array<{ __typename?: 'file_assignations_users', created_at: string, user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, creator?: (
        { __typename?: 'users' }
        & { ' $fragmentRefs'?: { 'AssigneesApprovalsAndViewsDrawer_CreatorFragment': AssigneesApprovalsAndViewsDrawer_CreatorFragment } }
      ) | null }> } | null, last_version?: Array<(
    { __typename?: 'file_versions' }
    & { ' $fragmentRefs'?: { 'AssigneesApprovalsAndViewsDrawer_FileVersionFragment': AssigneesApprovalsAndViewsDrawer_FileVersionFragment } }
  )> | null, file_versions: Array<(
    { __typename?: 'file_versions' }
    & { ' $fragmentRefs'?: { 'AssigneesApprovalsAndViewsDrawer_FileVersionFragment': AssigneesApprovalsAndViewsDrawer_FileVersionFragment } }
  )> } & { ' $fragmentName'?: 'AssigneesApprovalsAndViewsDrawer_FileFragment' };

export type AssigneesApprovalsAndViewsDrawer_DataQueryVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type AssigneesApprovalsAndViewsDrawer_DataQuery = { __typename?: 'query_root', files_by_pk?: (
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'AssigneesApprovalsAndViewsDrawer_FileFragment': AssigneesApprovalsAndViewsDrawer_FileFragment } }
  ) | null };

export type CreateChannelForApprovalMutationVariables = Exact<{
  input: CreateChannelForApprovalInput;
}>;


export type CreateChannelForApprovalMutation = { __typename?: 'mutation_root', createChannelForApproval?: { __typename?: 'CreateChannelForApprovalErrors' } | { __typename: 'CreateChannelForApprovalSuccess', approval_id: string, channel_id: string } | null };

export type FileApproval_AttachmentFragment = { __typename?: 'file_approval_attachments', content_type?: string | null, created_at: string, creator_id: string, id: string, key: string, name: string, size?: number | null, updated_at: string, file_approval_id: string, url?: string | null } & { ' $fragmentName'?: 'FileApproval_AttachmentFragment' };

export type CreateFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateFolderMutation = { __typename?: 'mutation_root', createFolder?: { __typename: 'CreateFolderErrors', errors: Array<{ __typename: 'FolderAccessDenied', message: string } | { __typename: 'FolderDoesNotExists', message: string } | { __typename: 'InputValidationError' }> } | { __typename: 'CreateFolderSuccess', folder_id: string } | null };

export type PrepareFileForUploadMutationVariables = Exact<{
  input: PrepareFileForUploadInput;
}>;


export type PrepareFileForUploadMutation = { __typename?: 'mutation_root', prepareFileForUpload?: { __typename: 'PrepareFileForUploadErrors', errors: Array<{ __typename: 'FolderAccessDenied' } | { __typename: 'FolderDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'PrepareFileForUploadSuccess', key: string, url: string } | null };

export type CreateEmptyFileMutationVariables = Exact<{
  input: CreateEmptyFileInput;
}>;


export type CreateEmptyFileMutation = { __typename?: 'mutation_root', createEmptyFile?: { __typename: 'CreateEmptyFileErrors' } | { __typename: 'CreateEmptyFileSuccess', fileId: string, fileVersionId: string } | null };

export type GetDocsFilterAssigneesOptionsQueryVariables = Exact<{
  folderId: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type GetDocsFilterAssigneesOptionsQuery = { __typename?: 'query_root', folders_by_pk?: { __typename?: 'folders', id: string, suggestions_assignations_users?: Array<{ __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }> | null } | null, project_labels: Array<{ __typename?: 'project_labels', id: string, name: string, color: string }> };

export type ExportVisasScreen_ProjectFragment = { __typename?: 'projects', id: string, name: string } & { ' $fragmentName'?: 'ExportVisasScreen_ProjectFragment' };

export type ExportVisasDialog_ProjectQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ExportVisasDialog_ProjectQuery = { __typename?: 'query_root', project?: (
    { __typename?: 'projects' }
    & { ' $fragmentRefs'?: { 'ExportVisasScreen_ProjectFragment': ExportVisasScreen_ProjectFragment } }
  ) | null };

export type RequestApprovalExportMutationVariables = Exact<{
  input: RequestApprovalExportInput;
}>;


export type RequestApprovalExportMutation = { __typename?: 'mutation_root', requestApprovalExport?: { __typename: 'RequestApprovalExportErrors' } | { __typename: 'RequestApprovalExportSuccess', project_id: string } | null };

export type RequestApprovalReportMutationVariables = Exact<{
  input: RequestApprovalReportInput;
}>;


export type RequestApprovalReportMutation = { __typename?: 'mutation_root', requestApprovalReport?: { __typename: 'RequestApprovalReportErrors' } | { __typename: 'RequestApprovalReportSuccess', project_id: string } | null };

export type RequestFilesTreeExportMutationVariables = Exact<{
  input: RequestFilesTreeReportInput;
}>;


export type RequestFilesTreeExportMutation = { __typename?: 'mutation_root', requestFilesTreeReport?: { __typename: 'RequestFilesTreeReportErrors' } | { __typename: 'RequestFilesTreeReportSuccess', project_id: string } | null };

export type GetApprovals_VersionFragment = { __typename?: 'file_versions', number: number, created_at: string, creator: { __typename?: 'users', full_name?: string | null, teams: Array<{ __typename?: 'teams_to_users', team: { __typename?: 'teams', name: string } }>, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null }, approvals_overview?: { __typename?: 'file_versions_approvals_overview', is_approved_with_comments?: boolean | null, is_approved_without_comments?: boolean | null, is_denied?: boolean | null, is_completed?: boolean | null } | null, approvals: Array<{ __typename?: 'file_approvals', created_at: string, status: File_Approvals_Status_Enum_Enum, user_id: string, comments: Array<{ __typename?: 'file_comments', content: string }> }>, approval_requests?: { __typename?: 'file_version_approval_requests', users: Array<{ __typename?: 'file_version_approval_request_users', user: { __typename?: 'users', id: string, full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null, teams: Array<{ __typename?: 'teams_to_users', team: { __typename?: 'teams', name: string } }> } }> } | null, file: { __typename?: 'files', assignation?: { __typename?: 'file_assignations', users: Array<{ __typename?: 'file_assignations_users', user: { __typename?: 'users', full_name?: string | null, id: string, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null, teams: Array<{ __typename?: 'teams_to_users', team: { __typename?: 'teams', name: string } }> } }> } | null } } & { ' $fragmentName'?: 'GetApprovals_VersionFragment' };

export type GetApprovals_FileFragment = { __typename?: 'files', id: string, name: string, due_date?: string | null, parent_id: string, versions: Array<(
    { __typename?: 'file_versions' }
    & { ' $fragmentRefs'?: { 'GetApprovals_VersionFragment': GetApprovals_VersionFragment } }
  )>, folder: { __typename?: 'folders', id: string, name: string, parents_ids?: any | null } } & { ' $fragmentName'?: 'GetApprovals_FileFragment' };

export type GetApprovalsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetApprovalsQuery = { __typename?: 'query_root', files: Array<(
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'GetApprovals_FileFragment': GetApprovals_FileFragment } }
  )> };

export type GetFilesTreeQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetFilesTreeQuery = { __typename?: 'query_root', files: Array<(
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'GetApprovals_FileFragment': GetApprovals_FileFragment } }
  )> };

export type EnableFileApprovalsMutationVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type EnableFileApprovalsMutation = { __typename?: 'mutation_root', updateFilesApprovalMode?: { __typename: 'UpdateFilesApprovalModeErrors', errors: Array<{ __typename: 'CannotRemoveApprovalOnFile' } | { __typename: 'FileAccessDenied', message: string } | { __typename: 'FileDoesNotExists', message: string } | { __typename: 'InputValidationError' }> } | { __typename: 'UpdateFilesApprovalModeSuccess' } | null };

export type DisableFileApprovalsMutationVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type DisableFileApprovalsMutation = { __typename?: 'mutation_root', updateFilesApprovalMode?: { __typename: 'UpdateFilesApprovalModeErrors', errors: Array<{ __typename: 'CannotRemoveApprovalOnFile', message: string } | { __typename: 'FileAccessDenied', message: string } | { __typename: 'FileDoesNotExists', message: string } | { __typename: 'InputValidationError' }> } | { __typename: 'UpdateFilesApprovalModeSuccess' } | null };

export type DeleteFileMutationVariables = Exact<{
  input: DeleteFileInput;
}>;


export type DeleteFileMutation = { __typename?: 'mutation_root', deleteFile?: { __typename: 'DeleteFileErrors' } | { __typename: 'DeleteFileSuccess', file_id: string } | null };

export type DuplicateFileMutationVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type DuplicateFileMutation = { __typename?: 'mutation_root', duplicateFiles?: { __typename: 'DuplicateFilesErrors', errors: Array<{ __typename: 'FileAccessDenied', message: string } | { __typename: 'FileDoesNotExists', message: string } | { __typename: 'InputValidationError' }> } | { __typename: 'DuplicateFilesSuccess', file_ids: Array<string> } | null };

export type UpdatePermissionsFileForm_FileFragment = { __typename?: 'files', name: string, id: string, permission?: { __typename?: 'file_permissions', orgs: Array<{ __typename?: 'file_permissions_orgs', access: File_Access_Enum_Enum, org: { __typename?: 'orgs', id: string } }>, teams: Array<{ __typename?: 'file_permissions_teams', access: File_Access_Enum_Enum, team: { __typename?: 'teams', id: string } }>, users: Array<{ __typename?: 'file_permissions_users', access: File_Access_Enum_Enum, user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null } & { ' $fragmentName'?: 'UpdatePermissionsFileForm_FileFragment' };

export type GetFilePermissionsQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFilePermissionsQuery = { __typename?: 'query_root', files_by_pk?: (
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'UpdatePermissionsFileForm_FileFragment': UpdatePermissionsFileForm_FileFragment } }
  ) | null };

export type GetFilePermissionsOptionsQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFilePermissionsOptionsQuery = { __typename?: 'query_root', file?: { __typename?: 'files', suggestions_permissions_orgs?: Array<{ __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null }> | null, suggestions_permissions_teams?: Array<{ __typename?: 'teams', id: string, name: string, color: string }> | null, suggestions_permissions_users?: Array<{ __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }> | null } | null };

export type UpdatePermissionsFileMutationVariables = Exact<{
  input: UpdatePermissionsFileInput;
}>;


export type UpdatePermissionsFileMutation = { __typename?: 'mutation_root', updatePermissionsFile?: { __typename: 'UpdatePermissionFileSuccess', file_id: string } | { __typename: 'UpdatePermissionsFileErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileDoesNotExists' } | { __typename: 'InputValidationError' } | { __typename: 'PermissionsConflictError' }> } | null };

export type RenameFileForm_FileFragment = { __typename?: 'files', id: string, name: string } & { ' $fragmentName'?: 'RenameFileForm_FileFragment' };

export type RenameFileMutationVariables = Exact<{
  input: RenameFileInput;
}>;


export type RenameFileMutation = { __typename?: 'mutation_root', renameFile?: { __typename: 'RenameFileErrors' } | { __typename: 'RenameFileSuccess', file_id: string } | null };

export type DownloadFolderMutationVariables = Exact<{
  folderId: Scalars['uuid']['input'];
}>;


export type DownloadFolderMutation = { __typename?: 'mutation_root', downloadFolder?: { __typename: 'DownloadFolderErrors', errors: Array<{ __typename: 'FolderAccessDenied' } | { __typename: 'FolderDoesNotExists' } | { __typename: 'InputValidationError' }> } | { __typename: 'DownloadFolderSuccess' } | null };

export type FileInfoDrawerContentDataQueryVariables = Exact<{
  folderId: Scalars['uuid']['input'];
}>;


export type FileInfoDrawerContentDataQuery = { __typename?: 'query_root', folders_by_pk?: { __typename?: 'folders', id: string, name: string, created_at: string, folders: Array<{ __typename?: 'folders', id: string }>, files: Array<{ __typename?: 'files', id: string }>, creator?: (
      { __typename?: 'users' }
      & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UserFragment': FolderInfoDrawerContent_UserFragment } }
    ) | null, permission?: { __typename?: 'folder_permissions', teams: Array<{ __typename?: 'folder_permissions_teams', id: string, created_at: string, team: (
          { __typename?: 'teams' }
          & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_TeamFragment': FolderInfoDrawerContent_TeamFragment } }
        ), creator?: (
          { __typename?: 'users' }
          & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UserFragment': FolderInfoDrawerContent_UserFragment } }
        ) | null }>, orgs: Array<{ __typename?: 'folder_permissions_orgs', created_at: string, org: (
          { __typename?: 'orgs' }
          & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_OrgFragment': FolderInfoDrawerContent_OrgFragment } }
        ), creator?: (
          { __typename?: 'users' }
          & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UserFragment': FolderInfoDrawerContent_UserFragment } }
        ) | null }>, users: Array<{ __typename?: 'folder_permissions_users', created_at: string, user: (
          { __typename?: 'users' }
          & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UserFragment': FolderInfoDrawerContent_UserFragment } }
        ), creator?: (
          { __typename?: 'users' }
          & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UserFragment': FolderInfoDrawerContent_UserFragment } }
        ) | null }> } | null, assignation?: { __typename?: 'folder_assignations', users: Array<(
        { __typename?: 'folder_assignations_users' }
        & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UsersFragment': FolderInfoDrawerContent_UsersFragment } }
      )> } | null } | null };

export type FolderInfoDrawerContent_UsersFragment = { __typename?: 'folder_assignations_users', created_at: string, creator?: (
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UserFragment': FolderInfoDrawerContent_UserFragment } }
  ) | null, user: (
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'FolderInfoDrawerContent_UserFragment': FolderInfoDrawerContent_UserFragment } }
  ) } & { ' $fragmentName'?: 'FolderInfoDrawerContent_UsersFragment' };

export type FolderInfoDrawerContent_UserFragment = { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } & { ' $fragmentName'?: 'FolderInfoDrawerContent_UserFragment' };

export type FolderInfoDrawerContent_TeamFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'FolderInfoDrawerContent_TeamFragment' };

export type FolderInfoDrawerContent_OrgFragment = { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } & { ' $fragmentName'?: 'FolderInfoDrawerContent_OrgFragment' };

export type DeleteFolderMutationVariables = Exact<{
  input: DeleteFolderInput;
}>;


export type DeleteFolderMutation = { __typename?: 'mutation_root', deleteFolder?: { __typename: 'DeleteFolderErrors' } | { __typename: 'DeleteFolderSuccess', folder_id: string } | null };

export type UpdatePermissionsFolderForm_FolderFragment = { __typename?: 'folders', name: string, id: string, creator_id?: string | null, permission?: { __typename?: 'folder_permissions', orgs: Array<{ __typename?: 'folder_permissions_orgs', access: Folder_Access_Enum_Enum, org: { __typename?: 'orgs', id: string } }>, teams: Array<{ __typename?: 'folder_permissions_teams', access: Folder_Access_Enum_Enum, team: { __typename?: 'teams', id: string } }>, users: Array<{ __typename?: 'folder_permissions_users', access: Folder_Access_Enum_Enum, user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null, creator?: { __typename?: 'users', id: string, full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org_id: string } | null } | null } & { ' $fragmentName'?: 'UpdatePermissionsFolderForm_FolderFragment' };

export type GetFolderPermissionsQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
}>;


export type GetFolderPermissionsQuery = { __typename?: 'query_root', folders_by_pk?: (
    { __typename?: 'folders' }
    & { ' $fragmentRefs'?: { 'UpdatePermissionsFolderForm_FolderFragment': UpdatePermissionsFolderForm_FolderFragment } }
  ) | null };

export type GetFolderPermissionsOptionsQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
}>;


export type GetFolderPermissionsOptionsQuery = { __typename?: 'query_root', folder?: { __typename?: 'folders', id: string, suggestions_permissions_orgs?: Array<{ __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null }> | null, suggestions_permissions_teams?: Array<{ __typename?: 'teams', id: string, name: string, color: string }> | null, suggestions_permissions_users?: Array<{ __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }> | null } | null };

export type UpdatePermissionsFolderMutationVariables = Exact<{
  input: UpdatePermissionsFolderInput;
}>;


export type UpdatePermissionsFolderMutation = { __typename?: 'mutation_root', updatePermissionsFolder?: { __typename: 'UpdatePermissionFolderSuccess', folder_id: string } | { __typename: 'UpdatePermissionsFolderErrors', errors: Array<{ __typename: 'FolderAccessDenied' } | { __typename: 'FolderDoesNotExists' } | { __typename: 'InputValidationError' } | { __typename: 'PermissionsConflictError' }> } | null };

export type RenameFolderForm_FolderFragment = { __typename?: 'folders', name: string, id: string } & { ' $fragmentName'?: 'RenameFolderForm_FolderFragment' };

export type RenameFolderMutationVariables = Exact<{
  input: RenameFolderInput;
}>;


export type RenameFolderMutation = { __typename?: 'mutation_root', renameFolder?: { __typename: 'RenameFolderErrors' } | { __typename: 'RenameFolderSuccess', folder_id: string } | null };

export type DocsFiltersSelected_UsersFragment = { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } & { ' $fragmentName'?: 'DocsFiltersSelected_UsersFragment' };

export type DocsFiltersSelected_LabelsFragment = { __typename?: 'project_labels', id: string, name: string, color: string } & { ' $fragmentName'?: 'DocsFiltersSelected_LabelsFragment' };

export type DocsFilterSelected_DataQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  labelIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DocsFilterSelected_DataQuery = { __typename?: 'query_root', users: Array<(
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'DocsFiltersSelected_UsersFragment': DocsFiltersSelected_UsersFragment } }
  )>, project_labels: Array<(
    { __typename?: 'project_labels' }
    & { ' $fragmentRefs'?: { 'DocsFiltersSelected_LabelsFragment': DocsFiltersSelected_LabelsFragment } }
  )> };

export type MoveFilesMutationVariables = Exact<{
  input: MoveFilesInput;
}>;


export type MoveFilesMutation = { __typename?: 'mutation_root', moveFiles?: { __typename: 'MoveFilesErrors', errors: Array<{ __typename: 'FileAccessDenied' } | { __typename: 'FileDoesNotExists' } | { __typename: 'InputValidationError' } | { __typename: 'PermissionsConflictError' }> } | { __typename: 'MoveFilesSuccess', file_ids: Array<string> } | null };

export type MoveFoldersMutationVariables = Exact<{
  input: MoveFoldersInput;
}>;


export type MoveFoldersMutation = { __typename?: 'mutation_root', moveFolders?: { __typename: 'MoveFoldersErrors', errors: Array<{ __typename: 'FolderAccessDenied' } | { __typename: 'FolderCannotBeMoveInAnotherProject' } | { __typename: 'FolderDoesNotExists' } | { __typename: 'InputValidationError' } | { __typename: 'PermissionsConflictError' }> } | { __typename: 'MoveFoldersSuccess', folder_ids: Array<string> } | null };

export type EnableFilesApprovalsMutationVariables = Exact<{
  fileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type EnableFilesApprovalsMutation = { __typename?: 'mutation_root', updateFilesApprovalMode?: { __typename: 'UpdateFilesApprovalModeErrors', errors: Array<{ __typename: 'CannotRemoveApprovalOnFile' } | { __typename: 'FileAccessDenied', message: string } | { __typename: 'FileDoesNotExists', message: string } | { __typename: 'InputValidationError' }> } | { __typename: 'UpdateFilesApprovalModeSuccess' } | null };

export type DisableFilesApprovalsMutationVariables = Exact<{
  fileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DisableFilesApprovalsMutation = { __typename?: 'mutation_root', updateFilesApprovalMode?: { __typename: 'UpdateFilesApprovalModeErrors', errors: Array<{ __typename: 'CannotRemoveApprovalOnFile', message: string } | { __typename: 'FileAccessDenied', message: string } | { __typename: 'FileDoesNotExists', message: string } | { __typename: 'InputValidationError' }> } | { __typename: 'UpdateFilesApprovalModeSuccess' } | null };

export type UpdateAssignationsFilesFoldersForm_FolderFragment = { __typename?: 'folders', name: string, id: string, assignation?: { __typename?: 'folder_assignations', orgs: Array<{ __typename?: 'folder_assignations_orgs', org: { __typename?: 'orgs', id: string } }>, teams: Array<{ __typename?: 'folder_assignations_teams', team: { __typename?: 'teams', id: string } }>, users: Array<{ __typename?: 'folder_assignations_users', user: { __typename?: 'users', id: string } }> } | null } & { ' $fragmentName'?: 'UpdateAssignationsFilesFoldersForm_FolderFragment' };

export type UpdateAssignationsFilesFoldersForm_FileFragment = { __typename?: 'files', id: string, name: string, assignation?: { __typename?: 'file_assignations', orgs: Array<{ __typename?: 'file_assignations_orgs', org: { __typename?: 'orgs', id: string } }>, teams: Array<{ __typename?: 'file_assignations_teams', team: { __typename?: 'teams', id: string } }>, users: Array<{ __typename?: 'file_assignations_users', user: { __typename?: 'users', id: string } }> } | null } & { ' $fragmentName'?: 'UpdateAssignationsFilesFoldersForm_FileFragment' };

export type GetFilesFoldersAssignationsQueryVariables = Exact<{
  folder_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  file_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetFilesFoldersAssignationsQuery = { __typename?: 'query_root', folders: Array<(
    { __typename?: 'folders' }
    & { ' $fragmentRefs'?: { 'UpdateAssignationsFilesFoldersForm_FolderFragment': UpdateAssignationsFilesFoldersForm_FolderFragment } }
  )>, files: Array<(
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'UpdateAssignationsFilesFoldersForm_FileFragment': UpdateAssignationsFilesFoldersForm_FileFragment } }
  )> };

export type UpdateFilesFoldersAssignationsMutationVariables = Exact<{
  input: UpdateAssignationsFilesFoldersInput;
}>;


export type UpdateFilesFoldersAssignationsMutation = { __typename?: 'mutation_root', updateAssignationsFilesFolders?: { __typename: 'UpdateAssignationsFilesFoldersErrors' } | { __typename: 'UpdateAssignationsFilesFoldersSuccess', folder_ids: Array<string>, file_ids: Array<string> } | null };

export type UpdateLabelsFilesFolderForm_FolderFragment = { __typename?: 'folders', labels: Array<{ __typename?: 'folders_to_project_labels', label: { __typename?: 'project_labels', id: string } }> } & { ' $fragmentName'?: 'UpdateLabelsFilesFolderForm_FolderFragment' };

export type UpdateLabelsFilesFolderForm_FileFragment = { __typename?: 'files', labels: Array<{ __typename?: 'files_to_project_labels', label: { __typename?: 'project_labels', id: string } }> } & { ' $fragmentName'?: 'UpdateLabelsFilesFolderForm_FileFragment' };

export type GetFilesFoldersLabelsQueryVariables = Exact<{
  folder_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  file_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetFilesFoldersLabelsQuery = { __typename?: 'query_root', folders: Array<(
    { __typename?: 'folders' }
    & { ' $fragmentRefs'?: { 'UpdateLabelsFilesFolderForm_FolderFragment': UpdateLabelsFilesFolderForm_FolderFragment } }
  )>, files: Array<(
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'UpdateLabelsFilesFolderForm_FileFragment': UpdateLabelsFilesFolderForm_FileFragment } }
  )> };

export type RequestUsersApprovalsFilesForm_FileFragment = { __typename?: 'files', id: string, name: string, assignation?: { __typename?: 'file_assignations', users: Array<{ __typename?: 'file_assignations_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null } & { ' $fragmentName'?: 'RequestUsersApprovalsFilesForm_FileFragment' };

export type GetFileUsersRequestsQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFileUsersRequestsQuery = { __typename?: 'query_root', files_by_pk?: (
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'RequestUsersApprovalsFilesForm_FileFragment': RequestUsersApprovalsFilesForm_FileFragment } }
  ) | null };

export type GetRequestApprovalsUserOptionsQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetRequestApprovalsUserOptionsQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', id: string, suggestions_assignations_users?: Array<{ __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }> | null } | null };

export type RequestUsersApprovalsFilesMutationVariables = Exact<{
  input: RequestUsersApprovalsFilesInput;
}>;


export type RequestUsersApprovalsFilesMutation = { __typename?: 'mutation_root', requestUsersApprovalsFiles?: { __typename: 'RequestUsersApprovalsFilesErrors' } | { __typename: 'RequestUsersApprovalsFilesSuccess', file_ids: Array<string> } | null };

export type UpdateAssignationsFileForm_FileFragment = { __typename?: 'files', id: string, name: string, assignation?: { __typename?: 'file_assignations', orgs: Array<{ __typename?: 'file_assignations_orgs', org: { __typename?: 'orgs', id: string } }>, teams: Array<{ __typename?: 'file_assignations_teams', team: { __typename?: 'teams', id: string } }>, users: Array<{ __typename?: 'file_assignations_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null } & { ' $fragmentName'?: 'UpdateAssignationsFileForm_FileFragment' };

export type UpdateAssignationsFileFormSelectInput_OrgFragment = { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } & { ' $fragmentName'?: 'UpdateAssignationsFileFormSelectInput_OrgFragment' };

export type UpdateAssignationsFileFormSelectInput_TeamFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'UpdateAssignationsFileFormSelectInput_TeamFragment' };

export type UpdateAssignationsFileFormSelectInput_UserFragment = { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } & { ' $fragmentName'?: 'UpdateAssignationsFileFormSelectInput_UserFragment' };

export type GetFileAssignationsQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFileAssignationsQuery = { __typename?: 'query_root', files_by_pk?: (
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'UpdateAssignationsFileForm_FileFragment': UpdateAssignationsFileForm_FileFragment } }
  ) | null };

export type GetFileAssignationsOptionsQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFileAssignationsOptionsQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', id: string, suggestions_assignations_orgs?: Array<(
      { __typename?: 'orgs' }
      & { ' $fragmentRefs'?: { 'UpdateAssignationsFileFormSelectInput_OrgFragment': UpdateAssignationsFileFormSelectInput_OrgFragment } }
    )> | null, suggestions_assignations_teams?: Array<(
      { __typename?: 'teams' }
      & { ' $fragmentRefs'?: { 'UpdateAssignationsFileFormSelectInput_TeamFragment': UpdateAssignationsFileFormSelectInput_TeamFragment } }
    )> | null, suggestions_assignations_users?: Array<(
      { __typename?: 'users' }
      & { ' $fragmentRefs'?: { 'UpdateAssignationsFileFormSelectInput_UserFragment': UpdateAssignationsFileFormSelectInput_UserFragment } }
    )> | null } | null };

export type UpdateAssignationsFilesMutationVariables = Exact<{
  input: UpdateAssignationsFilesInput;
}>;


export type UpdateAssignationsFilesMutation = { __typename?: 'mutation_root', updateAssignationsFiles?: { __typename: 'UpdateAssignationsFilesErrors' } | { __typename: 'UpdateAssignationsFilesSuccess', file_ids: Array<string> } | null };

export type UpdateAssignationsFolderForm_FolderFragment = { __typename?: 'folders', name: string, id: string, assignee_automation_mode: boolean, approval_automation_mode: boolean, duedate_automation_mode?: number | null, assignation?: { __typename?: 'folder_assignations', orgs: Array<{ __typename?: 'folder_assignations_orgs', org: { __typename?: 'orgs', id: string } }>, teams: Array<{ __typename?: 'folder_assignations_teams', team: { __typename?: 'teams', id: string } }>, users: Array<{ __typename?: 'folder_assignations_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null } & { ' $fragmentName'?: 'UpdateAssignationsFolderForm_FolderFragment' };

export type GetFolderAssignationsQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
}>;


export type GetFolderAssignationsQuery = { __typename?: 'query_root', folders_by_pk?: (
    { __typename?: 'folders' }
    & { ' $fragmentRefs'?: { 'UpdateAssignationsFolderForm_FolderFragment': UpdateAssignationsFolderForm_FolderFragment } }
  ) | null };

export type GetFolderAssignationsOptionsQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
}>;


export type GetFolderAssignationsOptionsQuery = { __typename?: 'query_root', folder?: { __typename?: 'folders', id: string, suggestions_assignations_orgs?: Array<{ __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null }> | null, suggestions_assignations_teams?: Array<{ __typename?: 'teams', id: string, name: string, color: string }> | null, suggestions_assignations_users?: Array<{ __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }> | null } | null };

export type UpdateAssignationsFoldersMutationVariables = Exact<{
  input: UpdateAssignationsFoldersInput;
}>;


export type UpdateAssignationsFoldersMutation = { __typename?: 'mutation_root', updateAssignationsFolders?: { __typename: 'UpdateAssignationsFoldersErrors' } | { __typename: 'UpdateAssignationsFoldersSuccess', folder_ids: Array<string> } | null };

export type UpdateDueDateFileForm_FileFragment = { __typename?: 'files', id: string, due_date?: string | null } & { ' $fragmentName'?: 'UpdateDueDateFileForm_FileFragment' };

export type UpdateDueDateFileMutationVariables = Exact<{
  input: UpdateDueDateFileInput;
}>;


export type UpdateDueDateFileMutation = { __typename?: 'mutation_root', updateDueDateFile?: { __typename: 'UpdateDueDateFileErrors' } | { __typename: 'UpdateDueDateFileSuccess', file_id: string } | null };

export type UpdateLabelsFileForm_FileFragment = { __typename?: 'files', labels: Array<{ __typename?: 'files_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }> } & { ' $fragmentName'?: 'UpdateLabelsFileForm_FileFragment' };

export type GetFileLabelsQueryVariables = Exact<{
  file_id: Scalars['uuid']['input'];
}>;


export type GetFileLabelsQuery = { __typename?: 'query_root', files_by_pk?: (
    { __typename?: 'files' }
    & { ' $fragmentRefs'?: { 'UpdateLabelsFileForm_FileFragment': UpdateLabelsFileForm_FileFragment } }
  ) | null };

export type UpdateLabelsFilesMutationVariables = Exact<{
  input: UpdateLabelsFilesInput;
}>;


export type UpdateLabelsFilesMutation = { __typename?: 'mutation_root', updateLabelsFiles?: { __typename: 'UpdateLabelsFilesErrors' } | { __typename: 'UpdateLabelsFilesSuccess', file_ids: Array<string> } | null };

export type UpdateLabelsFolderForm_FolderFragment = { __typename?: 'folders', labels: Array<{ __typename?: 'folders_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }> } & { ' $fragmentName'?: 'UpdateLabelsFolderForm_FolderFragment' };

export type GetFolderLabelsQueryVariables = Exact<{
  folder_id: Scalars['uuid']['input'];
}>;


export type GetFolderLabelsQuery = { __typename?: 'query_root', folders_by_pk?: (
    { __typename?: 'folders', id: string }
    & { ' $fragmentRefs'?: { 'UpdateLabelsFolderForm_FolderFragment': UpdateLabelsFolderForm_FolderFragment } }
  ) | null };

export type UpdateLabelsFoldersMutationVariables = Exact<{
  input: UpdateLabelsFoldersInput;
}>;


export type UpdateLabelsFoldersMutation = { __typename?: 'mutation_root', updateLabelsFolders?: { __typename: 'UpdateLabelsFoldersErrors' } | { __typename: 'UpdateLabelsFoldersSuccess', folder_ids: Array<string> } | null };

export type FolderViewersDetailsDrawerContent_DataQueryVariables = Exact<{
  folderId: Scalars['uuid']['input'];
}>;


export type FolderViewersDetailsDrawerContent_DataQuery = { __typename?: 'query_root', folders_by_pk?: { __typename?: 'folders', id: string, views: Array<{ __typename?: 'folder_views', created_at: string, updated_at: string, user: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type InfosScreenActionsExtraButton_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type InfosScreenActionsExtraButton_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org_project_summary?: Array<{ __typename?: 'org_project_summary', is_project_template: boolean, id: string, is_archived: boolean }> | null, org: Array<{ __typename?: 'orgs', id: string }> } | null };

export type UpdateProjectTemplateMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  isProjectTemplate: Scalars['Boolean']['input'];
}>;


export type UpdateProjectTemplateMutation = { __typename?: 'mutation_root', updateProjectTemplate?: { __typename: 'UpdateProjectTemplateErrors' } | { __typename: 'UpdateProjectTemplateSuccess' } | null };

export type InviteParticipantsButton_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type InviteParticipantsButton_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org: Array<{ __typename?: 'orgs', id: string }> } | null };

export type MemberFilterSelected_OrgsFragment = { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } & { ' $fragmentName'?: 'MemberFilterSelected_OrgsFragment' };

export type MemberFilterSelected_TeamsFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'MemberFilterSelected_TeamsFragment' };

export type MemberFilterSelected_DataQueryVariables = Exact<{
  orgIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  teamIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type MemberFilterSelected_DataQuery = { __typename?: 'query_root', orgs: Array<(
    { __typename?: 'orgs' }
    & { ' $fragmentRefs'?: { 'MemberFilterSelected_OrgsFragment': MemberFilterSelected_OrgsFragment } }
  )>, teams: Array<(
    { __typename?: 'teams' }
    & { ' $fragmentRefs'?: { 'MemberFilterSelected_TeamsFragment': MemberFilterSelected_TeamsFragment } }
  )> };

export type MembersFiltersFormSelectInput_OrgFragment = { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } & { ' $fragmentName'?: 'MembersFiltersFormSelectInput_OrgFragment' };

export type MembersFiltersFormSelectInput_TeamFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'MembersFiltersFormSelectInput_TeamFragment' };

export type GetMembersSelectOptionsQueryVariables = Exact<{
  filters?: InputMaybe<Projects_Bool_Exp>;
}>;


export type GetMembersSelectOptionsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', teams: Array<(
      { __typename?: 'teams' }
      & { ' $fragmentRefs'?: { 'MembersFiltersFormSelectInput_TeamFragment': MembersFiltersFormSelectInput_TeamFragment } }
    )>, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', role: { __typename?: 'org_roles', name: string }, org: (
            { __typename?: 'orgs' }
            & { ' $fragmentRefs'?: { 'MembersFiltersFormSelectInput_OrgFragment': MembersFiltersFormSelectInput_OrgFragment } }
          ) } | null } }> }> };

export type ProjectMembersTabsCounter_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectMembersTabsCounter_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string } }>, org: Array<{ __typename?: 'orgs', id: string }> } | null };

export type ProjectEditScreen_ProjectQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ProjectEditScreen_ProjectQuery = { __typename?: 'query_root', project?: (
    { __typename?: 'projects', org: Array<{ __typename?: 'orgs', id: string }>, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, is_archived: boolean, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', color: string, id: string, name: string } }> }> | null }
    & { ' $fragmentRefs'?: { 'ProfileForm_ProjectFragment': ProfileForm_ProjectFragment } }
  ) | null };

export type PrepareProjectAssetForUploadMutationVariables = Exact<{
  input: PrepareProjectAssetForUploadInput;
}>;


export type PrepareProjectAssetForUploadMutation = { __typename?: 'mutation_root', prepareProjectAssetForUpload?: { __typename: 'PrepareProjectAssetForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' }> } | { __typename: 'PrepareProjectAssetForUploadSuccess', key: string, url: string } | null };

export type ProfileForm_ProjectFragment = { __typename?: 'projects', id: string, name: string, description?: string | null, background?: string | null, banner?: string | null, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, address?: { __typename?: 'project_address', street?: string | null, postal_code?: string | null, city?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, is_archived: boolean }> | null } & { ' $fragmentName'?: 'ProfileForm_ProjectFragment' };

export type UpdateProjectProfileMutationVariables = Exact<{
  input: UpdateProjectProfileInput;
}>;


export type UpdateProjectProfileMutation = { __typename?: 'mutation_root', updateProjectProfile?: { __typename: 'UpdateProjectProfileErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'ProjectDoesNotExist' } | { __typename: 'UpdateProjectProfilePermissionDenied' }> } | { __typename: 'UpdateProjectProfileSuccess', project_id: string } | null };

export type ProjectMembersList_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  filters?: InputMaybe<Projects_To_Users_Bool_Exp>;
}>;


export type ProjectMembersList_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org: Array<{ __typename?: 'orgs', id: string }>, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, first_name: string, last_name: string, company_name?: string | null, is_active: boolean, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, teams: Array<{ __typename?: 'teams_to_users', team_id: string, team: { __typename?: 'teams', name: string, color: string } }>, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null, contact?: { __typename?: 'user_contact', id?: string | null, phone?: string | null, email?: string | null } | null, connections: Array<{ __typename?: 'user_connections', created_at: string }> }, role: { __typename?: 'project_roles', name: string }, inviter?: { __typename?: 'users', id: string } | null }> } | null };

export type UpdateProjectRoleMutationVariables = Exact<{
  input: UpdateProjectRoleInput;
}>;


export type UpdateProjectRoleMutation = { __typename?: 'mutation_root', updateProjectRole?: { __typename: 'UpdateProjectRoleErrors' } | { __typename: 'UpdateProjectRoleSuccess', project_id: string } | null };

export type UpdateUserTeamsMutationVariables = Exact<{
  input: UpdateUserTeamsInput;
}>;


export type UpdateUserTeamsMutation = { __typename?: 'mutation_root', updateUserTeams?: { __typename: 'UpdateUserTeamsErrors' } | { __typename: 'UpdateUserTeamsSuccess', team_ids: Array<string | null> } | null };

export type UpdateProjectUserInfosMutationVariables = Exact<{
  input: UpdateProjectUserInfosInput;
}>;


export type UpdateProjectUserInfosMutation = { __typename?: 'mutation_root', updateProjectUserInfos?: { __typename: 'UpdateProjectUserInfosErrors', errors: Array<{ __typename: 'CannotModifyEmailOfActiveUser' } | { __typename: 'CannotSetGreaterProjectRoleThanYours' } | { __typename: 'EmailAlreadyUsedByAnotherUser' } | { __typename: 'InputValidationError' } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' } | { __typename: 'ProjectNeedsAtLeastOneOwner' } | { __typename: 'TeamAccessDenied' } | { __typename: 'TeamDoesNotExist' } | { __typename: 'UpdateProjectUserInfosPermissionDenied' } | { __typename: 'UserDoesNotExist' }> } | { __typename: 'UpdateProjectUserInfosSuccess', project_id: string } | null };

export type PrepareProjectUserAvatarForUploadMutationVariables = Exact<{
  input: PrepareProjectUserAvatarForUploadInput;
}>;


export type PrepareProjectUserAvatarForUploadMutation = { __typename?: 'mutation_root', prepareProjectUserAvatarForUpload?: { __typename: 'PrepareProjectUserAvatarForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' } | { __typename: 'UpdateProjectUserInfosPermissionDenied' } | { __typename: 'UserDoesNotExist' }> } | { __typename: 'PrepareProjectUserAvatarForUploadSuccess', key: string, url: string } | null };

export type EditUserForm_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type EditUserForm_DataQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', first_name: string, last_name: string, company_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string, id: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null } }> }> };

export type ProjectProfileScreen_ProjectFragment = { __typename?: 'projects', id: string, name: string, banner?: string | null, description?: string | null, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, teams: Array<{ __typename?: 'teams', id: string, name: string, color: string }>, labels: Array<{ __typename?: 'project_labels', color: string, id: string, name: string }>, address?: { __typename?: 'project_address', lat?: number | null, lng?: number | null, street?: string | null, postal_code?: string | null, city?: string | null } | null, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string } }>, org: Array<{ __typename?: 'orgs', id: string }>, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, is_archived: boolean, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', color: string, id: string, name: string } }> }> | null } & { ' $fragmentName'?: 'ProjectProfileScreen_ProjectFragment' };

export type ProjectTemplatesFragmentFragment = { __typename?: 'projects', id: string, name: string, description?: string | null, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, is_project_template: boolean }> | null, org: Array<{ __typename?: 'orgs', id: string }> } & { ' $fragmentName'?: 'ProjectTemplatesFragmentFragment' };

export type ProjectProfileScreen_ProjectQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type ProjectProfileScreen_ProjectQuery = { __typename?: 'query_root', project?: (
    { __typename?: 'projects', tasks: Array<(
      { __typename?: 'tasks' }
      & { ' $fragmentRefs'?: { 'MetricsData_TaskFragment': MetricsData_TaskFragment } }
    )>, tasks_aggregate: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null } }
    & { ' $fragmentRefs'?: { 'ProjectProfileScreen_ProjectFragment': ProjectProfileScreen_ProjectFragment } }
  ) | null, approvals?: { __typename?: 'users', id: string, file_version_approval_request_users: Array<(
      { __typename?: 'file_version_approval_request_users' }
      & { ' $fragmentRefs'?: { 'ApprovalRequestItem_DataFragment': ApprovalRequestItem_DataFragment } }
    )>, file_version_approval_request_users_aggregate: { __typename?: 'file_version_approval_request_users_aggregate', aggregate?: { __typename?: 'file_version_approval_request_users_aggregate_fields', count: number } | null } } | null };

export type ProjectTemplatesQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type ProjectTemplatesQuery = { __typename?: 'query_root', templates: Array<{ __typename?: 'org_project_summary', id: string, project: (
      { __typename?: 'projects' }
      & { ' $fragmentRefs'?: { 'ProjectTemplatesFragmentFragment': ProjectTemplatesFragmentFragment } }
    ) }> };

export type ProjectOrgData_Org_Project_SummaryFragment = { __typename?: 'org_project_summary', id: string, reference?: string | null, is_archived: boolean, start_date?: string | null, end_date?: string | null, client_fullname?: string | null, client_email?: string | null, client_phone_number?: string | null, price_estimate?: string | null, hours_done?: number | null, hours_expected?: number | null, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: { __typename?: 'project_categories', color: string, name: string, id: string } }>, project_groups: Array<{ __typename?: 'org_project_summary_to_project_groups', project_group: { __typename?: 'project_groups', color: string, name: string } }> } & { ' $fragmentName'?: 'ProjectOrgData_Org_Project_SummaryFragment' };

export type ProjectOrgData_OrgProjectSummaryQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectOrgData_OrgProjectSummaryQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org_project_summary?: Array<(
      { __typename?: 'org_project_summary' }
      & { ' $fragmentRefs'?: { 'ProjectOrgData_Org_Project_SummaryFragment': ProjectOrgData_Org_Project_SummaryFragment } }
    )> | null } | null };

export type CreateOrgProjectSummaryMutationVariables = Exact<{
  input: CreateOrgProjectSummaryInput;
}>;


export type CreateOrgProjectSummaryMutation = { __typename?: 'mutation_root', createOrgProjectSummary?: { __typename: 'CreateOrgProjectSummaryErrors' } | { __typename: 'CreateOrgProjectSummarySuccess', org_project_summary_id: string } | null };

export type CreateOrgProjectSummaryForm_Project_CategoriesFragment = { __typename?: 'project_categories', id: string, color: string, name: string } & { ' $fragmentName'?: 'CreateOrgProjectSummaryForm_Project_CategoriesFragment' };

export type GetCreateOrgProjectSummaryCategoriesOptionsQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetCreateOrgProjectSummaryCategoriesOptionsQuery = { __typename?: 'query_root', project_categories: Array<(
    { __typename?: 'project_categories' }
    & { ' $fragmentRefs'?: { 'CreateOrgProjectSummaryForm_Project_CategoriesFragment': CreateOrgProjectSummaryForm_Project_CategoriesFragment } }
  )> };

export type GetOrgProjectSummaryIdQueryVariables = Exact<{
  orgProjectSummaryId: Scalars['uuid']['input'];
}>;


export type GetOrgProjectSummaryIdQuery = { __typename?: 'query_root', org_project_summary_by_pk?: { __typename?: 'org_project_summary', id: string, org_id: string, project: { __typename?: 'projects', id: string, name: string } } | null };

export type UpdateOrgProjectSummaryForm_Project_CategoriesFragment = { __typename?: 'project_categories', id: string, color: string, name: string } & { ' $fragmentName'?: 'UpdateOrgProjectSummaryForm_Project_CategoriesFragment' };

export type UpdateOrgProjectSummaryForm_Org_Project_SummaryFragment = { __typename?: 'org_project_summary', id: string, org_id: string, reference?: string | null, start_date?: string | null, end_date?: string | null, client_fullname?: string | null, client_email?: string | null, client_phone_number?: string | null, price_estimate?: string | null, hours_expected?: number | null, hours_done?: number | null, project_id: string, project_categories: Array<{ __typename?: 'org_project_summary_to_project_categories', project_category: (
      { __typename?: 'project_categories' }
      & { ' $fragmentRefs'?: { 'UpdateOrgProjectSummaryForm_Project_CategoriesFragment': UpdateOrgProjectSummaryForm_Project_CategoriesFragment } }
    ) }>, project_groups: Array<{ __typename?: 'org_project_summary_to_project_groups', project_group: (
      { __typename?: 'project_groups' }
      & { ' $fragmentRefs'?: { 'UpdateOrgProjectSummaryForm_Project_GroupsFragment': UpdateOrgProjectSummaryForm_Project_GroupsFragment } }
    ) }> } & { ' $fragmentName'?: 'UpdateOrgProjectSummaryForm_Org_Project_SummaryFragment' };

export type UpdateOrgProjectSummaryForm_Project_GroupsFragment = { __typename?: 'project_groups', id: string, color: string, name: string, project_group_avatar?: { __typename?: 'project_group_avatars', public_url: string } | null } & { ' $fragmentName'?: 'UpdateOrgProjectSummaryForm_Project_GroupsFragment' };

export type GetOrgProjectSummaryQueryVariables = Exact<{
  orgProjectSummaryId: Scalars['uuid']['input'];
}>;


export type GetOrgProjectSummaryQuery = { __typename?: 'query_root', org_project_summary_by_pk?: (
    { __typename?: 'org_project_summary' }
    & { ' $fragmentRefs'?: { 'UpdateOrgProjectSummaryForm_Org_Project_SummaryFragment': UpdateOrgProjectSummaryForm_Org_Project_SummaryFragment } }
  ) | null };

export type GetUpdateOrgProjectSummaryCategoriesOptionsQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetUpdateOrgProjectSummaryCategoriesOptionsQuery = { __typename?: 'query_root', project_categories: Array<(
    { __typename?: 'project_categories' }
    & { ' $fragmentRefs'?: { 'UpdateOrgProjectSummaryForm_Project_CategoriesFragment': UpdateOrgProjectSummaryForm_Project_CategoriesFragment } }
  )> };

export type GetUpdateOrgProjectSummaryGroupsOptionsQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetUpdateOrgProjectSummaryGroupsOptionsQuery = { __typename?: 'query_root', project_groups: Array<(
    { __typename?: 'project_groups' }
    & { ' $fragmentRefs'?: { 'UpdateOrgProjectSummaryForm_Project_GroupsFragment': UpdateOrgProjectSummaryForm_Project_GroupsFragment } }
  )> };

export type UpdateOrgProjectSummaryMutationVariables = Exact<{
  input: UpdateOrgProjectSummaryInput;
}>;


export type UpdateOrgProjectSummaryMutation = { __typename?: 'mutation_root', updateOrgProjectSummary?: { __typename: 'UpdateOrgProjectSummaryErrors' } | { __typename: 'UpdateOrgProjectSummarySuccess', org_project_summary_id: string } | null };

export type ProjectClientsFragment = { __typename?: 'projects', org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, client_fullname?: string | null }> | null } & { ' $fragmentName'?: 'ProjectClientsFragment' };

export type GetProjectClientsFormOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectClientsFormOptionsQuery = { __typename?: 'query_root', projects: Array<(
    { __typename?: 'projects', id: string }
    & { ' $fragmentRefs'?: { 'ProjectClientsFragment': ProjectClientsFragment } }
  )>, projects_map_overview: Array<{ __typename?: 'projects_map_overview', id: string, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, client_fullname?: string | null }> | null }> };

export type UserProjectRoleQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type UserProjectRoleQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, is_demo: boolean, members: Array<{ __typename?: 'projects_to_users', role: { __typename?: 'project_roles', name: string } }> } | null };

export type AddUserViewToProjectMutationVariables = Exact<{
  input: AddUserViewToProjectInput;
}>;


export type AddUserViewToProjectMutation = { __typename?: 'mutation_root', addUserViewToProject?: { __typename: 'AddUserViewToProjectErrors' } | { __typename: 'AddUserViewToProjectSuccess' } | null };

export type ProjectLightDataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectLightDataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, labels: Array<{ __typename?: 'project_labels', id: string, name: string }>, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', full_name?: string | null, id: string } }>, teams: Array<{ __typename?: 'teams', id: string, name: string, color: string }> } | null };

export type CopyTaskDialog_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  taskId: Scalars['uuid']['input'];
}>;


export type CopyTaskDialog_DataQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, tasks: Array<{ __typename?: 'tasks', id: string, description: string, start_date?: string | null, end_date?: string | null, hours_expected?: number | null, hours_done?: number | null, labels: Array<{ __typename?: 'tasks_to_project_labels', project_label_id: string }>, location?: { __typename?: 'task_locations', lat: number, lng: number } | null, file_versions: Array<{ __typename?: 'tasks_file_versions', file_version: { __typename?: 'file_versions', id: string, name: string }, location?: { __typename?: 'task_file_version_location', page_number: number, x: number, y: number } | null }>, ancestors: Array<{ __typename?: 'task_dependencies', from_id: string, to_id: string }>, predecessors: Array<{ __typename?: 'task_dependencies', from_id: string, to_id: string }>, attachments: Array<{ __typename?: 'task_attachments', id: string, name: string }>, subtasks: Array<{ __typename?: 'task_subtasks', description: string, closed?: boolean | null, start_date?: string | null, end_date?: string | null }>, assignations?: { __typename?: 'task_assignations', orgs: Array<{ __typename?: 'task_assignations_orgs', org_id: string }>, teams: Array<{ __typename?: 'task_assignations_teams', team_id: string }>, users: Array<{ __typename?: 'task_assignations_users', user_id: string }> } | null }> } | null };

export type CreateTaskForm_ProjectLocationFragment = { __typename?: 'project_address', lat?: number | null, lng?: number | null } & { ' $fragmentName'?: 'CreateTaskForm_ProjectLocationFragment' };

export type CreateTaskForm_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type CreateTaskForm_DataQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, address?: (
      { __typename?: 'project_address' }
      & { ' $fragmentRefs'?: { 'CreateTaskForm_ProjectLocationFragment': CreateTaskForm_ProjectLocationFragment } }
    ) | null, tasks: Array<{ __typename?: 'tasks', created_at: string, id: string, description: string, end_date?: string | null, project_id: string, start_date?: string | null, number: number, assignations?: { __typename?: 'task_assignations', orgs: Array<{ __typename?: 'task_assignations_orgs', org_id: string }>, teams: Array<{ __typename?: 'task_assignations_teams', team_id: string }>, users: Array<{ __typename?: 'task_assignations_users', user_id: string }> } | null, file_versions: Array<{ __typename?: 'tasks_file_versions', file_version_id: string, location?: { __typename?: 'task_file_version_location', page_number: number, x: number, y: number } | null }>, labels: Array<{ __typename?: 'tasks_to_project_labels', project_label_id: string }>, location?: { __typename?: 'task_locations', lat: number, lng: number } | null, subtasks: Array<{ __typename?: 'task_subtasks', description: string, closed?: boolean | null }> }> } | null };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'mutation_root', createTask?: { __typename: 'CreateTaskErrors' } | { __typename: 'CreateTaskSuccess', task_id: string } | null };

export type PrepareTaskAttachmentForUploadMutationVariables = Exact<{
  input: PrepareTaskAttachmentForUploadInput;
}>;


export type PrepareTaskAttachmentForUploadMutation = { __typename?: 'mutation_root', prepareTaskAttachmentForUpload?: { __typename: 'PrepareTaskAttachmentForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'TaskAccessDenied' } | { __typename: 'TaskDoesNotExist' }> } | { __typename: 'PrepareTaskAttachmentForUploadSuccess', key: string, url: string } | null };

export type GetTaskDependenciesInformationQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetTaskDependenciesInformationQuery = { __typename?: 'query_root', tasks: Array<{ __typename?: 'tasks', description: string, id: string, number: number, is_validated_by?: string | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', color: string } }> }> };

export type UserFieldsFragment = { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null } & { ' $fragmentName'?: 'UserFieldsFragment' };

export type GetUsersQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUsersQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', role: { __typename?: 'project_roles', name: string }, user: (
        { __typename?: 'users' }
        & { ' $fragmentRefs'?: { 'UserFieldsFragment': UserFieldsFragment } }
      ) }> } | null };

export type GetTeamsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTeamsQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, teams: Array<{ __typename?: 'teams', id: string, name: string, color: string }> } | null };

export type FileBadge_FileVersionFragment = { __typename?: 'file_versions', id: string, name: string, content_type: string, url?: string | null, file_id: string, tasks: Array<{ __typename?: 'tasks_file_versions', location?: { __typename?: 'task_file_version_location', page_number: number, x: number, y: number } | null }> } & { ' $fragmentName'?: 'FileBadge_FileVersionFragment' };

export type FileBadge_DataQueryVariables = Exact<{
  fileVersionId: Scalars['uuid']['input'];
}>;


export type FileBadge_DataQuery = { __typename?: 'query_root', file_versions_by_pk?: (
    { __typename?: 'file_versions' }
    & { ' $fragmentRefs'?: { 'FileBadge_FileVersionFragment': FileBadge_FileVersionFragment } }
  ) | null };

export type PrepareTaskSpreadsheetForUploadMutationVariables = Exact<{
  input: PrepareTaskSpreadsheetForUploadInput;
}>;


export type PrepareTaskSpreadsheetForUploadMutation = { __typename?: 'mutation_root', prepareTaskSpreadsheetForUpload?: { __typename: 'PrepareTaskSpreadsheetForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' }> } | { __typename: 'PrepareTaskSpreadsheetForUploadSuccess', key: string, url: string } | null };

export type TaskImportRequestExcelTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type TaskImportRequestExcelTemplateMutation = { __typename?: 'mutation_root', taskImportRequestExcelTemplate?: { __typename: 'TaskImportRequestExcelTemplateErrors' } | { __typename: 'TaskImportRequestExcelTemplateSuccess', url: string } | null };

export type ProjectTasksListTabsCounter_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectTasksListTabsCounter_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, tasks: Array<{ __typename?: 'tasks', id: string }> } | null };

export type SelectFileDialog_DataQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
}>;


export type SelectFileDialog_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, root_folder_id?: string | null } | null };

export type UpdateSubTaskMutationVariables = Exact<{
  input: UpdateSubtaskInput;
}>;


export type UpdateSubTaskMutation = { __typename?: 'mutation_root', updateSubtask?: { __typename: 'UpdateSubtaskErrors' } | { __typename: 'UpdateSubtaskSuccess', subtask_id: string } | null };

export type GetTaskAssignationsOptionsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetTaskAssignationsOptionsQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null } }>, teams: Array<{ __typename?: 'teams', id: string, name: string, color: string }> } | null };

export type UpdateAssignationsTaskMutationVariables = Exact<{
  input: UpdateAssignationsTaskInput;
}>;


export type UpdateAssignationsTaskMutation = { __typename?: 'mutation_root', updateAssignationsTask?: { __typename: 'UpdateAssignationTaskSuccess', task_id: string } | { __typename: 'UpdateAssignationsTaskErrors' } | null };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'mutation_root', updateTask?: { __typename: 'UpdateTaskErrors' } | { __typename: 'UpdateTaskSuccess', task_id: string } | null };

export type ProjectTasksGantt_DependenciesFragment = { __typename?: 'task_dependencies', from_id: string, from_side: string, to_id: string, to_side: string, relationship_type?: string | null } & { ' $fragmentName'?: 'ProjectTasksGantt_DependenciesFragment' };

export type TaskEdit_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  taskId: Scalars['uuid']['input'];
}>;


export type TaskEdit_DataQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, tasks: Array<(
      { __typename?: 'tasks', number: number, deleted_at?: string | null, hours_done?: number | null, hours_expected?: number | null, ancestors: Array<(
        { __typename?: 'task_dependencies' }
        & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
      )>, predecessors: Array<(
        { __typename?: 'task_dependencies' }
        & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'UpdateTaskForm_DataFragment': UpdateTaskForm_DataFragment } }
    )>, members: Array<(
      { __typename?: 'projects_to_users' }
      & { ' $fragmentRefs'?: { 'UpdateTaskForm_MembersFragment': UpdateTaskForm_MembersFragment } }
    )>, address?: (
      { __typename?: 'project_address' }
      & { ' $fragmentRefs'?: { 'UpdateTaskForm_ProjectLocationFragment': UpdateTaskForm_ProjectLocationFragment } }
    ) | null } | null };

export type UpdateArchiveTaskMutationVariables = Exact<{
  input: UpdateArchiveTaskInput;
}>;


export type UpdateArchiveTaskMutation = { __typename?: 'mutation_root', updateArchiveTask?: { __typename: 'UpdateArchiveTaskErrors' } | { __typename: 'UpdateArchiveTaskSuccess', task_id: string } | null };

export type UpdateTaskForm_DataFragment = { __typename?: 'tasks', id: string, description: string, start_date?: string | null, end_date?: string | null, hours_done?: number | null, hours_expected?: number | null, labels: Array<{ __typename?: 'tasks_to_project_labels', project_label_id: string }>, location?: { __typename?: 'task_locations', lat: number, lng: number } | null, file_versions: Array<{ __typename?: 'tasks_file_versions', file_version: { __typename?: 'file_versions', id: string, name: string, file_id: string }, location?: { __typename?: 'task_file_version_location', page_number: number, x: number, y: number } | null }>, attachments: Array<(
    { __typename?: 'task_attachments' }
    & { ' $fragmentRefs'?: { 'UpdateTaskForm_AttachmentFragment': UpdateTaskForm_AttachmentFragment } }
  )>, subtasks: Array<(
    { __typename?: 'task_subtasks' }
    & { ' $fragmentRefs'?: { 'UpdateTaskForm_SubtaskFragment': UpdateTaskForm_SubtaskFragment } }
  )>, assignations?: { __typename?: 'task_assignations', orgs: Array<{ __typename?: 'task_assignations_orgs', org_id: string }>, teams: Array<{ __typename?: 'task_assignations_teams', team_id: string }>, users: Array<{ __typename?: 'task_assignations_users', user_id: string }> } | null, permissions?: { __typename?: 'task_permissions', orgs: Array<{ __typename?: 'task_permissions_orgs', org_id: string }>, teams: Array<{ __typename?: 'task_permissions_teams', team_id: string }>, users: Array<{ __typename?: 'task_permissions_users', user_id: string }> } | null } & { ' $fragmentName'?: 'UpdateTaskForm_DataFragment' };

export type UpdateTaskForm_AttachmentFragment = { __typename?: 'task_attachments', id: string, name: string, url?: string | null, content_type?: string | null } & { ' $fragmentName'?: 'UpdateTaskForm_AttachmentFragment' };

export type UpdateTaskForm_SubtaskFragment = { __typename?: 'task_subtasks', id: string, description: string, closed?: boolean | null, start_date?: string | null, end_date?: string | null } & { ' $fragmentName'?: 'UpdateTaskForm_SubtaskFragment' };

export type UpdateTaskForm_MembersFragment = { __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null } } & { ' $fragmentName'?: 'UpdateTaskForm_MembersFragment' };

export type UpdateTaskForm_ProjectLocationFragment = { __typename?: 'project_address', lat?: number | null, lng?: number | null } & { ' $fragmentName'?: 'UpdateTaskForm_ProjectLocationFragment' };

export type DeleteSubtaskMutationVariables = Exact<{
  input: DeleteSubtaskInput;
}>;


export type DeleteSubtaskMutation = { __typename?: 'mutation_root', deleteSubtask?: { __typename: 'DeleteSubtaskErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'SubtaskAccessDenied' } | { __typename: 'SubtaskDoesNotExist' }> } | { __typename: 'DeleteSubtaskSuccess' } | null };

export type CreateSubtaskMutationVariables = Exact<{
  input: CreateSubtaskInput;
}>;


export type CreateSubtaskMutation = { __typename?: 'mutation_root', createSubtask?: { __typename: 'CreateSubtaskErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'TaskAccessDenied' } | { __typename: 'TaskDoesNotExist' }> } | { __typename: 'CreateSubtaskSuccess' } | null };

export type UpdateSubtaskMutationVariables = Exact<{
  input: UpdateSubtaskInput;
}>;


export type UpdateSubtaskMutation = { __typename?: 'mutation_root', updateSubtask?: { __typename: 'UpdateSubtaskErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'SubtaskAccessDenied' } | { __typename: 'SubtaskDoesNotExist' }> } | { __typename: 'UpdateSubtaskSuccess' } | null };

export type DeleteTaskAttachmentMutationVariables = Exact<{
  input: DeleteTaskAttachmentInput;
}>;


export type DeleteTaskAttachmentMutation = { __typename?: 'mutation_root', deleteTaskAttachment?: { __typename: 'DeleteTaskAttachmentErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'TaskAttachmentAccessDenied' } | { __typename: 'TaskAttachmentDoesNotExist' }> } | { __typename: 'DeleteTaskAttachmentSuccess' } | null };

export type DeleteTaskMutationVariables = Exact<{
  input: DeleteTaskInput;
}>;


export type DeleteTaskMutation = { __typename?: 'mutation_root', deleteTask?: { __typename: 'DeleteTaskErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'TaskAccessDenied' } | { __typename: 'TaskDoesNotExist' }> } | { __typename: 'DeleteTaskSuccess' } | null };

export type PrepareTaskAttachmentAnnotationForUploadMutationVariables = Exact<{
  input: PrepareTaskAttachmentAnnotationForUploadInput;
}>;


export type PrepareTaskAttachmentAnnotationForUploadMutation = { __typename?: 'mutation_root', prepareTaskAttachmentAnnotationForUpload?: { __typename: 'PrepareTaskAttachmentAnnotationForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'TaskAccessDenied' } | { __typename: 'TaskAttachmentDoesNotExist' } | { __typename: 'TaskDoesNotExist' }> } | { __typename: 'PrepareTaskAttachmentAnnotationForUploadSuccess', key: string, url: string } | null };

export type TaskView_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  taskId: Scalars['uuid']['input'];
}>;


export type TaskView_DataQuery = { __typename?: 'query_root', task?: { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, tasks: Array<{ __typename?: 'tasks', number: number, id: string, description: string, end_date?: string | null, start_date?: string | null, deleted_at?: string | null, created_at: string, is_validated_by?: string | null, creator_id: string, hours_expected?: number | null, hours_done?: number | null, validations: Array<{ __typename?: 'task_validations', updated_at: string, user: (
          { __typename?: 'users' }
          & { ' $fragmentRefs'?: { 'TaskView_ValidationsFragment': TaskView_ValidationsFragment } }
        ) }>, creator: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, attachments: Array<(
        { __typename?: 'task_attachments' }
        & { ' $fragmentRefs'?: { 'TaskView_AttachmentsFragment': TaskView_AttachmentsFragment } }
      )>, labels: Array<(
        { __typename?: 'tasks_to_project_labels' }
        & { ' $fragmentRefs'?: { 'TaskView_LabelsFragment': TaskView_LabelsFragment } }
      )>, location?: (
        { __typename?: 'task_locations' }
        & { ' $fragmentRefs'?: { 'TaskView_LocationFragment': TaskView_LocationFragment } }
      ) | null, file_versions: Array<(
        { __typename?: 'tasks_file_versions' }
        & { ' $fragmentRefs'?: { 'TaskView_File_VersionsFragment': TaskView_File_VersionsFragment } }
      )>, subtasks: Array<(
        { __typename?: 'task_subtasks' }
        & { ' $fragmentRefs'?: { 'TaskView_SubtasksFragment': TaskView_SubtasksFragment } }
      )>, assignations?: (
        { __typename?: 'task_assignations' }
        & { ' $fragmentRefs'?: { 'TaskView_AssignationsFragment': TaskView_AssignationsFragment } }
      ) | null, ancestors: Array<(
        { __typename?: 'task_dependencies' }
        & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
      )>, predecessors: Array<(
        { __typename?: 'task_dependencies' }
        & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
      )> }> } | null };

export type AddUserViewToTaskMutationVariables = Exact<{
  input: AddUserViewToTaskInput;
}>;


export type AddUserViewToTaskMutation = { __typename?: 'mutation_root', addUserViewToTask?: { __typename: 'AddUserViewToTaskErrors' } | { __typename: 'AddUserViewToTaskSuccess' } | null };

export type UpdateValidationTaskMutationVariables = Exact<{
  input: UpdateValidationTaskInput;
}>;


export type UpdateValidationTaskMutation = { __typename?: 'mutation_root', updateValidationTask?: { __typename: 'UpdateValidationTaskErrors' } | { __typename: 'UpdateValidationTaskSuccess' } | null };

export type CreateChannelForTaskMutationVariables = Exact<{
  input: CreateChannelForTaskInput;
}>;


export type CreateChannelForTaskMutation = { __typename?: 'mutation_root', createChannelForTask?: { __typename: 'CreateChannelForTaskErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'TaskAccessDenied' } | { __typename: 'TaskDoesNotExist' }> } | { __typename: 'CreateChannelForTaskSuccess', channel_id: string } | null };

export type TaskView_OrgAssignationsFragment = { __typename?: 'task_assignations_orgs', org: { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } & { ' $fragmentName'?: 'TaskView_OrgAssignationsFragment' };

export type TaskView_TeamAssignationsFragment = { __typename?: 'task_assignations_teams', team: { __typename?: 'teams', id: string, name: string, color: string } } & { ' $fragmentName'?: 'TaskView_TeamAssignationsFragment' };

export type TaskView_UserAssignationsFragment = { __typename?: 'task_assignations_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } } & { ' $fragmentName'?: 'TaskView_UserAssignationsFragment' };

export type TaskView_AssignationsFragment = { __typename?: 'task_assignations', orgs: Array<(
    { __typename?: 'task_assignations_orgs' }
    & { ' $fragmentRefs'?: { 'TaskView_OrgAssignationsFragment': TaskView_OrgAssignationsFragment } }
  )>, teams: Array<(
    { __typename?: 'task_assignations_teams' }
    & { ' $fragmentRefs'?: { 'TaskView_TeamAssignationsFragment': TaskView_TeamAssignationsFragment } }
  )>, users: Array<(
    { __typename?: 'task_assignations_users' }
    & { ' $fragmentRefs'?: { 'TaskView_UserAssignationsFragment': TaskView_UserAssignationsFragment } }
  )> } & { ' $fragmentName'?: 'TaskView_AssignationsFragment' };

export type TaskView_AttachmentsFragment = { __typename?: 'task_attachments', id: string, name: string, url?: string | null, content_type?: string | null } & { ' $fragmentName'?: 'TaskView_AttachmentsFragment' };

export type TaskDescription_DataQueryVariables = Exact<{
  taskIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type TaskDescription_DataQuery = { __typename?: 'query_root', tasks: Array<{ __typename?: 'tasks', id: string, description: string, number: number, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }>, ancestors: Array<(
      { __typename?: 'task_dependencies' }
      & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
    )>, predecessors: Array<(
      { __typename?: 'task_dependencies' }
      & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
    )> }> };

export type DeleteTaskDependenciesMutationVariables = Exact<{
  input: DeleteTaskDependenciesInput;
}>;


export type DeleteTaskDependenciesMutation = { __typename?: 'mutation_root', deleteTaskDependencies?: { __typename: 'DeleteTaskDependenciesErrors', errors: Array<{ __typename?: 'InputValidationError', formErrors: Array<string | null>, fieldErrors: any } | { __typename?: 'TaskAccessDenied', message: string, type: string } | { __typename?: 'TaskDoesNotExist' }> } | { __typename: 'DeleteTaskDependenciesSuccess', task_ids: Array<string> } | null };

export type TaskView_File_VersionsFragment = { __typename?: 'tasks_file_versions', task_id: string, file_version: { __typename?: 'file_versions', id: string, name: string, file_id: string, url?: string | null, content_type: string }, location?: { __typename?: 'task_file_version_location', page_number: number, x: number, y: number } | null } & { ' $fragmentName'?: 'TaskView_File_VersionsFragment' };

export type TaskView_LabelsFragment = { __typename?: 'tasks_to_project_labels', id: string, label: { __typename?: 'project_labels', id: string, color: string, name: string } } & { ' $fragmentName'?: 'TaskView_LabelsFragment' };

export type TaskView_LocationFragment = { __typename?: 'task_locations', lat: number, lng: number } & { ' $fragmentName'?: 'TaskView_LocationFragment' };

export type SubtaskValidationHistory_DataQueryVariables = Exact<{
  subtaskId: Scalars['uuid']['input'];
}>;


export type SubtaskValidationHistory_DataQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: string, payload?: any | null, type: string, creator_id: string, created_at: string, user: { __typename?: 'users', id: string, full_name?: string | null, company_name?: string | null, email: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> };

export type TaskView_SubtasksFragment = { __typename?: 'task_subtasks', id: string, description: string, closed?: boolean | null, start_date?: string | null, end_date?: string | null, last_validated_at?: any | null, last_user_to_validate?: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null } & { ' $fragmentName'?: 'TaskView_SubtasksFragment' };

export type TaskView_ValidationsFragment = { __typename?: 'users', full_name?: string | null, first_name: string, id: string, company_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org_id: string } | null } & { ' $fragmentName'?: 'TaskView_ValidationsFragment' };

export type TaskViewersDetailsDrawerContent_DataQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type TaskViewersDetailsDrawerContent_DataQuery = { __typename?: 'query_root', tasks_by_pk?: { __typename?: 'tasks', id: string, views: Array<{ __typename?: 'task_views', updated_at: string, created_at: string, user: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type TopbarQuery_DataQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type TopbarQuery_DataQuery = { __typename?: 'query_root', tasks_by_pk?: { __typename?: 'tasks', id: string, assignations?: { __typename?: 'task_assignations', id: string, users: Array<{ __typename?: 'task_assignations_users', user: { __typename?: 'users', id: string } }>, orgs: Array<{ __typename?: 'task_assignations_orgs', org: { __typename?: 'orgs', id: string } }>, teams: Array<{ __typename?: 'task_assignations_teams', team: { __typename?: 'teams', id: string } }> } | null } | null };

export type TaskFiltersFormSelectInput_OrgFragment = { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } & { ' $fragmentName'?: 'TaskFiltersFormSelectInput_OrgFragment' };

export type TaskFiltersFormSelectInput_TeamFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'TaskFiltersFormSelectInput_TeamFragment' };

export type TaskFiltersFormSelectInput_UserFragment = { __typename?: 'users', id: string, full_name?: string | null, company_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } & { ' $fragmentName'?: 'TaskFiltersFormSelectInput_UserFragment' };

export type TaskFiltersFormSelectInput_LabelFragment = { __typename?: 'project_labels', id: string, name: string, color: string } & { ' $fragmentName'?: 'TaskFiltersFormSelectInput_LabelFragment' };

export type GetSelectOptionsQueryVariables = Exact<{
  filters?: InputMaybe<Projects_Bool_Exp>;
}>;


export type GetSelectOptionsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, teams: Array<(
      { __typename?: 'teams' }
      & { ' $fragmentRefs'?: { 'TaskFiltersFormSelectInput_TeamFragment': TaskFiltersFormSelectInput_TeamFragment } }
    )>, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, client_fullname?: string | null }> | null, members: Array<{ __typename?: 'projects_to_users', user: (
        { __typename?: 'users', active_org?: { __typename?: 'orgs_to_users', org: (
            { __typename?: 'orgs' }
            & { ' $fragmentRefs'?: { 'TaskFiltersFormSelectInput_OrgFragment': TaskFiltersFormSelectInput_OrgFragment } }
          ) } | null }
        & { ' $fragmentRefs'?: { 'TaskFiltersFormSelectInput_UserFragment': TaskFiltersFormSelectInput_UserFragment } }
      ) }>, labels: Array<(
      { __typename?: 'project_labels' }
      & { ' $fragmentRefs'?: { 'TaskFiltersFormSelectInput_LabelFragment': TaskFiltersFormSelectInput_LabelFragment } }
    )> }> };

export type FilterUserDefaultMutationMutationVariables = Exact<{
  input: FilterUserDefaultInput;
}>;


export type FilterUserDefaultMutationMutation = { __typename?: 'mutation_root', FilterUserDefault?: { __typename: 'FilterUserDefaultErrors' } | { __typename: 'FilterUserDefaultSuccess', defaultFilterId: string } | null };

export type GetUniqueLabelsQueryVariables = Exact<{
  projectIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetUniqueLabelsQuery = { __typename?: 'query_root', project_labels: Array<{ __typename?: 'project_labels', id: string, name: string, normalized_name: string, color: string }> };

export type DeleteFilterMutationMutationVariables = Exact<{
  input: DeleteFilterInput;
}>;


export type DeleteFilterMutationMutation = { __typename?: 'mutation_root', deleteFilter?: { __typename: 'DeleteFilterErrors' } | { __typename: 'DeleteFilterSuccess', filter_id?: string | null } | null };

export type CreateFilterMutationVariables = Exact<{
  input: CreateFilterInput;
}>;


export type CreateFilterMutation = { __typename?: 'mutation_root', createFilter?: { __typename: 'CreateFilterErrors' } | { __typename: 'CreateFilterSuccess', filter_id: string, name: string } | null };

export type UpdateFilterMutationVariables = Exact<{
  input: UpdateFilterInput;
}>;


export type UpdateFilterMutation = { __typename?: 'mutation_root', updateFilter?: { __typename: 'UpdateFilterErrors' } | { __typename: 'UpdateFilterSuccess', filter_id: string, name: string } | null };

export type FiltersSelected_OrgsFragment = { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } & { ' $fragmentName'?: 'FiltersSelected_OrgsFragment' };

export type FiltersSelected_TeamsFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'FiltersSelected_TeamsFragment' };

export type FiltersSelected_UsersFragment = { __typename?: 'users', id: string, full_name?: string | null, company_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } & { ' $fragmentName'?: 'FiltersSelected_UsersFragment' };

export type FiltersSelected_LabelsFragment = { __typename?: 'project_labels', id: string, name: string, color: string } & { ' $fragmentName'?: 'FiltersSelected_LabelsFragment' };

export type FiltersSelected_DataQueryVariables = Exact<{
  projectId?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  orgIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  teamIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  userIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  labelsIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  labelsNormalizedName?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  approvedByUser?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  approvedByOrg?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  approvedByTeam?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type FiltersSelected_DataQuery = { __typename?: 'query_root', orgs: Array<(
    { __typename?: 'orgs' }
    & { ' $fragmentRefs'?: { 'FiltersSelected_OrgsFragment': FiltersSelected_OrgsFragment } }
  )>, teams: Array<(
    { __typename?: 'teams' }
    & { ' $fragmentRefs'?: { 'FiltersSelected_TeamsFragment': FiltersSelected_TeamsFragment } }
  )>, users: Array<(
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'FiltersSelected_UsersFragment': FiltersSelected_UsersFragment } }
  )>, project: Array<{ __typename?: 'projects', name: string, id: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, labels: Array<(
      { __typename?: 'project_labels' }
      & { ' $fragmentRefs'?: { 'FiltersSelected_LabelsFragment': FiltersSelected_LabelsFragment } }
    )> }>, projectLabel: Array<{ __typename?: 'projects', id: string, labels: Array<(
      { __typename?: 'project_labels' }
      & { ' $fragmentRefs'?: { 'FiltersSelected_LabelsFragment': FiltersSelected_LabelsFragment } }
    )> }>, approvedByUsers: Array<(
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'FiltersSelected_UsersFragment': FiltersSelected_UsersFragment } }
  )>, approvedByOrgs: Array<(
    { __typename?: 'orgs' }
    & { ' $fragmentRefs'?: { 'FiltersSelected_OrgsFragment': FiltersSelected_OrgsFragment } }
  )>, approvedByTeams: Array<(
    { __typename?: 'teams' }
    & { ' $fragmentRefs'?: { 'FiltersSelected_TeamsFragment': FiltersSelected_TeamsFragment } }
  )> };

export type GetTaskPermissionsOptionsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetTaskPermissionsOptionsQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } } | null } }>, teams: Array<{ __typename?: 'teams', id: string, name: string, color: string }> } | null };

export type UpdatePermissionsTaskMutationVariables = Exact<{
  input: UpdatePermissionsTaskInput;
}>;


export type UpdatePermissionsTaskMutation = { __typename?: 'mutation_root', updatePermissionsTask?: { __typename: 'UpdatePermissionTaskSuccess', task_id: string } | { __typename: 'UpdatePermissionsTaskErrors' } | null };

export type TasksReportDialog_LabelsFragment = { __typename?: 'project_labels', id: string, name: string, color: string } & { ' $fragmentName'?: 'TasksReportDialog_LabelsFragment' };

export type TasksReportDialog_TeamsFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'TasksReportDialog_TeamsFragment' };

export type TasksReportDialog_MemberFragment = { __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, company_name?: string | null, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null, phone?: string | null } | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string, id: string } } | null, teams: Array<{ __typename?: 'teams_to_users', team: { __typename?: 'teams', name: string, id: string } }> } } & { ' $fragmentName'?: 'TasksReportDialog_MemberFragment' };

export type TasksReportDialog_ProjectFragment = { __typename?: 'projects', id: string, name: string, description?: string | null, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null, address?: { __typename?: 'project_address', street?: string | null, postal_code?: string | null, city?: string | null, country?: string | null } | null, members: Array<(
    { __typename?: 'projects_to_users' }
    & { ' $fragmentRefs'?: { 'TasksReportDialog_MemberFragment': TasksReportDialog_MemberFragment } }
  )>, org_project_summary?: Array<{ __typename?: 'org_project_summary', id: string, client_fullname?: string | null, start_date?: string | null, end_date?: string | null, reference?: string | null }> | null, teams: Array<(
    { __typename?: 'teams' }
    & { ' $fragmentRefs'?: { 'TasksReportDialog_TeamsFragment': TasksReportDialog_TeamsFragment } }
  )>, labels: Array<(
    { __typename?: 'project_labels' }
    & { ' $fragmentRefs'?: { 'TasksReportDialog_LabelsFragment': TasksReportDialog_LabelsFragment } }
  )> } & { ' $fragmentName'?: 'TasksReportDialog_ProjectFragment' };

export type TasksReportDialog_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  filters: Tasks_Bool_Exp;
}>;


export type TasksReportDialog_DataQuery = { __typename?: 'query_root', projects_by_pk?: (
    { __typename?: 'projects', tasks: Array<{ __typename?: 'tasks', id: string, number: number, description: string }> }
    & { ' $fragmentRefs'?: { 'TasksReportDialog_ProjectFragment': TasksReportDialog_ProjectFragment } }
  ) | null };

export type RequestTasksReportMutationVariables = Exact<{
  input: RequestTasksReportInput;
}>;


export type RequestTasksReportMutation = { __typename?: 'mutation_root', requestTasksReport?: { __typename: 'RequestTasksReportErrors' } | { __typename: 'RequestTasksReportSuccess', project_id: string } | null };

export type TasksReportTasksList_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  tasksIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type TasksReportTasksList_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, tasks: Array<{ __typename?: 'tasks', id: string, created_at: string, number: number, description: string, end_date?: string | null, is_validated_by?: string | null, creator: { __typename?: 'users', full_name?: string | null, id: string, company_name?: string | null }, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', name: string, color: string, id: string } }>, file_versions: Array<{ __typename?: 'tasks_file_versions', location?: { __typename?: 'task_file_version_location', page_number: number, x: number, y: number } | null }>, subtasks: Array<{ __typename?: 'task_subtasks', description: string, closed?: boolean | null }>, attachments: Array<{ __typename?: 'task_attachments', url?: string | null, content_type?: string | null }>, assignations?: { __typename?: 'task_assignations', orgs: Array<{ __typename?: 'task_assignations_orgs', org: { __typename?: 'orgs', name: string, id: string } }>, teams: Array<{ __typename?: 'task_assignations_teams', team: { __typename?: 'teams', name: string, id: string } }>, users: Array<{ __typename?: 'task_assignations_users', user: { __typename?: 'users', full_name?: string | null, id: string } }> } | null, views: Array<{ __typename?: 'task_views', updated_at: string, created_at: string, user: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> }> } | null };

export type CreateReportBlocksMutationVariables = Exact<{
  input: CreateReportBlocksInput;
}>;


export type CreateReportBlocksMutation = { __typename?: 'mutation_root', createReportBlocks?: { __typename: 'CreateReportBlocksErrors' } | { __typename: 'CreateReportBlocksSuccess', name: string, report_block_id: string } | null };

export type UpdateReportBlockMutationVariables = Exact<{
  input: UpdateReportBlocksInput;
}>;


export type UpdateReportBlockMutation = { __typename?: 'mutation_root', updateReportBlocks?: { __typename: 'UpdateReportBlocksErrors' } | { __typename: 'UpdateReportBlocksSuccess', name: string, report_block_id: string } | null };

export type GetReportBlocksQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  orgId?: InputMaybe<Scalars['uuid']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  type: Scalars['String']['input'];
}>;


export type GetReportBlocksQuery = { __typename?: 'query_root', report_blocks: Array<{ __typename?: 'report_blocks', visibility_user_id?: string | null, visibility_team_id?: string | null, visibility_project_id?: string | null, visibility_org_id?: string | null, type?: string | null, name: string, id: string, creator_id: string, created_at: string, block_content: string, color: string }> };

export type DeleteReportBlockMutationVariables = Exact<{
  input: DeleteReportBlockInput;
}>;


export type DeleteReportBlockMutation = { __typename?: 'mutation_root', deleteReportBlock?: { __typename: 'DeleteReportBlockErrors' } | { __typename: 'DeleteReportBlockSuccess', reportBlockId?: string | null } | null };

export type CheckTaskDeletedQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type CheckTaskDeletedQuery = { __typename?: 'query_root', tasks_by_pk?: { __typename?: 'tasks', id: string, deleted: boolean, project: { __typename?: 'projects', id: string } } | null };

export type ProjectTasksExportScreen_MemberFragment = { __typename?: 'projects_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null } } & { ' $fragmentName'?: 'ProjectTasksExportScreen_MemberFragment' };

export type ProjectTasksExportScreen_ProjectFragment = { __typename?: 'projects', id: string, name: string, members: Array<(
    { __typename?: 'projects_to_users' }
    & { ' $fragmentRefs'?: { 'ProjectTasksExportScreen_MemberFragment': ProjectTasksExportScreen_MemberFragment } }
  )> } & { ' $fragmentName'?: 'ProjectTasksExportScreen_ProjectFragment' };

export type ProjectTasksExportScreen_ProjectQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ProjectTasksExportScreen_ProjectQuery = { __typename?: 'query_root', project?: (
    { __typename?: 'projects' }
    & { ' $fragmentRefs'?: { 'ProjectTasksExportScreen_ProjectFragment': ProjectTasksExportScreen_ProjectFragment } }
  ) | null };

export type TasksExport_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  filters: Tasks_Bool_Exp;
}>;


export type TasksExport_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, tasks: Array<{ __typename?: 'tasks', id: string, number: number, description: string, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', color: string } }> }> } | null };

export type RequestTasksExportMutationVariables = Exact<{
  input: RequestTasksExportInput;
}>;


export type RequestTasksExportMutation = { __typename?: 'mutation_root', requestTasksExport?: { __typename: 'RequestTasksExportErrors' } | { __typename: 'RequestTasksExportSuccess', project_id: string } | null };

export type ProjectTasksGantt_AssignationsFragment = { __typename?: 'task_assignations', teams: Array<{ __typename?: 'task_assignations_teams', team: { __typename?: 'teams', id: string, name: string, color: string } }>, users: Array<{ __typename?: 'task_assignations_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }>, orgs: Array<{ __typename?: 'task_assignations_orgs', org: { __typename?: 'orgs', id: string, name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } }> } & { ' $fragmentName'?: 'ProjectTasksGantt_AssignationsFragment' };

export type ProjectTasksGantt_OrgProjectSummaryDataFragment = { __typename?: 'org_project_summary', start_date?: string | null, end_date?: string | null, created_at: string, id: string } & { ' $fragmentName'?: 'ProjectTasksGantt_OrgProjectSummaryDataFragment' };

export type ProjectTasksGanttTasks_DataFragment = { __typename?: 'tasks', id: string, number: number, is_validated_by?: string | null, start_date?: string | null, end_date?: string | null, description: string, hours_done?: number | null, hours_expected?: number | null, subtasks_progress?: number | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', color: string } }>, subtasks: Array<{ __typename?: 'task_subtasks', closed?: boolean | null, description: string, created_at: string, task_id: string, start_date?: string | null, end_date?: string | null, id: string }>, assignations?: (
    { __typename?: 'task_assignations' }
    & { ' $fragmentRefs'?: { 'ProjectTasksGantt_AssignationsFragment': ProjectTasksGantt_AssignationsFragment } }
  ) | null, ancestors: Array<(
    { __typename?: 'task_dependencies' }
    & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
  )>, predecessors: Array<(
    { __typename?: 'task_dependencies' }
    & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
  )> } & { ' $fragmentName'?: 'ProjectTasksGanttTasks_DataFragment' };

export type ProjectTasksGanttQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  filters: Tasks_Bool_Exp;
}>;


export type ProjectTasksGanttQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, tasks: Array<(
      { __typename?: 'tasks' }
      & { ' $fragmentRefs'?: { 'ProjectTasksGanttTasks_DataFragment': ProjectTasksGanttTasks_DataFragment } }
    )>, org_project_summary?: Array<(
      { __typename?: 'org_project_summary' }
      & { ' $fragmentRefs'?: { 'ProjectTasksGantt_OrgProjectSummaryDataFragment': ProjectTasksGantt_OrgProjectSummaryDataFragment } }
    )> | null } | null, task_dependencies: Array<(
    { __typename?: 'task_dependencies' }
    & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
  )> };

export type UpdateSubtaskDatesMutationVariables = Exact<{
  input: UpdateSubtaskInput;
}>;


export type UpdateSubtaskDatesMutation = { __typename?: 'mutation_root', updateSubtask?: { __typename: 'UpdateSubtaskErrors' } | { __typename: 'UpdateSubtaskSuccess', subtask_id: string, task_id: string } | null };

export type UpdateTaskDependenciesMutationVariables = Exact<{
  input: UpdateTaskDependenciesInput;
}>;


export type UpdateTaskDependenciesMutation = { __typename?: 'mutation_root', updateTaskDependencies?: { __typename: 'UpdateTaskDependenciesErrors', errors: Array<{ __typename?: 'InputValidationError', formErrors: Array<string | null>, fieldErrors: any } | { __typename?: 'TaskAccessDenied', message: string, type: string } | { __typename?: 'TaskDoesNotExist' }> } | { __typename: 'UpdateTaskDependenciesSuccess', task_ids: Array<string> } | null };

export type ProjectTasksList_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  filters: Tasks_Bool_Exp;
  sort?: InputMaybe<Array<Tasks_Order_By> | Tasks_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectTasksList_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, name: string, tasks: Array<(
      { __typename?: 'tasks', attachments: Array<(
        { __typename?: 'task_attachments' }
        & { ' $fragmentRefs'?: { 'TaskListItem_AttachmentFragment': TaskListItem_AttachmentFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'TaskListItem_Core_Extended_OfflineFragment': TaskListItem_Core_Extended_OfflineFragment } }
    )>, tasks_count_filtered: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null }, tasks_count: { __typename?: 'tasks_aggregate', aggregate?: { __typename?: 'tasks_aggregate_fields', count: number } | null } } | null };

export type FilterUserDefaultQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type FilterUserDefaultQuery = { __typename?: 'query_root', filter_user_default: Array<{ __typename?: 'filter_user_default', id: string, filter_id?: string | null, filter?: { __typename?: 'filters', content: string } | null }> };

export type ActionsMenuDeleteTaskMutationVariables = Exact<{
  input: DeleteTaskInput;
}>;


export type ActionsMenuDeleteTaskMutation = { __typename?: 'mutation_root', deleteTask?: { __typename: 'DeleteTaskErrors' } | { __typename: 'DeleteTaskSuccess', task_id: string } | null };

export type TasksList_AssignationsFragment = { __typename?: 'tasks', assignations?: { __typename?: 'task_assignations', teams: Array<{ __typename?: 'task_assignations_teams', created_at: string, team_id: string, team: { __typename?: 'teams', name: string, color: string }, creator?: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }>, users: Array<{ __typename?: 'task_assignations_users', created_at: string, user_id: string, user: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null }, creator?: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }>, orgs: Array<{ __typename?: 'task_assignations_orgs', created_at: string, org_id: string, org: { __typename?: 'orgs', name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null }, creator?: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }> } | null } & { ' $fragmentName'?: 'TasksList_AssignationsFragment' };

export type TaskList_PermissionsFragment = { __typename?: 'tasks', permissions?: { __typename?: 'task_permissions', orgs: Array<{ __typename?: 'task_permissions_orgs', org_id: string, org: { __typename?: 'orgs', name: string, org_avatar?: { __typename?: 'org_avatars', public_url: string } | null } }>, users: Array<{ __typename?: 'task_permissions_users', user_id: string, user?: { __typename?: 'users', full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null }>, teams: Array<{ __typename?: 'task_permissions_teams', team_id: string, team: { __typename?: 'teams', color: string, name: string } }> } | null } & { ' $fragmentName'?: 'TaskList_PermissionsFragment' };

export type TaskListItem_CoreFragment = (
  { __typename?: 'tasks', id: string, number: number, description: string, is_validated_by?: string | null, start_date?: string | null, end_date?: string | null, created_at: string, deleted: boolean, deleted_at?: string | null, subtasks_progress?: number | null, labels: Array<{ __typename?: 'tasks_to_project_labels', label: { __typename?: 'project_labels', id: string, name: string, color: string } }>, ancestors: Array<(
    { __typename?: 'task_dependencies' }
    & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
  )>, predecessors: Array<(
    { __typename?: 'task_dependencies' }
    & { ' $fragmentRefs'?: { 'ProjectTasksGantt_DependenciesFragment': ProjectTasksGantt_DependenciesFragment } }
  )>, project: { __typename?: 'projects', id: string, name: string, project_avatar?: { __typename?: 'project_avatars', public_url: string } | null } }
  & { ' $fragmentRefs'?: { 'TasksList_AssignationsFragment': TasksList_AssignationsFragment;'TaskList_PermissionsFragment': TaskList_PermissionsFragment } }
) & { ' $fragmentName'?: 'TaskListItem_CoreFragment' };

export type TaskListItem_Core_Extended_OfflineFragment = (
  { __typename?: 'tasks', hours_expected?: number | null, hours_done?: number | null, subtasks: Array<{ __typename?: 'task_subtasks', id: string, description: string, closed?: boolean | null, start_date?: string | null, end_date?: string | null }>, creator: { __typename?: 'users', id: string, full_name?: string | null } }
  & { ' $fragmentRefs'?: { 'TaskListItem_CoreFragment': TaskListItem_CoreFragment } }
) & { ' $fragmentName'?: 'TaskListItem_Core_Extended_OfflineFragment' };

export type TaskListItem_Core_Extended_Offline_AttachmentsFragment = (
  { __typename?: 'tasks', attachments: Array<(
    { __typename?: 'task_attachments' }
    & { ' $fragmentRefs'?: { 'TaskListItem_AttachmentFragment': TaskListItem_AttachmentFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'TaskListItem_Core_Extended_OfflineFragment': TaskListItem_Core_Extended_OfflineFragment } }
) & { ' $fragmentName'?: 'TaskListItem_Core_Extended_Offline_AttachmentsFragment' };

export type TaskListItem_AttachmentFragment = { __typename?: 'task_attachments', id: string, name: string, url?: string | null, content_type?: string | null } & { ' $fragmentName'?: 'TaskListItem_AttachmentFragment' };

export type TasksList_ItemFragment = (
  { __typename?: 'tasks', attachments: Array<(
    { __typename?: 'task_attachments' }
    & { ' $fragmentRefs'?: { 'TaskListItem_AttachmentFragment': TaskListItem_AttachmentFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'TaskListItem_CoreFragment': TaskListItem_CoreFragment } }
) & { ' $fragmentName'?: 'TasksList_ItemFragment' };

export type UpdateLabelsTasksMutationVariables = Exact<{
  input: UpdateLabelsTasksInput;
}>;


export type UpdateLabelsTasksMutation = { __typename?: 'mutation_root', updateLabelsTasks?: { __typename: 'UpdateLabelsTasksErrors' } | { __typename: 'UpdateLabelsTasksSuccess', task_ids: Array<string> } | null };

export type UpdateTaskFull_DataFragment = { __typename?: 'tasks', description: string, start_date?: string | null, end_date?: string | null, id: string, labels: Array<{ __typename?: 'tasks_to_project_labels', project_label_id: string }>, location?: { __typename?: 'task_locations', lat: number, lng: number } | null, file_versions: Array<{ __typename?: 'tasks_file_versions', file_version_id: string, location?: { __typename?: 'task_file_version_location', page_number: number, x: number, y: number } | null }>, attachments: Array<(
    { __typename?: 'task_attachments' }
    & { ' $fragmentRefs'?: { 'UpdateTaskForm_AttachmentFragment': UpdateTaskForm_AttachmentFragment } }
  )>, subtasks: Array<(
    { __typename?: 'task_subtasks' }
    & { ' $fragmentRefs'?: { 'UpdateTaskForm_SubtaskFragment': UpdateTaskForm_SubtaskFragment } }
  )>, assignations?: { __typename?: 'task_assignations', orgs: Array<{ __typename?: 'task_assignations_orgs', org_id: string }>, teams: Array<{ __typename?: 'task_assignations_teams', team_id: string }>, users: Array<{ __typename?: 'task_assignations_users', user_id: string }> } | null } & { ' $fragmentName'?: 'UpdateTaskFull_DataFragment' };

export type GetFullTaskQueryVariables = Exact<{
  task_id: Scalars['uuid']['input'];
}>;


export type GetFullTaskQuery = { __typename?: 'query_root', tasks: Array<(
    { __typename?: 'tasks' }
    & { ' $fragmentRefs'?: { 'UpdateTaskFull_DataFragment': UpdateTaskFull_DataFragment } }
  )> };

export type BulkDeleteTasksMutationVariables = Exact<{
  input: BulkDeleteTasksInput;
}>;


export type BulkDeleteTasksMutation = { __typename?: 'mutation_root', bulkDeleteTasks?: { __typename: 'BulkDeleteTasksErrors' } | { __typename: 'BulkDeleteTasksSuccess', task_ids: Array<string> } | null };

export type DeleteTasksMutationVariables = Exact<{
  input: DeleteTasksInput;
}>;


export type DeleteTasksMutation = { __typename?: 'mutation_root', deleteTasks?: { __typename: 'DeleteTasksErrors' } | { __typename: 'DeleteTasksSuccess', task_ids: Array<string> } | null };

export type LabelsList_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type LabelsList_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, labels: Array<(
      { __typename?: 'project_labels' }
      & { ' $fragmentRefs'?: { 'LabelsList_ItemFragment': LabelsList_ItemFragment } }
    )> } | null };

export type LabelsList_ItemFragment = { __typename?: 'project_labels', id: string, name: string, color: string } & { ' $fragmentName'?: 'LabelsList_ItemFragment' };

export type UpdateProjectLabelMutationVariables = Exact<{
  input: UpdateProjectLabelInput;
}>;


export type UpdateProjectLabelMutation = { __typename?: 'mutation_root', updateProjectLabel?: { __typename: 'UpdateProjectLabelErrors' } | { __typename: 'UpdateProjectLabelSuccess', project_label_id: string } | null };

export type DeleteProjectLabelMutationVariables = Exact<{
  input: DeleteProjectLabelInput;
}>;


export type DeleteProjectLabelMutation = { __typename?: 'mutation_root', deleteProjectLabel?: { __typename: 'DeleteProjectLabelErrors' } | { __typename: 'DeleteProjectLabelSuccess', project_label_id: string } | null };

export type ProjectTeamDrawer_TeamQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type ProjectTeamDrawer_TeamQuery = { __typename?: 'query_root', teams_by_pk?: { __typename?: 'teams', name: string, id: string, project: { __typename?: 'projects', id: string, name: string }, users: Array<{ __typename?: 'teams_to_users', user: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type TeamsList_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type TeamsList_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, teams: Array<(
      { __typename?: 'teams' }
      & { ' $fragmentRefs'?: { 'TeamsList_ItemFragment': TeamsList_ItemFragment } }
    )> } | null };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'mutation_root', createTeam?: { __typename: 'CreateTeamErrors' } | { __typename: 'CreateTeamSuccess', team_id: string } | null };

export type TeamsList_ItemFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'TeamsList_ItemFragment' };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'mutation_root', updateTeam?: { __typename: 'UpdateTeamErrors' } | { __typename: 'UpdateTeamSuccess', team_id: string } | null };

export type DeleteTeamMutationVariables = Exact<{
  input: DeleteTeamInput;
}>;


export type DeleteTeamMutation = { __typename?: 'mutation_root', deleteTeam?: { __typename: 'DeleteTeamErrors' } | { __typename: 'DeleteTeamSuccess', team_id: string } | null };

export type ProjectViewersDetailsDrawerContent_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectViewersDetailsDrawerContent_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, views: Array<{ __typename?: 'project_views', created_at: string, updated_at: string, user: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type ProjectInvitationFormInformation_DataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectInvitationFormInformation_DataQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', full_name?: string | null, active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null, metadatas?: { __typename?: 'user_metadatas', placeholder_company_name?: string | null } | null } }>, org: Array<{ __typename?: 'orgs', id: string }> }> };

export type ProjectTeamsMultiSelect_TeamFragment = { __typename?: 'teams', id: string, name: string, color: string } & { ' $fragmentName'?: 'ProjectTeamsMultiSelect_TeamFragment' };

export type GetProjectTeamsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetProjectTeamsQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, teams: Array<(
      { __typename?: 'teams' }
      & { ' $fragmentRefs'?: { 'ProjectTeamsMultiSelect_TeamFragment': ProjectTeamsMultiSelect_TeamFragment } }
    )> } | null };

export type InputsGroup_DataQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type InputsGroup_DataQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', role: { __typename?: 'project_roles', name: string } }> }> };

export type ProjectInvitationDialogContent_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type ProjectInvitationDialogContent_DataQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, org: Array<{ __typename?: 'orgs', id: string }> } | null };

export type ProjectInvitationRequestExcelTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type ProjectInvitationRequestExcelTemplateMutation = { __typename?: 'mutation_root', ProjectInvitationRequestExcelTemplate?: { __typename: 'ProjectInvitationRequestExcelTemplateErrors' } | { __typename: 'ProjectInvitationRequestExcelTemplateSuccess', url: string } | null };

export type SendUserEmailInvitationMutationVariables = Exact<{
  input: SendUserEmailInvitationInput;
}>;


export type SendUserEmailInvitationMutation = { __typename?: 'mutation_root', sendUserEmailInvitation?: { __typename: 'SendUserEmailInvitationErrors' } | { __typename: 'SendUserEmailInvitationSuccess', emails_sent: boolean } | null };

export type UpdateUsersCompanyNameMutationVariables = Exact<{
  input: UpdateUsersCompanyNameInput;
}>;


export type UpdateUsersCompanyNameMutation = { __typename?: 'mutation_root', updateUsersCompanyName?: { __typename: 'UpdateUsersCompanyNameErrors' } | { __typename: 'UpdateUsersCompanyNameSuccess', project_id: string, user_ids: Array<string | null> } | null };

export type GetProjectMembersOrgNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectMembersOrgNameQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', active_org?: { __typename?: 'orgs_to_users', org: { __typename?: 'orgs', name: string } } | null } }> }> };

export type UpdateProjectMembersRoleMutationVariables = Exact<{
  input: UpdateProjectMembersRoleInput;
}>;


export type UpdateProjectMembersRoleMutation = { __typename?: 'mutation_root', updateProjectMembersRole?: { __typename: 'UpdateProjectMembersRoleErrors' } | { __typename: 'UpdateProjectMembersRoleSuccess', user_ids: Array<string | null> } | null };

export type GetMembersProjectTeamsQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
}>;


export type GetMembersProjectTeamsQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, teams: Array<{ __typename?: 'teams', color: string, name: string, id: string }> } | null };

export type UpdateUsersTeamsMutationVariables = Exact<{
  input: UpdateUsersTeamsInput;
}>;


export type UpdateUsersTeamsMutation = { __typename?: 'mutation_root', updateUsersTeams?: { __typename: 'UpdateUsersTeamsErrors' } | { __typename: 'UpdateUsersTeamsSuccess', project_id: string, team_ids: Array<string | null>, user_ids: Array<string | null> } | null };

export type UpdateTasksAssignationsMutationVariables = Exact<{
  input: UpdateTasksAssignationsInput;
}>;


export type UpdateTasksAssignationsMutation = { __typename?: 'mutation_root', updateTasksAssignations?: { __typename: 'UpdateTasksAssignationsErrors' } | { __typename: 'UpdateTasksAssignationsSuccess', task_ids: Array<string> } | null };

export type UpdateTasksDatesMutationVariables = Exact<{
  input: UpdateTasksDatesInput;
}>;


export type UpdateTasksDatesMutation = { __typename?: 'mutation_root', updateTasksDates?: { __typename: 'UpdateTasksDatesErrors' } | { __typename: 'UpdateTasksDatesSuccess', task_ids: Array<string> } | null };

export type UpdateValidationsTasksMutationVariables = Exact<{
  input: UpdateValidationsTasksInput;
}>;


export type UpdateValidationsTasksMutation = { __typename?: 'mutation_root', updateValidationsTasks?: { __typename: 'UpdateValidationsTasksErrors' } | { __typename: 'UpdateValidationsTasksSuccess', task_ids: Array<string> } | null };

export type GetTeamMembersQueryVariables = Exact<{
  team_id: Scalars['uuid']['input'];
}>;


export type GetTeamMembersQuery = { __typename?: 'query_root', teams_by_pk?: { __typename?: 'teams', id: string, project: { __typename?: 'projects', id: string }, users: Array<{ __typename?: 'teams_to_users', user: { __typename?: 'users', id: string } }> } | null };

export type GetTeamMembersOptionsQueryVariables = Exact<{
  project_id: Scalars['uuid']['input'];
}>;


export type GetTeamMembersOptionsQuery = { __typename?: 'query_root', projects_by_pk?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', user: { __typename?: 'users', full_name?: string | null, id: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } }> } | null };

export type UpdateUsersInTeamMutationVariables = Exact<{
  input: UpdateUsersInTeamInput;
}>;


export type UpdateUsersInTeamMutation = { __typename?: 'mutation_root', updateUsersInTeam?: { __typename: 'UpdateUsersInTeamErrors' } | { __typename: 'UpdateUsersInTeamSuccess', project_id: string, team_id: string } | null };

export type NotProjectMemberScreen_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type NotProjectMemberScreen_DataQuery = { __typename?: 'query_root', projects_map_overview: Array<{ __typename?: 'projects_map_overview', id: string, name: string }> };

export type JoinOrgUserProjectMutationVariables = Exact<{
  input: JoinOrgUserProjectInput;
}>;


export type JoinOrgUserProjectMutation = { __typename?: 'mutation_root', joinOrgUserProject?: { __typename: 'JoinOrgUserProjectErrors', errors: Array<{ __typename: 'CannotInviteOnProject' } | { __typename: 'InputValidationError' } | { __typename: 'JoinOrgUserProjectPermissionDenied' }> } | { __typename: 'JoinOrgUserProjectSuccess' } | null };

export type ProjectAccessDeniedScreen_DataQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type ProjectAccessDeniedScreen_DataQuery = { __typename?: 'query_root', project?: { __typename?: 'projects', id: string, members: Array<{ __typename?: 'projects_to_users', updater?: { __typename?: 'users', full_name?: string | null } | null }> } | null };

export type UserNotificationsScreen_NotificationsQueryVariables = Exact<{
  where?: InputMaybe<User_Notifications_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserNotificationsScreen_NotificationsQuery = { __typename?: 'query_root', user_notifications: Array<(
    { __typename?: 'user_notifications' }
    & { ' $fragmentRefs'?: { 'UserNotification_NotificationFragment': UserNotification_NotificationFragment } }
  )> };

export type AvatarFromUserId_UserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AvatarFromUserId_UserQuery = { __typename?: 'query_root', user?: { __typename?: 'users', id: string, full_name?: string | null, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null } | null };

export type UserProfileScreen_UserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserProfileScreen_UserQuery = { __typename?: 'query_root', user?: (
    { __typename?: 'users', id: string, email_notifications?: (
      { __typename?: 'email_notifications' }
      & { ' $fragmentRefs'?: { 'EmailNotifications_DataFragment': EmailNotifications_DataFragment } }
    ) | null, push_notifications?: (
      { __typename?: 'push_notifications' }
      & { ' $fragmentRefs'?: { 'PushNotifications_DataFragment': PushNotifications_DataFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'ProfileForm_UserFragment': ProfileForm_UserFragment } }
  ) | null };

export type PushNotifications_DataFragment = { __typename?: 'push_notifications', chat_channel: boolean, chat_direct_message: boolean } & { ' $fragmentName'?: 'PushNotifications_DataFragment' };

export type UpdatePushNotificationsMutationVariables = Exact<{
  input: UpdatePushNotificationsInput;
}>;


export type UpdatePushNotificationsMutation = { __typename?: 'mutation_root', updatePushNotifications?: { __typename: 'UpdatePushNotificationsErrors' } | { __typename: 'UpdatePushNotificationsSuccess', user_id: string } | null };

export type EmailNotifications_DataFragment = { __typename?: 'email_notifications', id: string, unread_notification_report: boolean, invitation: boolean, weekly_report: boolean } & { ' $fragmentName'?: 'EmailNotifications_DataFragment' };

export type UpdateEmailNotificationsMutationVariables = Exact<{
  input: UpdateEmailNotificationsInput;
}>;


export type UpdateEmailNotificationsMutation = { __typename?: 'mutation_root', updateEmailNotifications?: { __typename: 'UpdateEmailNotificationsErrors' } | { __typename: 'UpdateEmailNotificationsSuccess', email_notifications_id: string } | null };

export type ProfileForm_UserFragment = { __typename?: 'users', id: string, first_name: string, last_name: string, full_name?: string | null, language: string, user_avatar?: { __typename?: 'user_avatars', public_url: string } | null, contact?: { __typename?: 'user_contact', id?: string | null, email?: string | null, phone?: string | null } | null, metadatas?: { __typename?: 'user_metadatas', country_code?: string | null } | null } & { ' $fragmentName'?: 'ProfileForm_UserFragment' };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'mutation_root', updateUserProfile?: { __typename: 'UpdateUserProfileErrors' } | { __typename: 'UpdateUserProfileSuccess', user_id: string } | null };

export type PrepareUserAvatarForUploadMutationVariables = Exact<{
  input: PrepareUserAvatarForUploadInput;
}>;


export type PrepareUserAvatarForUploadMutation = { __typename?: 'mutation_root', prepareUserAvatarForUpload?: { __typename: 'PrepareUserAvatarForUploadErrors', errors: Array<{ __typename: 'InputValidationError' }> } | { __typename: 'PrepareUserAvatarForUploadSuccess', key: string, url: string } | null };

export type UpdateOrgProjectSummaryArchiveMutationVariables = Exact<{
  input: UpdateOrgProjectSummaryArchiveInput;
}>;


export type UpdateOrgProjectSummaryArchiveMutation = { __typename?: 'mutation_root', updateOrgProjectSummaryArchive?: { __typename: 'UpdateOrgProjectSummaryArchiveErrors' } | { __typename: 'UpdateOrgProjectSummaryArchiveSuccess', project_id: string } | null };

export type DeleteProjectMutationVariables = Exact<{
  input: DeleteProjectInput;
}>;


export type DeleteProjectMutation = { __typename?: 'mutation_root', deleteProject?: { __typename: 'DeleteProjectErrors', errors: Array<{ __typename: 'CannotDeleteOrgProject' } | { __typename: 'CannotDeleteProjectSharedWithMultipleOrgs' } | { __typename: 'InputValidationError' } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' }> } | { __typename: 'DeleteProjectSuccess', project_id: string } | null };

export type RequestProjectExportMutationVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type RequestProjectExportMutation = { __typename?: 'mutation_root', requestProjectExport?: { __typename: 'RequestProjectExportErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'ProjectAccessDenied' } | { __typename: 'ProjectDoesNotExist' }> } | { __typename: 'RequestProjectExportSuccess' } | null };

export type CreateFolderTreeMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateFolderTreeMutation = { __typename?: 'mutation_root', createFolder?: { __typename: 'CreateFolderErrors' } | { __typename: 'CreateFolderSuccess', folder_id: string } | null };

export type DeleteFirebaseTokenMutationVariables = Exact<{
  input: DeleteFirebaseTokenInput;
}>;


export type DeleteFirebaseTokenMutation = { __typename?: 'mutation_root', deleteFirebaseToken?: { __typename: 'DeleteFirebaseTokenErrors' } | { __typename: 'DeleteFirebaseTokenSuccess' } | null };

export type UseRedirectAfterLogin_DataQueryVariables = Exact<{
  auth0_id?: InputMaybe<Scalars['String']['input']>;
}>;


export type UseRedirectAfterLogin_DataQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, active_org?: { __typename?: 'orgs_to_users', org_id: string } | null, projects: Array<{ __typename?: 'projects_to_users', project: { __typename?: 'projects', id: string, name: string } }> }> };

export const UserActiveOrgRole_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveOrgRole_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UserActiveOrgRole_DataFragment, unknown>;
export const UserActiveOrg_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveOrg_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserActiveOrg_DataFragment, unknown>;
export const UserTeams_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTeams_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]} as unknown as DocumentNode<UserTeams_DataFragment, unknown>;
export const UserNotification_BadgeNotificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNotification_badgeNotification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_strong"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]} as unknown as DocumentNode<UserNotification_BadgeNotificationFragment, unknown>;
export const UserNotification_NotificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNotification_notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNotification_badgeNotification"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_id"}},{"kind":"Field","name":{"kind":"Name","value":"read_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNotification_badgeNotification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_strong"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]} as unknown as DocumentNode<UserNotification_NotificationFragment, unknown>;
export const WorkerStatus_StatusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkerStatus_status"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"events_workers_status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<WorkerStatus_StatusFragment, unknown>;
export const CreateDemoProjectForm_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateDemoProjectForm_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_templates_overview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<CreateDemoProjectForm_DataFragment, unknown>;
export const TaskFileVersionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TaskFileVersionFragment, unknown>;
export const FileVersionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileVersions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tasksFilter"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFileVersion"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileVersionsFragment, unknown>;
export const FileViewer_FileVersionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileViewer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"current_extension"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_annotated"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}}]}}]}}]}}]} as unknown as DocumentNode<FileViewer_FileVersionFragment, unknown>;
export const FileViewer_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileViewer_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"pdf_location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"autodesk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urn"}},{"kind":"Field","name":{"kind":"Name","value":"conversion_progress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileViewer_fileVersion"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autodesk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urn"}},{"kind":"Field","name":{"kind":"Name","value":"conversion_progress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileViewer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"current_extension"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_annotated"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}}]}}]}}]}}]} as unknown as DocumentNode<FileViewer_FileFragment, unknown>;
export const TaskAnnotations_FileVersionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskAnnotations_fileVersions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tasksFilter"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"pdf_location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TaskAnnotations_FileVersionsFragment, unknown>;
export const LabelsMultiSelect_ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelsMultiSelect_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<LabelsMultiSelect_ProjectFragment, unknown>;
export const OriginalInviterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"originalInviter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OriginalInviterFragment, unknown>;
export const ProjectsMultiSelect_ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsMultiSelect_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_project_template"}}]}}]}}]} as unknown as DocumentNode<ProjectsMultiSelect_ProjectFragment, unknown>;
export const UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_connected"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder_company_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<UserFragment, unknown>;
export const ProjectCategoryFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCategoryFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ProjectCategoryFilterFragment, unknown>;
export const UserProjectInfoFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProjectInfoFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCategoryFilter"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCategoryFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<UserProjectInfoFilterFragment, unknown>;
export const OrgProjectInfoFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgProjectInfoFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_map_overview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCategoryFilter"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCategoryFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<OrgProjectInfoFilterFragment, unknown>;
export const UserProjectMembersFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProjectMembersFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProjectMembersFilterFragment, unknown>;
export const Tasks_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tasks_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]} as unknown as DocumentNode<Tasks_DataFragment, unknown>;
export const ProjectCategories_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCategories_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary_to_project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProjectCategories_DataFragment, unknown>;
export const ProjectsGantt_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsGantt_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCategories_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCategories_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary_to_project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProjectsGantt_DataFragment, unknown>;
export const ProjectsMaps_ProjectsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsMaps_projects"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_map_overview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsMaps_ProjectsFragment, unknown>;
export const ApprovalRequestItem_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalRequestItem_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_version_approval_request_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_approval_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApprovalRequestItem_DataFragment, unknown>;
export const MetricsData_TaskFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricsData_task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MetricsData_TaskFragment, unknown>;
export const CreateTaskTwoStepsOnDbClickDialog_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateTaskTwoStepsOnDbClickDialog_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskTwoStepsOnDbClickDialog_DataFragment, unknown>;
export const CreateTaskTwoStepsDialog_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateTaskTwoStepsDialog_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskTwoStepsDialog_DataFragment, unknown>;
export const TasksListGlobalTask_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksListGlobalTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]} as unknown as DocumentNode<TasksListGlobalTask_DataFragment, unknown>;
export const ProjectsSchedulerTask_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsSchedulerTask_DataFragment, unknown>;
export const TasksSchedulerTask_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TasksSchedulerTask_DataFragment, unknown>;
export const CategoriesList_ItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoriesList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<CategoriesList_ItemFragment, unknown>;
export const GroupsList_ItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupsList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<GroupsList_ItemFragment, unknown>;
export const ProfileForm_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileForm_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"legal_number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_menu_by_group"}}]}},{"kind":"Field","name":{"kind":"Name","value":"public_api_token"}}]}}]} as unknown as DocumentNode<ProfileForm_OrgFragment, unknown>;
export const FileVersionsVirtualList_VersionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileVersionsVirtualList_versions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}},{"kind":"Field","name":{"kind":"Name","value":"is_completed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_approval_id"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileVersionsVirtualList_VersionsFragment, unknown>;
export const FilesFoldersNavigatorsData_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersNavigatorsData_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<FilesFoldersNavigatorsData_FolderFragment, unknown>;
export const FilesFoldersNavigatorsData_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersNavigatorsData_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FilesFoldersNavigatorsData_FileFragment, unknown>;
export const BinFilesFoldersData_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinFilesFoldersData_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignee_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<BinFilesFoldersData_FolderFragment, unknown>;
export const BinFilesFoldersData_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinFilesFoldersData_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<BinFilesFoldersData_FileFragment, unknown>;
export const FilesFoldersData_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersData_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignee_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FilesFoldersData_FolderFragment, unknown>;
export const FileApproval_AttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileApproval_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_approval_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<FileApproval_AttachmentFragment, unknown>;
export const FilesFoldersData_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersData_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileApproval_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_approval_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<FilesFoldersData_FileFragment, unknown>;
export const AssigneesApprovalsAndViewsDrawer_CreatorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]} as unknown as DocumentNode<AssigneesApprovalsAndViewsDrawer_CreatorFragment, unknown>;
export const AssigneesApprovalsAndViewsDrawer_FileVersionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_approvals_file_versions_attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileApproval_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_approval_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]} as unknown as DocumentNode<AssigneesApprovalsAndViewsDrawer_FileVersionFragment, unknown>;
export const AssigneesApprovalsAndViewsDrawer_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"file_versions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileApproval_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_approval_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_approvals_file_versions_attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}}]} as unknown as DocumentNode<AssigneesApprovalsAndViewsDrawer_FileFragment, unknown>;
export const ExportVisasScreen_ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExportVisasScreen_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ExportVisasScreen_ProjectFragment, unknown>;
export const GetApprovals_VersionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetApprovals_version"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}},{"kind":"Field","name":{"kind":"Name","value":"is_completed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetApprovals_VersionFragment, unknown>;
export const GetApprovals_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetApprovals_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetApprovals_version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetApprovals_version"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}},{"kind":"Field","name":{"kind":"Name","value":"is_completed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetApprovals_FileFragment, unknown>;
export const UpdatePermissionsFileForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdatePermissionsFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePermissionsFileForm_FileFragment, unknown>;
export const RenameFileForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RenameFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<RenameFileForm_FileFragment, unknown>;
export const FolderInfoDrawerContent_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<FolderInfoDrawerContent_UserFragment, unknown>;
export const FolderInfoDrawerContent_UsersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folder_assignations_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<FolderInfoDrawerContent_UsersFragment, unknown>;
export const FolderInfoDrawerContent_TeamFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<FolderInfoDrawerContent_TeamFragment, unknown>;
export const FolderInfoDrawerContent_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<FolderInfoDrawerContent_OrgFragment, unknown>;
export const UpdatePermissionsFolderForm_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdatePermissionsFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePermissionsFolderForm_FolderFragment, unknown>;
export const RenameFolderForm_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RenameFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<RenameFolderForm_FolderFragment, unknown>;
export const DocsFiltersSelected_UsersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocsFiltersSelected_users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<DocsFiltersSelected_UsersFragment, unknown>;
export const DocsFiltersSelected_LabelsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocsFiltersSelected_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<DocsFiltersSelected_LabelsFragment, unknown>;
export const UpdateAssignationsFilesFoldersForm_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFilesFoldersForm_FolderFragment, unknown>;
export const UpdateAssignationsFilesFoldersForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFilesFoldersForm_FileFragment, unknown>;
export const UpdateLabelsFilesFolderForm_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFilesFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLabelsFilesFolderForm_FolderFragment, unknown>;
export const UpdateLabelsFilesFolderForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFilesFolderForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLabelsFilesFolderForm_FileFragment, unknown>;
export const RequestUsersApprovalsFilesForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestUsersApprovalsFilesForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequestUsersApprovalsFilesForm_FileFragment, unknown>;
export const UpdateAssignationsFileForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFileForm_FileFragment, unknown>;
export const UpdateAssignationsFileFormSelectInput_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFileFormSelectInput_OrgFragment, unknown>;
export const UpdateAssignationsFileFormSelectInput_TeamFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<UpdateAssignationsFileFormSelectInput_TeamFragment, unknown>;
export const UpdateAssignationsFileFormSelectInput_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFileFormSelectInput_UserFragment, unknown>;
export const UpdateAssignationsFolderForm_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignee_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"duedate_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFolderForm_FolderFragment, unknown>;
export const UpdateDueDateFileForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateDueDateFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}}]} as unknown as DocumentNode<UpdateDueDateFileForm_FileFragment, unknown>;
export const UpdateLabelsFileForm_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLabelsFileForm_FileFragment, unknown>;
export const UpdateLabelsFolderForm_FolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLabelsFolderForm_FolderFragment, unknown>;
export const MemberFilterSelected_OrgsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MemberFilterSelected_orgs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<MemberFilterSelected_OrgsFragment, unknown>;
export const MemberFilterSelected_TeamsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MemberFilterSelected_teams"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<MemberFilterSelected_TeamsFragment, unknown>;
export const MembersFiltersFormSelectInput_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembersFiltersFormSelectInput_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<MembersFiltersFormSelectInput_OrgFragment, unknown>;
export const MembersFiltersFormSelectInput_TeamFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembersFiltersFormSelectInput_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<MembersFiltersFormSelectInput_TeamFragment, unknown>;
export const ProfileForm_ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileForm_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"banner"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}}]}}]}}]} as unknown as DocumentNode<ProfileForm_ProjectFragment, unknown>;
export const ProjectProfileScreen_ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectProfileScreen_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"banner"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectProfileScreen_ProjectFragment, unknown>;
export const ProjectTemplatesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTemplatesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_project_template"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ProjectTemplatesFragmentFragment, unknown>;
export const ProjectOrgData_Org_Project_SummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectOrgData_org_project_summary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"client_email"}},{"kind":"Field","name":{"kind":"Name","value":"client_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"price_estimate"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}}]}}]} as unknown as DocumentNode<ProjectOrgData_Org_Project_SummaryFragment, unknown>;
export const CreateOrgProjectSummaryForm_Project_CategoriesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateOrgProjectSummaryForm_project_categories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<CreateOrgProjectSummaryForm_Project_CategoriesFragment, unknown>;
export const UpdateOrgProjectSummaryForm_Project_CategoriesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_categories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<UpdateOrgProjectSummaryForm_Project_CategoriesFragment, unknown>;
export const UpdateOrgProjectSummaryForm_Project_GroupsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_groups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<UpdateOrgProjectSummaryForm_Project_GroupsFragment, unknown>;
export const UpdateOrgProjectSummaryForm_Org_Project_SummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_org_project_summary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_categories"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_groups"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"client_email"}},{"kind":"Field","name":{"kind":"Name","value":"client_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"price_estimate"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_categories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_groups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<UpdateOrgProjectSummaryForm_Org_Project_SummaryFragment, unknown>;
export const ProjectClientsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"projectClients"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}}]}}]}}]} as unknown as DocumentNode<ProjectClientsFragment, unknown>;
export const CreateTaskForm_ProjectLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateTaskForm_projectLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<CreateTaskForm_ProjectLocationFragment, unknown>;
export const UserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserFieldsFragment, unknown>;
export const FileBadge_FileVersionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileBadge_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]} as unknown as DocumentNode<FileBadge_FileVersionFragment, unknown>;
export const UpdateTaskForm_AttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]} as unknown as DocumentNode<UpdateTaskForm_AttachmentFragment, unknown>;
export const UpdateTaskForm_SubtaskFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_subtask"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_subtasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}}]} as unknown as DocumentNode<UpdateTaskForm_SubtaskFragment, unknown>;
export const UpdateTaskForm_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_subtask"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_subtask"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_subtasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}}]} as unknown as DocumentNode<UpdateTaskForm_DataFragment, unknown>;
export const UpdateTaskForm_MembersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_members"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<UpdateTaskForm_MembersFragment, unknown>;
export const UpdateTaskForm_ProjectLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_projectLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<UpdateTaskForm_ProjectLocationFragment, unknown>;
export const TaskView_OrgAssignationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_OrgAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TaskView_OrgAssignationsFragment, unknown>;
export const TaskView_TeamAssignationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_TeamAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<TaskView_TeamAssignationsFragment, unknown>;
export const TaskView_UserAssignationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_UserAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TaskView_UserAssignationsFragment, unknown>;
export const TaskView_AssignationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_OrgAssignations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_TeamAssignations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_UserAssignations"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_OrgAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_TeamAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_UserAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TaskView_AssignationsFragment, unknown>;
export const TaskView_AttachmentsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_attachments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]} as unknown as DocumentNode<TaskView_AttachmentsFragment, unknown>;
export const TaskView_File_VersionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_file_versions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]} as unknown as DocumentNode<TaskView_File_VersionsFragment, unknown>;
export const TaskView_LabelsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_to_project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TaskView_LabelsFragment, unknown>;
export const TaskView_LocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_location"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_locations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<TaskView_LocationFragment, unknown>;
export const TaskView_SubtasksFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_subtasks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_subtasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"last_validated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_to_validate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TaskView_SubtasksFragment, unknown>;
export const TaskView_ValidationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_validations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}}]}}]} as unknown as DocumentNode<TaskView_ValidationsFragment, unknown>;
export const TaskFiltersFormSelectInput_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<TaskFiltersFormSelectInput_OrgFragment, unknown>;
export const TaskFiltersFormSelectInput_TeamFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TaskFiltersFormSelectInput_TeamFragment, unknown>;
export const TaskFiltersFormSelectInput_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}}]}}]} as unknown as DocumentNode<TaskFiltersFormSelectInput_UserFragment, unknown>;
export const TaskFiltersFormSelectInput_LabelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_label"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TaskFiltersFormSelectInput_LabelFragment, unknown>;
export const FiltersSelected_OrgsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_orgs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<FiltersSelected_OrgsFragment, unknown>;
export const FiltersSelected_TeamsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_teams"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<FiltersSelected_TeamsFragment, unknown>;
export const FiltersSelected_UsersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}}]}}]} as unknown as DocumentNode<FiltersSelected_UsersFragment, unknown>;
export const FiltersSelected_LabelsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<FiltersSelected_LabelsFragment, unknown>;
export const TasksReportDialog_MemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TasksReportDialog_MemberFragment, unknown>;
export const TasksReportDialog_TeamsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_teams"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TasksReportDialog_TeamsFragment, unknown>;
export const TasksReportDialog_LabelsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TasksReportDialog_LabelsFragment, unknown>;
export const TasksReportDialog_ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksReportDialog_member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksReportDialog_teams"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksReportDialog_labels"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_teams"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TasksReportDialog_ProjectFragment, unknown>;
export const ProjectTasksExportScreen_MemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksExportScreen_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTasksExportScreen_MemberFragment, unknown>;
export const ProjectTasksExportScreen_ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksExportScreen_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksExportScreen_member"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksExportScreen_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTasksExportScreen_ProjectFragment, unknown>;
export const ProjectTasksGantt_OrgProjectSummaryDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_orgProjectSummaryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<ProjectTasksGantt_OrgProjectSummaryDataFragment, unknown>;
export const ProjectTasksGantt_AssignationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTasksGantt_AssignationsFragment, unknown>;
export const ProjectTasksGantt_DependenciesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}}]} as unknown as DocumentNode<ProjectTasksGantt_DependenciesFragment, unknown>;
export const ProjectTasksGanttTasks_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGanttTasks_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"task_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_assignations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}}]} as unknown as DocumentNode<ProjectTasksGanttTasks_DataFragment, unknown>;
export const TasksList_AssignationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksList_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TasksList_AssignationsFragment, unknown>;
export const TaskList_PermissionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskList_permissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TaskList_PermissionsFragment, unknown>;
export const TaskListItem_CoreFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksList_assignations"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskList_permissions"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksList_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskList_permissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}}]} as unknown as DocumentNode<TaskListItem_CoreFragment, unknown>;
export const TaskListItem_Core_Extended_OfflineFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core_extended_offline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_core"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksList_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskList_permissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksList_assignations"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskList_permissions"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TaskListItem_Core_Extended_OfflineFragment, unknown>;
export const TaskListItem_AttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]} as unknown as DocumentNode<TaskListItem_AttachmentFragment, unknown>;
export const TaskListItem_Core_Extended_Offline_AttachmentsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core_extended_offline_attachments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_core_extended_offline"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_attachment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksList_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskList_permissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksList_assignations"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskList_permissions"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core_extended_offline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_core"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]} as unknown as DocumentNode<TaskListItem_Core_Extended_Offline_AttachmentsFragment, unknown>;
export const TasksList_ItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_core"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_attachment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksList_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskList_permissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksList_assignations"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskList_permissions"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]} as unknown as DocumentNode<TasksList_ItemFragment, unknown>;
export const UpdateTaskFull_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskFull_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_subtask"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_subtask"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_subtasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}}]} as unknown as DocumentNode<UpdateTaskFull_DataFragment, unknown>;
export const LabelsList_ItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelsList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<LabelsList_ItemFragment, unknown>;
export const TeamsList_ItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TeamsList_ItemFragment, unknown>;
export const ProjectTeamsMultiSelect_TeamFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTeamsMultiSelect_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<ProjectTeamsMultiSelect_TeamFragment, unknown>;
export const PushNotifications_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PushNotifications_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"push_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat_channel"}},{"kind":"Field","name":{"kind":"Name","value":"chat_direct_message"}}]}}]} as unknown as DocumentNode<PushNotifications_DataFragment, unknown>;
export const EmailNotifications_DataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailNotifications_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unread_notification_report"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_report"}}]}}]} as unknown as DocumentNode<EmailNotifications_DataFragment, unknown>;
export const ProfileForm_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileForm_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<ProfileForm_UserFragment, unknown>;
export const SaveFirebaseTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveFirebaseToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveFirebaseTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveFirebaseToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SaveFirebaseTokenSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_device_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SaveFirebaseTokenErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaveFirebaseTokenMutation, SaveFirebaseTokenMutationVariables>;
export const FinalizeUploadedFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedFileMutation, FinalizeUploadedFileMutationVariables>;
export const FinalizeUploadedFileVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedFileVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedFileVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileVersionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileVersionErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedFileVersionMutation, FinalizeUploadedFileVersionMutationVariables>;
export const UppyFinalizeUploadedFileApprovalsAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uppyFinalizeUploadedFileApprovalsAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileApprovalsAttachmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedFileApprovalsAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileApprovalsAttachmentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_approval_attachment_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileApprovalsAttachmentErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UppyFinalizeUploadedFileApprovalsAttachmentMutation, UppyFinalizeUploadedFileApprovalsAttachmentMutationVariables>;
export const FinalizeUploadedTaskAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedTaskAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskAttachmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedTaskAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskAttachmentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_attachment_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskAttachmentErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedTaskAttachmentMutation, FinalizeUploadedTaskAttachmentMutationVariables>;
export const FinalizeUploadedTaskAttachmentAnnotationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedTaskAttachmentAnnotation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskAttachmentAnnotationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedTaskAttachmentAnnotation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskAttachmentAnnotationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_attachment_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskAttachmentAnnotationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedTaskAttachmentAnnotationMutation, FinalizeUploadedTaskAttachmentAnnotationMutationVariables>;
export const FinalizeUploadedOrgAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedOrgAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedOrgAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedOrgAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedOrgAvatarSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedOrgAvatarErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedOrgAvatarMutation, FinalizeUploadedOrgAvatarMutationVariables>;
export const FinalizeUploadedOrgBackgroundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedOrgBackground"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedOrgBackgroundInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedOrgBackground"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedOrgBackgroundSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedOrgBackgroundErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedOrgBackgroundMutation, FinalizeUploadedOrgBackgroundMutationVariables>;
export const FinalizeUploadedProjectAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedProjectAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedProjectAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectAvatarSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectAvatarErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedProjectAvatarMutation, FinalizeUploadedProjectAvatarMutationVariables>;
export const FinalizeUploadedProjectGroupAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizeUploadedProjectGroupAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectGroupAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FinalizeUploadedProjectGroupAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectGroupAvatarSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectGroupAvatarErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedProjectGroupAvatarMutation, FinalizeUploadedProjectGroupAvatarMutationVariables>;
export const FinalizeUploadedProjectBackgroundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedProjectBackground"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectBackgroundInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedProjectBackground"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectBackgroundSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectBackgroundErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedProjectBackgroundMutation, FinalizeUploadedProjectBackgroundMutationVariables>;
export const FinalizeUploadedProjectBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedProjectBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedProjectBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectBannerSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectBannerErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedProjectBannerMutation, FinalizeUploadedProjectBannerMutationVariables>;
export const FinalizeUploadedUserAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedUserAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedUserAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedUserAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedUserAvatarSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedUserAvatarErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedUserAvatarMutation, FinalizeUploadedUserAvatarMutationVariables>;
export const FinalizeUploadedChannelAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedChannelAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedChannelAssetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedChannelAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedChannelAssetSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel_id"}},{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedChannelAssetErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedChannelAssetMutation, FinalizeUploadedChannelAssetMutationVariables>;
export const FinalizeUploadedFileStructureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedFileStructure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileStructureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedFileStructure"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileStructureSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parent_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileStructureErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedFileStructureMutation, FinalizeUploadedFileStructureMutationVariables>;
export const FinalizeUploadedTaskSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedTaskSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskSpreadsheetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedTaskSpreadsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskSpreadsheetSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedTaskSpreadsheetErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedTaskSpreadsheetMutation, FinalizeUploadedTaskSpreadsheetMutationVariables>;
export const FinalizeUploadedProjectSpreadsheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeUploadedProjectSpreadsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectSpreadsheetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedProjectSpreadsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectSpreadsheetSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedProjectSpreadsheetErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedProjectSpreadsheetMutation, FinalizeUploadedProjectSpreadsheetMutationVariables>;
export const FinalizeFileVersionAnnotationsForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"finalizeFileVersionAnnotationsForUpload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<FinalizeFileVersionAnnotationsForUploadMutation, FinalizeFileVersionAnnotationsForUploadMutationVariables>;
export const UserProvider_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProvider_user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auth0_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auth0_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auth0_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"stream_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"auth0_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTeams_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"algolia_key"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveOrgRole_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveOrg_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stream_chat_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_locked"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTeams_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveOrgRole_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveOrg_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserProvider_UserQuery, UserProvider_UserQueryVariables>;
export const UserNotifcationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userNotifcations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unreadNotifications"},"name":{"kind":"Name","value":"user_notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"recipient_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"read_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNotification_notification"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNotification_badgeNotification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_strong"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNotification_notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNotification_badgeNotification"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_id"}},{"kind":"Field","name":{"kind":"Name","value":"read_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<UserNotifcationsQuery, UserNotifcationsQueryVariables>;
export const ReadNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"readNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const UnreadNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unreadNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unreadNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UnreadNotificationsMutation, UnreadNotificationsMutationVariables>;
export const WorkerStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workerStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"workerStatus"},"name":{"kind":"Name","value":"events_workers_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creator_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkerStatus_status"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkerStatus_status"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"events_workers_status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<WorkerStatusQuery, WorkerStatusQueryVariables>;
export const GetCapawesomeChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCapawesomeChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"app_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCapawesomeChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"app_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"app_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCapawesomeChannelsQuery, GetCapawesomeChannelsQueryVariables>;
export const GetCapgoChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCapgoChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"app_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCapgoChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"app_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"app_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetCapgoChannelsQuery, GetCapgoChannelsQueryVariables>;
export const GetProjectMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stream_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectMembersQuery, GetProjectMembersQueryVariables>;
export const AddMembersToProjectChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addMembersToProjectChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddMembersToProjectChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMembersToProjectChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddMembersToProjectChannelSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel_id"}}]}}]}}]}}]} as unknown as DocumentNode<AddMembersToProjectChannelMutation, AddMembersToProjectChannelMutationVariables>;
export const RemoveMembersFromProjectChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeMembersFromProjectChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveMembersFromProjectChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMembersFromProjectChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveMembersFromProjectChannelSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveMembersFromProjectChannelErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveMembersFromProjectChannelMutation, RemoveMembersFromProjectChannelMutationVariables>;
export const RenameChannelForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renameChannelForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenameChannelForProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameChannelForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenameChannelForProjectSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel_id"}}]}}]}}]}}]} as unknown as DocumentNode<RenameChannelForProjectMutation, RenameChannelForProjectMutationVariables>;
export const CreateChannelForProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChannelForProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelForProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChannelForProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelForProjectSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateChannelForProjectMutation, CreateChannelForProjectMutationVariables>;
export const CreateProjectDirectMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProjectDirectMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectDirectMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectDirectMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectDirectMessageSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectDirectMessageErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDoesNotExist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectDirectMessageMutation, CreateProjectDirectMessageMutationVariables>;
export const PrepareChannelAssetForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareChannelAssetForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareChannelAssetForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareChannelAssetForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareChannelAssetForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareChannelAssetForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareChannelAssetForUploadMutation, PrepareChannelAssetForUploadMutationVariables>;
export const CreateDemoProjectFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateDemoProjectForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"templates"},"name":{"kind":"Name","value":"project_templates_overview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateDemoProjectForm_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateDemoProjectForm_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_templates_overview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<CreateDemoProjectFormQuery, CreateDemoProjectFormQueryVariables>;
export const CopyProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CopyProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CopyProjectSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<CopyProjectMutation, CopyProjectMutationVariables>;
export const CreateOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrgSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrgMutation, CreateOrgMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const FileTasksDrawerContent_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileTasksDrawerContent_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tasksFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileVersions"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileVersions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tasksFilter"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFileVersion"}}]}}]}}]} as unknown as DocumentNode<FileTasksDrawerContent_DataQuery, FileTasksDrawerContent_DataQueryVariables>;
export const UpdateTaskFileVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaskFileVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskFileVersionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaskFileVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskFileVersionsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaskFileVersionsMutation, UpdateTaskFileVersionsMutationVariables>;
export const FileViewer_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileViewer_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileViewer_file"}},{"kind":"Field","alias":{"kind":"Name","value":"version"},"name":{"kind":"Name","value":"versions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileViewer_fileVersion"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileViewer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"current_extension"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_annotated"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileViewer_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"pdf_location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"autodesk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urn"}},{"kind":"Field","name":{"kind":"Name","value":"conversion_progress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileViewer_fileVersion"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autodesk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urn"}},{"kind":"Field","name":{"kind":"Name","value":"conversion_progress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}}]} as unknown as DocumentNode<FileViewer_DataQuery, FileViewer_DataQueryVariables>;
export const AddUserViewToFileVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUserViewToFileVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserViewToFileVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserViewToFileVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AddUserViewToFileVersionMutation, AddUserViewToFileVersionMutationVariables>;
export const PrepareFileForAutodeskViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareFileForAutodeskViewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileForAutodeskViewerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareFileForAutodeskViewer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileForAutodeskViewerErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareFileForAutodeskViewerMutation, PrepareFileForAutodeskViewerMutationVariables>;
export const ConvertFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConvertFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConvertFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"convertFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConvertFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConvertFileErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConvertFileMutation, ConvertFileMutationVariables>;
export const PrepareFileVersionAnnotationForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareFileVersionAnnotationForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileVersionAnnotationForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareFileVersionAnnotationForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileVersionAnnotationForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileVersionAnnotationForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareFileVersionAnnotationForUploadMutation, PrepareFileVersionAnnotationForUploadMutationVariables>;
export const GetAutodeskTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutodeskToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAutodeskToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autodesk_access_token"}}]}}]}}]} as unknown as DocumentNode<GetAutodeskTokenQuery, GetAutodeskTokenQueryVariables>;
export const ApprovalMode_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApprovalMode_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_versions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApprovalMode_DataQuery, ApprovalMode_DataQueryVariables>;
export const AddUserApprovalToFileVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUserApprovalToFileVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserApprovalToFileVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserApprovalToFileVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserApprovalToFileVersionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}}]}}]}}]}}]} as unknown as DocumentNode<AddUserApprovalToFileVersionMutation, AddUserApprovalToFileVersionMutationVariables>;
export const PrepareFileApprovalsAttachmentForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareFileApprovalsAttachmentForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileApprovalsAttachmentForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareFileApprovalsAttachmentForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileApprovalsAttachmentForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareFileApprovalsAttachmentForUploadMutation, PrepareFileApprovalsAttachmentForUploadMutationVariables>;
export const AddFileApprovalsFileVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddFileApprovalsFileVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddFileApprovalsFileVersionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFileApprovalsFileVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddFileApprovalsFileVersionsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saved"}}]}}]}}]}}]} as unknown as DocumentNode<AddFileApprovalsFileVersionsMutation, AddFileApprovalsFileVersionsMutationVariables>;
export const FinalizeUploadedFileApprovalsAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizeUploadedFileApprovalsAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileApprovalsAttachmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeUploadedFileApprovalsAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeUploadedFileApprovalsAttachmentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_approval_attachment_id"}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeUploadedFileApprovalsAttachmentMutation, FinalizeUploadedFileApprovalsAttachmentMutationVariables>;
export const AddUserMultiApprovalToFilesVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUserMultiApprovalToFilesVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserMultiApprovalToFilesVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserMultiApprovalToFilesVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddMultiUserApprovalToFileVersionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_ids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddUserMultiApprovalToFilesVersionMutation, AddUserMultiApprovalToFilesVersionMutationVariables>;
export const AnnotateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"annotateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnotateFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annotateFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnotateFileErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnotateFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}}]}}]}}]}}]} as unknown as DocumentNode<AnnotateFileMutation, AnnotateFileMutationVariables>;
export const SignFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SignFileErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SignFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}}]}}]}}]}}]} as unknown as DocumentNode<SignFileMutation, SignFileMutationVariables>;
export const TasksAnnotations_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksAnnotations_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tasksFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskAnnotations_fileVersions"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskAnnotations_fileVersions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tasksFilter"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"pdf_location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TasksAnnotations_DataQuery, TasksAnnotations_DataQueryVariables>;
export const FileViewersDetailsDrawerContent_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileViewersDetailsDrawerContent_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_versions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileViewersDetailsDrawerContent_DataQuery, FileViewersDetailsDrawerContent_DataQueryVariables>;
export const FilterList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"e7c36ad5-53e5-4b9d-b1f2-3d0b06335d37","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"e7c36ad5-53e5-4b9d-b1f2-3d0b06335d37","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"e7c36ad5-53e5-4b9d-b1f2-3d0b06335d37","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibility_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility_project_id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility_org_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"filterDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filter_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<FilterList_DataQuery, FilterList_DataQueryVariables>;
export const GetUserAuthenticatedLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserAuthenticatedLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirect"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"link"},"name":{"kind":"Name","value":"getUserAuthLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirect"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirect"}}}]}]}}]} as unknown as DocumentNode<GetUserAuthenticatedLinkQuery, GetUserAuthenticatedLinkQueryVariables>;
export const GetLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabelsMultiSelect_project"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelsMultiSelect_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetLabelsQuery, GetLabelsQueryVariables>;
export const GetProjectLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabelsMultiSelect_project"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelsMultiSelect_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetProjectLabelsQuery, GetProjectLabelsQueryVariables>;
export const CreateProjectLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProjectLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectLabelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectLabelSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectLabelMutation, CreateProjectLabelMutationVariables>;
export const CreateMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"uploadId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMultipartUploadMutation, CreateMultipartUploadMutationVariables>;
export const ListMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"listMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"etag"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListMultipartUploadMutation, ListMultipartUploadMutationVariables>;
export const PrepareMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"uploadId"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrls"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareMultipartUploadMutation, PrepareMultipartUploadMutationVariables>;
export const CompleteMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"completeMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteMultipartUploadMutation, CompleteMultipartUploadMutationVariables>;
export const AbortMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"abortMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AbortMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abortMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbortMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbortMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAborted"}}]}}]}}]}}]} as unknown as DocumentNode<AbortMultipartUploadMutation, AbortMultipartUploadMutationVariables>;
export const NavigationDrawer_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavigationDrawer_user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveOrg_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}]}}]}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_project_template"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_demo"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"originalInviter"},"name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"originalInviter"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveOrg_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"originalInviter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NavigationDrawer_UserQuery, NavigationDrawer_UserQueryVariables>;
export const NavigationDrawer_OrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavigationDrawer_org"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_menu_by_group"}}]}}]}}]}}]} as unknown as DocumentNode<NavigationDrawer_OrgQuery, NavigationDrawer_OrgQueryVariables>;
export const GetPwdOfFilesAndFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPwdOfFilesAndFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folders_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"folders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folders_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}}]} as unknown as DocumentNode<GetPwdOfFilesAndFoldersQuery, GetPwdOfFilesAndFoldersQueryVariables>;
export const GetValuedProjectUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getValuedProjectUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"owner","block":false},{"kind":"StringValue","value":"administrator","block":false}]}}]}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValuedProjectUsersQuery, GetValuedProjectUsersQueryVariables>;
export const ProjectInfoContainer_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectInfoContainer_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"banner"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_email"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"client_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectInfoContainer_DataQuery, ProjectInfoContainer_DataQueryVariables>;
export const ProjectProfileContainer_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectProfileContainer_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"street"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectProfileContainer_DataQuery, ProjectProfileContainer_DataQueryVariables>;
export const GetProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectsMultiSelect_project"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsMultiSelect_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_project_template"}}]}}]}}]} as unknown as DocumentNode<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetOrgProjectTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrgProjectTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrgProjectTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrgProjectTemplatesQuery, GetOrgProjectTemplatesQueryVariables>;
export const QueryExample_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryExample_query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<QueryExample_QueryQuery, QueryExample_QueryQueryVariables>;
export const UpdateTasksSchedulerDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTasksSchedulerDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksDatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTasksDates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksDatesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTasksSchedulerDatesMutation, UpdateTasksSchedulerDatesMutationVariables>;
export const UpdateTasksSchedulerAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTasksSchedulerAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksAssignationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTasksAssignations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksAssignationsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTasksSchedulerAssignationsMutation, UpdateTasksSchedulerAssignationsMutationVariables>;
export const CopyTaskAttachmentsUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyTaskAttachmentsUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CopyTaskAttachmentsUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyTaskAttachmentsUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"copyTaskAttachmentsUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<CopyTaskAttachmentsUploadMutation, CopyTaskAttachmentsUploadMutationVariables>;
export const PrepareTaskAttachmentMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareTaskAttachmentMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareTaskAttachmentMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDoesNotExist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"uploadId"}},{"kind":"Field","name":{"kind":"Name","value":"presignedUrls"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareTaskAttachmentMultipartUploadMutation, PrepareTaskAttachmentMultipartUploadMutationVariables>;
export const CreateTaskAttachmentMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTaskAttachmentMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskAttachmentMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTaskAttachmentMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskAttachmentMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDoesNotExist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskAttachmentMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"uploadId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskAttachmentMultipartUploadMutation, CreateTaskAttachmentMultipartUploadMutationVariables>;
export const ListTaskAttachmentMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"listTaskAttachmentMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTaskAttachmentMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listTaskAttachmentMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListTaskAttachmentMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDoesNotExist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListTaskAttachmentMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"etag"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListTaskAttachmentMultipartUploadMutation, ListTaskAttachmentMultipartUploadMutationVariables>;
export const CompleteTaskAttachmentMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"completeTaskAttachmentMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteTaskAttachmentMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeTaskAttachmentMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteTaskAttachmentMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDoesNotExist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteTaskAttachmentMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteTaskAttachmentMultipartUploadMutation, CompleteTaskAttachmentMultipartUploadMutationVariables>;
export const AbortTaskAttachmentMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"abortTaskAttachmentMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AbortTaskAttachmentMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abortTaskAttachmentMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbortTaskAttachmentMultipartUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskDoesNotExist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}},{"kind":"Field","name":{"kind":"Name","value":"formErrors"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbortTaskAttachmentMultipartUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAborted"}}]}}]}}]}}]} as unknown as DocumentNode<AbortTaskAttachmentMultipartUploadMutation, AbortTaskAttachmentMultipartUploadMutationVariables>;
export const UpdateUserAppMetadataInfosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserAppMetadataInfos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appMobile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appDesktop"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAppMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app_desktop_installed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appDesktop"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"app_mobile_installed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appMobile"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserAppMetadataSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserAppMetadataInfosMutation, UpdateUserAppMetadataInfosMutationVariables>;
export const UpdateBrowserTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBrowserTimezone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBrowserTimezone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBrowserTimezoneSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBrowserTimezoneMutation, UpdateBrowserTimezoneMutationVariables>;
export const UpdateBrowserLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBrowserLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBrowserLanguage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"browser_language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBrowserLanguageSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBrowserLanguageMutation, UpdateBrowserLanguageMutationVariables>;
export const GetUserEmailSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserEmailSuggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder_company_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder_company_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserEmailSuggestionsQuery, GetUserEmailSuggestionsQueryVariables>;
export const GetOrgsNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrgsNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgs_id"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgs_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetOrgsNamesQuery, GetOrgsNamesQueryVariables>;
export const UserProfileContainer_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProfileContainer_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_connected"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder_company_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<UserProfileContainer_DataQuery, UserProfileContainer_DataQueryVariables>;
export const UserProjectInfo_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProjectInfo_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"User"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder_company_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_connected"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder_company_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<UserProjectInfo_DataQuery, UserProjectInfo_DataQueryVariables>;
export const VisasApprovalsContainer_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisasApprovalsContainer_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisasApprovalsContainer_DataQuery, VisasApprovalsContainer_DataQueryVariables>;
export const GetFilterProjectFormOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFilterProjectFormOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_archived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_archived"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProjectInfoFilter"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProjectMembersFilter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects_map_overview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_archived"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgProjectInfoFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCategoryFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProjectInfoFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCategoryFilter"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProjectMembersFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgProjectInfoFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_map_overview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCategoryFilter"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFilterProjectFormOptionsQuery, GetFilterProjectFormOptionsQueryVariables>;
export const GetOrgMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrgMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrgMembersQuery, GetOrgMembersQueryVariables>;
export const UpdateProjectsCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectsCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectsCategoriesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectsCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectsCategoriesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectsCategoriesMutation, UpdateProjectsCategoriesMutationVariables>;
export const UpdateProjectsClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectsClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectsClientInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectsClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectsClientSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"client_email"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"client_phone_number"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectsClientMutation, UpdateProjectsClientMutationVariables>;
export const ProjectInvitationForm_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectInvitationForm_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectInvitationForm_DataQuery, ProjectInvitationForm_DataQueryVariables>;
export const ProjectBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectBasicInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectBasicInfoQuery, ProjectBasicInfoQueryVariables>;
export const TasksAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_assignations_orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"task_assignee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"task_assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Tasks_data"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"task_assignations_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"task_assignee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}]}}]}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"task_assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Tasks_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tasks_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]} as unknown as DocumentNode<TasksAssignationsQuery, TasksAssignationsQueryVariables>;
export const CalendarTasksUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalendarTasksUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}]}}]}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Tasks_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tasks_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]} as unknown as DocumentNode<CalendarTasksUserQuery, CalendarTasksUserQueryVariables>;
export const UsersByOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersByOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersByOrgQuery, UsersByOrgQueryVariables>;
export const UpdateTaskDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaskDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskPermissionDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formErrors"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaskDatesMutation, UpdateTaskDatesMutationVariables>;
export const UpdateTaskUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTaskUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaskUserMutation, UpdateTaskUserMutationVariables>;
export const ProjectInvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"projectInvitations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectInvitationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectInvitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectInvitationsErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CannotUpdateProjectRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formErrors"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectInvitationsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"errorReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_already_org_project_member"}},{"kind":"Field","name":{"kind":"Name","value":"user_already_project_member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"successReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectInvitationsMutation, ProjectInvitationsMutationVariables>;
export const ProjectsGanttDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsGantt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectsGantt_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectCategories_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary_to_project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsGantt_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectCategories_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}}]}}]}}]} as unknown as DocumentNode<ProjectsGanttQuery, ProjectsGanttQueryVariables>;
export const UpdateOrgProjectSummaryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrgProjectSummaryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProjectSummaryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrgProjectSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProjectSummarySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrgProjectSummaryDataMutation, UpdateOrgProjectSummaryDataMutationVariables>;
export const ProjectsList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_map_overview_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_map_overview_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"projects"},"name":{"kind":"Name","value":"projects_map_overview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_member"}},{"kind":"Field","name":{"kind":"Name","value":"is_creator_in_my_org"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"price_estimate"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"projects_count_filtered"},"name":{"kind":"Name","value":"projects_map_overview_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"projects_count"},"name":{"kind":"Name","value":"projects_map_overview_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsList_DataQuery, ProjectsList_DataQueryVariables>;
export const UserProjectsRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userProjectsRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProjectsRolesQuery, UserProjectsRolesQueryVariables>;
export const ProjectGroupsData_ProjectGroupsCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectGroupsData_ProjectGroupsCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectGroupsData_ProjectGroupsCategoriesQuery, ProjectGroupsData_ProjectGroupsCategoriesQueryVariables>;
export const ProjectOrgData_ProjectCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectOrgData_ProjectCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectOrgData_ProjectCategoriesQuery, ProjectOrgData_ProjectCategoriesQueryVariables>;
export const ProjectMapsScreenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectMapsScreen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_map_overview_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_map_overview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectsMaps_projects"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"projects_count"},"name":{"kind":"Name","value":"projects_map_overview_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsMaps_projects"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_map_overview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectMapsScreenQuery, ProjectMapsScreenQueryVariables>;
export const MetricsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version_approval_request_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_approval_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_version_approval_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_in_bin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version_approval_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"due_date"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalRequestItem_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_version_approval_request_users_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_approval_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_version_approval_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_in_bin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creator_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orgs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_validated_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"user","block":false},{"kind":"StringValue","value":"org","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end_date"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricsData_task"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creator_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orgs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_validated_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"user","block":false},{"kind":"StringValue","value":"org","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isArchived"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalRequestItem_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_version_approval_request_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_approval_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricsData_task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MetricsDataQuery, MetricsDataQueryVariables>;
export const GetProjectCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>;
export const CreateTaskTwoStepsOnDbClickDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateTaskTwoStepsOnDbClickDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secondUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roles"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstUserId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roles"}}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secondUserId"}}}]}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateTaskTwoStepsOnDbClickDialog_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateTaskTwoStepsOnDbClickDialog_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskTwoStepsOnDbClickDialogQuery, CreateTaskTwoStepsOnDbClickDialogQueryVariables>;
export const CreateTaskTwoStepsDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateTaskTwoStepsDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateTaskTwoStepsDialog_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateTaskTwoStepsDialog_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskTwoStepsDialogQuery, CreateTaskTwoStepsDialogQueryVariables>;
export const TasksListGlobalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksListGlobal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filters"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksListGlobalTask_data"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tasks_count_filtered"},"name":{"kind":"Name","value":"tasks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filters"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tasks_count_total"},"name":{"kind":"Name","value":"tasks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tasks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tasks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksListGlobalTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]} as unknown as DocumentNode<TasksListGlobalQuery, TasksListGlobalQueryVariables>;
export const TasksSchedulerDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksSchedulerData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor_start_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"filters"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor_start_date"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksSchedulerTask_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TasksSchedulerDataQuery, TasksSchedulerDataQueryVariables>;
export const TasksSchedulerDataPastDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksSchedulerDataPast"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor_start_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"filters"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor_start_date"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksSchedulerTask_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TasksSchedulerDataPastQuery, TasksSchedulerDataPastQueryVariables>;
export const TasksByPkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksByPk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksSchedulerTask_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TasksByPkQuery, TasksByPkQueryVariables>;
export const TasksSchedulerDateRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksSchedulerDateRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"filters"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksSchedulerTask_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectsSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TasksSchedulerDateRangeQuery, TasksSchedulerDateRangeQueryVariables>;
export const TasksSchedulerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksScheduler"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_project_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filters"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksSchedulerTask_data"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksSchedulerTask_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<TasksSchedulerQuery, TasksSchedulerQueryVariables>;
export const UpdateTaskAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaskAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssignationsTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaskAssignationsMutation, UpdateTaskAssignationsMutationVariables>;
export const InvitationConfirmationDialog_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvitationConfirmationDialog_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]} as unknown as DocumentNode<InvitationConfirmationDialog_DataQuery, InvitationConfirmationDialog_DataQueryVariables>;
export const UserOrgRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userOrgRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserOrgRoleQuery, UserOrgRoleQueryVariables>;
export const PrepareProjectSpreadsheetForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareProjectSpreadsheetForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectSpreadsheetForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareProjectSpreadsheetForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectSpreadsheetForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectSpreadsheetForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareProjectSpreadsheetForUploadMutation, PrepareProjectSpreadsheetForUploadMutationVariables>;
export const ProjectImportRequestExcelTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProjectImportRequestExcelTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectImportRequestExcelTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectImportRequestExcelTemplateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectImportRequestExcelTemplateMutation, ProjectImportRequestExcelTemplateMutationVariables>;
export const OrgNavigation_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgNavigation_user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrgNavigation_UserQuery, OrgNavigation_UserQueryVariables>;
export const OrgProfileContainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgProfileContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"legal_number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<OrgProfileContainerQuery, OrgProfileContainerQueryVariables>;
export const ProjectInfosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectInfos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectInfosQuery, ProjectInfosQueryVariables>;
export const CategoriesList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoriesList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoriesList_item"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoriesList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<CategoriesList_DataQuery, CategoriesList_DataQueryVariables>;
export const CreateProjectCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProjectCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectCategorySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectCategoryMutation, CreateProjectCategoryMutationVariables>;
export const UpdateProjectCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectCategorySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectCategoryMutation, UpdateProjectCategoryMutationVariables>;
export const DeleteProjectCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProjectCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectCategorySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectCategoryMutation, DeleteProjectCategoryMutationVariables>;
export const GroupsList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupsList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupsList_item"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupsList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<GroupsList_DataQuery, GroupsList_DataQueryVariables>;
export const CreateProjectGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProjectGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectGroupSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectGroupMutation, CreateProjectGroupMutationVariables>;
export const PrepareProjectGroupAssetForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareProjectGroupAssetForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectGroupAssetForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PrepareProjectGroupAssetForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectGroupAssetForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareProjectGroupAssetForUploadMutation, PrepareProjectGroupAssetForUploadMutationVariables>;
export const UpdateProjectGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectGroupSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectGroupMutation, UpdateProjectGroupMutationVariables>;
export const DeleteProjectGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProjectGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectGroupSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectGroupMutation, DeleteProjectGroupMutationVariables>;
export const OrgAccessDeniedScreen_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgAccessDeniedScreen_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrgAccessDeniedScreen_DataQuery, OrgAccessDeniedScreen_DataQueryVariables>;
export const OrgMembersList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgMembersList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"orgs_to_users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviter_id"}}]}}]}}]}}]} as unknown as DocumentNode<OrgMembersList_DataQuery, OrgMembersList_DataQueryVariables>;
export const OrgProfileScreen_OrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgProfileScreen_Org"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"orgs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileForm_org"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileForm_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"legal_number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_menu_by_group"}}]}},{"kind":"Field","name":{"kind":"Name","value":"public_api_token"}}]}}]} as unknown as DocumentNode<OrgProfileScreen_OrgQuery, OrgProfileScreen_OrgQueryVariables>;
export const UpdateOrgProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrgProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrgProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProfileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrgProfileMutation, UpdateOrgProfileMutationVariables>;
export const GenerateApiTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generateApiToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateApiTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateApiToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateApiTokenSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>;
export const PrepareOrgAssetForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareOrgAssetForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareOrgAssetForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareOrgAssetForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareOrgAssetForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareOrgAssetForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareOrgAssetForUploadMutation, PrepareOrgAssetForUploadMutationVariables>;
export const ProjectMembers_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectMembers_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stream_user_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectMembers_DataQuery, ProjectMembers_DataQueryVariables>;
export const ProjectChatHeader_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectChatHeader_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectChatHeader_DataQuery, ProjectChatHeader_DataQueryVariables>;
export const GetProjectDocumentFolderRootDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectDocumentFolderRoot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"root_folder_id"}},{"kind":"Field","name":{"kind":"Name","value":"root_bin_folder_id"}}]}}]}}]} as unknown as DocumentNode<GetProjectDocumentFolderRootQuery, GetProjectDocumentFolderRootQueryVariables>;
export const RestoreFileVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"restoreFileVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RestoreFileVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreFileVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestoreFileVersionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}}]}}]}}]}}]} as unknown as DocumentNode<RestoreFileVersionMutation, RestoreFileVersionMutationVariables>;
export const GetFileVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileVersionsVirtualList_versions"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileVersionsVirtualList_versions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}},{"kind":"Field","name":{"kind":"Name","value":"is_completed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_approval_id"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFileVersionsQuery, GetFileVersionsQueryVariables>;
export const GetFilesFoldersNavigatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilesFoldersNavigator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"folders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesFoldersNavigatorsData_folder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesFoldersNavigatorsData_file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersNavigatorsData_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersNavigatorsData_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFilesFoldersNavigatorQuery, GetFilesFoldersNavigatorQueryVariables>;
export const GetProjectFileRootDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectFileRoot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"root_bin_folder_id"}},{"kind":"Field","name":{"kind":"Name","value":"root_folder_id"}}]}}]}}]} as unknown as DocumentNode<GetProjectFileRootQuery, GetProjectFileRootQueryVariables>;
export const GetFileLastVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFileLastVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFileLastVersionQuery, GetFileLastVersionQueryVariables>;
export const GetFileVersionByPkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFileVersionByPk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_versions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_in_bin"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFileVersionByPkQuery, GetFileVersionByPkQueryVariables>;
export const GetBinFolderFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBinFolderFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"folders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BinFilesFoldersData_folder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BinFilesFoldersData_file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinFilesFoldersData_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignee_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinFilesFoldersData_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetBinFolderFilesQuery, GetBinFolderFilesQueryVariables>;
export const GetProjectFoldersRootDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectFoldersRoot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"root_folder_id"}}]}}]}}]} as unknown as DocumentNode<GetProjectFoldersRootQuery, GetProjectFoldersRootQueryVariables>;
export const RestoreFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"restoreFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFilesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFilesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_ids"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFilesErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestoreFileMutation, RestoreFileMutationVariables>;
export const RestoreFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"restoreFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFoldersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFoldersSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_ids"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFoldersErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestoreFolderMutation, RestoreFolderMutationVariables>;
export const GetFolderFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFolderFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"files_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"folders_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_in_bin"}},{"kind":"Field","name":{"kind":"Name","value":"folders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesFoldersData_folder"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RenameFolderForm_folder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesFoldersData_file"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RenameFileForm_file"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateDueDateFileForm_file"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileApproval_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_approval_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_approvals_file_versions_attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersData_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignee_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RenameFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersData_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RenameFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateDueDateFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"file_versions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}}]} as unknown as DocumentNode<GetFolderFilesQuery, GetFolderFilesQueryVariables>;
export const SearchFilesAndFoldersByFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchFilesAndFoldersByFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"files_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"folders_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"fileFilters"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesFoldersData_file"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RenameFileForm_file"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateDueDateFileForm_file"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_file"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"folderFilters"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_in_bin"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilesFoldersData_folder"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RenameFolderForm_folder"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileApproval_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_approval_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_approvals_file_versions_attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersData_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"original_url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RenameFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateDueDateFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"file_versions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilesFoldersData_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignee_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RenameFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<SearchFilesAndFoldersByFilterQuery, SearchFilesAndFoldersByFilterQueryVariables>;
export const GetSubFolderCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubFolderCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSubFolderCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subFileCount"}},{"kind":"Field","name":{"kind":"Name","value":"subFolderCount"}},{"kind":"Field","name":{"kind":"Name","value":"subFolderId"}}]}}]}}]} as unknown as DocumentNode<GetSubFolderCountQuery, GetSubFolderCountQueryVariables>;
export const AddUserViewToFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUserViewToFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserViewToFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserViewToFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AddUserViewToFolderMutation, AddUserViewToFolderMutationVariables>;
export const GetFileLastVersionIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileLastVersionId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFileLastVersionIdQuery, GetFileLastVersionIdQueryVariables>;
export const GetFolderNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFolderNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetFolderNamesQuery, GetFolderNamesQueryVariables>;
export const PrepareFileVersionForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareFileVersionForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileVersionForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareFileVersionForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileVersionForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileVersionForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareFileVersionForUploadMutation, PrepareFileVersionForUploadMutationVariables>;
export const RenameNewFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renameNewFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenameFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenameFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}}]}}]} as unknown as DocumentNode<RenameNewFileMutation, RenameNewFileMutationVariables>;
export const PrepareFileStructureForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareFileStructureForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileStructureForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareFileStructureForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileStructureForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileStructureForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareFileStructureForUploadMutation, PrepareFileStructureForUploadMutationVariables>;
export const AssigneesApprovalsAndViewsDrawer_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileApproval_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_approval_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"approval_attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileApproval_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_approvals_file_versions_attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_on_a_version"}},{"kind":"Field","name":{"kind":"Name","value":"is_approval_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_creator"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"file_versions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssigneesApprovalsAndViewsDrawer_fileVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}}]}}]} as unknown as DocumentNode<AssigneesApprovalsAndViewsDrawer_DataQuery, AssigneesApprovalsAndViewsDrawer_DataQueryVariables>;
export const CreateChannelForApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChannelForApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelForApprovalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChannelForApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelForApprovalSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"approval_id"}},{"kind":"Field","name":{"kind":"Name","value":"channel_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateChannelForApprovalMutation, CreateChannelForApprovalMutationVariables>;
export const CreateFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFolderSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFolderErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FolderAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateFolderMutation, CreateFolderMutationVariables>;
export const PrepareFileForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareFileForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareFileForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareFileForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareFileForUploadMutation, PrepareFileForUploadMutationVariables>;
export const CreateEmptyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createEmptyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEmptyFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEmptyFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEmptyFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileVersionId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEmptyFileMutation, CreateEmptyFileMutationVariables>;
export const GetDocsFilterAssigneesOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocsFilterAssigneesOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<GetDocsFilterAssigneesOptionsQuery, GetDocsFilterAssigneesOptionsQueryVariables>;
export const ExportVisasDialog_ProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportVisasDialog_Project"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExportVisasScreen_project"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExportVisasScreen_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ExportVisasDialog_ProjectQuery, ExportVisasDialog_ProjectQueryVariables>;
export const RequestApprovalExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestApprovalExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestApprovalExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestApprovalExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestApprovalExportSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<RequestApprovalExportMutation, RequestApprovalExportMutationVariables>;
export const RequestApprovalReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestApprovalReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestApprovalReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestApprovalReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestApprovalReportSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<RequestApprovalReportMutation, RequestApprovalReportMutationVariables>;
export const RequestFilesTreeExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestFilesTreeExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestFilesTreeReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestFilesTreeReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestFilesTreeReportSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<RequestFilesTreeExportMutation, RequestFilesTreeExportMutationVariables>;
export const GetApprovalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApprovals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_approval_mode"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"folder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_in_bin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetApprovals_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetApprovals_version"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}},{"kind":"Field","name":{"kind":"Name","value":"is_completed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetApprovals_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetApprovals_version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}}]} as unknown as DocumentNode<GetApprovalsQuery, GetApprovalsQueryVariables>;
export const GetFilesTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilesTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"folder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_in_bin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetApprovals_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetApprovals_version"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_approved_with_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_approved_without_comments"}},{"kind":"Field","name":{"kind":"Name","value":"is_denied"}},{"kind":"Field","name":{"kind":"Name","value":"is_completed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approval_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetApprovals_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetApprovals_version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parents_ids"}}]}}]}}]} as unknown as DocumentNode<GetFilesTreeQuery, GetFilesTreeQueryVariables>;
export const EnableFileApprovalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enableFileApprovals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilesApprovalMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isApprovalMode"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFilesApprovalModeErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EnableFileApprovalsMutation, EnableFileApprovalsMutationVariables>;
export const DisableFileApprovalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"disableFileApprovals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilesApprovalMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isApprovalMode"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFilesApprovalModeErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CannotRemoveApprovalOnFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DisableFileApprovalsMutation, DisableFileApprovalsMutationVariables>;
export const DeleteFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFileMutation, DeleteFileMutationVariables>;
export const DuplicateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"duplicateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateFilesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_ids"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateFilesErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DuplicateFileMutation, DuplicateFileMutationVariables>;
export const GetFilePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFilePermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdatePermissionsFileForm_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdatePermissionsFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}}]}}]}}]} as unknown as DocumentNode<GetFilePermissionsQuery, GetFilePermissionsQueryVariables>;
export const GetFilePermissionsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFilePermissionsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"file"},"name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions_permissions_orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_permissions_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_permissions_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"files"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFilePermissionsOptionsQuery, GetFilePermissionsOptionsQueryVariables>;
export const UpdatePermissionsFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePermissionsFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionsFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermissionsFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionsFileErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePermissionsFileMutation, UpdatePermissionsFileMutationVariables>;
export const RenameFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renameFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenameFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenameFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}}]}}]} as unknown as DocumentNode<RenameFileMutation, RenameFileMutationVariables>;
export const DownloadFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"downloadFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DownloadFolderErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DownloadFolderMutation, DownloadFolderMutationVariables>;
export const FileInfoDrawerContentDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileInfoDrawerContentData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"folders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_org"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_users"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FolderInfoDrawerContent_users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folder_assignations_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FolderInfoDrawerContent_user"}}]}}]}}]} as unknown as DocumentNode<FileInfoDrawerContentDataQuery, FileInfoDrawerContentDataQueryVariables>;
export const DeleteFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFolderSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const GetFolderPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFolderPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdatePermissionsFolderForm_folder"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdatePermissionsFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"access"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFolderPermissionsQuery, GetFolderPermissionsQueryVariables>;
export const GetFolderPermissionsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFolderPermissionsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"folder"},"name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_permissions_orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_permissions_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_permissions_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFolderPermissionsOptionsQuery, GetFolderPermissionsOptionsQueryVariables>;
export const UpdatePermissionsFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePermissionsFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionsFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermissionsFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionFolderSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionsFolderErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePermissionsFolderMutation, UpdatePermissionsFolderMutationVariables>;
export const RenameFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renameFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenameFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenameFolderSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_id"}}]}}]}}]}}]} as unknown as DocumentNode<RenameFolderMutation, RenameFolderMutationVariables>;
export const DocsFilterSelected_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocsFilterSelected_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"labelIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocsFiltersSelected_users"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"labelIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocsFiltersSelected_labels"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocsFiltersSelected_users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocsFiltersSelected_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<DocsFilterSelected_DataQuery, DocsFilterSelected_DataQueryVariables>;
export const MoveFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"moveFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFilesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFilesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_ids"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFilesErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MoveFilesMutation, MoveFilesMutationVariables>;
export const MoveFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"moveFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFoldersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFoldersSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_ids"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoveFoldersErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MoveFoldersMutation, MoveFoldersMutationVariables>;
export const EnableFilesApprovalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"enableFilesApprovals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilesApprovalMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isApprovalMode"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFilesApprovalModeErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EnableFilesApprovalsMutation, EnableFilesApprovalsMutationVariables>;
export const DisableFilesApprovalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"disableFilesApprovals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilesApprovalMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isApprovalMode"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFilesApprovalModeErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileDoesNotExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CannotRemoveApprovalOnFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DisableFilesApprovalsMutation, DisableFilesApprovalsMutationVariables>;
export const GetFilesFoldersAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFilesFoldersAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersForm_folder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersForm_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFilesFoldersAssignationsQuery, GetFilesFoldersAssignationsQueryVariables>;
export const UpdateFilesFoldersAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFilesFoldersAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssignationsFilesFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsFilesFoldersSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_ids"}},{"kind":"Field","name":{"kind":"Name","value":"file_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFilesFoldersAssignationsMutation, UpdateFilesFoldersAssignationsMutationVariables>;
export const GetFilesFoldersLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFilesFoldersLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateLabelsFilesFolderForm_folder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateLabelsFilesFolderForm_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFilesFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFilesFolderForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFilesFoldersLabelsQuery, GetFilesFoldersLabelsQueryVariables>;
export const GetFileUsersRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileUsersRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RequestUsersApprovalsFilesForm_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RequestUsersApprovalsFilesForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFileUsersRequestsQuery, GetFileUsersRequestsQueryVariables>;
export const GetRequestApprovalsUserOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRequestApprovalsUserOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"files"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRequestApprovalsUserOptionsQuery, GetRequestApprovalsUserOptionsQueryVariables>;
export const RequestUsersApprovalsFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestUsersApprovalsFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestUsersApprovalsFilesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestUsersApprovalsFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestUsersApprovalsFilesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_ids"}}]}}]}}]}}]} as unknown as DocumentNode<RequestUsersApprovalsFilesMutation, RequestUsersApprovalsFilesMutationVariables>;
export const GetFileAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateAssignationsFileForm_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFileAssignationsQuery, GetFileAssignationsQueryVariables>;
export const GetFileAssignationsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileAssignationsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_org"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"files"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_user"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFileFormSelectInput_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<GetFileAssignationsOptionsQuery, GetFileAssignationsOptionsQueryVariables>;
export const UpdateAssignationsFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssignationsFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsFilesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssignationsFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsFilesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFilesMutation, UpdateAssignationsFilesMutationVariables>;
export const GetFolderAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFolderAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateAssignationsFolderForm_folder"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateAssignationsFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignee_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"duedate_automation_mode"}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFolderAssignationsQuery, GetFolderAssignationsQueryVariables>;
export const GetFolderAssignationsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFolderAssignationsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"folder"},"name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestions_assignations_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFolderAssignationsOptionsQuery, GetFolderAssignationsOptionsQueryVariables>;
export const UpdateAssignationsFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssignationsFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsFoldersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssignationsFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsFoldersSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsFoldersMutation, UpdateAssignationsFoldersMutationVariables>;
export const UpdateDueDateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDueDateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDueDateFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDueDateFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDueDateFileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDueDateFileMutation, UpdateDueDateFileMutationVariables>;
export const GetFileLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFileLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateLabelsFileForm_file"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFileForm_file"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<GetFileLabelsQuery, GetFileLabelsQueryVariables>;
export const UpdateLabelsFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLabelsFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLabelsFilesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLabelsFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLabelsFilesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLabelsFilesMutation, UpdateLabelsFilesMutationVariables>;
export const GetFolderLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFolderLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folder_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateLabelsFolderForm_folder"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateLabelsFolderForm_folder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"folders"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<GetFolderLabelsQuery, GetFolderLabelsQueryVariables>;
export const UpdateLabelsFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLabelsFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLabelsFoldersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLabelsFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLabelsFoldersSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLabelsFoldersMutation, UpdateLabelsFoldersMutationVariables>;
export const FolderViewersDetailsDrawerContent_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FolderViewersDetailsDrawerContent_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FolderViewersDetailsDrawerContent_DataQuery, FolderViewersDetailsDrawerContent_DataQueryVariables>;
export const InfosScreenActionsExtraButton_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InfosScreenActionsExtraButton_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_project_template"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InfosScreenActionsExtraButton_DataQuery, InfosScreenActionsExtraButton_DataQueryVariables>;
export const UpdateProjectTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isProjectTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isProjectTemplate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isProjectTemplate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectTemplateMutation, UpdateProjectTemplateMutationVariables>;
export const InviteParticipantsButton_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InviteParticipantsButton_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InviteParticipantsButton_DataQuery, InviteParticipantsButton_DataQueryVariables>;
export const MemberFilterSelected_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberFilterSelected_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MemberFilterSelected_orgs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MemberFilterSelected_teams"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MemberFilterSelected_orgs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MemberFilterSelected_teams"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<MemberFilterSelected_DataQuery, MemberFilterSelected_DataQueryVariables>;
export const GetMembersSelectOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMembersSelectOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembersFiltersFormSelectInput_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembersFiltersFormSelectInput_org"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembersFiltersFormSelectInput_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembersFiltersFormSelectInput_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<GetMembersSelectOptionsQuery, GetMembersSelectOptionsQueryVariables>;
export const ProjectMembersTabsCounter_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectMembersTabsCounter_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectMembersTabsCounter_DataQuery, ProjectMembersTabsCounter_DataQueryVariables>;
export const ProjectEditScreen_ProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectEditScreen_Project"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileForm_project"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileForm_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"banner"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}}]}}]}}]} as unknown as DocumentNode<ProjectEditScreen_ProjectQuery, ProjectEditScreen_ProjectQueryVariables>;
export const PrepareProjectAssetForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareProjectAssetForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectAssetForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareProjectAssetForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectAssetForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectAssetForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareProjectAssetForUploadMutation, PrepareProjectAssetForUploadMutationVariables>;
export const UpdateProjectProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectProfileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectProfileErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectProfileMutation, UpdateProjectProfileMutationVariables>;
export const ProjectMembersList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectMembersList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectMembersList_DataQuery, ProjectMembersList_DataQueryVariables>;
export const UpdateProjectRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectRoleSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>;
export const UpdateUserTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserTeamsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserTeamsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserTeamsMutation, UpdateUserTeamsMutationVariables>;
export const UpdateProjectUserInfosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectUserInfos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectUserInfosInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectUserInfos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectUserInfosSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectUserInfosErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectUserInfosMutation, UpdateProjectUserInfosMutationVariables>;
export const PrepareProjectUserAvatarForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareProjectUserAvatarForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectUserAvatarForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareProjectUserAvatarForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectUserAvatarForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProjectUserAvatarForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareProjectUserAvatarForUploadMutation, PrepareProjectUserAvatarForUploadMutationVariables>;
export const EditUserForm_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditUserForm_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"company_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditUserForm_DataQuery, EditUserForm_DataQueryVariables>;
export const ProjectProfileScreen_ProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectProfileScreen_Project"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectProfileScreen_project"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creator_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orgs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_validated_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"user","block":false},{"kind":"StringValue","value":"org","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end_date"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricsData_task"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creator_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orgs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_validated_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"user","block":false},{"kind":"StringValue","value":"org","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"approvals"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version_approval_request_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_approval_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_version_approval_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version_approval_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"due_date"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApprovalRequestItem_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_version_approval_request_users_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_approval_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_version_approval_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_version"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectProfileScreen_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"banner"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricsData_task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApprovalRequestItem_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_version_approval_request_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_approval_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectProfileScreen_ProjectQuery, ProjectProfileScreen_ProjectQueryVariables>;
export const ProjectTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"templates"},"name":{"kind":"Name","value":"org_project_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_project_template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTemplatesFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTemplatesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_project_template"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>;
export const ProjectOrgData_OrgProjectSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectOrgData_OrgProjectSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectOrgData_org_project_summary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectOrgData_org_project_summary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"is_archived"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"client_email"}},{"kind":"Field","name":{"kind":"Name","value":"client_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"price_estimate"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}}]}}]} as unknown as DocumentNode<ProjectOrgData_OrgProjectSummaryQuery, ProjectOrgData_OrgProjectSummaryQueryVariables>;
export const CreateOrgProjectSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrgProjectSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrgProjectSummaryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrgProjectSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrgProjectSummarySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrgProjectSummaryMutation, CreateOrgProjectSummaryMutationVariables>;
export const GetCreateOrgProjectSummaryCategoriesOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCreateOrgProjectSummaryCategoriesOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateOrgProjectSummaryForm_project_categories"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateOrgProjectSummaryForm_project_categories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetCreateOrgProjectSummaryCategoriesOptionsQuery, GetCreateOrgProjectSummaryCategoriesOptionsQueryVariables>;
export const GetOrgProjectSummaryIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrgProjectSummaryID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgProjectSummaryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgProjectSummaryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrgProjectSummaryIdQuery, GetOrgProjectSummaryIdQueryVariables>;
export const GetOrgProjectSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrgProjectSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgProjectSummaryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgProjectSummaryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_org_project_summary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_categories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_groups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_org_project_summary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_categories"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_groups"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"client_email"}},{"kind":"Field","name":{"kind":"Name","value":"client_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"price_estimate"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]} as unknown as DocumentNode<GetOrgProjectSummaryQuery, GetOrgProjectSummaryQueryVariables>;
export const GetUpdateOrgProjectSummaryCategoriesOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUpdateOrgProjectSummaryCategoriesOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_categories"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_categories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_categories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetUpdateOrgProjectSummaryCategoriesOptionsQuery, GetUpdateOrgProjectSummaryCategoriesOptionsQueryVariables>;
export const GetUpdateOrgProjectSummaryGroupsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUpdateOrgProjectSummaryGroupsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_groups"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateOrgProjectSummaryForm_project_groups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_groups"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_group_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<GetUpdateOrgProjectSummaryGroupsOptionsQuery, GetUpdateOrgProjectSummaryGroupsOptionsQueryVariables>;
export const UpdateOrgProjectSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrgProjectSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProjectSummaryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrgProjectSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProjectSummarySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrgProjectSummaryMutation, UpdateOrgProjectSummaryMutationVariables>;
export const GetProjectClientsFormOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectClientsFormOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"projectClients"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects_map_overview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"projectClients"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}}]}}]}}]} as unknown as DocumentNode<GetProjectClientsFormOptionsQuery, GetProjectClientsFormOptionsQueryVariables>;
export const UserProjectRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userProjectRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_demo"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProjectRoleQuery, UserProjectRoleQueryVariables>;
export const AddUserViewToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUserViewToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserViewToProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserViewToProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AddUserViewToProjectMutation, AddUserViewToProjectMutationVariables>;
export const ProjectLightDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectLightData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectLightDataQuery, ProjectLightDataQueryVariables>;
export const CopyTaskDialog_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CopyTaskDialog_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CopyTaskDialog_DataQuery, CopyTaskDialog_DataQueryVariables>;
export const CreateTaskForm_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateTaskForm_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateTaskForm_projectLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"creator_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateTaskForm_projectLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<CreateTaskForm_DataQuery, CreateTaskForm_DataQueryVariables>;
export const CreateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskMutation, CreateTaskMutationVariables>;
export const PrepareTaskAttachmentForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareTaskAttachmentForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareTaskAttachmentForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareTaskAttachmentForUploadMutation, PrepareTaskAttachmentForUploadMutationVariables>;
export const GetTaskDependenciesInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaskDependenciesInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTaskDependenciesInformationQuery, GetTaskDependenciesInformationQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamsQuery, GetTeamsQueryVariables>;
export const FileBadge_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileBadge_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_versions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileBadge_fileVersion"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileBadge_fileVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]} as unknown as DocumentNode<FileBadge_DataQuery, FileBadge_DataQueryVariables>;
export const PrepareTaskSpreadsheetForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareTaskSpreadsheetForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskSpreadsheetForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareTaskSpreadsheetForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskSpreadsheetForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskSpreadsheetForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareTaskSpreadsheetForUploadMutation, PrepareTaskSpreadsheetForUploadMutationVariables>;
export const TaskImportRequestExcelTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskImportRequestExcelTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskImportRequestExcelTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskImportRequestExcelTemplateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TaskImportRequestExcelTemplateMutation, TaskImportRequestExcelTemplateMutationVariables>;
export const ProjectTasksListTabsCounter_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectTasksListTabsCounter_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTasksListTabsCounter_DataQuery, ProjectTasksListTabsCounter_DataQueryVariables>;
export const SelectFileDialog_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectFileDialog_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"root_folder_id"}}]}}]}}]} as unknown as DocumentNode<SelectFileDialog_DataQuery, SelectFileDialog_DataQueryVariables>;
export const UpdateSubTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubtaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubtask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubtaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtask_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubTaskMutation, UpdateSubTaskMutationVariables>;
export const GetTaskAssignationsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaskAssignationsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<GetTaskAssignationsOptionsQuery, GetTaskAssignationsOptionsQueryVariables>;
export const UpdateAssignationsTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAssignationsTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationsTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssignationsTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssignationTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssignationsTaskMutation, UpdateAssignationsTaskMutationVariables>;
export const UpdateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const TaskEdit_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskEdit_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_data"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_members"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_projectLocation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_subtask"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_subtasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_subtask"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_members"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_projectLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<TaskEdit_DataQuery, TaskEdit_DataQueryVariables>;
export const UpdateArchiveTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateArchiveTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateArchiveTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateArchiveTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateArchiveTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateArchiveTaskMutation, UpdateArchiveTaskMutationVariables>;
export const DeleteSubtaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSubtask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSubtaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSubtask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSubtaskErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSubtaskMutation, DeleteSubtaskMutationVariables>;
export const CreateSubtaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSubtask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSubtaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubtask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSubtaskErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateSubtaskMutation, CreateSubtaskMutationVariables>;
export const UpdateSubtaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubtask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubtaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubtask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubtaskErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubtaskMutation, UpdateSubtaskMutationVariables>;
export const DeleteTaskAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTaskAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskAttachmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTaskAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskAttachmentErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTaskAttachmentMutation, DeleteTaskAttachmentMutationVariables>;
export const DeleteTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const PrepareTaskAttachmentAnnotationForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareTaskAttachmentAnnotationForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentAnnotationForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareTaskAttachmentAnnotationForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentAnnotationForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareTaskAttachmentAnnotationForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareTaskAttachmentAnnotationForUploadMutation, PrepareTaskAttachmentAnnotationForUploadMutationVariables>;
export const TaskView_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskView_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"task"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_validations"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_attachments"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_labels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_file_versions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_subtasks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_assignations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_OrgAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_TeamAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_UserAssignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_validations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_attachments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_to_project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_location"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_locations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_file_versions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_file_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_subtasks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_subtasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"last_validated_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_user_to_validate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskView_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_OrgAssignations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_TeamAssignations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskView_UserAssignations"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}}]} as unknown as DocumentNode<TaskView_DataQuery, TaskView_DataQueryVariables>;
export const AddUserViewToTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUserViewToTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUserViewToTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserViewToTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AddUserViewToTaskMutation, AddUserViewToTaskMutationVariables>;
export const UpdateValidationTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateValidationTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateValidationTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateValidationTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateValidationTaskMutation, UpdateValidationTaskMutationVariables>;
export const CreateChannelForTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChannelForTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelForTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChannelForTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelForTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateChannelForTaskErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateChannelForTaskMutation, CreateChannelForTaskMutationVariables>;
export const TaskDescription_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskDescription_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}}]} as unknown as DocumentNode<TaskDescription_DataQuery, TaskDescription_DataQueryVariables>;
export const DeleteTaskDependenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTaskDependencies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskDependenciesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTaskDependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskDependenciesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskDependenciesErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formErrors"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTaskDependenciesMutation, DeleteTaskDependenciesMutationVariables>;
export const SubtaskValidationHistory_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubtaskValidationHistory_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subtaskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SUBTASK_VALIDATION_TOGGLED","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subtaskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subtaskId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<SubtaskValidationHistory_DataQuery, SubtaskValidationHistory_DataQueryVariables>;
export const TaskViewersDetailsDrawerContent_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TaskViewersDetailsDrawerContent_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TaskViewersDetailsDrawerContent_DataQuery, TaskViewersDetailsDrawerContent_DataQueryVariables>;
export const TopbarQuery_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TopbarQuery_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TopbarQuery_DataQuery, TopbarQuery_DataQueryVariables>;
export const GetSelectOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSelectOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_user"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_org"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_label"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskFiltersFormSelectInput_label"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetSelectOptionsQuery, GetSelectOptionsQueryVariables>;
export const FilterUserDefaultMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"filterUserDefaultMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterUserDefaultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FilterUserDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterUserDefaultSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"defaultFilterId"}}]}}]}}]}}]} as unknown as DocumentNode<FilterUserDefaultMutationMutation, FilterUserDefaultMutationMutationVariables>;
export const GetUniqueLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUniqueLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"normalized_name"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<GetUniqueLabelsQuery, GetUniqueLabelsQueryVariables>;
export const DeleteFilterMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFilterMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFilterSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"filter_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFilterMutationMutation, DeleteFilterMutationMutationVariables>;
export const CreateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFilterSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"filter_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFilterMutation, CreateFilterMutationVariables>;
export const UpdateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFilterSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"filter_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFilterMutation, UpdateFilterMutationVariables>;
export const FiltersSelected_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FiltersSelected_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"labelsIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"labelsNormalizedName"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvedByUser"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvedByOrg"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvedByTeam"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_orgs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_teams"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_users"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"labelsIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_labels"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"projectLabel"},"name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"normalized_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"labelsNormalizedName"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_labels"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"approvedByUsers"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvedByUser"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_users"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"approvedByOrgs"},"name":{"kind":"Name","value":"orgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvedByOrg"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_orgs"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"approvedByTeams"},"name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvedByTeam"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FiltersSelected_teams"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_orgs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"orgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_teams"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FiltersSelected_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<FiltersSelected_DataQuery, FiltersSelected_DataQueryVariables>;
export const GetTaskPermissionsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTaskPermissionsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<GetTaskPermissionsOptionsQuery, GetTaskPermissionsOptionsQueryVariables>;
export const UpdatePermissionsTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePermissionsTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionsTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePermissionsTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePermissionTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePermissionsTaskMutation, UpdatePermissionsTaskMutationVariables>;
export const TasksReportDialog_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksReportDialog_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksReportDialog_project"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filters"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_teams"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_labels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksReportDialog_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksReportDialog_member"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_fullname"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksReportDialog_teams"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksReportDialog_labels"}}]}}]}}]} as unknown as DocumentNode<TasksReportDialog_DataQuery, TasksReportDialog_DataQueryVariables>;
export const RequestTasksReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestTasksReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestTasksReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestTasksReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestTasksReportSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<RequestTasksReportMutation, RequestTasksReportMutationVariables>;
export const TasksReportTasksList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksReportTasksList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tasksIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tasksIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TasksReportTasksList_DataQuery, TasksReportTasksList_DataQueryVariables>;
export const CreateReportBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReportBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportBlocksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReportBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportBlocksSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"report_block_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateReportBlocksMutation, CreateReportBlocksMutationVariables>;
export const UpdateReportBlockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReportBlock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReportBlocksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReportBlocksSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"report_block_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateReportBlockMutation, UpdateReportBlockMutationVariables>;
export const GetReportBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"e7c36ad5-53e5-4b9d-b1f2-3d0b06335d37","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"e7c36ad5-53e5-4b9d-b1f2-3d0b06335d37","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"e7c36ad5-53e5-4b9d-b1f2-3d0b06335d37","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report_blocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visibility_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibility_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility_project_id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility_org_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"block_content"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<GetReportBlocksQuery, GetReportBlocksQueryVariables>;
export const DeleteReportBlockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReportBlock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteReportBlockInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReportBlock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteReportBlockSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"reportBlockId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteReportBlockMutation, DeleteReportBlockMutationVariables>;
export const CheckTaskDeletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkTaskDeleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CheckTaskDeletedQuery, CheckTaskDeletedQueryVariables>;
export const ProjectTasksExportScreen_ProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectTasksExportScreen_Project"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksExportScreen_project"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksExportScreen_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_to_users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksExportScreen_project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"disabled","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksExportScreen_member"}}]}}]}}]} as unknown as DocumentNode<ProjectTasksExportScreen_ProjectQuery, ProjectTasksExportScreen_ProjectQueryVariables>;
export const TasksExport_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksExport_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filters"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TasksExport_DataQuery, TasksExport_DataQueryVariables>;
export const RequestTasksExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestTasksExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestTasksExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestTasksExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestTasksExportSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<RequestTasksExportMutation, RequestTasksExportMutationVariables>;
export const ProjectTasksGanttDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectTasksGantt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filters"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGanttTasks_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org_project_summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_orgProjectSummaryData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"task_dependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_assignations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGanttTasks_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start_date"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"task_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_assignations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_orgProjectSummaryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_project_summary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<ProjectTasksGanttQuery, ProjectTasksGanttQueryVariables>;
export const UpdateSubtaskDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubtaskDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubtaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubtask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubtaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtask_id"}},{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubtaskDatesMutation, UpdateSubtaskDatesMutationVariables>;
export const UpdateTaskDependenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaskDependencies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskDependenciesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaskDependencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskDependenciesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskDependenciesErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskAccessDenied"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InputValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formErrors"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaskDependenciesMutation, UpdateTaskDependenciesMutationVariables>;
export const ProjectTasksList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectTasksList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tasks_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_core_extended_offline"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_attachment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tasks_count_filtered"},"name":{"kind":"Name","value":"tasks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filters"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tasks_count"},"name":{"kind":"Name","value":"tasks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TasksList_assignations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskList_permissions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_dependencies"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_id"}},{"kind":"Field","name":{"kind":"Name","value":"from_side"}},{"kind":"Field","name":{"kind":"Name","value":"to_id"}},{"kind":"Field","name":{"kind":"Name","value":"to_side"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_validated_by"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"deleted_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks_progress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TasksList_assignations"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskList_permissions"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"predecessors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTasksGantt_dependencies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"project_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_core_extended_offline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskListItem_core"}},{"kind":"Field","name":{"kind":"Name","value":"hours_expected"}},{"kind":"Field","name":{"kind":"Name","value":"hours_done"}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskListItem_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]} as unknown as DocumentNode<ProjectTasksList_DataQuery, ProjectTasksList_DataQueryVariables>;
export const FilterUserDefaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterUserDefault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filter_user_default"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filter_id"}},{"kind":"Field","name":{"kind":"Name","value":"filter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode<FilterUserDefaultQuery, FilterUserDefaultQueryVariables>;
export const ActionsMenuDeleteTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActionsMenuDeleteTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTaskSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_id"}}]}}]}}]}}]} as unknown as DocumentNode<ActionsMenuDeleteTaskMutation, ActionsMenuDeleteTaskMutationVariables>;
export const UpdateLabelsTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLabelsTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLabelsTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLabelsTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLabelsTasksSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLabelsTasksMutation, UpdateLabelsTasksMutationVariables>;
export const GetFullTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"task_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"task_id"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskFull_data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_attachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_attachments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskForm_subtask"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"task_subtasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateTaskFull_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tasks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_version_id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_attachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpdateTaskForm_subtask"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFullTaskQuery, GetFullTaskQueryVariables>;
export const BulkDeleteTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteTasksSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}}]}}]}}]} as unknown as DocumentNode<BulkDeleteTasksMutation, BulkDeleteTasksMutationVariables>;
export const DeleteTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTasksSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTasksMutation, DeleteTasksMutationVariables>;
export const LabelsList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabelsList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabelsList_item"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelsList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"project_labels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<LabelsList_DataQuery, LabelsList_DataQueryVariables>;
export const UpdateProjectLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectLabelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectLabelSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectLabelMutation, UpdateProjectLabelMutationVariables>;
export const DeleteProjectLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProjectLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectLabelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProjectLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectLabelSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_label_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectLabelMutation, DeleteProjectLabelMutationVariables>;
export const ProjectTeamDrawer_TeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectTeamDrawer_team"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTeamDrawer_TeamQuery, ProjectTeamDrawer_TeamQueryVariables>;
export const TeamsList_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamsList_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamsList_item"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsList_item"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TeamsList_DataQuery, TeamsList_DataQueryVariables>;
export const CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTeamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTeamSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTeamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTeamSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const DeleteTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTeamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTeamSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const ProjectViewersDetailsDrawerContent_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectViewersDetailsDrawerContent_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectViewersDetailsDrawerContent_DataQuery, ProjectViewersDetailsDrawerContent_DataQueryVariables>;
export const ProjectInvitationFormInformation_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectInvitationFormInformation_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder_company_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectInvitationFormInformation_DataQuery, ProjectInvitationFormInformation_DataQueryVariables>;
export const GetProjectTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTeamsMultiSelect_team"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTeamsMultiSelect_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetProjectTeamsQuery, GetProjectTeamsQueryVariables>;
export const InputsGroup_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InputsGroup_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InputsGroup_DataQuery, InputsGroup_DataQueryVariables>;
export const ProjectInvitationDialogContent_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectInvitationDialogContent_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectInvitationDialogContent_DataQuery, ProjectInvitationDialogContent_DataQueryVariables>;
export const ProjectInvitationRequestExcelTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"projectInvitationRequestExcelTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProjectInvitationRequestExcelTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectInvitationRequestExcelTemplateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectInvitationRequestExcelTemplateMutation, ProjectInvitationRequestExcelTemplateMutationVariables>;
export const SendUserEmailInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendUserEmailInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendUserEmailInvitationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendUserEmailInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendUserEmailInvitationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails_sent"}}]}}]}}]}}]} as unknown as DocumentNode<SendUserEmailInvitationMutation, SendUserEmailInvitationMutationVariables>;
export const UpdateUsersCompanyNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUsersCompanyName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsersCompanyNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsersCompanyName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsersCompanyNameSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUsersCompanyNameMutation, UpdateUsersCompanyNameMutationVariables>;
export const GetProjectMembersOrgNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectMembersOrgName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active_org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectMembersOrgNameQuery, GetProjectMembersOrgNameQueryVariables>;
export const UpdateProjectMembersRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectMembersRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectMembersRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectMembersRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectMembersRoleSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectMembersRoleMutation, UpdateProjectMembersRoleMutationVariables>;
export const GetMembersProjectTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMembersProjectTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetMembersProjectTeamsQuery, GetMembersProjectTeamsQueryVariables>;
export const UpdateUsersTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUsersTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsersTeamsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsersTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsersTeamsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_ids"}},{"kind":"Field","name":{"kind":"Name","value":"user_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUsersTeamsMutation, UpdateUsersTeamsMutationVariables>;
export const UpdateTasksAssignationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTasksAssignations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksAssignationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTasksAssignations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksAssignationsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTasksAssignationsMutation, UpdateTasksAssignationsMutationVariables>;
export const UpdateTasksDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTasksDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksDatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTasksDates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTasksDatesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTasksDatesMutation, UpdateTasksDatesMutationVariables>;
export const UpdateValidationsTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateValidationsTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateValidationsTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateValidationsTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateValidationsTasksSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task_ids"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateValidationsTasksMutation, UpdateValidationsTasksMutationVariables>;
export const GetTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export const GetTeamMembersOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTeamMembersOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamMembersOptionsQuery, GetTeamMembersOptionsQueryVariables>;
export const UpdateUsersInTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUsersInTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsersInTeamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsersInTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUsersInTeamSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUsersInTeamMutation, UpdateUsersInTeamMutationVariables>;
export const NotProjectMemberScreen_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotProjectMemberScreen_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_map_overview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<NotProjectMemberScreen_DataQuery, NotProjectMemberScreen_DataQueryVariables>;
export const JoinOrgUserProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"joinOrgUserProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JoinOrgUserProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinOrgUserProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JoinOrgUserProjectErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JoinOrgUserProjectMutation, JoinOrgUserProjectMutationVariables>;
export const ProjectAccessDeniedScreen_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectAccessDeniedScreen_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"project"},"name":{"kind":"Name","value":"projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectAccessDeniedScreen_DataQuery, ProjectAccessDeniedScreen_DataQueryVariables>;
export const UserNotificationsScreen_NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserNotificationsScreen_Notifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNotification_notification"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNotification_badgeNotification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_strong"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNotification_notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNotification_badgeNotification"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_id"}},{"kind":"Field","name":{"kind":"Name","value":"read_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<UserNotificationsScreen_NotificationsQuery, UserNotificationsScreen_NotificationsQueryVariables>;
export const AvatarFromUserId_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvatarFromUserId_user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<AvatarFromUserId_UserQuery, AvatarFromUserId_UserQueryVariables>;
export const UserProfileScreen_UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProfileScreen_user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileForm_user"}},{"kind":"Field","name":{"kind":"Name","value":"email_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailNotifications_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"push_notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PushNotifications_data"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileForm_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"metadatas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailNotifications_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unread_notification_report"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_report"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PushNotifications_data"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"push_notifications"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat_channel"}},{"kind":"Field","name":{"kind":"Name","value":"chat_direct_message"}}]}}]} as unknown as DocumentNode<UserProfileScreen_UserQuery, UserProfileScreen_UserQueryVariables>;
export const UpdatePushNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePushNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePushNotificationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePushNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePushNotificationsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePushNotificationsMutation, UpdatePushNotificationsMutationVariables>;
export const UpdateEmailNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEmailNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEmailNotificationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmailNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEmailNotificationsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_notifications_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEmailNotificationsMutation, UpdateEmailNotificationsMutationVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserProfileSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const PrepareUserAvatarForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"prepareUserAvatarForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareUserAvatarForUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareUserAvatarForUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareUserAvatarForUploadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareUserAvatarForUploadErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrepareUserAvatarForUploadMutation, PrepareUserAvatarForUploadMutationVariables>;
export const UpdateOrgProjectSummaryArchiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrgProjectSummaryArchive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProjectSummaryArchiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrgProjectSummaryArchive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgProjectSummaryArchiveSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrgProjectSummaryArchiveMutation, UpdateOrgProjectSummaryArchiveMutationVariables>;
export const DeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProjectErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const RequestProjectExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestProjectExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestProjectExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestProjectExportSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestProjectExportErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequestProjectExportMutation, RequestProjectExportMutationVariables>;
export const CreateFolderTreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFolderTree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFolderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFolderSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folder_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFolderTreeMutation, CreateFolderTreeMutationVariables>;
export const DeleteFirebaseTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFirebaseToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFirebaseTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFirebaseToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<DeleteFirebaseTokenMutation, DeleteFirebaseTokenMutationVariables>;
export const UseRedirectAfterLogin_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useRedirectAfterLogin_data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auth0_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auth0_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auth0_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active_org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UseRedirectAfterLogin_DataQuery, UseRedirectAfterLogin_DataQueryVariables>;
import type { IntrospectionQuery } from 'graphql';
export default {
  "__schema": {
    "queryType": {
      "name": "query_root"
    },
    "mutationType": {
      "name": "mutation_root"
    },
    "subscriptionType": {
      "name": "subscription_root"
    },
    "types": [
      {
        "kind": "UNION",
        "name": "AbortMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AbortMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AbortMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AbortMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AbortMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AbortMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AbortMultipartUploadSuccess",
        "fields": [
          {
            "name": "isAborted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AbortTaskAttachmentMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AbortTaskAttachmentMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AbortTaskAttachmentMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AbortTaskAttachmentMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AbortTaskAttachmentMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AbortTaskAttachmentMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AbortTaskAttachmentMultipartUploadSuccess",
        "fields": [
          {
            "name": "isAborted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddFileApprovalsFileVersionsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileApprovalNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddFileApprovalsFileVersionsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddFileApprovalsFileVersionsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddFileApprovalsFileVersionsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddFileApprovalsFileVersionsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddFileApprovalsFileVersionsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddFileApprovalsFileVersionsSuccess",
        "fields": [
          {
            "name": "saved",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddMembersToProjectChannelError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ChannelDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotMemberOfThisChannel"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotModeratorOfThisChannel"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddMembersToProjectChannelErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddMembersToProjectChannelError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddMembersToProjectChannelResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddMembersToProjectChannelErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddMembersToProjectChannelSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddMembersToProjectChannelSuccess",
        "fields": [
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddMultiUserApprovalToFileVersionSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FileMultipleApprovalIds",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserApprovalToFileVersionError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DuplicateApprovalOnFileVersion"
          },
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "FileNotInApprovalMode"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "UserCommentIsNecessaryToFile"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotAssignedToFile"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserApprovalToFileVersionErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddUserApprovalToFileVersionError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserApprovalToFileVersionResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddUserApprovalToFileVersionErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddUserApprovalToFileVersionSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserApprovalToFileVersionSuccess",
        "fields": [
          {
            "name": "file_approval_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserInTeamError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserAlreadyPartOfThisTeam"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserInTeamErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddUserInTeamError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserInTeamResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddUserInTeamErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddUserInTeamSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserInTeamSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserMultiApprovalToFilesVersionError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DuplicateApprovalOnFileVersion"
          },
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "FileNotInApprovalMode"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotAssignedToFile"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserMultiApprovalToFilesVersionErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddUserMultiApprovalToFilesVersionError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserMultiApprovalToFilesVersionResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddMultiUserApprovalToFileVersionSuccess"
          },
          {
            "kind": "OBJECT",
            "name": "AddUserMultiApprovalToFilesVersionErrors"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToFileVersionError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToFileVersionErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddUserViewToFileVersionError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToFileVersionResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddUserViewToFileVersionErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddUserViewToFileVersionSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToFileVersionSuccess",
        "fields": [
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToFolderError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToFolderErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddUserViewToFolderError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToFolderResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddUserViewToFolderErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddUserViewToFolderSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToFolderSuccess",
        "fields": [
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToProjectError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToProjectErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddUserViewToProjectError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToProjectResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddUserViewToProjectErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddUserViewToProjectSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToProjectSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AddUserViewToTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AddUserViewToTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddUserViewToTaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AddUserViewToTaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddUserViewToTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AnnotateFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileFormatNotSupported"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AnnotateFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AnnotateFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AnnotateFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AnnotateFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "AnnotateFileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AnnotateFileSuccess",
        "fields": [
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "BulkDeleteTasksError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BulkDeleteTasksErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "BulkDeleteTasksError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "BulkDeleteTasksResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "BulkDeleteTasksErrors"
          },
          {
            "kind": "OBJECT",
            "name": "BulkDeleteTasksSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BulkDeleteTasksSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotConvertToTemplateOrgProject",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotCreateOrgProjectSummaryOnOrgProject",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotDeleteOrgProject",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotDeleteProjectSharedWithMultipleOrgs",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotInviteOnProject",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotModifyEmailOfActiveUser",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotModifyUserWithGreaterProjectRoleThanYours",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotRemoveApprovalOnFile",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotSetGreaterProjectRoleThanYours",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CannotUpdateProjectRole",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CapawesomeChannel",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CapgoChannel",
        "fields": [
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ChannelDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CompleteMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CompleteMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CompleteMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CompleteMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CompleteMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CompleteMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CompleteMultipartUploadSuccess",
        "fields": [
          {
            "name": "location",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CompleteTaskAttachmentMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CompleteTaskAttachmentMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CompleteTaskAttachmentMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CompleteTaskAttachmentMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CompleteTaskAttachmentMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CompleteTaskAttachmentMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CompleteTaskAttachmentMultipartUploadSuccess",
        "fields": [
          {
            "name": "location",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ConvertFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "FileFormatNotSupported"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConvertFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ConvertFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ConvertFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ConvertFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ConvertFileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConvertFileSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CopyFromTemporaryBucketFailed",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CopyProjectError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CopyProjectErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CopyProjectError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CopyProjectResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyProjectErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CopyProjectSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CopyProjectSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "steps",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "optionsSuccess",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CopyTaskAttachmentsUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CopyTaskAttachmentsUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CopyTaskAttachmentsUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CopyTaskAttachmentsUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyTaskAttachmentsUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "copyTaskAttachmentsUploadSuccess"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateChannelForApprovalError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileApprovalNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateChannelForApprovalErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateChannelForApprovalError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateChannelForApprovalResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateChannelForApprovalErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateChannelForApprovalSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateChannelForApprovalSuccess",
        "fields": [
          {
            "name": "approval_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateChannelForProjectError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateChannelForProjectErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateChannelForProjectError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateChannelForProjectResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateChannelForProjectErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateChannelForProjectSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateChannelForProjectSuccess",
        "fields": [
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateChannelForTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateChannelForTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateChannelForTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateChannelForTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateChannelForTaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateChannelForTaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateChannelForTaskSuccess",
        "fields": [
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateEmptyFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileFormatNotSupported"
          },
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateEmptyFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateEmptyFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateEmptyFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateEmptyFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateEmptyFileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateEmptyFileSuccess",
        "fields": [
          {
            "name": "fileId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "fileVersionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateFilterError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FilterMultipleVisibility"
          },
          {
            "kind": "OBJECT",
            "name": "FilterNeedToBeVisible"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateFilterErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateFilterError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateFilterResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateFilterErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateFilterSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateFilterSuccess",
        "fields": [
          {
            "name": "filter_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateFolderError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateFolderErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateFolderError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateFolderResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateFolderErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateFolderSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateFolderSuccess",
        "fields": [
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateMultipartUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateOrgError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateOrgFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateOrgErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateOrgError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateOrgFailed",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateOrgProjectSummaryError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotCreateOrgProjectSummaryOnOrgProject"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "OrgProjectSummaryAlreadyExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateOrgProjectSummaryErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateOrgProjectSummaryError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateOrgProjectSummaryResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateOrgProjectSummaryErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateOrgProjectSummarySuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateOrgProjectSummarySuccess",
        "fields": [
          {
            "name": "org_project_summary_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateOrgResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateOrgErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateOrgSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateOrgSuccess",
        "fields": [
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectCategoryError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryAccessDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectCategoryErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateProjectCategoryError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectCategoryResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateProjectCategoryErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateProjectCategorySuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectCategorySuccess",
        "fields": [
          {
            "name": "project_category_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectDirectMessageError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectDirectMessageErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateProjectDirectMessageError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectDirectMessageResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateProjectDirectMessageErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateProjectDirectMessageSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectDirectMessageSuccess",
        "fields": [
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgRequired"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateProjectError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectGroupError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectGroupAccessDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectGroupErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateProjectGroupError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectGroupResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateProjectGroupErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateProjectGroupSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectGroupSuccess",
        "fields": [
          {
            "name": "project_group_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectLabelError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectLabelAccessDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectLabelErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateProjectLabelError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectLabelResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateProjectLabelErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateProjectLabelSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectLabelSuccess",
        "fields": [
          {
            "name": "project_label_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateProjectResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateProjectErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateProjectSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProjectSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateReportBlocksError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ReportBlockMultipleVisibility"
          },
          {
            "kind": "OBJECT",
            "name": "ReportBlockNeedToBeVisible"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateReportBlocksErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateReportBlocksError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateReportBlocksResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateReportBlocksErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateReportBlocksSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateReportBlocksSuccess",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "report_block_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateSubtaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateSubtaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateSubtaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateSubtaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateSubtaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateSubtaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateSubtaskSuccess",
        "fields": [
          {
            "name": "subtask_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateTaskAttachmentMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateTaskAttachmentMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateTaskAttachmentMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateTaskAttachmentMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateTaskAttachmentMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateTaskAttachmentMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateTaskAttachmentMultipartUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAssignationsNotAllowed"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateTaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateTaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateTeamError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamNameAlreadyExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateTeamErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateTeamError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "CreateTeamResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreateTeamErrors"
          },
          {
            "kind": "OBJECT",
            "name": "CreateTeamSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateTeamSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteFileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFileSuccess",
        "fields": [
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFilterError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FilterDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFilterErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteFilterError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFilterResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteFilterErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteFilterSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFilterSuccess",
        "fields": [
          {
            "name": "filter_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFirebaseTokenError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFirebaseTokenErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteFirebaseTokenError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFirebaseTokenResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteFirebaseTokenErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteFirebaseTokenSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFirebaseTokenSuccess",
        "fields": [
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFolderError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFolderErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteFolderError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteFolderResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteFolderErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteFolderSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFolderSuccess",
        "fields": [
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectCategoryError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectCategoryErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteProjectCategoryError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectCategoryResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteProjectCategoryErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteProjectCategorySuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectCategorySuccess",
        "fields": [
          {
            "name": "project_category_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotDeleteOrgProject"
          },
          {
            "kind": "OBJECT",
            "name": "CannotDeleteProjectSharedWithMultipleOrgs"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteProjectError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectGroupError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectGroupAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectGroupDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectGroupErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteProjectGroupError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectGroupResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteProjectGroupErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteProjectGroupSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectGroupSuccess",
        "fields": [
          {
            "name": "project_group_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectLabelError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectLabelAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectLabelDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectLabelErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteProjectLabelError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectLabelResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteProjectLabelErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteProjectLabelSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectLabelSuccess",
        "fields": [
          {
            "name": "project_label_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteProjectResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteProjectErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteProjectSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProjectSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteReportBlockError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ReportBlockDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteReportBlockErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteReportBlockError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteReportBlockResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteReportBlockErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteReportBlockSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteReportBlockSuccess",
        "fields": [
          {
            "name": "reportBlockId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteSubtaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "SubtaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "SubtaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteSubtaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteSubtaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteSubtaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteSubtaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteSubtaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteSubtaskSuccess",
        "fields": [
          {
            "name": "subtask_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTaskAttachmentError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAttachmentAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAttachmentDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTaskAttachmentErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteTaskAttachmentError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTaskAttachmentResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteTaskAttachmentErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteTaskAttachmentSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTaskAttachmentSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTaskDependenciesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTaskDependenciesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteTaskDependenciesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTaskDependenciesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteTaskDependenciesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteTaskDependenciesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTaskDependenciesSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteTaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteTaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTasksError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTasksErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteTasksError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTasksResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteTasksErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteTasksSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTasksSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTeamError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTeamErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DeleteTeamError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DeleteTeamResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DeleteTeamErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteTeamSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTeamSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DownloadFolderError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DownloadFolderErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DownloadFolderError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DownloadFolderResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DownloadFolderErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DownloadFolderSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DownloadFolderSuccess",
        "fields": [
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateApprovalOnFileVersion",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DuplicateFilesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateFilesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "DuplicateFilesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DuplicateFilesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DuplicateFilesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicateFilesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateFilesSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "EmailAlreadyUsedByAnotherUser",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ErrorReportType",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "org_name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_already_org_project_member",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user_already_project_member",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileApprovalNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileDoesNotExists",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileFormatNotSupported",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileMultipleApprovalIds",
        "fields": [
          {
            "name": "file_approval_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileNotInApprovalMode",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileTooLarge",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FileVersionDoesNotExists",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FilterCannotBeUpdate",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FilterDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FilterMultipleVisibility",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FilterNeedToBeVisible",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FilterUserDefaultError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FilterDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FilterUserDefaultErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FilterUserDefaultError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FilterUserDefaultResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FilterUserDefaultErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FilterUserDefaultSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FilterUserDefaultSuccess",
        "fields": [
          {
            "name": "defaultFilterId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedChannelAssetError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedChannelAssetErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedChannelAssetError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedChannelAssetResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedChannelAssetErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedChannelAssetSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedChannelAssetSuccess",
        "fields": [
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "public_url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileApprovalsAttachmentError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotRemoveApprovalOnFile"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicateApprovalOnFileVersion"
          },
          {
            "kind": "OBJECT",
            "name": "FileApprovalNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "FileNotInApprovalMode"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          },
          {
            "kind": "OBJECT",
            "name": "NotFoundFilesInApprovalMode"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotAssignedToFile"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileApprovalsAttachmentErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedFileApprovalsAttachmentError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileApprovalsAttachmentResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileApprovalsAttachmentErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileApprovalsAttachmentSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileApprovalsAttachmentSuccess",
        "fields": [
          {
            "name": "file_approval_attachment_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileSuccess"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileStructureError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileTooLarge"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileStructureErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedFileStructureError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileStructureResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileStructureErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileStructureSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileStructureSuccess",
        "fields": [
          {
            "name": "parent_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileSuccess",
        "fields": [
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileVersionError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileVersionErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedFileVersionError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedFileVersionResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileVersionErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedFileVersionSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedFileVersionSuccess",
        "fields": [
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedOrgAvatarError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedOrgAvatarErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedOrgAvatarError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedOrgAvatarResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedOrgAvatarErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedOrgAvatarSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedOrgAvatarSuccess",
        "fields": [
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedOrgBackgroundError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedOrgBackgroundErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedOrgBackgroundError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedOrgBackgroundResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedOrgBackgroundErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedOrgBackgroundSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedOrgBackgroundSuccess",
        "fields": [
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectAvatarError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectAvatarErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedProjectAvatarError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectAvatarResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectAvatarErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectAvatarSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectAvatarSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectBackgroundError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectBackgroundErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedProjectBackgroundError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectBackgroundResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectBackgroundErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectBackgroundSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectBackgroundSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectBannerError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectBannerErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedProjectBannerError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectBannerResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectBannerErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectBannerSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectBannerSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectGroupAvatarError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectGroupAvatarErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedProjectGroupAvatarError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectGroupAvatarResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectGroupAvatarErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectGroupAvatarSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectGroupAvatarSuccess",
        "fields": [
          {
            "name": "project_group_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectSpreadsheetError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileTooLarge"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidContentType"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectSpreadsheetErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedProjectSpreadsheetError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedProjectSpreadsheetResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectSpreadsheetErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedProjectSpreadsheetSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedProjectSpreadsheetSuccess",
        "fields": [
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedTaskAttachmentAnnotationError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAttachmentDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedTaskAttachmentAnnotationErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedTaskAttachmentAnnotationError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedTaskAttachmentAnnotationResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedTaskAttachmentAnnotationErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedTaskAttachmentAnnotationSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedTaskAttachmentAnnotationSuccess",
        "fields": [
          {
            "name": "task_attachment_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedTaskAttachmentError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedTaskAttachmentErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedTaskAttachmentError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedTaskAttachmentResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedTaskAttachmentErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedTaskAttachmentSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedTaskAttachmentSuccess",
        "fields": [
          {
            "name": "task_attachment_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedTaskSpreadsheetError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileTooLarge"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidContentType"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "NotAuthorOfTheUpload"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedTaskSpreadsheetErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedTaskSpreadsheetError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedTaskSpreadsheetResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedTaskSpreadsheetErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedTaskSpreadsheetSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedTaskSpreadsheetSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedUserAvatarError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CopyFromTemporaryBucketFailed"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "KeyDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "MissingMetadata"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedUserAvatarErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "FinalizeUploadedUserAvatarError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FinalizeUploadedUserAvatarResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedUserAvatarErrors"
          },
          {
            "kind": "OBJECT",
            "name": "FinalizeUploadedUserAvatarSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FinalizeUploadedUserAvatarSuccess",
        "fields": [
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FolderAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FolderCannotBeMoveInAnotherProject",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FolderDoesNotExists",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "GenerateApiTokenError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "GenerateApiTokenPermissionDenied"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateApiTokenErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "GenerateApiTokenError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GenerateApiTokenPermissionDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "GenerateApiTokenResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "GenerateApiTokenErrors"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateApiTokenSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateApiTokenSuccess",
        "fields": [
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GetAlgoliaUserApiKeySuccess",
        "fields": [
          {
            "name": "exp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GetOrgProejectTemplate",
        "fields": [
          {
            "name": "templates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "OrgProjectTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GetStreamChatUserTokenSuccess",
        "fields": [
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InputValidationError",
        "fields": [
          {
            "name": "fieldErrors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "formErrors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InvalidContentType",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "JoinOrgUserProjectError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotInviteOnProject"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "JoinOrgUserProjectPermissionDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "JoinOrgUserProjectErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "JoinOrgUserProjectError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "JoinOrgUserProjectPermissionDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "JoinOrgUserProjectResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "JoinOrgUserProjectErrors"
          },
          {
            "kind": "OBJECT",
            "name": "JoinOrgUserProjectSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "JoinOrgUserProjectSuccess",
        "fields": [
          {
            "name": "projectId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "KeyDoesNotExists",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ListMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ListMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ListMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ListMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ListMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ListMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ListMultipartUploadSuccess",
        "fields": [
          {
            "name": "parts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "awsS3Part",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ListTaskAttachmentMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ListTaskAttachmentMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ListTaskAttachmentMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ListTaskAttachmentMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ListTaskAttachmentMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ListTaskAttachmentMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ListTaskAttachmentMultipartUploadSuccess",
        "fields": [
          {
            "name": "parts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "awsS3PartTaskAttachment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "MigrateAvatarPublicUrlError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MigrateAvatarPublicUrlFailed"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MigrateAvatarPublicUrlErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "MigrateAvatarPublicUrlError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MigrateAvatarPublicUrlFailed",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "MigrateAvatarPublicUrlResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MigrateAvatarPublicUrlErrors"
          },
          {
            "kind": "OBJECT",
            "name": "MigrateAvatarPublicUrlSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MigrateAvatarPublicUrlSuccess",
        "fields": [
          {
            "name": "ok",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MissingMetadata",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "MoveFilesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "PermissionsConflictError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MoveFilesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "MoveFilesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "MoveFilesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MoveFilesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "MoveFilesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MoveFilesSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "MoveFoldersError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderCannotBeMoveInAnotherProject"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "PermissionsConflictError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MoveFoldersErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "MoveFoldersError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "MoveFoldersResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MoveFoldersErrors"
          },
          {
            "kind": "OBJECT",
            "name": "MoveFoldersSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MoveFoldersSuccess",
        "fields": [
          {
            "name": "folder_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NotAuthorOfTheUpload",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NotFoundFiles",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NotFoundFilesInApprovalMode",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NotMemberOfThisChannel",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NotificationDoesNotExists",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrgAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrgDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrgOrProjectUserDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrgProjectSummaryAlreadyExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrgProjectSummaryDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrgProjectTemplate",
        "fields": [
          {
            "name": "avatar",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OrgRequired",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PermissionsConflictError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareChannelAssetForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ChannelDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotMemberOfThisChannel"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareChannelAssetForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareChannelAssetForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareChannelAssetForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareChannelAssetForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareChannelAssetForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareChannelAssetForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileApprovalsAttachmentForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileApprovalNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileApprovalsAttachmentForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareFileApprovalsAttachmentForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileApprovalsAttachmentForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareFileApprovalsAttachmentForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareFileApprovalsAttachmentForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileApprovalsAttachmentForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileForAutodeskViewerError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileForAutodeskViewerErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareFileForAutodeskViewerError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileForAutodeskViewerResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareFileForAutodeskViewerErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareFileForAutodeskViewerSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileForAutodeskViewerSuccess",
        "fields": [
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareFileForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareFileForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareFileForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileStructureForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileStructureForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareFileStructureForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileStructureForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareFileStructureForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareFileStructureForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileStructureForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileVersionAnnotationForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileVersionAnnotationForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareFileVersionAnnotationForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileVersionAnnotationForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareFileVersionAnnotationForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareFileVersionAnnotationForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileVersionAnnotationForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileVersionForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileVersionForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareFileVersionForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareFileVersionForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareFileVersionForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareFileVersionForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareFileVersionForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareMultipartUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "presignedUrls",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareOrgAssetForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareOrgAssetForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareOrgAssetForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareOrgAssetForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareOrgAssetForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareOrgAssetForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareOrgAssetForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectAssetForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectAssetForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareProjectAssetForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectAssetForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareProjectAssetForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareProjectAssetForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectAssetForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectGroupAssetForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectGroupDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectGroupAssetForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareProjectGroupAssetForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectGroupAssetForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareProjectGroupAssetForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareProjectGroupAssetForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectGroupAssetForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectSpreadsheetForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectSpreadsheetForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareProjectSpreadsheetForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectSpreadsheetForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareProjectSpreadsheetForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareProjectSpreadsheetForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectSpreadsheetForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectUserAvatarForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectUserInfosPermissionDenied"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectUserAvatarForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareProjectUserAvatarForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareProjectUserAvatarForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareProjectUserAvatarForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareProjectUserAvatarForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareProjectUserAvatarForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskAttachmentAnnotationForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAttachmentDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskAttachmentAnnotationForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareTaskAttachmentAnnotationForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskAttachmentAnnotationForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareTaskAttachmentAnnotationForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareTaskAttachmentAnnotationForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskAttachmentAnnotationForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskAttachmentForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskAttachmentForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareTaskAttachmentForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskAttachmentForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareTaskAttachmentForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareTaskAttachmentForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskAttachmentForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskAttachmentMultipartUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskAttachmentMultipartUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareTaskAttachmentMultipartUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskAttachmentMultipartUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareTaskAttachmentMultipartUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareTaskAttachmentMultipartUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskAttachmentMultipartUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "presignedUrls",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskSpreadsheetForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskSpreadsheetForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareTaskSpreadsheetForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareTaskSpreadsheetForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareTaskSpreadsheetForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareTaskSpreadsheetForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareTaskSpreadsheetForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareUserAvatarForUploadError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareUserAvatarForUploadErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "PrepareUserAvatarForUploadError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PrepareUserAvatarForUploadResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PrepareUserAvatarForUploadErrors"
          },
          {
            "kind": "OBJECT",
            "name": "PrepareUserAvatarForUploadSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PrepareUserAvatarForUploadSuccess",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectCategoryAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectCategoryDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectGroupAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectGroupDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ProjectImportRequestExcelTemplateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ProjectRequestCarboneImportExcelTemplateVoid"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProjectImportRequestExcelTemplateErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ProjectImportRequestExcelTemplateError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ProjectImportRequestExcelTemplateResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ProjectImportRequestExcelTemplateErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectImportRequestExcelTemplateSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProjectImportRequestExcelTemplateSuccess",
        "fields": [
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ProjectInvitationRequestExcelTemplateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ProjectRequestCarboneInvitationExcelTemplateVoid"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProjectInvitationRequestExcelTemplateErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ProjectInvitationRequestExcelTemplateError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ProjectInvitationRequestExcelTemplateResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ProjectInvitationRequestExcelTemplateErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectInvitationRequestExcelTemplateSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProjectInvitationRequestExcelTemplateSuccess",
        "fields": [
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ProjectInvitationsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotUpdateProjectRole"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProjectInvitationsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ProjectInvitationsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ProjectInvitationsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ProjectInvitationsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectInvitationsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProjectInvitationsSuccess",
        "fields": [
          {
            "name": "errorReport",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ErrorReportType",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "ok",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "successReport",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SuccessReportType",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectLabelAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectLabelDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectNeedsAtLeastOneOwner",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectRequestCarboneImportExcelTemplateVoid",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProjectRequestCarboneInvitationExcelTemplateVoid",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ReadNotificationsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotificationDoesNotExists"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ReadNotificationsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ReadNotificationsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ReadNotificationsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ReadNotificationsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ReadNotificationsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ReadNotificationsSuccess",
        "fields": [
          {
            "name": "notification_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RemoveMembersFromProjectChannelError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ChannelDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotMemberOfThisChannel"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotModeratorOfThisChannel"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RemoveMembersFromProjectChannelErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RemoveMembersFromProjectChannelError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RemoveMembersFromProjectChannelResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RemoveMembersFromProjectChannelErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RemoveMembersFromProjectChannelSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RemoveMembersFromProjectChannelSuccess",
        "fields": [
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RemoveUserInTeamError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotPartOfThisTeam"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RemoveUserInTeamErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RemoveUserInTeamError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RemoveUserInTeamResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RemoveUserInTeamErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RemoveUserInTeamSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RemoveUserInTeamSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RenameChannelForProjectError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ChannelDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotMemberOfThisChannel"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotModeratorOfThisChannel"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RenameChannelForProjectErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RenameChannelForProjectError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RenameChannelForProjectResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RenameChannelForProjectErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RenameChannelForProjectSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RenameChannelForProjectSuccess",
        "fields": [
          {
            "name": "channel_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RenameFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RenameFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RenameFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RenameFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RenameFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RenameFileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RenameFileSuccess",
        "fields": [
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RenameFolderError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RenameFolderErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RenameFolderError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RenameFolderResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RenameFolderErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RenameFolderSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RenameFolderSuccess",
        "fields": [
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReportBlockCannotBeUpdate",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReportBlockDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReportBlockMultipleVisibility",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReportBlockNeedToBeVisible",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestApprovalExportError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotFoundFilesInApprovalMode"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestApprovalExportErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RequestApprovalExportError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestApprovalExportResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestApprovalExportErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RequestApprovalExportSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestApprovalExportSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestApprovalReportError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotFoundFilesInApprovalMode"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestApprovalReportErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RequestApprovalReportError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestApprovalReportResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestApprovalReportErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RequestApprovalReportSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestApprovalReportSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestFilesTreeReportError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotFoundFiles"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestFilesTreeReportErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RequestFilesTreeReportError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestFilesTreeReportResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestFilesTreeReportErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RequestFilesTreeReportSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestFilesTreeReportSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestProjectExportError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestProjectExportErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RequestProjectExportError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestProjectExportResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestProjectExportErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RequestProjectExportSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestProjectExportSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestTasksExportError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestTasksExportErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RequestTasksExportError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestTasksExportResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestTasksExportErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RequestTasksExportSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestTasksExportSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestTasksReportError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestTasksReportErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RequestTasksReportError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestTasksReportResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestTasksReportErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RequestTasksReportSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestTasksReportSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestUsersApprovalsFilesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestUsersApprovalsFilesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RequestUsersApprovalsFilesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestUsersApprovalsFilesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestUsersApprovalsFilesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RequestUsersApprovalsFilesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestUsersApprovalsFilesSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RestoreFileVersionError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RestoreFileVersionErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "RestoreFileVersionError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RestoreFileVersionResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RestoreFileVersionErrors"
          },
          {
            "kind": "OBJECT",
            "name": "RestoreFileVersionSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RestoreFileVersionSuccess",
        "fields": [
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SaveFirebaseTokenError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SaveFirebaseTokenErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "SaveFirebaseTokenError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SaveFirebaseTokenResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "SaveFirebaseTokenErrors"
          },
          {
            "kind": "OBJECT",
            "name": "SaveFirebaseTokenSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SaveFirebaseTokenSuccess",
        "fields": [
          {
            "name": "user_device_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SendUserEmailInvitationError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "OrgOrProjectUserDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SendUserEmailInvitationErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "SendUserEmailInvitationError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SendUserEmailInvitationResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "SendUserEmailInvitationErrors"
          },
          {
            "kind": "OBJECT",
            "name": "SendUserEmailInvitationSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SendUserEmailInvitationSuccess",
        "fields": [
          {
            "name": "emails_sent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SignFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileFormatNotSupported"
          },
          {
            "kind": "OBJECT",
            "name": "FileVersionDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SignFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "SignFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SignFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "SignFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "SignFileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SignFileSuccess",
        "fields": [
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SubtaskAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SubtaskDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuccessReportType",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskAssignationsNotAllowed",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskAttachmentAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskAttachmentDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "TaskImportRequestExcelTemplateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "TaskRequestCarboneImportExcelTemplateVoid"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TaskImportRequestExcelTemplateErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "TaskImportRequestExcelTemplateError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "TaskImportRequestExcelTemplateResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "TaskImportRequestExcelTemplateErrors"
          },
          {
            "kind": "OBJECT",
            "name": "TaskImportRequestExcelTemplateSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TaskImportRequestExcelTemplateSuccess",
        "fields": [
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskPermissionsNotAllowed",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskRequestCarboneImportExcelTemplateVoid",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TeamAccessDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TeamDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TeamNameAlreadyExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "TestMigrateAvatarPublicUrlError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "TestMigrateAvatarPublicUrlFailed"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TestMigrateAvatarPublicUrlErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "TestMigrateAvatarPublicUrlError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TestMigrateAvatarPublicUrlFailed",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "TestMigrateAvatarPublicUrlResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "TestMigrateAvatarPublicUrlErrors"
          },
          {
            "kind": "OBJECT",
            "name": "TestMigrateAvatarPublicUrlSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TestMigrateAvatarPublicUrlSuccess",
        "fields": [
          {
            "name": "ok",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UnreadNotificationsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "NotificationDoesNotExists"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UnreadNotificationsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UnreadNotificationsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UnreadNotificationsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UnreadNotificationsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UnreadNotificationsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UnreadNotificationsSuccess",
        "fields": [
          {
            "name": "notification_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateArchiveTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateArchiveTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateArchiveTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateArchiveTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateArchiveTaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateArchiveTaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateArchiveTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsFilesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationsFilesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateAssignationsFilesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsFilesFoldersError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationsFilesFoldersErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateAssignationsFilesFoldersError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsFilesFoldersResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationsFilesFoldersErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationsFilesFoldersSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationsFilesFoldersSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "folder_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsFilesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationsFilesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationsFilesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationsFilesSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsFoldersError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationsFoldersErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateAssignationsFoldersError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsFoldersResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationsFoldersErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationsFoldersSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationsFoldersSuccess",
        "fields": [
          {
            "name": "folder_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAssignationsNotAllowed"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssignationsTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateAssignationsTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateAssignationsTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationTaskSuccess"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateAssignationsTaskErrors"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateBrowserLanguageError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateBrowserLanguageErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateBrowserLanguageError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateBrowserLanguageResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateBrowserLanguageErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateBrowserLanguageSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateBrowserLanguageSuccess",
        "fields": [
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateBrowserTimezoneError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateBrowserTimezoneErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateBrowserTimezoneError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateBrowserTimezoneResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateBrowserTimezoneErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateBrowserTimezoneSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateBrowserTimezoneSuccess",
        "fields": [
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateDueDateFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateDueDateFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateDueDateFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateDueDateFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateDueDateFileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateDueDateFileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateDueDateFileSuccess",
        "fields": [
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateEmailNotificationsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateEmailNotificationsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateEmailNotificationsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateEmailNotificationsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateEmailNotificationsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateEmailNotificationsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateEmailNotificationsSuccess",
        "fields": [
          {
            "name": "email_notifications_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateFilesApprovalModeError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotRemoveApprovalOnFile"
          },
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateFilesApprovalModeErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateFilesApprovalModeError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateFilesApprovalModeResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateFilesApprovalModeErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateFilesApprovalModeSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateFilesApprovalModeSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateFilterError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FilterCannotBeUpdate"
          },
          {
            "kind": "OBJECT",
            "name": "FilterDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "FilterMultipleVisibility"
          },
          {
            "kind": "OBJECT",
            "name": "FilterNeedToBeVisible"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateFilterErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateFilterError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateFilterResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateFilterErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateFilterSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateFilterSuccess",
        "fields": [
          {
            "name": "filter_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateLabelsFilesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateLabelsFilesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateLabelsFilesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateLabelsFilesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateLabelsFilesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateLabelsFilesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateLabelsFilesSuccess",
        "fields": [
          {
            "name": "file_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateLabelsFoldersError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateLabelsFoldersErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateLabelsFoldersError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateLabelsFoldersResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateLabelsFoldersErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateLabelsFoldersSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateLabelsFoldersSuccess",
        "fields": [
          {
            "name": "folder_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateLabelsTasksError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateLabelsTasksErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateLabelsTasksError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateLabelsTasksResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateLabelsTasksErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateLabelsTasksSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateLabelsTasksSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateOrgProfileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProfilePermissionDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProfileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateOrgProfileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProfilePermissionDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateOrgProfileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProfileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProfileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProfileSuccess",
        "fields": [
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateOrgProjectSummaryArchiveError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "OrgProjectSummaryDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProjectSummaryArchiveErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateOrgProjectSummaryArchiveError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateOrgProjectSummaryArchiveResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProjectSummaryArchiveErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProjectSummaryArchiveSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProjectSummaryArchiveSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateOrgProjectSummaryError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgProjectSummaryDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectGroupDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProjectSummaryPermissionDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProjectSummaryErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateOrgProjectSummaryError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProjectSummaryPermissionDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateOrgProjectSummaryResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProjectSummaryErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProjectSummarySuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateOrgProjectSummarySuccess",
        "fields": [
          {
            "name": "org_project_summary_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePermissionFileSuccess",
        "fields": [
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePermissionFolderSuccess",
        "fields": [
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePermissionTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdatePermissionsFileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FileDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "PermissionsConflictError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePermissionsFileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdatePermissionsFileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdatePermissionsFileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdatePermissionFileSuccess"
          },
          {
            "kind": "OBJECT",
            "name": "UpdatePermissionsFileErrors"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdatePermissionsFolderError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FolderAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "FolderDoesNotExists"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "PermissionsConflictError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePermissionsFolderErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdatePermissionsFolderError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdatePermissionsFolderResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdatePermissionFolderSuccess"
          },
          {
            "kind": "OBJECT",
            "name": "UpdatePermissionsFolderErrors"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdatePermissionsTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TaskPermissionsNotAllowed"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePermissionsTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdatePermissionsTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdatePermissionsTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdatePermissionTaskSuccess"
          },
          {
            "kind": "OBJECT",
            "name": "UpdatePermissionsTaskErrors"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectCategoryError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectCategoryErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectCategoryError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectCategoryResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectCategoryErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectCategorySuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectCategorySuccess",
        "fields": [
          {
            "name": "project_category_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectGroupError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectGroupAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectGroupDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectGroupErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectGroupError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectGroupResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectGroupErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectGroupSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectGroupSuccess",
        "fields": [
          {
            "name": "project_group_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectLabelError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectLabelAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectLabelDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectLabelErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectLabelError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectLabelResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectLabelErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectLabelSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectLabelSuccess",
        "fields": [
          {
            "name": "project_label_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectMembersRoleError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotModifyUserWithGreaterProjectRoleThanYours"
          },
          {
            "kind": "OBJECT",
            "name": "CannotSetGreaterProjectRoleThanYours"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectNeedsAtLeastOneOwner"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectMembersRoleErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectMembersRoleError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectMembersRoleResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectMembersRoleErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectMembersRoleSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectMembersRoleSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectProfileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectProfilePermissionDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectProfileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectProfileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectProfilePermissionDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectProfileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectProfileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectProfileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectProfileSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectRoleError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotModifyUserWithGreaterProjectRoleThanYours"
          },
          {
            "kind": "OBJECT",
            "name": "CannotSetGreaterProjectRoleThanYours"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectNeedsAtLeastOneOwner"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectRoleErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectRoleError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectRoleResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectRoleErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectRoleSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectRoleSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectTemplateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotConvertToTemplateOrgProject"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectTemplateErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectTemplateError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectTemplateResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectTemplateErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectTemplateSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectTemplateSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectUserInfosError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotModifyEmailOfActiveUser"
          },
          {
            "kind": "OBJECT",
            "name": "CannotSetGreaterProjectRoleThanYours"
          },
          {
            "kind": "OBJECT",
            "name": "EmailAlreadyUsedByAnotherUser"
          },
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectNeedsAtLeastOneOwner"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectUserInfosPermissionDenied"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectUserInfosErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectUserInfosError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectUserInfosPermissionDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectUserInfosResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectUserInfosErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectUserInfosSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectUserInfosSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectsCategoriesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "OrgProjectSummaryDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectCategoryDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProjectSummaryPermissionDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectsCategoriesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectsCategoriesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectsCategoriesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectsCategoriesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectsCategoriesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectsCategoriesSuccess",
        "fields": [
          {
            "name": "categories",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "orgId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "projectIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectsClientError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "OrgProjectSummaryDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateOrgProjectSummaryPermissionDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectsClientErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateProjectsClientError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateProjectsClientResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateProjectsClientErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProjectsClientSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProjectsClientSuccess",
        "fields": [
          {
            "name": "client_email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "client_fullname",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "client_phone_number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdatePushNotificationsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePushNotificationsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdatePushNotificationsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdatePushNotificationsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdatePushNotificationsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdatePushNotificationsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePushNotificationsSuccess",
        "fields": [
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateReportBlocksError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "OrgAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "OrgDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ReportBlockCannotBeUpdate"
          },
          {
            "kind": "OBJECT",
            "name": "ReportBlockDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "ReportBlockMultipleVisibility"
          },
          {
            "kind": "OBJECT",
            "name": "ReportBlockNeedToBeVisible"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateReportBlocksErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateReportBlocksError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateReportBlocksResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateReportBlocksErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateReportBlocksSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateReportBlocksSuccess",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "report_block_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateSubtaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "SubtaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "SubtaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateSubtaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateSubtaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateSubtaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateSubtaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateSubtaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateSubtaskSuccess",
        "fields": [
          {
            "name": "subtask_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTaskDependenciesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTaskDependenciesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateTaskDependenciesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTaskDependenciesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateTaskDependenciesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateTaskDependenciesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTaskDependenciesSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAssignationsNotAllowed"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateTaskPermissionDenied"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTaskFileVersionsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTaskFileVersionsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateTaskFileVersionsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTaskFileVersionsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateTaskFileVersionsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateTaskFileVersionsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTaskFileVersionsSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTaskPermissionDenied",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateTaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateTaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTasksAssignationsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAssignationsNotAllowed"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTasksAssignationsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateTasksAssignationsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTasksAssignationsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateTasksAssignationsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateTasksAssignationsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTasksAssignationsSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTasksDatesError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTasksDatesErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateTasksDatesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTasksDatesResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateTasksDatesErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateTasksDatesSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTasksDatesSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTeamError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TeamNameAlreadyExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTeamErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateTeamError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateTeamResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateTeamErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateTeamSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTeamSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUserAppMetadataError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserAppMetadataErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateUserAppMetadataError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUserAppMetadataResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateUserAppMetadataErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateUserAppMetadataSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserAppMetadataSuccess",
        "fields": [
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUserProfileError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserProfileErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateUserProfileError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUserProfileResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateUserProfileErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateUserProfileSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserProfileSuccess",
        "fields": [
          {
            "name": "ok",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUserTeamsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserTeamsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateUserTeamsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUserTeamsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateUserTeamsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateUserTeamsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserTeamsSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUsersCompanyNameError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUsersCompanyNameErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateUsersCompanyNameError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUsersCompanyNameResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateUsersCompanyNameErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateUsersCompanyNameSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUsersCompanyNameSuccess",
        "fields": [
          {
            "name": "company_name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUsersInTeamError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUsersInTeamErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateUsersInTeamError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUsersInTeamResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateUsersInTeamErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateUsersInTeamSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUsersInTeamSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUsersTeamsError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "ProjectDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "TeamAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TeamDoesNotExist"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUsersTeamsErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateUsersTeamsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateUsersTeamsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateUsersTeamsErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateUsersTeamsSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUsersTeamsSuccess",
        "fields": [
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "user_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateValidationTaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateValidationTaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateValidationTaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateValidationTaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateValidationTaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateValidationTaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateValidationTaskSuccess",
        "fields": [
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateValidationsTasksError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "TaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "TaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateValidationsTasksErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "UpdateValidationsTasksError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UpdateValidationsTasksResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "UpdateValidationsTasksErrors"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateValidationsTasksSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateValidationsTasksSuccess",
        "fields": [
          {
            "name": "task_ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserAlreadyPartOfThisTeam",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserCommentIsNecessaryToFile",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserDoesNotExist",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserNotAssignedToFile",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserNotModeratorOfThisChannel",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserNotPartOfThisTeam",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ValidateSubtaskError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InputValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "SubtaskAccessDenied"
          },
          {
            "kind": "OBJECT",
            "name": "SubtaskDoesNotExist"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ValidateSubtaskErrors",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ValidateSubtaskError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ValidateSubtaskResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidateSubtaskErrors"
          },
          {
            "kind": "OBJECT",
            "name": "ValidateSubtaskSuccess"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ValidateSubtaskSuccess",
        "fields": [
          {
            "name": "subtask_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "awsS3Part",
        "fields": [
          {
            "name": "etag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "partNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "awsS3PartTaskAttachment",
        "fields": [
          {
            "name": "etag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "partNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "copyTaskAttachmentsUploadSuccess",
        "fields": [
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "email_notifications",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "invitation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "unread_notification_report",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "weekly_report",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "payload",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "path",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "events_workers_status",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "event_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "payload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "path",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_approval",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_approvals",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approval_attachments",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_avg_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_max_fields",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_min_fields",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_stddev_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_stddev_pop_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_stddev_samp_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_sum_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_var_pop_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_var_samp_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approval_attachments_variance_fields",
        "fields": [
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approvals",
        "fields": [
          {
            "name": "approval_attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approval_attachments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "approval_attachments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_approval_attachments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_comments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_approvals_file_versions_attachment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_versions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_approvals_file_versions",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_approval",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_approvals",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_versions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_assignations",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "files",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_assignations_orgs",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_assignations_teams",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "teams",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_assignations_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_comments",
        "fields": [
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_approval",
            "type": {
              "kind": "OBJECT",
              "name": "file_approvals",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_versions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_permissions",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "files",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_permissions_orgs",
        "fields": [
          {
            "name": "access",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_permission_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_permissions_teams",
        "fields": [
          {
            "name": "access",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_permission_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "teams",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_permissions_users",
        "fields": [
          {
            "name": "access",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_permission_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_signatures",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_versions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "signed_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "signed_by",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_version_approval_request_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_approval",
            "type": {
              "kind": "OBJECT",
              "name": "file_approvals",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_version_approval_request",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_version_approval_requests",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_approval_request_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_version_approval_request_users_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_request_users_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_approval_request_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_version_approval_request_users_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_request_users_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_request_users_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_version_approval_request_users_max_fields",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_version_approval_request_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_version_approval_request_users_min_fields",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_approval_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_version_approval_request_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_version_approval_requests",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_versions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_approval_request_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_version_approval_request_users_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_version_autodesk",
        "fields": [
          {
            "name": "conversion_progress",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "urn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_versions",
        "fields": [
          {
            "name": "approval_requests",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_requests",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "approvals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "approvals_overview",
            "type": {
              "kind": "OBJECT",
              "name": "file_versions_approvals_overview",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "autodesk",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_autodesk",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_comments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "content_type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "current_extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "files",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_approvals_file_versions_attachment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_annotated",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "original_url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "signatures",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_signatures",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user_approvals",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "file_approvals",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_versions_approvals_overview",
        "fields": [
          {
            "name": "file_version",
            "type": {
              "kind": "OBJECT",
              "name": "file_versions",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "is_approved_with_comments",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "is_approved_without_comments",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "is_completed",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "is_denied",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "file_views",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_versions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "files",
        "fields": [
          {
            "name": "assignation",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "due_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folders",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_approval_mode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_approved_on_a_version",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "files_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "last_version",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "file_versions",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "parent_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "permission",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "suggestions_assignations_orgs",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "orgs",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_assignations_teams",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "teams",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_assignations_users",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "users",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_permissions_orgs",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "orgs",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_permissions_teams",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "teams",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_permissions_users",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "users",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "versions_by_pk",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "file_versions",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "args",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "files_to_project_labels",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "files",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "project_labels",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "order",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_label_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "filter_user_default",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "filter",
            "type": {
              "kind": "OBJECT",
              "name": "filters",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "filter_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "filters",
        "fields": [
          {
            "name": "color",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "filterDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "filter_user_default",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "visibility_org_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "visibility_project_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "visibility_team_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "visibility_user_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_assignations",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folders",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_assignations_orgs",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folder_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_assignations_teams",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folder_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "teams",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_assignations_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folder_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_permissions",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folders",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "inherited_from",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_permissions_orgs",
        "fields": [
          {
            "name": "access",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder_permission_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folder_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_permissions_teams",
        "fields": [
          {
            "name": "access",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder_permission_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folder_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "teams",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_permissions_users",
        "fields": [
          {
            "name": "access",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder_permission_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folder_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folder_views",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folders",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folders",
        "fields": [
          {
            "name": "approval_automation_mode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "assignation",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "assignee_automation_mode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "duedate_automation_mode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "files",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_in_bin",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folders_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "notification_badge",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "t_folder_notification_badge",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "parent",
            "type": {
              "kind": "OBJECT",
              "name": "folders",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "parent_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "parents_ids",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "permission",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pwd",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "t_folder_pwd",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_assignations_orgs",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "orgs",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_assignations_teams",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "teams",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_assignations_users",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "users",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_permissions_orgs",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "orgs",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_permissions_teams",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "teams",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestions_permissions_users",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "users",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "folders_to_project_labels",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "folders",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "project_labels",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "order",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_label_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "getAutodeskToken",
        "fields": [
          {
            "name": "autodesk_access_token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "mutation_root",
        "fields": [
          {
            "name": "FilterUserDefault",
            "type": {
              "kind": "UNION",
              "name": "FilterUserDefaultResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "FinalizeUploadedProjectGroupAvatar",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedProjectGroupAvatarResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "PrepareProjectGroupAssetForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareProjectGroupAssetForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "ProjectInvitationRequestExcelTemplate",
            "type": {
              "kind": "UNION",
              "name": "ProjectInvitationRequestExcelTemplateResult",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "abortMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "AbortMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "abortTaskAttachmentMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "AbortTaskAttachmentMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addFileApprovalsFileVersions",
            "type": {
              "kind": "UNION",
              "name": "AddFileApprovalsFileVersionsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addMembersToProjectChannel",
            "type": {
              "kind": "UNION",
              "name": "AddMembersToProjectChannelResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addUserApprovalToFileVersion",
            "type": {
              "kind": "UNION",
              "name": "AddUserApprovalToFileVersionResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addUserInTeam",
            "type": {
              "kind": "UNION",
              "name": "AddUserInTeamResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addUserMultiApprovalToFilesVersion",
            "type": {
              "kind": "UNION",
              "name": "AddUserMultiApprovalToFilesVersionResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addUserViewToFileVersion",
            "type": {
              "kind": "UNION",
              "name": "AddUserViewToFileVersionResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addUserViewToFolder",
            "type": {
              "kind": "UNION",
              "name": "AddUserViewToFolderResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addUserViewToProject",
            "type": {
              "kind": "UNION",
              "name": "AddUserViewToProjectResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addUserViewToTask",
            "type": {
              "kind": "UNION",
              "name": "AddUserViewToTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "annotateFile",
            "type": {
              "kind": "UNION",
              "name": "AnnotateFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "bulkDeleteTasks",
            "type": {
              "kind": "UNION",
              "name": "BulkDeleteTasksResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "completeMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "CompleteMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "completeTaskAttachmentMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "CompleteTaskAttachmentMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "convertFile",
            "type": {
              "kind": "UNION",
              "name": "ConvertFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "copyProject",
            "type": {
              "kind": "UNION",
              "name": "CopyProjectResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "copyTaskAttachmentsUpload",
            "type": {
              "kind": "UNION",
              "name": "CopyTaskAttachmentsUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createChannelForApproval",
            "type": {
              "kind": "UNION",
              "name": "CreateChannelForApprovalResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createChannelForProject",
            "type": {
              "kind": "UNION",
              "name": "CreateChannelForProjectResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createChannelForTask",
            "type": {
              "kind": "UNION",
              "name": "CreateChannelForTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createEmptyFile",
            "type": {
              "kind": "UNION",
              "name": "CreateEmptyFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createFilter",
            "type": {
              "kind": "UNION",
              "name": "CreateFilterResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createFolder",
            "type": {
              "kind": "UNION",
              "name": "CreateFolderResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "CreateMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createOrg",
            "type": {
              "kind": "UNION",
              "name": "CreateOrgResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createOrgProjectSummary",
            "type": {
              "kind": "UNION",
              "name": "CreateOrgProjectSummaryResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProject",
            "type": {
              "kind": "UNION",
              "name": "CreateProjectResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProjectCategory",
            "type": {
              "kind": "UNION",
              "name": "CreateProjectCategoryResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProjectDirectMessage",
            "type": {
              "kind": "UNION",
              "name": "CreateProjectDirectMessageResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProjectGroup",
            "type": {
              "kind": "UNION",
              "name": "CreateProjectGroupResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProjectLabel",
            "type": {
              "kind": "UNION",
              "name": "CreateProjectLabelResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createReportBlocks",
            "type": {
              "kind": "UNION",
              "name": "CreateReportBlocksResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createSubtask",
            "type": {
              "kind": "UNION",
              "name": "CreateSubtaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTask",
            "type": {
              "kind": "UNION",
              "name": "CreateTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTaskAttachmentMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "CreateTaskAttachmentMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTeam",
            "type": {
              "kind": "UNION",
              "name": "CreateTeamResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFile",
            "type": {
              "kind": "UNION",
              "name": "DeleteFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFilter",
            "type": {
              "kind": "UNION",
              "name": "DeleteFilterResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFirebaseToken",
            "type": {
              "kind": "UNION",
              "name": "DeleteFirebaseTokenResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFolder",
            "type": {
              "kind": "UNION",
              "name": "DeleteFolderResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProject",
            "type": {
              "kind": "UNION",
              "name": "DeleteProjectResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProjectCategory",
            "type": {
              "kind": "UNION",
              "name": "DeleteProjectCategoryResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProjectGroup",
            "type": {
              "kind": "UNION",
              "name": "DeleteProjectGroupResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProjectLabel",
            "type": {
              "kind": "UNION",
              "name": "DeleteProjectLabelResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteReportBlock",
            "type": {
              "kind": "UNION",
              "name": "DeleteReportBlockResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteSubtask",
            "type": {
              "kind": "UNION",
              "name": "DeleteSubtaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTask",
            "type": {
              "kind": "UNION",
              "name": "DeleteTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTaskAttachment",
            "type": {
              "kind": "UNION",
              "name": "DeleteTaskAttachmentResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTaskDependencies",
            "type": {
              "kind": "UNION",
              "name": "DeleteTaskDependenciesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTasks",
            "type": {
              "kind": "UNION",
              "name": "DeleteTasksResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTeam",
            "type": {
              "kind": "UNION",
              "name": "DeleteTeamResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "downloadFolder",
            "type": {
              "kind": "UNION",
              "name": "DownloadFolderResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "duplicateFiles",
            "type": {
              "kind": "UNION",
              "name": "DuplicateFilesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedChannelAsset",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedChannelAssetResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedFile",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedFileApprovalsAttachment",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedFileApprovalsAttachmentResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedFileStructure",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedFileStructureResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedFileVersion",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedFileVersionResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedOrgAvatar",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedOrgAvatarResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedOrgBackground",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedOrgBackgroundResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedProjectAvatar",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedProjectAvatarResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedProjectBackground",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedProjectBackgroundResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedProjectBanner",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedProjectBannerResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedProjectSpreadsheet",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedProjectSpreadsheetResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedTaskAttachment",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedTaskAttachmentResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedTaskAttachmentAnnotation",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedTaskAttachmentAnnotationResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedTaskSpreadsheet",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedTaskSpreadsheetResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "finalizeUploadedUserAvatar",
            "type": {
              "kind": "UNION",
              "name": "FinalizeUploadedUserAvatarResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "generateApiToken",
            "type": {
              "kind": "UNION",
              "name": "GenerateApiTokenResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "joinOrgUserProject",
            "type": {
              "kind": "UNION",
              "name": "JoinOrgUserProjectResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "listMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "ListMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "listTaskAttachmentMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "ListTaskAttachmentMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "migrateAvatarPublicUrl",
            "type": {
              "kind": "UNION",
              "name": "MigrateAvatarPublicUrlResult",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "moveFiles",
            "type": {
              "kind": "UNION",
              "name": "MoveFilesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "moveFolders",
            "type": {
              "kind": "UNION",
              "name": "MoveFoldersResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareChannelAssetForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareChannelAssetForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareFileApprovalsAttachmentForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareFileApprovalsAttachmentForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareFileForAutodeskViewer",
            "type": {
              "kind": "UNION",
              "name": "PrepareFileForAutodeskViewerResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareFileForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareFileForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareFileStructureForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareFileStructureForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareFileVersionAnnotationForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareFileVersionAnnotationForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareFileVersionForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareFileVersionForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareOrgAssetForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareOrgAssetForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareProjectAssetForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareProjectAssetForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareProjectSpreadsheetForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareProjectSpreadsheetForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareProjectUserAvatarForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareProjectUserAvatarForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareTaskAttachmentAnnotationForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareTaskAttachmentAnnotationForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareTaskAttachmentForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareTaskAttachmentForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareTaskAttachmentMultipartUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareTaskAttachmentMultipartUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareTaskSpreadsheetForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareTaskSpreadsheetForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "prepareUserAvatarForUpload",
            "type": {
              "kind": "UNION",
              "name": "PrepareUserAvatarForUploadResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "projectImportRequestExcelTemplate",
            "type": {
              "kind": "UNION",
              "name": "ProjectImportRequestExcelTemplateResult",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "projectInvitations",
            "type": {
              "kind": "UNION",
              "name": "ProjectInvitationsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "readNotifications",
            "type": {
              "kind": "UNION",
              "name": "ReadNotificationsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "removeMembersFromProjectChannel",
            "type": {
              "kind": "UNION",
              "name": "RemoveMembersFromProjectChannelResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "removeUserInTeam",
            "type": {
              "kind": "UNION",
              "name": "RemoveUserInTeamResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "renameChannelForProject",
            "type": {
              "kind": "UNION",
              "name": "RenameChannelForProjectResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "renameFile",
            "type": {
              "kind": "UNION",
              "name": "RenameFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "renameFolder",
            "type": {
              "kind": "UNION",
              "name": "RenameFolderResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "requestApprovalExport",
            "type": {
              "kind": "UNION",
              "name": "RequestApprovalExportResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "requestApprovalReport",
            "type": {
              "kind": "UNION",
              "name": "RequestApprovalReportResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "requestFilesTreeReport",
            "type": {
              "kind": "UNION",
              "name": "RequestFilesTreeReportResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "requestProjectExport",
            "type": {
              "kind": "UNION",
              "name": "RequestProjectExportResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "requestTasksExport",
            "type": {
              "kind": "UNION",
              "name": "RequestTasksExportResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "requestTasksReport",
            "type": {
              "kind": "UNION",
              "name": "RequestTasksReportResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "requestUsersApprovalsFiles",
            "type": {
              "kind": "UNION",
              "name": "RequestUsersApprovalsFilesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "restoreFileVersion",
            "type": {
              "kind": "UNION",
              "name": "RestoreFileVersionResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "saveFirebaseToken",
            "type": {
              "kind": "UNION",
              "name": "SaveFirebaseTokenResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "sendUserEmailInvitation",
            "type": {
              "kind": "UNION",
              "name": "SendUserEmailInvitationResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "signFile",
            "type": {
              "kind": "UNION",
              "name": "SignFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "taskImportRequestExcelTemplate",
            "type": {
              "kind": "UNION",
              "name": "TaskImportRequestExcelTemplateResult",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "testMigrateAvatarPublicUrl",
            "type": {
              "kind": "UNION",
              "name": "TestMigrateAvatarPublicUrlResult",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "unreadNotifications",
            "type": {
              "kind": "UNION",
              "name": "UnreadNotificationsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateArchiveTask",
            "type": {
              "kind": "UNION",
              "name": "UpdateArchiveTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateAssignationsFiles",
            "type": {
              "kind": "UNION",
              "name": "UpdateAssignationsFilesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateAssignationsFilesFolders",
            "type": {
              "kind": "UNION",
              "name": "UpdateAssignationsFilesFoldersResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateAssignationsFolders",
            "type": {
              "kind": "UNION",
              "name": "UpdateAssignationsFoldersResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateAssignationsTask",
            "type": {
              "kind": "UNION",
              "name": "UpdateAssignationsTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateBrowserLanguage",
            "type": {
              "kind": "UNION",
              "name": "UpdateBrowserLanguageResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateBrowserTimezone",
            "type": {
              "kind": "UNION",
              "name": "UpdateBrowserTimezoneResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateDueDateFile",
            "type": {
              "kind": "UNION",
              "name": "UpdateDueDateFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateEmailNotifications",
            "type": {
              "kind": "UNION",
              "name": "UpdateEmailNotificationsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFilesApprovalMode",
            "type": {
              "kind": "UNION",
              "name": "UpdateFilesApprovalModeResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFilter",
            "type": {
              "kind": "UNION",
              "name": "UpdateFilterResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateLabelsFiles",
            "type": {
              "kind": "UNION",
              "name": "UpdateLabelsFilesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateLabelsFolders",
            "type": {
              "kind": "UNION",
              "name": "UpdateLabelsFoldersResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateLabelsTasks",
            "type": {
              "kind": "UNION",
              "name": "UpdateLabelsTasksResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateOrgProfile",
            "type": {
              "kind": "UNION",
              "name": "UpdateOrgProfileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateOrgProjectSummary",
            "type": {
              "kind": "UNION",
              "name": "UpdateOrgProjectSummaryResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateOrgProjectSummaryArchive",
            "type": {
              "kind": "UNION",
              "name": "UpdateOrgProjectSummaryArchiveResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePermissionsFile",
            "type": {
              "kind": "UNION",
              "name": "UpdatePermissionsFileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePermissionsFolder",
            "type": {
              "kind": "UNION",
              "name": "UpdatePermissionsFolderResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePermissionsTask",
            "type": {
              "kind": "UNION",
              "name": "UpdatePermissionsTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectCategory",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectCategoryResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectGroup",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectGroupResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectLabel",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectLabelResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectMembersRole",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectMembersRoleResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectProfile",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectProfileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectRole",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectRoleResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectTemplate",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectTemplateResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectUserInfos",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectUserInfosResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectsCategories",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectsCategoriesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProjectsClient",
            "type": {
              "kind": "UNION",
              "name": "UpdateProjectsClientResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePushNotifications",
            "type": {
              "kind": "UNION",
              "name": "UpdatePushNotificationsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateReportBlocks",
            "type": {
              "kind": "UNION",
              "name": "UpdateReportBlocksResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateSubtask",
            "type": {
              "kind": "UNION",
              "name": "UpdateSubtaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTask",
            "type": {
              "kind": "UNION",
              "name": "UpdateTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTaskDependencies",
            "type": {
              "kind": "UNION",
              "name": "UpdateTaskDependenciesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTaskFileVersions",
            "type": {
              "kind": "UNION",
              "name": "UpdateTaskFileVersionsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTasksAssignations",
            "type": {
              "kind": "UNION",
              "name": "UpdateTasksAssignationsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTasksDates",
            "type": {
              "kind": "UNION",
              "name": "UpdateTasksDatesResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTeam",
            "type": {
              "kind": "UNION",
              "name": "UpdateTeamResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUserAppMetadata",
            "type": {
              "kind": "UNION",
              "name": "UpdateUserAppMetadataResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUserProfile",
            "type": {
              "kind": "UNION",
              "name": "UpdateUserProfileResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUserTeams",
            "type": {
              "kind": "UNION",
              "name": "UpdateUserTeamsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUsersCompanyName",
            "type": {
              "kind": "UNION",
              "name": "UpdateUsersCompanyNameResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUsersInTeam",
            "type": {
              "kind": "UNION",
              "name": "UpdateUsersInTeamResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUsersTeams",
            "type": {
              "kind": "UNION",
              "name": "UpdateUsersTeamsResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateValidationTask",
            "type": {
              "kind": "UNION",
              "name": "UpdateValidationTaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateValidationsTasks",
            "type": {
              "kind": "UNION",
              "name": "UpdateValidationsTasksResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "validateSubtask",
            "type": {
              "kind": "UNION",
              "name": "ValidateSubtaskResult",
              "ofType": null
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "optionsSuccess",
        "fields": [
          {
            "name": "labels",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "members",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "publicDocuments",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "restrictedDocuments",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tasks",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tasksComments",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "teams",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "org_address",
        "fields": [
          {
            "name": "administrative_area_level1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "administrative_area_level2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "city",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "country",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lat",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "lng",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "postal_code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "street",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "org_avatars",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "public_url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "org_project_summary",
        "fields": [
          {
            "name": "client_email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "client_fullname",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "client_phone_number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "end_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_archived",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_project_template",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "price_estimate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "project_categories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary_to_project_categories",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary_to_project_groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "reference",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "start_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "org_project_summary_to_project_categories",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "order",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "org_project_summary",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "org_project_summary",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_project_summary_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_categories_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "project_categories",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "org_project_summary_to_project_groups",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "order",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org_project_summary",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "org_project_summary",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_project_summary_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_group",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "project_groups",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "project_group_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "org_roles",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "orgs_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "org_settings",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "show_menu_by_group",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "orgs",
        "fields": [
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "org_address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "background",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folder_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "legal_number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "members",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org_avatar",
            "type": {
              "kind": "OBJECT",
              "name": "org_avatars",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "phone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "OBJECT",
              "name": "projects",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "project_categories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_categories",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "public_api_token",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "public_api_token_creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "settings",
            "type": {
              "kind": "OBJECT",
              "name": "org_settings",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "orgs_to_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "inviter",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "inviter_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "org_roles",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "role_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updater",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_address",
        "fields": [
          {
            "name": "administrative_area_level1",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "administrative_area_level2",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "city",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "country",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lat",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "lng",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "postal_code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "street",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_avatars",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "public_url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_categories",
        "fields": [
          {
            "name": "color",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_group_avatars",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_group_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "public_url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_groups",
        "fields": [
          {
            "name": "color",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_group_avatar",
            "type": {
              "kind": "OBJECT",
              "name": "project_group_avatars",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_labels",
        "fields": [
          {
            "name": "color",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "normalized_name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "tasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_roles",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "projects_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_templates_overview",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "is_archived",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "is_demo",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "language",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "project_views",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "projects",
        "fields": [
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "project_address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "background",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "banner",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "folders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_archived",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_demo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "members",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summaries",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summary",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "org_project_summary",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_avatar",
            "type": {
              "kind": "OBJECT",
              "name": "project_avatars",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "root_bin_folder_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "root_folder_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "projects_map_overview",
        "fields": [
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "project_address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "avatar",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_archived",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_creator_in_my_org",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "is_demo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_member",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org_project_summary",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "org_project_summary",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "projects_map_overview_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "projects_map_overview_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_map_overview",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "projects_map_overview_aggregate_fields",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "projects_map_overview_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "projects_map_overview_min_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "projects_map_overview_max_fields",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "projects_map_overview_min_fields",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "projects_to_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "inviter",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "project_roles",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updater",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "push_notifications",
        "fields": [
          {
            "name": "chat_channel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "chat_direct_message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "query_root",
        "fields": [
          {
            "name": "email_notifications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "email_notifications",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "email_notifications_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "email_notifications",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "events_workers_status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events_workers_status",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_workers_status_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events_workers_status",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_approval_attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approval_attachments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approval_attachments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_approval_attachments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approval_attachments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_approvals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approvals_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_approvals",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_approvals_file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approvals_file_versions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_approvals_file_versions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_comments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_comments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_comments",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_signatures",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_signatures",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_signatures_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_signatures",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_approval_request_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_version_approval_request_users_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_request_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_version_approval_requests",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_approval_requests",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_requests_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_requests",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_version_autodesk",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_autodesk",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_autodesk_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_autodesk",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_versions_approvals_overview",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions_approvals_overview",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_versions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_versions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "files",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "files",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "files_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "files",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "files_to_project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "files_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "files_to_project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "files_to_project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "filter_user_default",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "filter_user_default",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "filter_user_default_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "filter_user_default",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "filters",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "filters",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "filters_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "filters",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folders",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folders_to_project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folders_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folders_to_project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folders_to_project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getAlgoliaUserApiKey",
            "type": {
              "kind": "OBJECT",
              "name": "GetAlgoliaUserApiKeySuccess",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "getAutodeskToken",
            "type": {
              "kind": "OBJECT",
              "name": "getAutodeskToken",
              "ofType": null
            },
            "args": [
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getCapawesomeChannels",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CapawesomeChannel",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "app_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getCapgoChannels",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CapgoChannel",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "app_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getOrgBackgroundUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getOrgProjectTemplates",
            "type": {
              "kind": "OBJECT",
              "name": "GetOrgProejectTemplate",
              "ofType": null
            },
            "args": [
              {
                "name": "orgId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getPresignedFileApprovalAttachmentUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getPresignedFileUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getPresignedFileVersionUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getPresignedOriginalFileVersionUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getPresignedTaskAttachmentUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getProjectAvatarUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getProjectBackgroundUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getProjectBannerUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "getStreamChatUserToken",
            "type": {
              "kind": "OBJECT",
              "name": "GetStreamChatUserTokenSuccess",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "getSubFolderCount",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "subFolderCountType",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "getUserAuthLink",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "redirect",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "get_file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "args",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_address",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_address",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_address_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_address",
              "ofType": null
            },
            "args": [
              {
                "name": "org_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "org_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_project_summary",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summary_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_project_summary",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_categories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary_to_project_categories",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_categories_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_project_summary_to_project_categories",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary_to_project_groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_project_summary_to_project_groups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_roles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_roles",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_roles_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_roles",
              "ofType": null
            },
            "args": [
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_settings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_settings",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_settings_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_settings",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "orgs_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "orgs_to_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "orgs_to_users",
              "ofType": null
            },
            "args": [
              {
                "name": "user_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_address",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_address",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_address_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_address",
              "ofType": null
            },
            "args": [
              {
                "name": "project_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "project_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_categories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_categories",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_categories_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_categories",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_group_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_group_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_group_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_group_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_groups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_roles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_roles",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_roles_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_roles",
              "ofType": null
            },
            "args": [
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_templates_overview",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_templates_overview",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "projects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "projects",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "projects_map_overview",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_map_overview",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_map_overview_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects_map_overview_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "push_notifications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "push_notifications",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "push_notifications_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "push_notifications",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "report_blocks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "report_blocks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "report_blocks_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "report_blocks",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "t_folder_notification_badge",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "t_folder_notification_badge",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "t_folder_notification_badge_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "t_folder_notification_badge",
              "ofType": null
            },
            "args": [
              {
                "name": "folder_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "t_folder_pwd",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "t_folder_pwd",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "t_folder_pwd_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "t_folder_pwd",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_attachments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_attachments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_attachments",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_dependencies",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_dependencies",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_file_version_location",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_file_version_location",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_file_version_location_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_file_version_location",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_locations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_locations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_locations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_locations",
              "ofType": null
            },
            "args": [
              {
                "name": "task_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_subtasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_subtasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_subtasks_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_subtasks",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_validations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_validations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_validations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_validations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "tasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "tasks",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "tasks_file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_file_versions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_file_versions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "tasks_to_project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_to_project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_to_project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "teams_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "teams_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams_to_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "teams_to_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "uptime_test",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "uptime_test",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "uptime_test_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "uptime_test",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "user_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_connections",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_connections",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_connections_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_connections",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_contact",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_contact",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_locations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_locations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_locations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_locations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_metadatas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_metadatas",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_notifications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_notifications",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_notifications_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_notifications",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "report_blocks",
        "fields": [
          {
            "name": "block_content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "color",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "scope_org_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scope_project_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "visibility_org_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "visibility_project_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "visibility_team_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "visibility_user_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "subFolderCountType",
        "fields": [
          {
            "name": "subFileCount",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "subFolderCount",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "subFolderId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "subscription_root",
        "fields": [
          {
            "name": "email_notifications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "email_notifications",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "email_notifications_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "email_notifications",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "events_workers_status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events_workers_status",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "events_workers_status_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "events_workers_status",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_approval_attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approval_attachments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approval_attachments_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_approval_attachments_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approval_attachments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_approval_attachments",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_approvals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approvals_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_approvals",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_approvals_file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approvals_file_versions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_approvals_file_versions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_assignations_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_comments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_comments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_comments",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_permissions_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_permissions_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_signatures",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_signatures",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_signatures_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_signatures",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_approval_request_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_version_approval_request_users_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_request_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_version_approval_requests",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_approval_requests",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_requests_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_approval_requests",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_version_autodesk",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_autodesk",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_autodesk_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_version_autodesk",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_versions_approvals_overview",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions_approvals_overview",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_versions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_versions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "file_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "file_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "files",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "files",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "files_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "files",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "files_to_project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "files_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "files_to_project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "files_to_project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "filter_user_default",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "filter_user_default",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "filter_user_default_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "filter_user_default",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "filters",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "filters",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "filters_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "filters",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_assignations_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_permissions_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_permissions_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folder_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folder_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folders",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folders",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folders_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folders",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "folders_to_project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folders_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folders_to_project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "folders_to_project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "get_file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "args",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_address",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_address",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_address_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_address",
              "ofType": null
            },
            "args": [
              {
                "name": "org_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "org_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_project_summary",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summary_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_project_summary",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_categories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary_to_project_categories",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_categories_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_project_summary_to_project_categories",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_project_summary_to_project_groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_project_summary_to_project_groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_project_summary_to_project_groups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_roles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_roles",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_roles_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_roles",
              "ofType": null
            },
            "args": [
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "org_settings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "org_settings",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "org_settings_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "org_settings",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "orgs_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "orgs_to_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "orgs_to_users",
              "ofType": null
            },
            "args": [
              {
                "name": "user_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_address",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_address",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_address_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_address",
              "ofType": null
            },
            "args": [
              {
                "name": "project_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "project_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_categories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_categories",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_categories_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_categories",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_group_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_group_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_group_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_group_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_groups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_groups",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_groups_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_groups",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_roles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_roles",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_roles_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_roles",
              "ofType": null
            },
            "args": [
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "project_templates_overview",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_templates_overview",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "project_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "projects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "projects",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "projects_map_overview",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_map_overview",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_map_overview_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects_map_overview_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "push_notifications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "push_notifications",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "push_notifications_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "push_notifications",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "report_blocks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "report_blocks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "report_blocks_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "report_blocks",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "t_folder_notification_badge",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "t_folder_notification_badge",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "t_folder_notification_badge_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "t_folder_notification_badge",
              "ofType": null
            },
            "args": [
              {
                "name": "folder_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "t_folder_pwd",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "t_folder_pwd",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "t_folder_pwd_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "t_folder_pwd",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_assignations_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_attachments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_attachments_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_attachments",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_dependencies",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_dependencies",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_file_version_location",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_file_version_location",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_file_version_location_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_file_version_location",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_locations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_locations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_locations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_locations",
              "ofType": null
            },
            "args": [
              {
                "name": "task_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_orgs_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions_orgs",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions_teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_permissions_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_permissions_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_subtasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_subtasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_subtasks_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_subtasks",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_validations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_validations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_validations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_validations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "task_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_views_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "task_views",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "tasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "tasks",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "tasks_file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_file_versions_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_file_versions",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "tasks_to_project_labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_to_project_labels_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_to_project_labels",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "teams",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "teams_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "teams_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams_to_users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "teams_to_users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "uptime_test",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "uptime_test",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "uptime_test_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "uptime_test",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_avatars",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_avatars",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_avatars_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_avatars",
              "ofType": null
            },
            "args": [
              {
                "name": "user_id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_connections",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_connections",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_connections_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_connections",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_contact",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_contact",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_locations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_locations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_locations_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_locations",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "user_metadatas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_metadatas",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_notifications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_notifications",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user_notifications_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "user_notifications",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users_by_pk",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "t_folder_notification_badge",
        "fields": [
          {
            "name": "folder_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "strong_notification_count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "weak_notification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "t_folder_pwd",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "level",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_assignations",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_assignations_orgs",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "task_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_assignations_teams",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "task_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "teams",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_assignations_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_assignation_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_assignee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "task_assignations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_attachments",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_dependencies",
        "fields": [
          {
            "name": "ancestor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "from_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "from_side",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "predecessor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "relationship_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "to_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "to_side",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_file_version_location",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "page_number",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pdf_location",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "x",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "y",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_locations",
        "fields": [
          {
            "name": "lat",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lng",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_permissions",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_permissions_orgs",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "orgs",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "org_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "task_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_permissions_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_permissions_teams",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "task_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_permissions_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "teams",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_permissions_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_permission",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "task_permissions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_permissions_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "userByUserId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_subtasks",
        "fields": [
          {
            "name": "closed",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "end_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "last_user_to_validate",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "last_validated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "last_validated_by",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "order",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "start_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_validations",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "task_views",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks",
        "fields": [
          {
            "name": "ancestors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_dependencies",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "assignations",
            "type": {
              "kind": "OBJECT",
              "name": "task_assignations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_attachments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "deleted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "deleted_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "end_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_validated_by",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "labels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks_to_project_labels",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "location",
            "type": {
              "kind": "OBJECT",
              "name": "task_locations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "permissions",
            "type": {
              "kind": "OBJECT",
              "name": "task_permissions",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "predecessors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_dependencies",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "start_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "subtasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_subtasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "subtasks_progress",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_can_read",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "validations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_validations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_aggregate",
        "fields": [
          {
            "name": "aggregate",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_aggregate_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_aggregate_fields",
        "fields": [
          {
            "name": "avg",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_avg_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "columns",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "distinct",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "max",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_max_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "min",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_min_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_stddev_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_pop",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_stddev_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stddev_samp",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_stddev_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sum",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_sum_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_pop",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_var_pop_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "var_samp",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_var_samp_fields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "tasks_variance_fields",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_avg_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_file_versions",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "file_version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_versions",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file_version_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "location",
            "type": {
              "kind": "OBJECT",
              "name": "task_file_version_location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_location_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_max_fields",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deleted_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "end_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "start_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_min_fields",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deleted_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "end_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "start_date",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_stddev_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_stddev_pop_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_stddev_samp_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_sum_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_to_project_labels",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "project_labels",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "order",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project_label_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_var_pop_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_var_samp_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "tasks_variance_fields",
        "fields": [
          {
            "name": "hours_done",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hours_expected",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "teams",
        "fields": [
          {
            "name": "color",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "project",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "projects",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "project_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "teams_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "teams_to_users",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "team",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "teams",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "team_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "uptime_test",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "user_avatars",
        "fields": [
          {
            "name": "content_type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "extension",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "public_url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "user_connections",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_locations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_locations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "user_contact",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "phone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "users",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "user_locations",
        "fields": [
          {
            "name": "city_name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "continent_code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "country_code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "country_code3",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "country_name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "latitude",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "longitude",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "time_zone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_connection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "user_connections",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user_connection_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "user_metadatas",
        "fields": [
          {
            "name": "country_code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "placeholder_company_name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "users",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "user_notifications",
        "fields": [
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "creator_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "event_id",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_strong",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "payload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "path",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "read_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "recipient_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "users",
        "fields": [
          {
            "name": "active_org",
            "type": {
              "kind": "OBJECT",
              "name": "orgs_to_users",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "algolia_key",
            "type": {
              "kind": "OBJECT",
              "name": "GetAlgoliaUserApiKeySuccess",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "auth0_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "company_name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "connections",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_connections",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "contact",
            "type": {
              "kind": "OBJECT",
              "name": "user_contact",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "country_code",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "created_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "deleted_at",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "email_notifications",
            "type": {
              "kind": "OBJECT",
              "name": "email_notifications",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "events",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_approvals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_approvals",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_comments",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_permissions_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_signatures",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_signatures",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_version_approval_request_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_version_approval_request_users_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "file_version_approval_request_users_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_versions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_versions",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "file_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "file_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "first_name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "folder_assignations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_orgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_orgs",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_teams",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_permissions_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "folder_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "folder_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "full_name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_active",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_connected",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_legacy_user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "is_locked",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "language",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "last_name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "locations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_locations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "metadatas",
            "type": {
              "kind": "OBJECT",
              "name": "user_metadatas",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "org_invitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "orgs_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "project_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "project_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projectsByCreatorId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_invited",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "projects_to_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "projects_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "public_api_token_creator_id",
            "type": {
              "kind": "OBJECT",
              "name": "orgs",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "push_notifications",
            "type": {
              "kind": "OBJECT",
              "name": "push_notifications",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stream_chat_token",
            "type": {
              "kind": "OBJECT",
              "name": "GetStreamChatUserTokenSuccess",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "stream_user_id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task_assignations_users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_assignations_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_subtasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_subtasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_validations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_validations",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "task_views",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "task_views",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "tasks",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "tasks_aggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "tasks_aggregate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "teams",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "teams_to_users",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "timezone",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updated_at",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user_avatar",
            "type": {
              "kind": "OBJECT",
              "name": "user_avatars",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user_notifications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "user_notifications",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "distinct_on",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "offset",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "order_by",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "where",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "Any"
      }
    ],
    "directives": []
  }
} as unknown as IntrospectionQuery;